/******/ (function (modules) {
  // webpackBootstrap
  /******/ // install a JSONP callback for chunk loading
  /******/ function webpackJsonpCallback(data) {
    /******/ var chunkIds = data[0];
    /******/ var moreModules = data[1];
    /******/
    /******/ var prefetchChunks = data[3] || [];
    /******/ // add "moreModules" to the modules object,
    /******/ // then flag all "chunkIds" as loaded and fire callback
    /******/ var moduleId,
    chunkId,
    i = 0,
    resolves = [];
  /******/ for (; i < chunkIds.length; i++) {
    /******/ chunkId = chunkIds[i];
    /******/ if (
      Object.prototype.hasOwnProperty.call(installedChunks, chunkId) &&
      installedChunks[chunkId]
    ) {
      /******/ resolves.push(installedChunks[chunkId][0]);
      /******/
    }
    /******/ installedChunks[chunkId] = 0;
    /******/
  }
  /******/ for (moduleId in moreModules) {
    /******/ if (
      Object.prototype.hasOwnProperty.call(moreModules, moduleId)
    ) {
      /******/ modules[moduleId] = moreModules[moduleId];
      /******/
    }
    /******/
  }
  /******/ if (parentJsonpFunction) parentJsonpFunction(data);
  /******/ // chunk prefetching for javascript
  /******/ prefetchChunks.forEach(function (chunkId) {
    /******/ if (installedChunks[chunkId] === undefined) {
      /******/ installedChunks[chunkId] = null;
      /******/ var link = document.createElement("link");
      /******/
      /******/ if (__webpack_require__.nc) {
        /******/ link.setAttribute("nonce", __webpack_require__.nc);
        /******/
      }
      /******/ link.rel = "prefetch";
      /******/ link.as = "script";
      /******/ link.href = jsonpScriptSrc(chunkId);
      /******/ document.head.appendChild(link);
      /******/
    }
    /******/
  });
  /******/ while (resolves.length) {
    /******/ resolves.shift()();
    /******/
  }
  /******/
  /******/
}
/******/
/******/
/******/ // The module cache
/******/ var installedModules = {};
/******/
/******/ // object to store loaded and loading chunks
/******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ // Promise = chunk loading, 0 = chunk loaded
/******/ var installedChunks = {
  /******/ 5: 0,
  /******/
};
/******/
/******/
/******/
/******/ // script path function
/******/ function jsonpScriptSrc(chunkId) {
  /******/ return (
    __webpack_require__.p +
    "assets/" +
    ({ 4: "product-image-zoom", 8: "vendors--product-image-zoom" }[chunkId] ||
      chunkId) +
    ".min.js"
  );
  /******/
}
/******/
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
  /******/
  /******/ // Check if module is in cache
  /******/ if (installedModules[moduleId]) {
    /******/ return installedModules[moduleId].exports;
    /******/
  }
  /******/ // Create a new module (and put it into the cache)
  /******/ var module = (installedModules[moduleId] = {
    /******/ i: moduleId,
    /******/ l: false,
    /******/ exports: {},
    /******/
  });
  /******/
  /******/ // Execute the module function
  /******/ modules[moduleId].call(
    module.exports,
    module,
    module.exports,
    __webpack_require__
  );
  /******/
  /******/ // Flag the module as loaded
  /******/ module.l = true;
  /******/
  /******/ // Return the exports of the module
  /******/ return module.exports;
  /******/
}
/******/
/******/ // This file contains only the entry chunk.
/******/ // The chunk loading function for additional chunks
/******/ __webpack_require__.e = function requireEnsure(chunkId) {
  /******/ var promises = [];
  /******/
  /******/
  /******/ // JSONP chunk loading for javascript
  /******/
  /******/ var installedChunkData = installedChunks[chunkId];
  /******/ if (installedChunkData !== 0) {
    // 0 means "already installed".
    /******/
    /******/ // a Promise means "currently loading".
    /******/ if (installedChunkData) {
      /******/ promises.push(installedChunkData[2]);
      /******/
    } else {
      /******/ // setup Promise in chunk cache
      /******/ var promise = new Promise(function (resolve, reject) {
        /******/ installedChunkData = installedChunks[chunkId] = [
          resolve,
          reject,
        ];
        /******/
      });
      /******/ promises.push((installedChunkData[2] = promise));
      /******/
      /******/ // start chunk loading
      /******/ var script = document.createElement("script");
      /******/ var onScriptComplete;
      /******/
      /******/ script.charset = "utf-8";
      /******/ script.timeout = 120;
      /******/ if (__webpack_require__.nc) {
        /******/ script.setAttribute("nonce", __webpack_require__.nc);
        /******/
      }
      /******/ script.src = jsonpScriptSrc(chunkId);
      /******/
      /******/ // create error before stack unwound to get useful stacktrace later
      /******/ var error = new Error();
      /******/ onScriptComplete = function (event) {
        /******/ // avoid mem leaks in IE.
        /******/ script.onerror = script.onload = null;
        /******/ clearTimeout(timeout);
        /******/ var chunk = installedChunks[chunkId];
        /******/ if (chunk !== 0) {
          /******/ if (chunk) {
            /******/ var errorType =
              event && (event.type === "load" ? "missing" : event.type);
            /******/ var realSrc = event && event.target && event.target.src;
            /******/ error.message =
              "Loading chunk " +
              chunkId +
              " failed.\n(" +
              errorType +
              ": " +
              realSrc +
              ")";
            /******/ error.name = "ChunkLoadError";
            /******/ error.type = errorType;
            /******/ error.request = realSrc;
            /******/ chunk[1](error);
            /******/
          }
          /******/ installedChunks[chunkId] = undefined;
          /******/
        }
        /******/
      };
      /******/ var timeout = setTimeout(function () {
        /******/ onScriptComplete({ type: "timeout", target: script });
        /******/
      }, 120000);
      /******/ script.onerror = script.onload = onScriptComplete;
      /******/ document.head.appendChild(script);
      /******/
    }
    /******/
  }
  /******/ return Promise.all(promises);
  /******/
};
/******/
/******/ // expose the modules object (__webpack_modules__)
/******/ __webpack_require__.m = modules;
/******/
/******/ // expose the module cache
/******/ __webpack_require__.c = installedModules;
/******/
/******/ // define getter function for harmony exports
/******/ __webpack_require__.d = function (exports, name, getter) {
  /******/ if (!__webpack_require__.o(exports, name)) {
    /******/ Object.defineProperty(exports, name, {
      enumerable: true,
      get: getter,
    });
    /******/
  }
  /******/
};
/******/
/******/ // define __esModule on exports
/******/ __webpack_require__.r = function (exports) {
  /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    /******/ Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module",
    });
    /******/
  }
  /******/ Object.defineProperty(exports, "__esModule", { value: true });
  /******/
};
/******/
/******/ // create a fake namespace object
/******/ // mode & 1: value is a module id, require it
/******/ // mode & 2: merge all properties of value into the ns
/******/ // mode & 4: return value when already ns object
/******/ // mode & 8|1: behave like require
/******/ __webpack_require__.t = function (value, mode) {
  /******/ if (mode & 1) value = __webpack_require__(value);
  /******/ if (mode & 8) return value;
  /******/ if (
    mode & 4 &&
    typeof value === "object" &&
    value &&
    value.__esModule
  )
    return value;
  /******/ var ns = Object.create(null);
  /******/ __webpack_require__.r(ns);
  /******/ Object.defineProperty(ns, "default", {
    enumerable: true,
    value: value,
  });
  /******/ if (mode & 2 && typeof value != "string")
    for (var key in value)
      __webpack_require__.d(
        ns,
        key,
        function (key) {
          return value[key];
        }.bind(null, key)
      );
  /******/ return ns;
  /******/
};
/******/
/******/ // getDefaultExport function for compatibility with non-harmony modules
/******/ __webpack_require__.n = function (module) {
  /******/ var getter =
    module && module.__esModule
      ? /******/ function getDefault() {
          return module["default"];
        }
      : /******/ function getModuleExports() {
          return module;
        };
  /******/ __webpack_require__.d(getter, "a", getter);
  /******/ return getter;
  /******/
};
/******/
/******/ // Object.prototype.hasOwnProperty.call
/******/ __webpack_require__.o = function (object, property) {
  return Object.prototype.hasOwnProperty.call(object, property);
};
/******/
/******/ // __webpack_public_path__
/******/ __webpack_require__.p = "";
/******/
/******/ // on error function for async loading
/******/ __webpack_require__.oe = function (err) {
  console.error(err);
  throw err;
};
/******/
/******/ var jsonpArray = (window["labelWebpackJsonp"] =
  window["labelWebpackJsonp"] || []);
/******/ var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ jsonpArray.push = webpackJsonpCallback;
/******/ jsonpArray = jsonpArray.slice();
/******/ for (var i = 0; i < jsonpArray.length; i++)
  webpackJsonpCallback(jsonpArray[i]);
/******/ var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ var startupResult = (function () {
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 66));
  /******/
})();
/******/
/******/ webpackJsonpCallback([[], {}, 0, [8, 4]]);
/******/ return startupResult;
/******/
})(
/************************************************************************/
/******/ [
  /* 0 */
  /***/ function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "d", function () {
      return /* binding */ objectHasNoKeys;
    });
    __webpack_require__.d(__webpack_exports__, "b", function () {
      return /* binding */ getImageSrcset;
    });
    __webpack_require__.d(__webpack_exports__, "c", function () {
      return /* binding */ getSiblings;
    });
    __webpack_require__.d(__webpack_exports__, "f", function () {
      return /* binding */ wrapTable;
    });
    __webpack_require__.d(__webpack_exports__, "e", function () {
      return /* binding */ wrapIframe;
    });
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return /* binding */ Helpers;
    });

    // UNUSED EXPORTS: makeSelectorFromElement, findInstance, keyboardKeys, removeInstance, compact, defaultTo, text_truncate, headerIsActive, getJSTemplate, initAlpineComponent, isEventSupported

    // CONCATENATED MODULE: ./node_modules/@switchthemes/utilities/node_modules/@shopify/theme-images/images.js
    /**
     * Image Helper Functions
     * -----------------------------------------------------------------------------
     * https://github.com/Shopify/slate.git.
     *
     */

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
      if (typeof images === "string") {
        images = [images];
      }

      for (let i = 0; i < images.length; i++) {
        const image = images[i];
        loadImage(getSizedImageUrl(image, size));
      }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      const match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }

      if (size === "master") {
        return removeProtocol(src);
      }

      const match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match) {
        const prefix = src.split(match[0]);
        const suffix = match[0];

        return removeProtocol(`${prefix[0]}_${size}${suffix}`);
      } else {
        return null;
      }
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    // CONCATENATED MODULE: ./node_modules/@switchthemes/utilities/index.js
    /**
     * Utility helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions for dealing with arrays and objects
     *
     * @namespace utils
     */

    /**
     * Make a selector from an element’s class and its data- and aria- attributes
     *
     * @param {HTMLElement} element The element to create a selector from
     * @param {Array.<String>} exclusions Attribute names to exclude
     */

    function makeSelectorFromElement(element, exclusions = []) {
      let selectorAttributes = [],
        classString;

      for (var i = 0; i < element.attributes.length; i++) {
        var attribute = element.attributes[i];

        if (
          attribute.name.indexOf("data-") === 0 ||
          attribute.name.indexOf("aria-") === 0
        ) {
          if (exclusions.indexOf(attribute.name) === -1) {
            selectorAttributes.push(attribute);
          }
        }

        if (attribute.name === "class" && attribute.value) {
          classString = attribute.value;
        }
      }

      let selector = "";

      if (classString && classString !== "") {
        selector += "." + classString.split(/\s+/).join(".");
      }

      if (selectorAttributes && selectorAttributes.length > 0) {
        for (var i = 0; i < selectorAttributes.length; i++) {
          var attribute = selectorAttributes[i];
          if (attribute.value) {
            selector += `[${attribute.name}="${attribute.value}"]`;
          } else {
            selector += `[${attribute.name}]`;
          }
        }
      }

      return selector;
    }

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    function findInstance(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    }

    const keyboardKeys = {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFTARROW: 37,
      RIGHTARROW: 39,
      SPACE: 32,
    };

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    function removeInstance(array, key, value) {
      var i = array.length;
      while (i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }

      return array;
    }

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    function compact(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function text_truncate(str, length, ending) {
      if (length == null) {
        length = 200;
      }
      if (ending == null) {
        ending = "...";
      }
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    }

    /**
     * A very basic alternative to _.isEmpty for objects
     *
     * @param {Object} obj An object
     */

    function objectHasNoKeys(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }

      return true;
    }

    /**
     * Generate an srcset given an image’s src
     * and an array of sizes
     *
     * @param {string} src The image’s src
     * @param {(string|number)[]} sizes The sizes
     *
     * @returns {string}
     */

    function getImageSrcset(
      src,
      sizes = [
        180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376,
        2592, 2808, 3024,
      ]
    ) {
      if (!src) return;

      const srcset = [];

      sizes.forEach((size) => {
        srcset.push(
          `${getSizedImageUrl(src, size.toString() + "x")} ${size}w`
        );
      });

      return srcset.join(",\n");
    }

    /**
     * Header is active
     */

    function headerIsActive() {
      return (
        document.querySelector(".site-header").classList.contains("active") ||
        false
      );
    }

    /**
     * Returns the content of a JS Template
     *
     * @param {string} id The id of the template
     */
    function getJSTemplate(id) {
      try {
        return document.getElementById(id).content;
      } catch (e) {
        console.error(`There was an error getting template ${id}`);
        return null;
      }
    }

    /**
     * Initialize Alpine component after page load
     *
     * @param {string} functionName Name of Alpine data function for `x-data`
     */

    function initAlpineComponent(functionName) {
      if (!functionName) return;

      document
        .querySelectorAll(`[data-alpinejs-component="${functionName}()"`)
        .forEach((el) => {
          el.removeAttribute("data-alpinejs-component");
          el.setAttribute("x-data", `${functionName}()`);
          window.Alpine.initializeComponent(el);
        });
    }

    const isEventSupported = (function () {
      const TAGNAMES = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img",
      };

      function isEventSupported(eventName) {
        let el = document.createElement(TAGNAMES[eventName] || "div");
        eventName = "on" + eventName;

        const isSupported = eventName in el;

        if (!isSupported) {
          el.setAttribute(eventName, "return;");
          isSupported = typeof el[eventName] == "function";
        }
        el = null;
        return isSupported;
      }

      return isEventSupported;
    })();

    /**
     * Get an element's siblings
     *
     * @param {elem} Element for which you want the sibling elements
     */

    function getSiblings(elem) {
      // Setup siblings array and get the first sibling
      let siblings = [];
      let sibling = elem.parentNode.firstChild;

      // Loop through each sibling and push to the array
      while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem) {
          siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
      }

      return siblings;
    }

    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {NodeList} options.tables - Elements of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    function wrapTable(options) {
      options.tables.forEach(function (table) {
        var wrapper = document.createElement("div");
        wrapper.classList.add(options.tableWrapperClass);

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }

    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    function wrapIframe(options) {
      options.iframes.forEach(function (iframe) {
        var wrapper = document.createElement("div");
        wrapper.classList.add(options.iframeWrapperClass);

        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);

        iframe.src = iframe.src;
      });
    }

    const Helpers = (function () {
      var touchDevice = false;

      function setTouch() {
        touchDevice = true;
      }

      function isTouch() {
        return touchDevice;
      }

      return {
        setTouch: setTouch,
        isTouch: isTouch,
      };
    })();

    /***/
  },
  /* 1 */
  /***/ function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "b", function () {
      return /* binding */ liveRegion;
    });
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return /* binding */ cartLiveRegion;
    });
    __webpack_require__.d(__webpack_exports__, "c", function () {
      return /* binding */ variantLiveRegion;
    });

    // CONCATENATED MODULE: ./node_modules/@switchthemes/live-region/node_modules/@shopify/theme-currency/currency.js
    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     */

    const moneyFormat = "${{amount}}";

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = "."
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    // CONCATENATED MODULE: ./node_modules/@switchthemes/live-region/index.js

    /**
     * Generic live region announcement
     *
     */
    function liveRegion(content, clear) {
      clearTimeout(window.liveRegionTimeout);
      let region = document.getElementById("screenreader-announce");
      region.innerHTML = content;

      window.liveRegionTimeout = setTimeout(() => {
        region.innerHTML = "";
      }, 3000);
    }

    function cartLiveRegion(item) {
      const templateString =
        theme.strings.update +
        ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";

      function _liveRegionContent() {
        let liveRegionContent = templateString;

        liveRegionContent = liveRegionContent
          .replace("[QuantityLabel]", theme.strings.quantity)
          .replace("[Quantity]", item.quantity);

        let regularLabel = "";
        let regularPrice = formatMoney(
          item.original_line_price,
          theme.moneyFormat
        );
        let discountLabel = "";
        let discountPrice = "";
        let discountInformation = "";

        if (item.original_line_price > item.final_line_price) {
          regularLabel = theme.strings.regularTotal;

          discountLabel = theme.strings.discountedTotal;
          discountPrice = formatMoney(
            item.final_line_price,
            theme.moneyFormat
          );

          discountInformation = theme.strings.priceColumn;
        }

        liveRegionContent = liveRegionContent
          .replace("[Regular]", regularLabel)
          .replace("[$$]", regularPrice)
          .replace("[DiscountedPrice]", discountLabel)
          .replace("[$]", discountPrice)
          .replace("[PriceInformation]", discountInformation)
          .replace("  .", "")
          .trim();

        return liveRegionContent;
      }

      liveRegion(_liveRegionContent(), true);
    }

    function variantLiveRegion(variant) {
      const templateString =
        "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";

      function _getBaseUnit() {
        if (variant.unit_price_measurement.reference_value === 1) {
          return variant.unit_price_measurement.reference_unit;
        }

        return (
          variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit
        );
      }

      /**
       * Compose the live region’s content based on the
       * variant’s properties.
       *
       * @param {Object} variant The variant
       */
      function _liveRegionContent() {
        let liveRegionContent = templateString;

        // Update availability
        const availability = variant.available
          ? ""
          : theme.strings.soldOut + ",";
        liveRegionContent = liveRegionContent.replace(
          "[Availability]",
          availability
        );

        // Update pricing
        let regularLabel = "";
        let regularPrice = formatMoney(variant.price, theme.moneyFormat);

        let saleLabel = "",
          salePrice = "",
          unitLabel = "",
          unitPrice = "";

        if (variant.compare_at_price > variant.price) {
          regularLabel = theme.strings.regularPrice;
          regularPrice = formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          );

          saleLabel = theme.strings.sale;
          salePrice = formatMoney(variant.price, theme.moneyFormat);
        }

        if (variant.unit_price) {
          unitLabel = theme.strings.unitPrice;
          unitPrice =
            formatMoney(variant.unit_price, theme.moneyFormat) +
            " " +
            theme.strings.unitPriceSeparator +
            " " +
            _getBaseUnit();
        }

        liveRegionContent = liveRegionContent
          .replace("[Regular]", regularLabel)
          .replace("[$$]", regularPrice)
          .replace("[Sale]", saleLabel)
          .replace("[$]", salePrice)
          .replace("[UnitPrice]", unitLabel)
          .replace("[$$$]", unitPrice)
          .replace("  .", "")
          .trim();

        return liveRegionContent;
      }

      liveRegion(_liveRegionContent(), false);
    }

    /***/
  },
  /* 2 */
  /***/ function (module, exports, __webpack_require__) {
    (function (window, factory) {
      var lazySizes = factory(window, window.document, Date);
      window.lazySizes = lazySizes;
      if (true && module.exports) {
        module.exports = lazySizes;
      }
    })(
      typeof window != "undefined" ? window : {},
      /**
       * import("./types/global")
       * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
       */
      function l(window, document, Date) {
        // Pass in the window Date function also for SSR because the Date class can be lost
        "use strict";
        /*jshint eqnull:true */

        var lazysizes,
          /**
           * @type { LazySizesConfigPartial }
           */
          lazySizesCfg;

        (function () {
          var prop;

          var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125,
          };

          lazySizesCfg =
            window.lazySizesConfig || window.lazysizesConfig || {};

          for (prop in lazySizesDefaults) {
            if (!(prop in lazySizesCfg)) {
              lazySizesCfg[prop] = lazySizesDefaults[prop];
            }
          }
        })();

        if (!document || !document.getElementsByClassName) {
          return {
            init: function () {},
            /**
             * @type { LazySizesConfigPartial }
             */
            cfg: lazySizesCfg,
            /**
             * @type { true }
             */
            noSupport: true,
          };
        }

        var docElem = document.documentElement;

        var supportPicture = window.HTMLPictureElement;

        var _addEventListener = "addEventListener";

        var _getAttribute = "getAttribute";

        /**
         * Update to bind to window because 'this' becomes null during SSR
         * builds.
         */
        var addEventListener = window[_addEventListener].bind(window);

        var setTimeout = window.setTimeout;

        var requestAnimationFrame =
          window.requestAnimationFrame || setTimeout;

        var requestIdleCallback = window.requestIdleCallback;

        var regPicture = /^picture$/i;

        var loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"];

        var regClassCache = {};

        var forEach = Array.prototype.forEach;

        /**
         * @param ele {Element}
         * @param cls {string}
         */
        var hasClass = function (ele, cls) {
          if (!regClassCache[cls]) {
            regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          }
          return (
            regClassCache[cls].test(ele[_getAttribute]("class") || "") &&
            regClassCache[cls]
          );
        };

        /**
         * @param ele {Element}
         * @param cls {string}
         */
        var addClass = function (ele, cls) {
          if (!hasClass(ele, cls)) {
            ele.setAttribute(
              "class",
              (ele[_getAttribute]("class") || "").trim() + " " + cls
            );
          }
        };

        /**
         * @param ele {Element}
         * @param cls {string}
         */
        var removeClass = function (ele, cls) {
          var reg;
          if ((reg = hasClass(ele, cls))) {
            ele.setAttribute(
              "class",
              (ele[_getAttribute]("class") || "").replace(reg, " ")
            );
          }
        };

        var addRemoveLoadEvents = function (dom, fn, add) {
          var action = add ? _addEventListener : "removeEventListener";
          if (add) {
            addRemoveLoadEvents(dom, fn);
          }
          loadEvents.forEach(function (evt) {
            dom[action](evt, fn);
          });
        };

        /**
         * @param elem { Element }
         * @param name { string }
         * @param detail { any }
         * @param noBubbles { boolean }
         * @param noCancelable { boolean }
         * @returns { CustomEvent }
         */
        var triggerEvent = function (
          elem,
          name,
          detail,
          noBubbles,
          noCancelable
        ) {
          var event = document.createEvent("Event");

          if (!detail) {
            detail = {};
          }

          detail.instance = lazysizes;

          event.initEvent(name, !noBubbles, !noCancelable);

          event.detail = detail;

          elem.dispatchEvent(event);
          return event;
        };

        var updatePolyfill = function (el, full) {
          var polyfill;
          if (
            !supportPicture &&
            (polyfill = window.picturefill || lazySizesCfg.pf)
          ) {
            if (full && full.src && !el[_getAttribute]("srcset")) {
              el.setAttribute("srcset", full.src);
            }
            polyfill({ reevaluate: true, elements: [el] });
          } else if (full && full.src) {
            el.src = full.src;
          }
        };

        var getCSS = function (elem, style) {
          return (getComputedStyle(elem, null) || {})[style];
        };

        /**
         *
         * @param elem { Element }
         * @param parent { Element }
         * @param [width] {number}
         * @returns {number}
         */
        var getWidth = function (elem, parent, width) {
          width = width || elem.offsetWidth;

          while (
            width < lazySizesCfg.minSize &&
            parent &&
            !elem._lazysizesWidth
          ) {
            width = parent.offsetWidth;
            parent = parent.parentNode;
          }

          return width;
        };

        var rAF = (function () {
          var running, waiting;
          var firstFns = [];
          var secondFns = [];
          var fns = firstFns;

          var run = function () {
            var runFns = fns;

            fns = firstFns.length ? secondFns : firstFns;

            running = true;
            waiting = false;

            while (runFns.length) {
              runFns.shift()();
            }

            running = false;
          };

          var rafBatch = function (fn, queue) {
            if (running && !queue) {
              fn.apply(this, arguments);
            } else {
              fns.push(fn);

              if (!waiting) {
                waiting = true;
                (document.hidden ? setTimeout : requestAnimationFrame)(run);
              }
            }
          };

          rafBatch._lsFlush = run;

          return rafBatch;
        })();

        var rAFIt = function (fn, simple) {
          return simple
            ? function () {
                rAF(fn);
              }
            : function () {
                var that = this;
                var args = arguments;
                rAF(function () {
                  fn.apply(that, args);
                });
              };
        };

        var throttle = function (fn) {
          var running;
          var lastTime = 0;
          var gDelay = lazySizesCfg.throttleDelay;
          var rICTimeout = lazySizesCfg.ricTimeout;
          var run = function () {
            running = false;
            lastTime = Date.now();
            fn();
          };
          var idleCallback =
            requestIdleCallback && rICTimeout > 49
              ? function () {
                  requestIdleCallback(run, { timeout: rICTimeout });

                  if (rICTimeout !== lazySizesCfg.ricTimeout) {
                    rICTimeout = lazySizesCfg.ricTimeout;
                  }
                }
              : rAFIt(function () {
                  setTimeout(run);
                }, true);
          return function (isPriority) {
            var delay;

            if ((isPriority = isPriority === true)) {
              rICTimeout = 33;
            }

            if (running) {
              return;
            }

            running = true;

            delay = gDelay - (Date.now() - lastTime);

            if (delay < 0) {
              delay = 0;
            }

            if (isPriority || delay < 9) {
              idleCallback();
            } else {
              setTimeout(idleCallback, delay);
            }
          };
        };

        //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
        var debounce = function (func) {
          var timeout, timestamp;
          var wait = 99;
          var run = function () {
            timeout = null;
            func();
          };
          var later = function () {
            var last = Date.now() - timestamp;

            if (last < wait) {
              setTimeout(later, wait - last);
            } else {
              (requestIdleCallback || run)(run);
            }
          };

          return function () {
            timestamp = Date.now();

            if (!timeout) {
              timeout = setTimeout(later, wait);
            }
          };
        };

        var loader = (function () {
          var preloadElems,
            isCompleted,
            resetPreloadingTimer,
            loadMode,
            started;

          var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

          var regImg = /^img$/i;
          var regIframe = /^iframe$/i;

          var supportScroll =
            "onscroll" in window && !/(gle|ing)bot/.test(navigator.userAgent);

          var shrinkExpand = 0;
          var currentExpand = 0;

          var isLoading = 0;
          var lowRuns = -1;

          var resetPreloading = function (e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) {
              isLoading = 0;
            }
          };

          var isVisible = function (elem) {
            if (isBodyHidden == null) {
              isBodyHidden = getCSS(document.body, "visibility") == "hidden";
            }

            return (
              isBodyHidden ||
              !(
                getCSS(elem.parentNode, "visibility") == "hidden" &&
                getCSS(elem, "visibility") == "hidden"
              )
            );
          };

          var isNestedVisible = function (elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);

            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;

            while (
              visible &&
              (parent = parent.offsetParent) &&
              parent != document.body &&
              parent != docElem
            ) {
              visible = (getCSS(parent, "opacity") || 1) > 0;

              if (visible && getCSS(parent, "overflow") != "visible") {
                outerRect = parent.getBoundingClientRect();
                visible =
                  eLright > outerRect.left &&
                  eLleft < outerRect.right &&
                  eLbottom > outerRect.top - 1 &&
                  eLtop < outerRect.bottom + 1;
              }
            }

            return visible;
          };

          var checkElements = function () {
            var eLlen,
              i,
              rect,
              autoLoadElem,
              loadedSomething,
              elemExpand,
              elemNegativeExpand,
              elemExpandVal,
              beforeExpandVal,
              defaultExpand,
              preloadExpand,
              hFac;
            var lazyloadElems = lazysizes.elements;

            if (
              (loadMode = lazySizesCfg.loadMode) &&
              isLoading < 8 &&
              (eLlen = lazyloadElems.length)
            ) {
              i = 0;

              lowRuns++;

              for (; i < eLlen; i++) {
                if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
                  continue;
                }

                if (
                  !supportScroll ||
                  (lazysizes.prematureUnveil &&
                    lazysizes.prematureUnveil(lazyloadElems[i]))
                ) {
                  unveilElement(lazyloadElems[i]);
                  continue;
                }

                if (
                  !(elemExpandVal =
                    lazyloadElems[i][_getAttribute]("data-expand")) ||
                  !(elemExpand = elemExpandVal * 1)
                ) {
                  elemExpand = currentExpand;
                }

                if (!defaultExpand) {
                  defaultExpand =
                    !lazySizesCfg.expand || lazySizesCfg.expand < 1
                      ? docElem.clientHeight > 500 &&
                        docElem.clientWidth > 500
                        ? 500
                        : 370
                      : lazySizesCfg.expand;

                  lazysizes._defEx = defaultExpand;

                  preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                  hFac = lazySizesCfg.hFac;
                  isBodyHidden = null;

                  if (
                    currentExpand < preloadExpand &&
                    isLoading < 1 &&
                    lowRuns > 2 &&
                    loadMode > 2 &&
                    !document.hidden
                  ) {
                    currentExpand = preloadExpand;
                    lowRuns = 0;
                  } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
                    currentExpand = defaultExpand;
                  } else {
                    currentExpand = shrinkExpand;
                  }
                }

                if (beforeExpandVal !== elemExpand) {
                  eLvW = innerWidth + elemExpand * hFac;
                  elvH = innerHeight + elemExpand;
                  elemNegativeExpand = elemExpand * -1;
                  beforeExpandVal = elemExpand;
                }

                rect = lazyloadElems[i].getBoundingClientRect();

                if (
                  (eLbottom = rect.bottom) >= elemNegativeExpand &&
                  (eLtop = rect.top) <= elvH &&
                  (eLright = rect.right) >= elemNegativeExpand * hFac &&
                  (eLleft = rect.left) <= eLvW &&
                  (eLbottom || eLright || eLleft || eLtop) &&
                  (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
                  ((isCompleted &&
                    isLoading < 3 &&
                    !elemExpandVal &&
                    (loadMode < 3 || lowRuns < 4)) ||
                    isNestedVisible(lazyloadElems[i], elemExpand))
                ) {
                  unveilElement(lazyloadElems[i]);
                  loadedSomething = true;
                  if (isLoading > 9) {
                    break;
                  }
                } else if (
                  !loadedSomething &&
                  isCompleted &&
                  !autoLoadElem &&
                  isLoading < 4 &&
                  lowRuns < 4 &&
                  loadMode > 2 &&
                  (preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
                  (preloadElems[0] ||
                    (!elemExpandVal &&
                      (eLbottom ||
                        eLright ||
                        eLleft ||
                        eLtop ||
                        lazyloadElems[i][_getAttribute](
                          lazySizesCfg.sizesAttr
                        ) != "auto")))
                ) {
                  autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
              }

              if (autoLoadElem && !loadedSomething) {
                unveilElement(autoLoadElem);
              }
            }
          };

          var throttledCheckElements = throttle(checkElements);

          var switchLoadingClass = function (e) {
            var elem = e.target;

            if (elem._lazyCache) {
              delete elem._lazyCache;
              return;
            }

            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
          };
          var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
          var rafSwitchLoadingClass = function (e) {
            rafedSwitchLoadingClass({ target: e.target });
          };

          var changeIframeSrc = function (elem, src) {
            var loadMode =
              elem.getAttribute("data-load-mode") ||
              lazySizesCfg.iframeLoadMode;

            // loadMode can be also a string!
            if (loadMode == 0) {
              elem.contentWindow.location.replace(src);
            } else if (loadMode == 1) {
              elem.src = src;
            }
          };

          var handleSources = function (source) {
            var customMedia;

            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

            if (
              (customMedia =
                lazySizesCfg.customMedia[
                  source[_getAttribute]("data-media") ||
                    source[_getAttribute]("media")
                ])
            ) {
              source.setAttribute("media", customMedia);
            }

            if (sourceSrcset) {
              source.setAttribute("srcset", sourceSrcset);
            }
          };

          var lazyUnveil = rAFIt(function (
            elem,
            detail,
            isAuto,
            sizes,
            isImg
          ) {
            var src, srcset, parent, isPicture, event, firesLoad;

            if (
              !(event = triggerEvent(elem, "lazybeforeunveil", detail))
                .defaultPrevented
            ) {
              if (sizes) {
                if (isAuto) {
                  addClass(elem, lazySizesCfg.autosizesClass);
                } else {
                  elem.setAttribute("sizes", sizes);
                }
              }

              srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
              src = elem[_getAttribute](lazySizesCfg.srcAttr);

              if (isImg) {
                parent = elem.parentNode;
                isPicture = parent && regPicture.test(parent.nodeName || "");
              }

              firesLoad =
                detail.firesLoad ||
                ("src" in elem && (srcset || src || isPicture));

              event = { target: elem };

              addClass(elem, lazySizesCfg.loadingClass);

              if (firesLoad) {
                clearTimeout(resetPreloadingTimer);
                resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
              }

              if (isPicture) {
                forEach.call(
                  parent.getElementsByTagName("source"),
                  handleSources
                );
              }

              if (srcset) {
                elem.setAttribute("srcset", srcset);
              } else if (src && !isPicture) {
                if (regIframe.test(elem.nodeName)) {
                  changeIframeSrc(elem, src);
                } else {
                  elem.src = src;
                }
              }

              if (isImg && (srcset || isPicture)) {
                updatePolyfill(elem, { src: src });
              }
            }

            if (elem._lazyRace) {
              delete elem._lazyRace;
            }
            removeClass(elem, lazySizesCfg.lazyClass);

            rAF(function () {
              // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
              var isLoaded = elem.complete && elem.naturalWidth > 1;

              if (!firesLoad || isLoaded) {
                if (isLoaded) {
                  addClass(elem, lazySizesCfg.fastLoadedClass);
                }
                switchLoadingClass(event);
                elem._lazyCache = true;
                setTimeout(function () {
                  if ("_lazyCache" in elem) {
                    delete elem._lazyCache;
                  }
                }, 9);
              }
              if (elem.loading == "lazy") {
                isLoading--;
              }
            }, true);
          });

          /**
           *
           * @param elem { Element }
           */
          var unveilElement = function (elem) {
            if (elem._lazyRace) {
              return;
            }
            var detail;

            var isImg = regImg.test(elem.nodeName);

            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes =
              isImg &&
              (elem[_getAttribute](lazySizesCfg.sizesAttr) ||
                elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";

            if (
              (isAuto || !isCompleted) &&
              isImg &&
              (elem[_getAttribute]("src") || elem.srcset) &&
              !elem.complete &&
              !hasClass(elem, lazySizesCfg.errorClass) &&
              hasClass(elem, lazySizesCfg.lazyClass)
            ) {
              return;
            }

            detail = triggerEvent(elem, "lazyunveilread").detail;

            if (isAuto) {
              autoSizer.updateElem(elem, true, elem.offsetWidth);
            }

            elem._lazyRace = true;
            isLoading++;

            lazyUnveil(elem, detail, isAuto, sizes, isImg);
          };

          var afterScroll = debounce(function () {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
          });

          var altLoadmodeScrollListner = function () {
            if (lazySizesCfg.loadMode == 3) {
              lazySizesCfg.loadMode = 2;
            }
            afterScroll();
          };

          var onload = function () {
            if (isCompleted) {
              return;
            }
            if (Date.now() - started < 999) {
              setTimeout(onload, 999);
              return;
            }

            isCompleted = true;

            lazySizesCfg.loadMode = 3;

            throttledCheckElements();

            addEventListener("scroll", altLoadmodeScrollListner, true);
          };

          return {
            _: function () {
              started = Date.now();

              lazysizes.elements = document.getElementsByClassName(
                lazySizesCfg.lazyClass
              );
              preloadElems = document.getElementsByClassName(
                lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass
              );

              addEventListener("scroll", throttledCheckElements, true);

              addEventListener("resize", throttledCheckElements, true);

              addEventListener("pageshow", function (e) {
                if (e.persisted) {
                  var loadingElements = document.querySelectorAll(
                    "." + lazySizesCfg.loadingClass
                  );

                  if (loadingElements.length && loadingElements.forEach) {
                    requestAnimationFrame(function () {
                      loadingElements.forEach(function (img) {
                        if (img.complete) {
                          unveilElement(img);
                        }
                      });
                    });
                  }
                }
              });

              if (window.MutationObserver) {
                new MutationObserver(throttledCheckElements).observe(
                  docElem,
                  { childList: true, subtree: true, attributes: true }
                );
              } else {
                docElem[_addEventListener](
                  "DOMNodeInserted",
                  throttledCheckElements,
                  true
                );
                docElem[_addEventListener](
                  "DOMAttrModified",
                  throttledCheckElements,
                  true
                );
                setInterval(throttledCheckElements, 999);
              }

              addEventListener("hashchange", throttledCheckElements, true);

              //, 'fullscreenchange'
              [
                "focus",
                "mouseover",
                "click",
                "load",
                "transitionend",
                "animationend",
              ].forEach(function (name) {
                document[_addEventListener](
                  name,
                  throttledCheckElements,
                  true
                );
              });

              if (/d$|^c/.test(document.readyState)) {
                onload();
              } else {
                addEventListener("load", onload);
                document[_addEventListener](
                  "DOMContentLoaded",
                  throttledCheckElements
                );
                setTimeout(onload, 20000);
              }

              if (lazysizes.elements.length) {
                checkElements();
                rAF._lsFlush();
              } else {
                throttledCheckElements();
              }
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner,
          };
        })();

        var autoSizer = (function () {
          var autosizesElems;

          var sizeElement = rAFIt(function (elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";

            elem.setAttribute("sizes", width);

            if (regPicture.test(parent.nodeName || "")) {
              sources = parent.getElementsByTagName("source");
              for (i = 0, len = sources.length; i < len; i++) {
                sources[i].setAttribute("sizes", width);
              }
            }

            if (!event.detail.dataAttr) {
              updatePolyfill(elem, event.detail);
            }
          });
          /**
           *
           * @param elem {Element}
           * @param dataAttr
           * @param [width] { number }
           */
          var getSizeElement = function (elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;

            if (parent) {
              width = getWidth(elem, parent, width);
              event = triggerEvent(elem, "lazybeforesizes", {
                width: width,
                dataAttr: !!dataAttr,
              });

              if (!event.defaultPrevented) {
                width = event.detail.width;

                if (width && width !== elem._lazysizesWidth) {
                  sizeElement(elem, parent, event, width);
                }
              }
            }
          };

          var updateElementsSizes = function () {
            var i;
            var len = autosizesElems.length;
            if (len) {
              i = 0;

              for (; i < len; i++) {
                getSizeElement(autosizesElems[i]);
              }
            }
          };

          var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

          return {
            _: function () {
              autosizesElems = document.getElementsByClassName(
                lazySizesCfg.autosizesClass
              );
              addEventListener("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement,
          };
        })();

        var init = function () {
          if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
          }
        };

        setTimeout(function () {
          if (lazySizesCfg.init) {
            init();
          }
        });

        lazysizes = {
          /**
           * @type { LazySizesConfigPartial }
           */
          cfg: lazySizesCfg,
          autoSizer: autoSizer,
          loader: loader,
          init: init,
          uP: updatePolyfill,
          aC: addClass,
          rC: removeClass,
          hC: hasClass,
          fire: triggerEvent,
          gW: getWidth,
          rAF: rAF,
        };

        return lazysizes;
      }
    );

    /***/
  },
  /* 3 */
  /***/ function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "c", function () {
      return /* binding */ getState;
    });
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return /* binding */ addItem;
    });
    __webpack_require__.d(__webpack_exports__, "b", function () {
      return /* binding */ addItemFromForm;
    });
    __webpack_require__.d(__webpack_exports__, "d", function () {
      return /* binding */ updateItem;
    });
    __webpack_require__.d(__webpack_exports__, "e", function () {
      return /* binding */ updateNote;
    });

    // UNUSED EXPORTS: getItemIndex, getItem, removeItem, clearItems, getAttributes, updateAttributes, clearAttributes, getNote, clearNote, getShippingRates

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-cart/request.js
    function getDefaultRequestConfig() {
      return JSON.parse(
        JSON.stringify({
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;",
          },
        })
      );
    }

    function fetchJSON(url, config) {
      return fetch(url, config).then(function (response) {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      });
    }

    function cart() {
      return fetchJSON("/cart.js", getDefaultRequestConfig());
    }

    function cartAdd(id, quantity, properties) {
      var config = getDefaultRequestConfig();

      config.method = "POST";
      config.body = JSON.stringify({
        id: id,
        quantity: quantity,
        properties: properties,
      });

      return fetchJSON("/cart/add.js", config);
    }

    function cartAddFromForm(formData) {
      var config = getDefaultRequestConfig();
      delete config.headers["Content-Type"];

      config.method = "POST";
      config.body = formData;

      return fetchJSON("/cart/add.js", config);
    }

    function cartChange(line, options) {
      var config = getDefaultRequestConfig();

      options = options || {};

      config.method = "POST";
      config.body = JSON.stringify({
        line: line,
        quantity: options.quantity,
        properties: options.properties,
      });

      return fetchJSON("/cart/change.js", config);
    }

    function cartClear() {
      var config = getDefaultRequestConfig();
      config.method = "POST";

      return fetchJSON("/cart/clear.js", config);
    }

    function cartUpdate(body) {
      var config = getDefaultRequestConfig();

      config.method = "POST";
      config.body = JSON.stringify(body);

      return fetchJSON("/cart/update.js", config);
    }

    function cartShippingRates() {
      return fetchJSON(
        "/cart/shipping_rates.json",
        getDefaultRequestConfig()
      );
    }

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-cart/validate.js
    function validate_key(key) {
      if (typeof key !== "string" || key.split(":").length !== 2) {
        throw new TypeError(
          "Theme Cart: Provided key value is not a string with the format xxx:xxx"
        );
      }
    }

    function quantity(quantity) {
      if (typeof quantity !== "number" || isNaN(quantity)) {
        throw new TypeError(
          "Theme Cart: An object which specifies a quantity or properties value is required"
        );
      }
    }

    function validate_id(id) {
      if (typeof id !== "number" || isNaN(id)) {
        throw new TypeError("Theme Cart: Variant ID must be a number");
      }
    }

    function properties(properties) {
      if (typeof properties !== "object") {
        throw new TypeError("Theme Cart: Properties must be an object");
      }
    }

    function validate_form(form) {
      if (!(form instanceof HTMLFormElement)) {
        throw new TypeError(
          "Theme Cart: Form must be an instance of HTMLFormElement"
        );
      }
    }

    function validate_options(options) {
      if (typeof options !== "object") {
        throw new TypeError("Theme Cart: Options must be an object");
      }

      if (
        typeof options.quantity === "undefined" &&
        typeof options.properties === "undefined"
      ) {
        throw new Error(
          "Theme Cart: You muse define a value for quantity or properties"
        );
      }

      if (typeof options.quantity !== "undefined") {
        quantity(options.quantity);
      }

      if (typeof options.properties !== "undefined") {
        properties(options.properties);
      }
    }

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-cart/theme-cart.js
    /**
     * Cart Template Script
     * ------------------------------------------------------------------------------
     * A file that contains scripts highly couple code to the Cart template.
     *
     * @namespace cart
     */

    /**
     * Returns the state object of the cart
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function getState() {
      return cart();
    }

    /**
     * Returns the index of the cart line item
     * @param {string} key The unique key of the line item
     * @returns {Promise} Resolves with the index number of the line item
     */
    function getItemIndex(key) {
      validate_key(key);

      return cart().then(function (state) {
        var index = -1;

        state.items.forEach(function (item, i) {
          index = item.key === key ? i + 1 : index;
        });

        if (index === -1) {
          return Promise.reject(
            new Error(
              "Theme Cart: Unable to match line item with provided key"
            )
          );
        }

        return index;
      });
    }

    /**
     * Fetches the line item object
     * @param {string} key The unique key of the line item
     * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
     */
    function getItem(key) {
      validate_key(key);

      return cart().then(function (state) {
        var lineItem = null;

        state.items.forEach(function (item) {
          lineItem = item.key === key ? item : lineItem;
        });

        if (lineItem === null) {
          return Promise.reject(
            new Error(
              "Theme Cart: Unable to match line item with provided key"
            )
          );
        }

        return lineItem;
      });
    }

    /**
     * Add a new line item to the cart
     * @param {number} id The variant's unique ID
     * @param {object} options Optional values to pass to /cart/add.js
     * @param {number} options.quantity The quantity of items to be added to the cart
     * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
     * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
     */
    function addItem(id, options) {
      options = options || {};

      validate_id(id);

      return cartAdd(id, options.quantity, options.properties);
    }

    /**
     * Add a new line item to the cart from a product form
     * @param {object} form DOM element which is equal to the <form> node
     * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
     */
    function addItemFromForm(form) {
      validate_form(form);

      var formData = new FormData(form);
      validate_id(parseInt(formData.get("id"), 10));

      return cartAddFromForm(formData);
    }

    /**
     * Changes the quantity and/or properties of an existing line item.
     * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
     * @param {object} options Optional values to pass to /cart/add.js
     * @param {number} options.quantity The quantity of items to be added to the cart
     * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function updateItem(key, options) {
      validate_key(key);
      validate_options(options);

      return getItemIndex(key).then(function (line) {
        return cartChange(line, options);
      });
    }

    /**
     * Removes a line item from the cart
     * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function removeItem(key) {
      validate_key(key);

      return getItemIndex(key).then(function (line) {
        return cartChange(line, { quantity: 0 });
      });
    }

    /**
     * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function clearItems() {
      return cartClear();
    }

    /**
     * Gets all cart attributes
     * @returns {Promise} Resolves with the cart attributes object
     */
    function getAttributes() {
      return cart().then(function (state) {
        return state.attributes;
      });
    }

    /**
     * Sets all cart attributes
     * @returns {Promise} Resolves with the cart state object
     */
    function updateAttributes(attributes) {
      return cartUpdate({ attributes: attributes });
    }

    /**
     * Clears all cart attributes
     * @returns {Promise} Resolves with the cart state object
     */
    function clearAttributes() {
      return getAttributes().then(function (attributes) {
        for (var key in attributes) {
          attributes[key] = "";
        }
        return updateAttributes(attributes);
      });
    }

    /**
     * Gets cart note
     * @returns {Promise} Resolves with the cart note string
     */
    function getNote() {
      return cart().then(function (state) {
        return state.note;
      });
    }

    /**
     * Sets cart note
     * @returns {Promise} Resolves with the cart state object
     */
    function updateNote(note) {
      return cartUpdate({ note: note });
    }

    /**
     * Clears cart note
     * @returns {Promise} Resolves with the cart state object
     */
    function clearNote() {
      return cartUpdate({ note: "" });
    }

    /**
     * Get estimated shipping rates.
     * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
     */
    function getShippingRates() {
      return cartShippingRates();
    }

    /***/
  },
  /* 4 */
  /***/ function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__(6),
      now = __webpack_require__(23),
      toNumber = __webpack_require__(14);

    /** Error message constants. */
    var FUNC_ERROR_TEXT = "Expected a function";

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max,
      nativeMin = Math.min;

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;

      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing
          ? nativeMax(toNumber(options.maxWait) || 0, wait)
          : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
          thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime,
          timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (
          lastCallTime === undefined ||
          timeSinceLastCall >= wait ||
          timeSinceLastCall < 0 ||
          (maxing && timeSinceLastInvoke >= maxWait)
        );
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
          isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    module.exports = debounce;

    /***/
  },
  /* 5 */
  /***/ function (module, __webpack_exports__, __webpack_require__) {
    "use strict";
    const LibraryLoader = (function () {
      const types = {
        link: "link",
        script: "script",
      };

      const status = {
        requested: "requested",
        loaded: "loaded",
      };

      const cloudCdn = "https://cdn.shopify.com/shopifycloud/";

      const libraries = {
        youtubeSdk: {
          tagId: "youtube-sdk",
          src: "https://www.youtube.com/iframe_api",
          type: types.script,
        },
        vimeoSdk: {
          tagId: "vimeo-sdk",
          src: "https://player.vimeo.com/api/player.js",
          type: types.script,
        },
        plyrShopifyStyles: {
          tagId: "plyr-shopify-styles",
          src: cloudCdn + "plyr/v2.0/shopify-plyr.css",
          type: types.link,
        },
        shopifyXr: {
          tagId: "shopify-model-viewer-xr",
          src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
          type: types.script,
        },
        modelViewerUi: {
          tagId: "shopify-model-viewer-ui",
          src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
          type: types.script,
        },
        modelViewerUiStyles: {
          tagId: "shopify-model-viewer-ui-styles",
          src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
          type: types.link,
        },
      };

      function load(libraryName, callback) {
        const library = libraries[libraryName];

        if (!library) return;
        if (library.status === status.requested) return;

        callback = callback || function () {};
        if (library.status === status.loaded) {
          callback();
          return;
        }

        library.status = status.requested;

        let tag;

        switch (library.type) {
          case types.script:
            tag = createScriptTag(library, callback);
            break;
          case types.link:
            tag = createLinkTag(library, callback);
            break;
        }

        tag.id = library.tagId;
        library.element = tag;

        const firstScriptTag = document.getElementsByTagName(library.type)[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }

      function createScriptTag(library, callback) {
        const tag = document.createElement("script");
        tag.src = library.src;
        tag.addEventListener("load", function () {
          library.status = status.loaded;
          callback();
        });
        return tag;
      }

      function createLinkTag(library, callback) {
        const tag = document.createElement("link");
        tag.href = library.src;
        tag.rel = "stylesheet";
        tag.type = "text/css";
        tag.addEventListener("load", function () {
          library.status = status.loaded;
          callback();
        });
        return tag;
      }

      return {
        load: load,
      };
    })();

    /* harmony default export */ __webpack_exports__["a"] = LibraryLoader;

    /***/
  },
  /* 6 */
  /***/ function (module, exports) {
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }

    module.exports = isObject;

    /***/
  },
  /* 7 */
  /***/ function (module, exports, __webpack_require__) {
    var freeGlobal = __webpack_require__(16);

    /** Detect free variable `self`. */
    var freeSelf =
      typeof self == "object" && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function("return this")();

    module.exports = root;

    /***/
  },
  /* 8 */
  /***/ function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true,
    });
    exports.preload = preload;
    exports.loadImage = loadImage;
    exports.imageSize = imageSize;
    exports.getSizedImageUrl = getSizedImageUrl;
    exports.removeProtocol = removeProtocol;
    /**
     * Image Helper Functions
     * -----------------------------------------------------------------------------
     * https://github.com/Shopify/slate.git.
     *
     */

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
      if (typeof images === "string") {
        images = [images];
      }

      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        loadImage(getSizedImageUrl(image, size));
      }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }

      if (size === "master") {
        return removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return removeProtocol(prefix[0] + "_" + size + suffix);
      } else {
        return null;
      }
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    /***/
  },
  /* 9 */
  /***/ function (module, exports, __webpack_require__) {
    var root = __webpack_require__(7);

    /** Built-in value references. */
    var Symbol = root.Symbol;

    module.exports = Symbol;

    /***/
  },
  /* 10 */
  /***/ function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true,
    });
    exports.formatMoney = formatMoney;
    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     */

    var moneyFormat = "${{amount}}";

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number) {
        var precision =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : 2;
        var thousands =
          arguments.length > 2 && arguments[2] !== undefined
            ? arguments[2]
            : ",";
        var decimal =
          arguments.length > 3 && arguments[3] !== undefined
            ? arguments[3]
            : ".";

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    /***/
  },
  /* 11 */
  /***/ function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */
    (function (factory) {
      var registeredInModuleLoader;
      if (true) {
        !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
        (__WEBPACK_AMD_DEFINE_RESULT__ =
          typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
            ? __WEBPACK_AMD_DEFINE_FACTORY__.call(
                exports,
                __webpack_require__,
                exports,
                module
              )
            : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
          (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        registeredInModuleLoader = true;
      }
      if (true) {
        module.exports = factory();
        registeredInModuleLoader = true;
      }
      if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = (window.Cookies = factory());
        api.noConflict = function () {
          window.Cookies = OldCookies;
          return api;
        };
      }
    })(function () {
      function extend() {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
          var attributes = arguments[i];
          for (var key in attributes) {
            result[key] = attributes[key];
          }
        }
        return result;
      }

      function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }

      function init(converter) {
        function api() {}

        function set(key, value, attributes) {
          if (typeof document === "undefined") {
            return;
          }

          attributes = extend(
            {
              path: "/",
            },
            api.defaults,
            attributes
          );

          if (typeof attributes.expires === "number") {
            attributes.expires = new Date(
              new Date() * 1 + attributes.expires * 864e5
            );
          }

          // We're using "expires" because "max-age" is not supported by IE
          attributes.expires = attributes.expires
            ? attributes.expires.toUTCString()
            : "";

          try {
            var result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {}

          value = converter.write
            ? converter.write(value, key)
            : encodeURIComponent(String(value)).replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent
              );

          key = encodeURIComponent(String(key))
            .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
            .replace(/[\(\)]/g, escape);

          var stringifiedAttributes = "";
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
              continue;
            }
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) {
              continue;
            }

            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes +=
              "=" + attributes[attributeName].split(";")[0];
          }

          return (document.cookie =
            key + "=" + value + stringifiedAttributes);
        }

        function get(key, json) {
          if (typeof document === "undefined") {
            return;
          }

          var jar = {};
          // To prevent the for loop in the first place assign an empty array
          // in case there are no cookies at all.
          var cookies = document.cookie ? document.cookie.split("; ") : [];
          var i = 0;

          for (; i < cookies.length; i++) {
            var parts = cookies[i].split("=");
            var cookie = parts.slice(1).join("=");

            if (!json && cookie.charAt(0) === '"') {
              cookie = cookie.slice(1, -1);
            }

            try {
              var name = decode(parts[0]);
              cookie =
                (converter.read || converter)(cookie, name) || decode(cookie);

              if (json) {
                try {
                  cookie = JSON.parse(cookie);
                } catch (e) {}
              }

              jar[name] = cookie;

              if (key === name) {
                break;
              }
            } catch (e) {}
          }

          return key ? jar[key] : jar;
        }

        api.set = set;
        api.get = function (key) {
          return get(key, false /* read as raw */);
        };
        api.getJSON = function (key) {
          return get(key, true /* read as json */);
        };
        api.remove = function (key, attributes) {
          set(
            key,
            "",
            extend(attributes, {
              expires: -1,
            })
          );
        };

        api.defaults = {};

        api.withConverter = init;

        return api;
      }

      return init(function () {});
    });

    /***/
  },
  /* 12 */
  /***/ function (module, exports) {
    var g;

    // This works in non-strict mode
    g = (function () {
      return this;
    })();

    try {
      // This works if eval is allowed (see CSP)
      g = g || new Function("return this")();
    } catch (e) {
      // This works if the window reference is available
      if (typeof window === "object") g = window;
    }

    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}

    module.exports = g;

    /***/
  },
  /* 13 */
  /***/ function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(9),
      getRawTag = __webpack_require__(17),
      objectToString = __webpack_require__(18);

    /** `Object#toString` result references. */
    var nullTag = "[object Null]",
      undefinedTag = "[object Undefined]";

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value)
        ? getRawTag(value)
        : objectToString(value);
    }

    module.exports = baseGetTag;

    /***/
  },
  /* 14 */
  /***/ function (module, exports, __webpack_require__) {
    var baseTrim = __webpack_require__(19),
      isObject = __webpack_require__(6),
      isSymbol = __webpack_require__(21);

    /** Used as references for various `Number` constants. */
    var NAN = 0 / 0;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Built-in method references without a dependency on `root`. */
    var freeParseInt = parseInt;

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other =
          typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value)
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : reIsBadHex.test(value)
        ? NAN
        : +value;
    }

    module.exports = toNumber;

    /***/
  },
  /* 15 */
  /***/ function (module, exports, __webpack_require__) {
    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
    
    /*!
     * Splide.js
     * Version  : 4.1.2
     * License  : MIT
     * Copyright: 2022 Naotoshi Fujita
     */
    (function (global, factory) {
      typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Splide = factory());
    })(this, function () {
      'use strict';
    
      var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
      var CREATED = 1;
      var MOUNTED = 2;
      var IDLE = 3;
      var MOVING = 4;
      var SCROLLING = 5;
      var DRAGGING = 6;
      var DESTROYED = 7;
      var STATES = {
        CREATED: CREATED,
        MOUNTED: MOUNTED,
        IDLE: IDLE,
        MOVING: MOVING,
        SCROLLING: SCROLLING,
        DRAGGING: DRAGGING,
        DESTROYED: DESTROYED
      };
    
      function empty(array) {
        array.length = 0;
      }
    
      function slice(arrayLike, start, end) {
        return Array.prototype.slice.call(arrayLike, start, end);
      }
    
      function apply(func) {
        return func.bind.apply(func, [null].concat(slice(arguments, 1)));
      }
    
      var nextTick = setTimeout;
    
      var noop = function noop() {};
    
      function raf(func) {
        return requestAnimationFrame(func);
      }
    
      function typeOf(type, subject) {
        return typeof subject === type;
      }
    
      function isObject(subject) {
        return !isNull(subject) && typeOf("object", subject);
      }
    
      var isArray = Array.isArray;
      var isFunction = apply(typeOf, "function");
      var isString = apply(typeOf, "string");
      var isUndefined = apply(typeOf, "undefined");
    
      function isNull(subject) {
        return subject === null;
      }
    
      function isHTMLElement(subject) {
        try {
          return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
        } catch (e) {
          return false;
        }
      }
    
      function toArray(value) {
        return isArray(value) ? value : [value];
      }
    
      function forEach(values, iteratee) {
        toArray(values).forEach(iteratee);
      }
    
      function includes(array, value) {
        return array.indexOf(value) > -1;
      }
    
      function push(array, items) {
        array.push.apply(array, toArray(items));
        return array;
      }
    
      function toggleClass(elm, classes, add) {
        if (elm) {
          forEach(classes, function (name) {
            if (name) {
              elm.classList[add ? "add" : "remove"](name);
            }
          });
        }
      }
    
      function addClass(elm, classes) {
        toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
      }
    
      function append(parent, children) {
        forEach(children, parent.appendChild.bind(parent));
      }
    
      function before(nodes, ref) {
        forEach(nodes, function (node) {
          var parent = (ref || node).parentNode;
    
          if (parent) {
            parent.insertBefore(node, ref);
          }
        });
      }
    
      function matches(elm, selector) {
        return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
      }
    
      function children(parent, selector) {
        var children2 = parent ? slice(parent.children) : [];
        return selector ? children2.filter(function (child) {
          return matches(child, selector);
        }) : children2;
      }
    
      function child(parent, selector) {
        return selector ? children(parent, selector)[0] : parent.firstElementChild;
      }
    
      var ownKeys = Object.keys;
    
      function forOwn(object, iteratee, right) {
        if (object) {
          (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function (key) {
            key !== "__proto__" && iteratee(object[key], key);
          });
        }
    
        return object;
      }
    
      function assign(object) {
        slice(arguments, 1).forEach(function (source) {
          forOwn(source, function (value, key) {
            object[key] = source[key];
          });
        });
        return object;
      }
    
      function merge(object) {
        slice(arguments, 1).forEach(function (source) {
          forOwn(source, function (value, key) {
            if (isArray(value)) {
              object[key] = value.slice();
            } else if (isObject(value)) {
              object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
            } else {
              object[key] = value;
            }
          });
        });
        return object;
      }
    
      function omit(object, keys) {
        forEach(keys || ownKeys(object), function (key) {
          delete object[key];
        });
      }
    
      function removeAttribute(elms, attrs) {
        forEach(elms, function (elm) {
          forEach(attrs, function (attr) {
            elm && elm.removeAttribute(attr);
          });
        });
      }
    
      function setAttribute(elms, attrs, value) {
        if (isObject(attrs)) {
          forOwn(attrs, function (value2, name) {
            setAttribute(elms, name, value2);
          });
        } else {
          forEach(elms, function (elm) {
            isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
          });
        }
      }
    
      function create(tag, attrs, parent) {
        var elm = document.createElement(tag);
    
        if (attrs) {
          isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
        }
    
        parent && append(parent, elm);
        return elm;
      }
    
      function style(elm, prop, value) {
        if (isUndefined(value)) {
          return getComputedStyle(elm)[prop];
        }
    
        if (!isNull(value)) {
          elm.style[prop] = "" + value;
        }
      }
    
      function display(elm, display2) {
        style(elm, "display", display2);
      }
    
      function focus(elm) {
        elm["setActive"] && elm["setActive"]() || elm.focus({
          preventScroll: true
        });
      }
    
      function getAttribute(elm, attr) {
        return elm.getAttribute(attr);
      }
    
      function hasClass(elm, className) {
        return elm && elm.classList.contains(className);
      }
    
      function rect(target) {
        return target.getBoundingClientRect();
      }
    
      function remove(nodes) {
        forEach(nodes, function (node) {
          if (node && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
      }
    
      function parseHtml(html) {
        return child(new DOMParser().parseFromString(html, "text/html").body);
      }
    
      function prevent(e, stopPropagation) {
        e.preventDefault();
    
        if (stopPropagation) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    
      function query(parent, selector) {
        return parent && parent.querySelector(selector);
      }
    
      function queryAll(parent, selector) {
        return selector ? slice(parent.querySelectorAll(selector)) : [];
      }
    
      function removeClass(elm, classes) {
        toggleClass(elm, classes, false);
      }
    
      function timeOf(e) {
        return e.timeStamp;
      }
    
      function unit(value) {
        return isString(value) ? value : value ? value + "px" : "";
      }
    
      var PROJECT_CODE = "splide";
      var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
    
      function assert(condition, message) {
        if (!condition) {
          throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
        }
      }
    
      var min = Math.min,
          max = Math.max,
          floor = Math.floor,
          ceil = Math.ceil,
          abs = Math.abs;
    
      function approximatelyEqual(x, y, epsilon) {
        return abs(x - y) < epsilon;
      }
    
      function between(number, x, y, exclusive) {
        var minimum = min(x, y);
        var maximum = max(x, y);
        return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
      }
    
      function clamp(number, x, y) {
        var minimum = min(x, y);
        var maximum = max(x, y);
        return min(max(minimum, number), maximum);
      }
    
      function sign(x) {
        return +(x > 0) - +(x < 0);
      }
    
      function format(string, replacements) {
        forEach(replacements, function (replacement) {
          string = string.replace("%s", "" + replacement);
        });
        return string;
      }
    
      function pad(number) {
        return number < 10 ? "0" + number : "" + number;
      }
    
      var ids = {};
    
      function uniqueId(prefix) {
        return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
      }
    
      function EventBinder() {
        var listeners = [];
    
        function bind(targets, events, callback, options) {
          forEachEvent(targets, events, function (target, event, namespace) {
            var isEventTarget = ("addEventListener" in target);
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([target, event, namespace, callback, remover]);
          });
        }
    
        function unbind(targets, events, callback) {
          forEachEvent(targets, events, function (target, event, namespace) {
            listeners = listeners.filter(function (listener) {
              if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                listener[4]();
                return false;
              }
    
              return true;
            });
          });
        }
    
        function dispatch(target, type, detail) {
          var e;
          var bubbles = true;
    
          if (typeof CustomEvent === "function") {
            e = new CustomEvent(type, {
              bubbles: bubbles,
              detail: detail
            });
          } else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
          }
    
          target.dispatchEvent(e);
          return e;
        }
    
        function forEachEvent(targets, events, iteratee) {
          forEach(targets, function (target) {
            target && forEach(events, function (events2) {
              events2.split(" ").forEach(function (eventNS) {
                var fragment = eventNS.split(".");
                iteratee(target, fragment[0], fragment[1]);
              });
            });
          });
        }
    
        function destroy() {
          listeners.forEach(function (data) {
            data[4]();
          });
          empty(listeners);
        }
    
        return {
          bind: bind,
          unbind: unbind,
          dispatch: dispatch,
          destroy: destroy
        };
      }
    
      var EVENT_MOUNTED = "mounted";
      var EVENT_READY = "ready";
      var EVENT_MOVE = "move";
      var EVENT_MOVED = "moved";
      var EVENT_CLICK = "click";
      var EVENT_ACTIVE = "active";
      var EVENT_INACTIVE = "inactive";
      var EVENT_VISIBLE = "visible";
      var EVENT_HIDDEN = "hidden";
      var EVENT_REFRESH = "refresh";
      var EVENT_UPDATED = "updated";
      var EVENT_RESIZE = "resize";
      var EVENT_RESIZED = "resized";
      var EVENT_DRAG = "drag";
      var EVENT_DRAGGING = "dragging";
      var EVENT_DRAGGED = "dragged";
      var EVENT_SCROLL = "scroll";
      var EVENT_SCROLLED = "scrolled";
      var EVENT_OVERFLOW = "overflow";
      var EVENT_DESTROY = "destroy";
      var EVENT_ARROWS_MOUNTED = "arrows:mounted";
      var EVENT_ARROWS_UPDATED = "arrows:updated";
      var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
      var EVENT_PAGINATION_UPDATED = "pagination:updated";
      var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
      var EVENT_AUTOPLAY_PLAY = "autoplay:play";
      var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
      var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
      var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
      var EVENT_SLIDE_KEYDOWN = "sk";
      var EVENT_SHIFTED = "sh";
      var EVENT_END_INDEX_CHANGED = "ei";
    
      function EventInterface(Splide2) {
        var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
        var binder = EventBinder();
    
        function on(events, callback) {
          binder.bind(bus, toArray(events).join(" "), function (e) {
            callback.apply(callback, isArray(e.detail) ? e.detail : []);
          });
        }
    
        function emit(event) {
          binder.dispatch(bus, event, slice(arguments, 1));
        }
    
        if (Splide2) {
          Splide2.event.on(EVENT_DESTROY, binder.destroy);
        }
    
        return assign(binder, {
          bus: bus,
          on: on,
          off: apply(binder.unbind, bus),
          emit: emit
        });
      }
    
      function RequestInterval(interval, onInterval, onUpdate, limit) {
        var now = Date.now;
        var startTime;
        var rate = 0;
        var id;
        var paused = true;
        var count = 0;
    
        function update() {
          if (!paused) {
            rate = interval ? min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
    
            if (rate >= 1) {
              onInterval();
              startTime = now();
    
              if (limit && ++count >= limit) {
                return pause();
              }
            }
    
            id = raf(update);
          }
        }
    
        function start(resume) {
          resume || cancel();
          startTime = now() - (resume ? rate * interval : 0);
          paused = false;
          id = raf(update);
        }
    
        function pause() {
          paused = true;
        }
    
        function rewind() {
          startTime = now();
          rate = 0;
    
          if (onUpdate) {
            onUpdate(rate);
          }
        }
    
        function cancel() {
          id && cancelAnimationFrame(id);
          rate = 0;
          id = 0;
          paused = true;
        }
    
        function set(time) {
          interval = time;
        }
    
        function isPaused() {
          return paused;
        }
    
        return {
          start: start,
          rewind: rewind,
          pause: pause,
          cancel: cancel,
          set: set,
          isPaused: isPaused
        };
      }
    
      function State(initialState) {
        var state = initialState;
    
        function set(value) {
          state = value;
        }
    
        function is(states) {
          return includes(toArray(states), state);
        }
    
        return {
          set: set,
          is: is
        };
      }
    
      function Throttle(func, duration) {
        var interval = RequestInterval(duration || 0, func, null, 1);
        return function () {
          interval.isPaused() && interval.start();
        };
      }
    
      function Media(Splide2, Components2, options) {
        var state = Splide2.state;
        var breakpoints = options.breakpoints || {};
        var reducedMotion = options.reducedMotion || {};
        var binder = EventBinder();
        var queries = [];
    
        function setup() {
          var isMin = options.mediaQuery === "min";
          ownKeys(breakpoints).sort(function (n, m) {
            return isMin ? +n - +m : +m - +n;
          }).forEach(function (key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
          });
          register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
          update();
        }
    
        function destroy(completely) {
          if (completely) {
            binder.destroy();
          }
        }
    
        function register(options2, query) {
          var queryList = matchMedia(query);
          binder.bind(queryList, "change", update);
          queries.push([options2, queryList]);
        }
    
        function update() {
          var destroyed = state.is(DESTROYED);
          var direction = options.direction;
          var merged = queries.reduce(function (merged2, entry) {
            return merge(merged2, entry[1].matches ? entry[0] : {});
          }, {});
          omit(options);
          set(merged);
    
          if (options.destroy) {
            Splide2.destroy(options.destroy === "completely");
          } else if (destroyed) {
            destroy(true);
            Splide2.mount();
          } else {
            direction !== options.direction && Splide2.refresh();
          }
        }
    
        function reduce(enable) {
          if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
            enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
          }
        }
    
        function set(opts, base, notify) {
          merge(options, opts);
          base && merge(Object.getPrototypeOf(options), opts);
    
          if (notify || !state.is(CREATED)) {
            Splide2.emit(EVENT_UPDATED, options);
          }
        }
    
        return {
          setup: setup,
          destroy: destroy,
          reduce: reduce,
          set: set
        };
      }
    
      var ARROW = "Arrow";
      var ARROW_LEFT = ARROW + "Left";
      var ARROW_RIGHT = ARROW + "Right";
      var ARROW_UP = ARROW + "Up";
      var ARROW_DOWN = ARROW + "Down";
      var RTL = "rtl";
      var TTB = "ttb";
      var ORIENTATION_MAP = {
        width: ["height"],
        left: ["top", "right"],
        right: ["bottom", "left"],
        x: ["y"],
        X: ["Y"],
        Y: ["X"],
        ArrowLeft: [ARROW_UP, ARROW_RIGHT],
        ArrowRight: [ARROW_DOWN, ARROW_LEFT]
      };
    
      function Direction(Splide2, Components2, options) {
        function resolve(prop, axisOnly, direction) {
          direction = direction || options.direction;
          var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
          return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function (match, offset) {
            var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
          });
        }
    
        function orient(value) {
          return value * (options.direction === RTL ? 1 : -1);
        }
    
        return {
          resolve: resolve,
          orient: orient
        };
      }
    
      var ROLE = "role";
      var TAB_INDEX = "tabindex";
      var DISABLED = "disabled";
      var ARIA_PREFIX = "aria-";
      var ARIA_CONTROLS = ARIA_PREFIX + "controls";
      var ARIA_CURRENT = ARIA_PREFIX + "current";
      var ARIA_SELECTED = ARIA_PREFIX + "selected";
      var ARIA_LABEL = ARIA_PREFIX + "label";
      var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
      var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
      var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
      var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
      var ARIA_LIVE = ARIA_PREFIX + "live";
      var ARIA_BUSY = ARIA_PREFIX + "busy";
      var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
      var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
      var CLASS_PREFIX = PROJECT_CODE + "__";
      var STATUS_CLASS_PREFIX = "is-";
      var CLASS_ROOT = PROJECT_CODE;
      var CLASS_TRACK = CLASS_PREFIX + "track";
      var CLASS_LIST = CLASS_PREFIX + "list";
      var CLASS_SLIDE = CLASS_PREFIX + "slide";
      var CLASS_CLONE = CLASS_SLIDE + "--clone";
      var CLASS_CONTAINER = CLASS_SLIDE + "__container";
      var CLASS_ARROWS = CLASS_PREFIX + "arrows";
      var CLASS_ARROW = CLASS_PREFIX + "arrow";
      var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
      var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
      var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
      var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
      var CLASS_PROGRESS = CLASS_PREFIX + "progress";
      var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
      var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
      var CLASS_SPINNER = CLASS_PREFIX + "spinner";
      var CLASS_SR = CLASS_PREFIX + "sr";
      var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
      var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
      var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
      var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
      var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
      var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
      var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
      var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
      var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
      var CLASSES = {
        slide: CLASS_SLIDE,
        clone: CLASS_CLONE,
        arrows: CLASS_ARROWS,
        arrow: CLASS_ARROW,
        prev: CLASS_ARROW_PREV,
        next: CLASS_ARROW_NEXT,
        pagination: CLASS_PAGINATION,
        page: CLASS_PAGINATION_PAGE,
        spinner: CLASS_SPINNER
      };
    
      function closest(from, selector) {
        if (isFunction(from.closest)) {
          return from.closest(selector);
        }
    
        var elm = from;
    
        while (elm && elm.nodeType === 1) {
          if (matches(elm, selector)) {
            break;
          }
    
          elm = elm.parentElement;
        }
    
        return elm;
      }
    
      var FRICTION = 5;
      var LOG_INTERVAL = 200;
      var POINTER_DOWN_EVENTS = "touchstart mousedown";
      var POINTER_MOVE_EVENTS = "touchmove mousemove";
      var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
    
      function Elements(Splide2, Components2, options) {
        var _EventInterface = EventInterface(Splide2),
            on = _EventInterface.on,
            bind = _EventInterface.bind;
    
        var root = Splide2.root;
        var i18n = options.i18n;
        var elements = {};
        var slides = [];
        var rootClasses = [];
        var trackClasses = [];
        var track;
        var list;
        var isUsingKey;
    
        function setup() {
          collect();
          init();
          update();
        }
    
        function mount() {
          on(EVENT_REFRESH, destroy);
          on(EVENT_REFRESH, setup);
          on(EVENT_UPDATED, update);
          bind(document, POINTER_DOWN_EVENTS + " keydown", function (e) {
            isUsingKey = e.type === "keydown";
          }, {
            capture: true
          });
          bind(root, "focusin", function () {
            toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
          });
        }
    
        function destroy(completely) {
          var attrs = ALL_ATTRIBUTES.concat("style");
          empty(slides);
          removeClass(root, rootClasses);
          removeClass(track, trackClasses);
          removeAttribute([track, list], attrs);
          removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
        }
    
        function update() {
          removeClass(root, rootClasses);
          removeClass(track, trackClasses);
          rootClasses = getClasses(CLASS_ROOT);
          trackClasses = getClasses(CLASS_TRACK);
          addClass(root, rootClasses);
          addClass(track, trackClasses);
          setAttribute(root, ARIA_LABEL, options.label);
          setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
        }
    
        function collect() {
          track = find("." + CLASS_TRACK);
          list = child(track, "." + CLASS_LIST);
          assert(track && list, "A track/list element is missing.");
          push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
          forOwn({
            arrows: CLASS_ARROWS,
            pagination: CLASS_PAGINATION,
            prev: CLASS_ARROW_PREV,
            next: CLASS_ARROW_NEXT,
            bar: CLASS_PROGRESS_BAR,
            toggle: CLASS_TOGGLE
          }, function (className, key) {
            elements[key] = find("." + className);
          });
          assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
          });
        }
    
        function init() {
          var id = root.id || uniqueId(PROJECT_CODE);
          var role = options.role;
          root.id = id;
          track.id = track.id || id + "-track";
          list.id = list.id || id + "-list";
    
          if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
            setAttribute(root, ROLE, role);
          }
    
          setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
          setAttribute(list, ROLE, "presentation");
        }
    
        function find(selector) {
          var elm = query(root, selector);
          return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
        }
    
        function getClasses(base) {
          return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
        }
    
        return assign(elements, {
          setup: setup,
          mount: mount,
          destroy: destroy
        });
      }
    
      var SLIDE = "slide";
      var LOOP = "loop";
      var FADE = "fade";
    
      function Slide$1(Splide2, index, slideIndex, slide) {
        var event = EventInterface(Splide2);
        var on = event.on,
            emit = event.emit,
            bind = event.bind;
        var Components = Splide2.Components,
            root = Splide2.root,
            options = Splide2.options;
        var isNavigation = options.isNavigation,
            updateOnMove = options.updateOnMove,
            i18n = options.i18n,
            pagination = options.pagination,
            slideFocus = options.slideFocus;
        var resolve = Components.Direction.resolve;
        var styles = getAttribute(slide, "style");
        var label = getAttribute(slide, ARIA_LABEL);
        var isClone = slideIndex > -1;
        var container = child(slide, "." + CLASS_CONTAINER);
        var destroyed;
    
        function mount() {
          if (!isClone) {
            slide.id = root.id + "-slide" + pad(index + 1);
            setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
            setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
            setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
          }
    
          listen();
        }
    
        function listen() {
          bind(slide, "click", apply(emit, EVENT_CLICK, self));
          bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
          on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
          on(EVENT_NAVIGATION_MOUNTED, initNavigation);
    
          if (updateOnMove) {
            on(EVENT_MOVE, onMove);
          }
        }
    
        function destroy() {
          destroyed = true;
          event.destroy();
          removeClass(slide, STATUS_CLASSES);
          removeAttribute(slide, ALL_ATTRIBUTES);
          setAttribute(slide, "style", styles);
          setAttribute(slide, ARIA_LABEL, label || "");
        }
    
        function initNavigation() {
          var controls = Splide2.splides.map(function (target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
          }).join(" ");
          setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
          setAttribute(slide, ARIA_CONTROLS, controls);
          setAttribute(slide, ROLE, slideFocus ? "button" : "");
          slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
        }
    
        function onMove() {
          if (!destroyed) {
            update();
          }
        }
    
        function update() {
          if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            toggleClass(slide, CLASS_PREV, index === curr - 1);
            toggleClass(slide, CLASS_NEXT, index === curr + 1);
          }
        }
    
        function updateActivity() {
          var active = isActive();
    
          if (active !== hasClass(slide, CLASS_ACTIVE)) {
            toggleClass(slide, CLASS_ACTIVE, active);
            setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
            emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
          }
        }
    
        function updateVisibility() {
          var visible = isVisible();
          var hidden = !visible && (!isActive() || isClone);
    
          if (!Splide2.state.is([MOVING, SCROLLING])) {
            setAttribute(slide, ARIA_HIDDEN, hidden || "");
          }
    
          setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
    
          if (slideFocus) {
            setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
          }
    
          if (visible !== hasClass(slide, CLASS_VISIBLE)) {
            toggleClass(slide, CLASS_VISIBLE, visible);
            emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
          }
    
          if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && focus(Slide2.slide);
          }
        }
    
        function style$1(prop, value, useContainer) {
          style(useContainer && container || slide, prop, value);
        }
    
        function isActive() {
          var curr = Splide2.index;
          return curr === index || options.cloneStatus && curr === slideIndex;
        }
    
        function isVisible() {
          if (Splide2.is(FADE)) {
            return isActive();
          }
    
          var trackRect = rect(Components.Elements.track);
          var slideRect = rect(slide);
          var left = resolve("left", true);
          var right = resolve("right", true);
          return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
        }
    
        function isWithin(from, distance) {
          var diff = abs(from - index);
    
          if (!isClone && (options.rewind || Splide2.is(LOOP))) {
            diff = min(diff, Splide2.length - diff);
          }
    
          return diff <= distance;
        }
    
        var self = {
          index: index,
          slideIndex: slideIndex,
          slide: slide,
          container: container,
          isClone: isClone,
          mount: mount,
          destroy: destroy,
          update: update,
          style: style$1,
          isWithin: isWithin
        };
        return self;
      }
    
      function Slides(Splide2, Components2, options) {
        var _EventInterface2 = EventInterface(Splide2),
            on = _EventInterface2.on,
            emit = _EventInterface2.emit,
            bind = _EventInterface2.bind;
    
        var _Components2$Elements = Components2.Elements,
            slides = _Components2$Elements.slides,
            list = _Components2$Elements.list;
        var Slides2 = [];
    
        function mount() {
          init();
          on(EVENT_REFRESH, destroy);
          on(EVENT_REFRESH, init);
        }
    
        function init() {
          slides.forEach(function (slide, index) {
            register(slide, index, -1);
          });
        }
    
        function destroy() {
          forEach$1(function (Slide2) {
            Slide2.destroy();
          });
          empty(Slides2);
        }
    
        function update() {
          forEach$1(function (Slide2) {
            Slide2.update();
          });
        }
    
        function register(slide, index, slideIndex) {
          var object = Slide$1(Splide2, index, slideIndex, slide);
          object.mount();
          Slides2.push(object);
          Slides2.sort(function (Slide1, Slide2) {
            return Slide1.index - Slide2.index;
          });
        }
    
        function get(excludeClones) {
          return excludeClones ? filter(function (Slide2) {
            return !Slide2.isClone;
          }) : Slides2;
        }
    
        function getIn(page) {
          var Controller = Components2.Controller;
          var index = Controller.toIndex(page);
          var max = Controller.hasFocus() ? 1 : options.perPage;
          return filter(function (Slide2) {
            return between(Slide2.index, index, index + max - 1);
          });
        }
    
        function getAt(index) {
          return filter(index)[0];
        }
    
        function add(items, index) {
          forEach(items, function (slide) {
            if (isString(slide)) {
              slide = parseHtml(slide);
            }
    
            if (isHTMLElement(slide)) {
              var ref = slides[index];
              ref ? before(slide, ref) : append(list, slide);
              addClass(slide, options.classes.slide);
              observeImages(slide, apply(emit, EVENT_RESIZE));
            }
          });
          emit(EVENT_REFRESH);
        }
    
        function remove$1(matcher) {
          remove(filter(matcher).map(function (Slide2) {
            return Slide2.slide;
          }));
          emit(EVENT_REFRESH);
        }
    
        function forEach$1(iteratee, excludeClones) {
          get(excludeClones).forEach(iteratee);
        }
    
        function filter(matcher) {
          return Slides2.filter(isFunction(matcher) ? matcher : function (Slide2) {
            return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
          });
        }
    
        function style(prop, value, useContainer) {
          forEach$1(function (Slide2) {
            Slide2.style(prop, value, useContainer);
          });
        }
    
        function observeImages(elm, callback) {
          var images = queryAll(elm, "img");
          var length = images.length;
    
          if (length) {
            images.forEach(function (img) {
              bind(img, "load error", function () {
                if (! --length) {
                  callback();
                }
              });
            });
          } else {
            callback();
          }
        }
    
        function getLength(excludeClones) {
          return excludeClones ? slides.length : Slides2.length;
        }
    
        function isEnough() {
          return Slides2.length > options.perPage;
        }
    
        return {
          mount: mount,
          destroy: destroy,
          update: update,
          register: register,
          get: get,
          getIn: getIn,
          getAt: getAt,
          add: add,
          remove: remove$1,
          forEach: forEach$1,
          filter: filter,
          style: style,
          getLength: getLength,
          isEnough: isEnough
        };
      }
    
      function Layout(Splide2, Components2, options) {
        var _EventInterface3 = EventInterface(Splide2),
            on = _EventInterface3.on,
            bind = _EventInterface3.bind,
            emit = _EventInterface3.emit;
    
        var Slides = Components2.Slides;
        var resolve = Components2.Direction.resolve;
        var _Components2$Elements2 = Components2.Elements,
            root = _Components2$Elements2.root,
            track = _Components2$Elements2.track,
            list = _Components2$Elements2.list;
        var getAt = Slides.getAt,
            styleSlides = Slides.style;
        var vertical;
        var rootRect;
        var overflow;
    
        function mount() {
          init();
          bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
          on([EVENT_UPDATED, EVENT_REFRESH], init);
          on(EVENT_RESIZE, resize);
        }
    
        function init() {
          vertical = options.direction === TTB;
          style(root, "maxWidth", unit(options.width));
          style(track, resolve("paddingLeft"), cssPadding(false));
          style(track, resolve("paddingRight"), cssPadding(true));
          resize(true);
        }
    
        function resize(force) {
          var newRect = rect(root);
    
          if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit(EVENT_RESIZED);
    
            if (overflow !== (overflow = isOverflow())) {
              toggleClass(root, CLASS_OVERFLOW, overflow);
              emit(EVENT_OVERFLOW, overflow);
            }
          }
        }
    
        function cssPadding(right) {
          var padding = options.padding;
          var prop = resolve(right ? "right" : "left");
          return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
        }
    
        function cssTrackHeight() {
          var height = "";
    
          if (vertical) {
            height = cssHeight();
            assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
          }
    
          return height;
        }
    
        function cssHeight() {
          return unit(options.height || rect(list).width * options.heightRatio);
        }
    
        function cssSlideWidth() {
          return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
        }
    
        function cssSlideHeight() {
          return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
        }
    
        function cssSlideSize() {
          var gap = unit(options.gap);
          return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
        }
    
        function listSize() {
          return rect(list)[resolve("width")];
        }
    
        function slideSize(index, withoutGap) {
          var Slide = getAt(index || 0);
          return Slide ? rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
        }
    
        function totalSize(index, withoutGap) {
          var Slide = getAt(index);
    
          if (Slide) {
            var right = rect(Slide.slide)[resolve("right")];
            var left = rect(list)[resolve("left")];
            return abs(right - left) + (withoutGap ? 0 : getGap());
          }
    
          return 0;
        }
    
        function sliderSize(withoutGap) {
          return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
        }
    
        function getGap() {
          var Slide = getAt(0);
          return Slide && parseFloat(style(Slide.slide, resolve("marginRight"))) || 0;
        }
    
        function getPadding(right) {
          return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
        }
    
        function isOverflow() {
          return Splide2.is(FADE) || sliderSize(true) > listSize();
        }
    
        return {
          mount: mount,
          resize: resize,
          listSize: listSize,
          slideSize: slideSize,
          sliderSize: sliderSize,
          totalSize: totalSize,
          getPadding: getPadding,
          isOverflow: isOverflow
        };
      }
    
      var MULTIPLIER = 2;
    
      function Clones(Splide2, Components2, options) {
        var event = EventInterface(Splide2);
        var on = event.on;
        var Elements = Components2.Elements,
            Slides = Components2.Slides;
        var resolve = Components2.Direction.resolve;
        var clones = [];
        var cloneCount;
    
        function mount() {
          on(EVENT_REFRESH, remount);
          on([EVENT_UPDATED, EVENT_RESIZE], observe);
    
          if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
          }
        }
    
        function remount() {
          destroy();
          mount();
        }
    
        function destroy() {
          remove(clones);
          empty(clones);
          event.destroy();
        }
    
        function observe() {
          var count = computeCloneCount();
    
          if (cloneCount !== count) {
            if (cloneCount < count || !count) {
              event.emit(EVENT_REFRESH);
            }
          }
        }
    
        function generate(count) {
          var slides = Slides.get().slice();
          var length = slides.length;
    
          if (length) {
            while (slides.length < count) {
              push(slides, slides);
            }
    
            push(slides.slice(-count), slides.slice(0, count)).forEach(function (Slide, index) {
              var isHead = index < count;
              var clone = cloneDeep(Slide.slide, index);
              isHead ? before(clone, slides[0].slide) : append(Elements.list, clone);
              push(clones, clone);
              Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
          }
        }
    
        function cloneDeep(elm, index) {
          var clone = elm.cloneNode(true);
          addClass(clone, options.classes.clone);
          clone.id = Splide2.root.id + "-clone" + pad(index + 1);
          return clone;
        }
    
        function computeCloneCount() {
          var clones2 = options.clones;
    
          if (!Splide2.is(LOOP)) {
            clones2 = 0;
          } else if (isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && ceil(rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
          }
    
          return clones2;
        }
    
        return {
          mount: mount,
          destroy: destroy
        };
      }
    
      function Move(Splide2, Components2, options) {
        var _EventInterface4 = EventInterface(Splide2),
            on = _EventInterface4.on,
            emit = _EventInterface4.emit;
    
        var set = Splide2.state.set;
        var _Components2$Layout = Components2.Layout,
            slideSize = _Components2$Layout.slideSize,
            getPadding = _Components2$Layout.getPadding,
            totalSize = _Components2$Layout.totalSize,
            listSize = _Components2$Layout.listSize,
            sliderSize = _Components2$Layout.sliderSize;
        var _Components2$Directio = Components2.Direction,
            resolve = _Components2$Directio.resolve,
            orient = _Components2$Directio.orient;
        var _Components2$Elements3 = Components2.Elements,
            list = _Components2$Elements3.list,
            track = _Components2$Elements3.track;
        var Transition;
    
        function mount() {
          Transition = Components2.Transition;
          on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
        }
    
        function reposition() {
          if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
          }
        }
    
        function move(dest, index, prev, callback) {
          if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
          }
    
          set(MOVING);
          emit(EVENT_MOVE, index, prev, dest);
          Transition.start(index, function () {
            set(IDLE);
            emit(EVENT_MOVED, index, prev, dest);
            callback && callback();
          });
        }
    
        function jump(index) {
          translate(toPosition(index, true));
        }
    
        function translate(position, preventLoop) {
          if (!Splide2.is(FADE)) {
            var destination = preventLoop ? position : loop(position);
            style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit(EVENT_SHIFTED);
          }
        }
    
        function loop(position) {
          if (Splide2.is(LOOP)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
    
            if (exceededMin || exceededMax) {
              position = shift(position, exceededMax);
            }
          }
    
          return position;
        }
    
        function shift(position, backwards) {
          var excess = position - getLimit(backwards);
          var size = sliderSize();
          position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
          return position;
        }
    
        function cancel() {
          translate(getPosition(), true);
          Transition.cancel();
        }
    
        function toIndex(position) {
          var Slides = Components2.Slides.get();
          var index = 0;
          var minDistance = Infinity;
    
          for (var i = 0; i < Slides.length; i++) {
            var slideIndex = Slides[i].index;
            var distance = abs(toPosition(slideIndex, true) - position);
    
            if (distance <= minDistance) {
              minDistance = distance;
              index = slideIndex;
            } else {
              break;
            }
          }
    
          return index;
        }
    
        function toPosition(index, trimming) {
          var position = orient(totalSize(index - 1) - offset(index));
          return trimming ? trim(position) : position;
        }
    
        function getPosition() {
          var left = resolve("left");
          return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
        }
    
        function trim(position) {
          if (options.trimSpace && Splide2.is(SLIDE)) {
            position = clamp(position, 0, orient(sliderSize(true) - listSize()));
          }
    
          return position;
        }
    
        function offset(index) {
          var focus = options.focus;
          return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
        }
    
        function getLimit(max) {
          return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
        }
    
        function canShift(backwards) {
          var shifted = orient(shift(getPosition(), backwards));
          return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
        }
    
        function exceededLimit(max, position) {
          position = isUndefined(position) ? getPosition() : position;
          var exceededMin = max !== true && orient(position) < orient(getLimit(false));
          var exceededMax = max !== false && orient(position) > orient(getLimit(true));
          return exceededMin || exceededMax;
        }
    
        return {
          mount: mount,
          move: move,
          jump: jump,
          translate: translate,
          shift: shift,
          cancel: cancel,
          toIndex: toIndex,
          toPosition: toPosition,
          getPosition: getPosition,
          getLimit: getLimit,
          exceededLimit: exceededLimit,
          reposition: reposition
        };
      }
    
      function Controller(Splide2, Components2, options) {
        var _EventInterface5 = EventInterface(Splide2),
            on = _EventInterface5.on,
            emit = _EventInterface5.emit;
    
        var Move = Components2.Move;
        var getPosition = Move.getPosition,
            getLimit = Move.getLimit,
            toPosition = Move.toPosition;
        var _Components2$Slides = Components2.Slides,
            isEnough = _Components2$Slides.isEnough,
            getLength = _Components2$Slides.getLength;
        var omitEnd = options.omitEnd;
        var isLoop = Splide2.is(LOOP);
        var isSlide = Splide2.is(SLIDE);
        var getNext = apply(getAdjacent, false);
        var getPrev = apply(getAdjacent, true);
        var currIndex = options.start || 0;
        var endIndex;
        var prevIndex = currIndex;
        var slideCount;
        var perMove;
        var perPage;
    
        function mount() {
          init();
          on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
          on(EVENT_RESIZED, onResized);
        }
    
        function init() {
          slideCount = getLength(true);
          perMove = options.perMove;
          perPage = options.perPage;
          endIndex = getEnd();
          var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
    
          if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
          }
        }
    
        function onResized() {
          if (endIndex !== getEnd()) {
            emit(EVENT_END_INDEX_CHANGED);
          }
        }
    
        function go(control, allowSameIndex, callback) {
          if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
    
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
              setIndex(index);
              Move.move(dest, index, prevIndex, callback);
            }
          }
        }
    
        function scroll(destination, duration, snap, callback) {
          Components2.Scroll.scroll(destination, duration, snap, function () {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? min(index, endIndex) : index);
            callback && callback();
          });
        }
    
        function parse(control) {
          var index = currIndex;
    
          if (isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [],
                indicator = _ref[1],
                number = _ref[2];
    
            if (indicator === "+" || indicator === "-") {
              index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            } else if (indicator === ">") {
              index = number ? toIndex(+number) : getNext(true);
            } else if (indicator === "<") {
              index = getPrev(true);
            }
          } else {
            index = isLoop ? control : clamp(control, 0, endIndex);
          }
    
          return index;
        }
    
        function getAdjacent(prev, destination) {
          var number = perMove || (hasFocus() ? 1 : perPage);
          var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
    
          if (dest === -1 && isSlide) {
            if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
              return prev ? 0 : endIndex;
            }
          }
    
          return destination ? dest : loop(dest);
        }
    
        function computeDestIndex(dest, from, snapPage) {
          if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
    
            if (index !== dest) {
              from = dest;
              dest = index;
              snapPage = false;
            }
    
            if (dest < 0 || dest > endIndex) {
              if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
                dest = toIndex(toPage(dest));
              } else {
                if (isLoop) {
                  dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                } else if (options.rewind) {
                  dest = dest < 0 ? endIndex : 0;
                } else {
                  dest = -1;
                }
              }
            } else {
              if (snapPage && dest !== from) {
                dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
              }
            }
          } else {
            dest = -1;
          }
    
          return dest;
        }
    
        function computeMovableDestIndex(dest) {
          if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
    
            while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
              dest < currIndex ? --dest : ++dest;
            }
          }
    
          return dest;
        }
    
        function loop(index) {
          return isLoop ? (index + slideCount) % slideCount || 0 : index;
        }
    
        function getEnd() {
          var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
    
          while (omitEnd && end-- > 0) {
            if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
              end++;
              break;
            }
          }
    
          return clamp(end, 0, slideCount - 1);
        }
    
        function toIndex(page) {
          return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
        }
    
        function toPage(index) {
          return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
        }
    
        function toDest(destination) {
          var closest = Move.toIndex(destination);
          return isSlide ? clamp(closest, 0, endIndex) : closest;
        }
    
        function setIndex(index) {
          if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
          }
        }
    
        function getIndex(prev) {
          return prev ? prevIndex : currIndex;
        }
    
        function hasFocus() {
          return !isUndefined(options.focus) || options.isNavigation;
        }
    
        function isBusy() {
          return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
        }
    
        return {
          mount: mount,
          go: go,
          scroll: scroll,
          getNext: getNext,
          getPrev: getPrev,
          getAdjacent: getAdjacent,
          getEnd: getEnd,
          setIndex: setIndex,
          getIndex: getIndex,
          toIndex: toIndex,
          toPage: toPage,
          toDest: toDest,
          hasFocus: hasFocus,
          isBusy: isBusy
        };
      }
    
      var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
      var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
      var SIZE = 40;
    
      function Arrows(Splide2, Components2, options) {
        var event = EventInterface(Splide2);
        var on = event.on,
            bind = event.bind,
            emit = event.emit;
        var classes = options.classes,
            i18n = options.i18n;
        var Elements = Components2.Elements,
            Controller = Components2.Controller;
        var placeholder = Elements.arrows,
            track = Elements.track;
        var wrapper = placeholder;
        var prev = Elements.prev;
        var next = Elements.next;
        var created;
        var wrapperClasses;
        var arrows = {};
    
        function mount() {
          init();
          on(EVENT_UPDATED, remount);
        }
    
        function remount() {
          destroy();
          mount();
        }
    
        function init() {
          var enabled = options.arrows;
    
          if (enabled && !(prev && next)) {
            createArrows();
          }
    
          if (prev && next) {
            assign(arrows, {
              prev: prev,
              next: next
            });
            display(wrapper, enabled ? "" : "none");
            addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
    
            if (enabled) {
              listen();
              update();
              setAttribute([prev, next], ARIA_CONTROLS, track.id);
              emit(EVENT_ARROWS_MOUNTED, prev, next);
            }
          }
        }
    
        function destroy() {
          event.destroy();
          removeClass(wrapper, wrapperClasses);
    
          if (created) {
            remove(placeholder ? [prev, next] : wrapper);
            prev = next = null;
          } else {
            removeAttribute([prev, next], ALL_ATTRIBUTES);
          }
        }
    
        function listen() {
          on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
          bind(next, "click", apply(go, ">"));
          bind(prev, "click", apply(go, "<"));
        }
    
        function go(control) {
          Controller.go(control, true);
        }
    
        function createArrows() {
          wrapper = placeholder || create("div", classes.arrows);
          prev = createArrow(true);
          next = createArrow(false);
          created = true;
          append(wrapper, [prev, next]);
          !placeholder && before(wrapper, track);
        }
    
        function createArrow(prev2) {
          var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + XML_NAME_SPACE + "\" viewBox=\"0 0 " + SIZE + " " + SIZE + "\" width=\"" + SIZE + "\" height=\"" + SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || PATH) + "\" />";
          return parseHtml(arrow);
        }
    
        function update() {
          if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            setAttribute(prev, ARIA_LABEL, prevLabel);
            setAttribute(next, ARIA_LABEL, nextLabel);
            emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
          }
        }
    
        return {
          arrows: arrows,
          mount: mount,
          destroy: destroy,
          update: update
        };
      }
    
      var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
    
      function Autoplay(Splide2, Components2, options) {
        var _EventInterface6 = EventInterface(Splide2),
            on = _EventInterface6.on,
            bind = _EventInterface6.bind,
            emit = _EventInterface6.emit;
    
        var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
        var isPaused = interval.isPaused;
        var Elements = Components2.Elements,
            _Components2$Elements4 = Components2.Elements,
            root = _Components2$Elements4.root,
            toggle = _Components2$Elements4.toggle;
        var autoplay = options.autoplay;
        var hovered;
        var focused;
        var stopped = autoplay === "pause";
    
        function mount() {
          if (autoplay) {
            listen();
            toggle && setAttribute(toggle, ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
          }
        }
    
        function listen() {
          if (options.pauseOnHover) {
            bind(root, "mouseenter mouseleave", function (e) {
              hovered = e.type === "mouseenter";
              autoToggle();
            });
          }
    
          if (options.pauseOnFocus) {
            bind(root, "focusin focusout", function (e) {
              focused = e.type === "focusin";
              autoToggle();
            });
          }
    
          if (toggle) {
            bind(toggle, "click", function () {
              stopped ? play() : pause(true);
            });
          }
    
          on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
          on(EVENT_MOVE, onMove);
        }
    
        function play() {
          if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit(EVENT_AUTOPLAY_PLAY);
          }
        }
    
        function pause(stop) {
          if (stop === void 0) {
            stop = true;
          }
    
          stopped = !!stop;
          update();
    
          if (!isPaused()) {
            interval.pause();
            emit(EVENT_AUTOPLAY_PAUSE);
          }
        }
    
        function autoToggle() {
          if (!stopped) {
            hovered || focused ? pause(false) : play();
          }
        }
    
        function update() {
          if (toggle) {
            toggleClass(toggle, CLASS_ACTIVE, !stopped);
            setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
          }
        }
    
        function onAnimationFrame(rate) {
          var bar = Elements.bar;
          bar && style(bar, "width", rate * 100 + "%");
          emit(EVENT_AUTOPLAY_PLAYING, rate);
        }
    
        function onMove(index) {
          var Slide = Components2.Slides.getAt(index);
          interval.set(Slide && +getAttribute(Slide.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
        }
    
        return {
          mount: mount,
          destroy: interval.cancel,
          play: play,
          pause: pause,
          isPaused: isPaused
        };
      }
    
      function Cover(Splide2, Components2, options) {
        var _EventInterface7 = EventInterface(Splide2),
            on = _EventInterface7.on;
    
        function mount() {
          if (options.cover) {
            on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
            on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
          }
        }
    
        function cover(cover2) {
          Components2.Slides.forEach(function (Slide) {
            var img = child(Slide.container || Slide.slide, "img");
    
            if (img && img.src) {
              toggle(cover2, img, Slide);
            }
          });
        }
    
        function toggle(cover2, img, Slide) {
          Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
          display(img, cover2 ? "none" : "");
        }
    
        return {
          mount: mount,
          destroy: apply(cover, false)
        };
      }
    
      var BOUNCE_DIFF_THRESHOLD = 10;
      var BOUNCE_DURATION = 600;
      var FRICTION_FACTOR = 0.6;
      var BASE_VELOCITY = 1.5;
      var MIN_DURATION = 800;
    
      function Scroll(Splide2, Components2, options) {
        var _EventInterface8 = EventInterface(Splide2),
            on = _EventInterface8.on,
            emit = _EventInterface8.emit;
    
        var set = Splide2.state.set;
        var Move = Components2.Move;
        var getPosition = Move.getPosition,
            getLimit = Move.getLimit,
            exceededLimit = Move.exceededLimit,
            translate = Move.translate;
        var isSlide = Splide2.is(SLIDE);
        var interval;
        var callback;
        var friction = 1;
    
        function mount() {
          on(EVENT_MOVE, clear);
          on([EVENT_UPDATED, EVENT_REFRESH], cancel);
        }
    
        function scroll(destination, duration, snap, onScrolled, noConstrain) {
          var from = getPosition();
          clear();
    
          if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
          }
    
          var noDistance = approximatelyEqual(from, destination, 1);
          friction = 1;
          duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
          callback = onScrolled;
          interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
          set(SCROLLING);
          emit(EVENT_SCROLL);
          interval.start();
        }
    
        function onEnd() {
          set(IDLE);
          callback && callback();
          emit(EVENT_SCROLLED);
        }
    
        function update(from, to, noConstrain, rate) {
          var position = getPosition();
          var target = from + (to - from) * easing(rate);
          var diff = (target - position) * friction;
          translate(position + diff);
    
          if (isSlide && !noConstrain && exceededLimit()) {
            friction *= FRICTION_FACTOR;
    
            if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
              scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
            }
          }
        }
    
        function clear() {
          if (interval) {
            interval.cancel();
          }
        }
    
        function cancel() {
          if (interval && !interval.isPaused()) {
            clear();
            onEnd();
          }
        }
    
        function easing(t) {
          var easingFunc = options.easingFunc;
          return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
        }
    
        return {
          mount: mount,
          destroy: clear,
          scroll: scroll,
          cancel: cancel
        };
      }
    
      var SCROLL_LISTENER_OPTIONS = {
        passive: false,
        capture: true
      };
    
      function Drag(Splide2, Components2, options) {
        var _EventInterface9 = EventInterface(Splide2),
            on = _EventInterface9.on,
            emit = _EventInterface9.emit,
            bind = _EventInterface9.bind,
            unbind = _EventInterface9.unbind;
    
        var state = Splide2.state;
        var Move = Components2.Move,
            Scroll = Components2.Scroll,
            Controller = Components2.Controller,
            track = Components2.Elements.track,
            reduce = Components2.Media.reduce;
        var _Components2$Directio2 = Components2.Direction,
            resolve = _Components2$Directio2.resolve,
            orient = _Components2$Directio2.orient;
        var getPosition = Move.getPosition,
            exceededLimit = Move.exceededLimit;
        var basePosition;
        var baseEvent;
        var prevBaseEvent;
        var isFree;
        var dragging;
        var exceeded = false;
        var clickPrevented;
        var disabled;
        var target;
    
        function mount() {
          bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
          bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
          bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
          bind(track, "click", onClick, {
            capture: true
          });
          bind(track, "dragstart", prevent);
          on([EVENT_MOUNTED, EVENT_UPDATED], init);
        }
    
        function init() {
          var drag = options.drag;
          disable(!drag);
          isFree = drag === "free";
        }
    
        function onPointerDown(e) {
          clickPrevented = false;
    
          if (!disabled) {
            var isTouch = isTouchEvent(e);
    
            if (isDraggable(e.target) && (isTouch || !e.button)) {
              if (!Controller.isBusy()) {
                target = isTouch ? track : window;
                dragging = state.is([MOVING, SCROLLING]);
                prevBaseEvent = null;
                bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
                bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
                Move.cancel();
                Scroll.cancel();
                save(e);
              } else {
                prevent(e, true);
              }
            }
          }
        }
    
        function onPointerMove(e) {
          if (!state.is(DRAGGING)) {
            state.set(DRAGGING);
            emit(EVENT_DRAG);
          }
    
          if (e.cancelable) {
            if (dragging) {
              Move.translate(basePosition + constrain(diffCoord(e)));
              var expired = diffTime(e) > LOG_INTERVAL;
              var hasExceeded = exceeded !== (exceeded = exceededLimit());
    
              if (expired || hasExceeded) {
                save(e);
              }
    
              clickPrevented = true;
              emit(EVENT_DRAGGING);
              prevent(e);
            } else if (isSliderDirection(e)) {
              dragging = shouldStart(e);
              prevent(e);
            }
          }
        }
    
        function onPointerUp(e) {
          if (state.is(DRAGGING)) {
            state.set(IDLE);
            emit(EVENT_DRAGGED);
          }
    
          if (dragging) {
            move(e);
            prevent(e);
          }
    
          unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
          unbind(target, POINTER_UP_EVENTS, onPointerUp);
          dragging = false;
        }
    
        function onClick(e) {
          if (!disabled && clickPrevented) {
            prevent(e, true);
          }
        }
    
        function save(e) {
          prevBaseEvent = baseEvent;
          baseEvent = e;
          basePosition = getPosition();
        }
    
        function move(e) {
          var velocity = computeVelocity(e);
          var destination = computeDestination(velocity);
          var rewind = options.rewind && options.rewindByDrag;
          reduce(false);
    
          if (isFree) {
            Controller.scroll(destination, 0, options.snap);
          } else if (Splide2.is(FADE)) {
            Controller.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
          } else if (Splide2.is(SLIDE) && exceeded && rewind) {
            Controller.go(exceededLimit(true) ? ">" : "<");
          } else {
            Controller.go(Controller.toDest(destination), true);
          }
    
          reduce(true);
        }
    
        function shouldStart(e) {
          var thresholds = options.dragMinThreshold;
          var isObj = isObject(thresholds);
          var mouse = isObj && thresholds.mouse || 0;
          var touch = (isObj ? thresholds.touch : +thresholds) || 10;
          return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
        }
    
        function isSliderDirection(e) {
          return abs(diffCoord(e)) > abs(diffCoord(e, true));
        }
    
        function computeVelocity(e) {
          if (Splide2.is(LOOP) || !exceeded) {
            var time = diffTime(e);
    
            if (time && time < LOG_INTERVAL) {
              return diffCoord(e) / time;
            }
          }
    
          return 0;
        }
    
        function computeDestination(velocity) {
          return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
        }
    
        function diffCoord(e, orthogonal) {
          return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
        }
    
        function diffTime(e) {
          return timeOf(e) - timeOf(getBaseEvent(e));
        }
    
        function getBaseEvent(e) {
          return baseEvent === e && prevBaseEvent || baseEvent;
        }
    
        function coordOf(e, orthogonal) {
          return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
        }
    
        function constrain(diff) {
          return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
        }
    
        function isDraggable(target2) {
          var noDrag = options.noDrag;
          return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
        }
    
        function isTouchEvent(e) {
          return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
        }
    
        function isDragging() {
          return dragging;
        }
    
        function disable(value) {
          disabled = value;
        }
    
        return {
          mount: mount,
          disable: disable,
          isDragging: isDragging
        };
      }
    
      var NORMALIZATION_MAP = {
        Spacebar: " ",
        Right: ARROW_RIGHT,
        Left: ARROW_LEFT,
        Up: ARROW_UP,
        Down: ARROW_DOWN
      };
    
      function normalizeKey(key) {
        key = isString(key) ? key : key.key;
        return NORMALIZATION_MAP[key] || key;
      }
    
      var KEYBOARD_EVENT = "keydown";
    
      function Keyboard(Splide2, Components2, options) {
        var _EventInterface10 = EventInterface(Splide2),
            on = _EventInterface10.on,
            bind = _EventInterface10.bind,
            unbind = _EventInterface10.unbind;
    
        var root = Splide2.root;
        var resolve = Components2.Direction.resolve;
        var target;
        var disabled;
    
        function mount() {
          init();
          on(EVENT_UPDATED, destroy);
          on(EVENT_UPDATED, init);
          on(EVENT_MOVE, onMove);
        }
    
        function init() {
          var keyboard = options.keyboard;
    
          if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, KEYBOARD_EVENT, onKeydown);
          }
        }
    
        function destroy() {
          unbind(target, KEYBOARD_EVENT);
        }
    
        function disable(value) {
          disabled = value;
        }
    
        function onMove() {
          var _disabled = disabled;
          disabled = true;
          nextTick(function () {
            disabled = _disabled;
          });
        }
    
        function onKeydown(e) {
          if (!disabled) {
            var key = normalizeKey(e);
    
            if (key === resolve(ARROW_LEFT)) {
              Splide2.go("<");
            } else if (key === resolve(ARROW_RIGHT)) {
              Splide2.go(">");
            }
          }
        }
    
        return {
          mount: mount,
          destroy: destroy,
          disable: disable
        };
      }
    
      var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
      var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
      var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
    
      function LazyLoad(Splide2, Components2, options) {
        var _EventInterface11 = EventInterface(Splide2),
            on = _EventInterface11.on,
            off = _EventInterface11.off,
            bind = _EventInterface11.bind,
            emit = _EventInterface11.emit;
    
        var isSequential = options.lazyLoad === "sequential";
        var events = [EVENT_MOVED, EVENT_SCROLLED];
        var entries = [];
    
        function mount() {
          if (options.lazyLoad) {
            init();
            on(EVENT_REFRESH, init);
          }
        }
    
        function init() {
          empty(entries);
          register();
    
          if (isSequential) {
            loadNext();
          } else {
            off(events);
            on(events, check);
            check();
          }
        }
    
        function register() {
          Components2.Slides.forEach(function (Slide) {
            queryAll(Slide.slide, IMAGE_SELECTOR).forEach(function (img) {
              var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
              var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
    
              if (src !== img.src || srcset !== img.srcset) {
                var className = options.classes.spinner;
                var parent = img.parentElement;
                var spinner = child(parent, "." + className) || create("span", className, parent);
                entries.push([img, Slide, spinner]);
                img.src || display(img, "none");
              }
            });
          });
        }
    
        function check() {
          entries = entries.filter(function (data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
          });
          entries.length || off(events);
        }
    
        function load(data) {
          var img = data[0];
          addClass(data[1].slide, CLASS_LOADING);
          bind(img, "load error", apply(onLoad, data));
          setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
          setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
          removeAttribute(img, SRC_DATA_ATTRIBUTE);
          removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
        }
    
        function onLoad(data, e) {
          var img = data[0],
              Slide = data[1];
          removeClass(Slide.slide, CLASS_LOADING);
    
          if (e.type !== "error") {
            remove(data[2]);
            display(img, "");
            emit(EVENT_LAZYLOAD_LOADED, img, Slide);
            emit(EVENT_RESIZE);
          }
    
          isSequential && loadNext();
        }
    
        function loadNext() {
          entries.length && load(entries.shift());
        }
    
        return {
          mount: mount,
          destroy: apply(empty, entries),
          check: check
        };
      }
    
      function Pagination(Splide2, Components2, options) {
        var event = EventInterface(Splide2);
        var on = event.on,
            emit = event.emit,
            bind = event.bind;
        var Slides = Components2.Slides,
            Elements = Components2.Elements,
            Controller = Components2.Controller;
        var hasFocus = Controller.hasFocus,
            getIndex = Controller.getIndex,
            go = Controller.go;
        var resolve = Components2.Direction.resolve;
        var placeholder = Elements.pagination;
        var items = [];
        var list;
        var paginationClasses;
    
        function mount() {
          destroy();
          on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
          var enabled = options.pagination;
          placeholder && display(placeholder, enabled ? "" : "none");
    
          if (enabled) {
            on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
            createPagination();
            update();
            emit(EVENT_PAGINATION_MOUNTED, {
              list: list,
              items: items
            }, getAt(Splide2.index));
          }
        }
    
        function destroy() {
          if (list) {
            remove(placeholder ? slice(list.children) : list);
            removeClass(list, paginationClasses);
            empty(items);
            list = null;
          }
    
          event.destroy();
        }
    
        function createPagination() {
          var length = Splide2.length;
          var classes = options.classes,
              i18n = options.i18n,
              perPage = options.perPage;
          var max = hasFocus() ? Controller.getEnd() + 1 : ceil(length / perPage);
          list = placeholder || create("ul", classes.pagination, Elements.track.parentElement);
          addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
          setAttribute(list, ROLE, "tablist");
          setAttribute(list, ARIA_LABEL, i18n.select);
          setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
    
          for (var i = 0; i < max; i++) {
            var li = create("li", null, list);
            var button = create("button", {
              class: classes.page,
              type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function (Slide) {
              return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", apply(onClick, i));
    
            if (options.paginationKeyboard) {
              bind(button, "keydown", apply(onKeydown, i));
            }
    
            setAttribute(li, ROLE, "presentation");
            setAttribute(button, ROLE, "tab");
            setAttribute(button, ARIA_CONTROLS, controls.join(" "));
            setAttribute(button, ARIA_LABEL, format(text, i + 1));
            setAttribute(button, TAB_INDEX, -1);
            items.push({
              li: li,
              button: button,
              page: i
            });
          }
        }
    
        function onClick(page) {
          go(">" + page, true);
        }
    
        function onKeydown(page, e) {
          var length = items.length;
          var key = normalizeKey(e);
          var dir = getDirection();
          var nextPage = -1;
    
          if (key === resolve(ARROW_RIGHT, false, dir)) {
            nextPage = ++page % length;
          } else if (key === resolve(ARROW_LEFT, false, dir)) {
            nextPage = (--page + length) % length;
          } else if (key === "Home") {
            nextPage = 0;
          } else if (key === "End") {
            nextPage = length - 1;
          }
    
          var item = items[nextPage];
    
          if (item) {
            focus(item.button);
            go(">" + nextPage);
            prevent(e, true);
          }
        }
    
        function getDirection() {
          return options.paginationDirection || options.direction;
        }
    
        function getAt(index) {
          return items[Controller.toPage(index)];
        }
    
        function update() {
          var prev = getAt(getIndex(true));
          var curr = getAt(getIndex());
    
          if (prev) {
            var button = prev.button;
            removeClass(button, CLASS_ACTIVE);
            removeAttribute(button, ARIA_SELECTED);
            setAttribute(button, TAB_INDEX, -1);
          }
    
          if (curr) {
            var _button = curr.button;
            addClass(_button, CLASS_ACTIVE);
            setAttribute(_button, ARIA_SELECTED, true);
            setAttribute(_button, TAB_INDEX, "");
          }
    
          emit(EVENT_PAGINATION_UPDATED, {
            list: list,
            items: items
          }, prev, curr);
        }
    
        return {
          items: items,
          mount: mount,
          destroy: destroy,
          getAt: getAt,
          update: update
        };
      }
    
      var TRIGGER_KEYS = [" ", "Enter"];
    
      function Sync(Splide2, Components2, options) {
        var isNavigation = options.isNavigation,
            slideFocus = options.slideFocus;
        var events = [];
    
        function mount() {
          Splide2.splides.forEach(function (target) {
            if (!target.isParent) {
              sync(Splide2, target.splide);
              sync(target.splide, Splide2);
            }
          });
    
          if (isNavigation) {
            navigate();
          }
        }
    
        function destroy() {
          events.forEach(function (event) {
            event.destroy();
          });
          empty(events);
        }
    
        function remount() {
          destroy();
          mount();
        }
    
        function sync(splide, target) {
          var event = EventInterface(splide);
          event.on(EVENT_MOVE, function (index, prev, dest) {
            target.go(target.is(LOOP) ? dest : index);
          });
          events.push(event);
        }
    
        function navigate() {
          var event = EventInterface(Splide2);
          var on = event.on;
          on(EVENT_CLICK, onClick);
          on(EVENT_SLIDE_KEYDOWN, onKeydown);
          on([EVENT_MOUNTED, EVENT_UPDATED], update);
          events.push(event);
          event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
        }
    
        function update() {
          setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
        }
    
        function onClick(Slide) {
          Splide2.go(Slide.index);
        }
    
        function onKeydown(Slide, e) {
          if (includes(TRIGGER_KEYS, normalizeKey(e))) {
            onClick(Slide);
            prevent(e);
          }
        }
    
        return {
          setup: apply(Components2.Media.set, {
            slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
          }, true),
          mount: mount,
          destroy: destroy,
          remount: remount
        };
      }
    
      function Wheel(Splide2, Components2, options) {
        var _EventInterface12 = EventInterface(Splide2),
            bind = _EventInterface12.bind;
    
        var lastTime = 0;
    
        function mount() {
          if (options.wheel) {
            bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
          }
        }
    
        function onWheel(e) {
          if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = timeOf(e);
    
            var _min = options.wheelMinThreshold || 0;
    
            var sleep = options.wheelSleep || 0;
    
            if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
              Splide2.go(backwards ? "<" : ">");
              lastTime = timeStamp;
            }
    
            shouldPrevent(backwards) && prevent(e);
          }
        }
    
        function shouldPrevent(backwards) {
          return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
        }
    
        return {
          mount: mount
        };
      }
    
      var SR_REMOVAL_DELAY = 90;
    
      function Live(Splide2, Components2, options) {
        var _EventInterface13 = EventInterface(Splide2),
            on = _EventInterface13.on;
    
        var track = Components2.Elements.track;
        var enabled = options.live && !options.isNavigation;
        var sr = create("span", CLASS_SR);
        var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
    
        function mount() {
          if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            setAttribute(track, ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
            on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
            on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
          }
        }
    
        function toggle(active) {
          setAttribute(track, ARIA_BUSY, active);
    
          if (active) {
            append(track, sr);
            interval.start();
          } else {
            remove(sr);
            interval.cancel();
          }
        }
    
        function destroy() {
          removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
          remove(sr);
        }
    
        function disable(disabled) {
          if (enabled) {
            setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
          }
        }
    
        return {
          mount: mount,
          disable: disable,
          destroy: destroy
        };
      }
    
      var ComponentConstructors = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Media: Media,
        Direction: Direction,
        Elements: Elements,
        Slides: Slides,
        Layout: Layout,
        Clones: Clones,
        Move: Move,
        Controller: Controller,
        Arrows: Arrows,
        Autoplay: Autoplay,
        Cover: Cover,
        Scroll: Scroll,
        Drag: Drag,
        Keyboard: Keyboard,
        LazyLoad: LazyLoad,
        Pagination: Pagination,
        Sync: Sync,
        Wheel: Wheel,
        Live: Live
      });
      var I18N = {
        prev: "Previous slide",
        next: "Next slide",
        first: "Go to first slide",
        last: "Go to last slide",
        slideX: "Go to slide %s",
        pageX: "Go to page %s",
        play: "Start autoplay",
        pause: "Pause autoplay",
        carousel: "carousel",
        slide: "slide",
        select: "Select a slide to show",
        slideLabel: "%s of %s"
      };
      var DEFAULTS = {
        type: "slide",
        role: "region",
        speed: 400,
        perPage: 1,
        cloneStatus: true,
        arrows: true,
        pagination: true,
        paginationKeyboard: true,
        interval: 5e3,
        pauseOnHover: true,
        pauseOnFocus: true,
        resetProgress: true,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        drag: true,
        direction: "ltr",
        trimSpace: true,
        focusableNodes: "a, button, textarea, input, select, iframe",
        live: true,
        classes: CLASSES,
        i18n: I18N,
        reducedMotion: {
          speed: 0,
          rewindSpeed: 0,
          autoplay: "pause"
        }
      };
    
      function Fade(Splide2, Components2, options) {
        var Slides = Components2.Slides;
    
        function mount() {
          EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
        }
    
        function init() {
          Slides.forEach(function (Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
          });
        }
    
        function start(index, done) {
          Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
          nextTick(done);
        }
    
        return {
          mount: mount,
          start: start,
          cancel: noop
        };
      }
    
      function Slide(Splide2, Components2, options) {
        var Move = Components2.Move,
            Controller = Components2.Controller,
            Scroll = Components2.Scroll;
        var list = Components2.Elements.list;
        var transition = apply(style, list, "transition");
        var endCallback;
    
        function mount() {
          EventInterface(Splide2).bind(list, "transitionend", function (e) {
            if (e.target === list && endCallback) {
              cancel();
              endCallback();
            }
          });
        }
    
        function start(index, done) {
          var destination = Move.toPosition(index, true);
          var position = Move.getPosition();
          var speed = getSpeed(index);
    
          if (abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) {
              Scroll.scroll(destination, speed, false, done);
            } else {
              transition("transform " + speed + "ms " + options.easing);
              Move.translate(destination, true);
              endCallback = done;
            }
          } else {
            Move.jump(index);
            done();
          }
        }
    
        function cancel() {
          transition("");
          Scroll.cancel();
        }
    
        function getSpeed(index) {
          var rewindSpeed = options.rewindSpeed;
    
          if (Splide2.is(SLIDE) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
    
            if (prev === 0 && index >= end || prev >= end && index === 0) {
              return rewindSpeed;
            }
          }
    
          return options.speed;
        }
    
        return {
          mount: mount,
          start: start,
          cancel: cancel
        };
      }
    
      var _Splide = /*#__PURE__*/function () {
        function _Splide(target, options) {
          this.event = EventInterface();
          this.Components = {};
          this.state = State(CREATED);
          this.splides = [];
          this._o = {};
          this._E = {};
          var root = isString(target) ? query(document, target) : target;
          assert(root, root + " is invalid.");
          this.root = root;
          options = merge({
            label: getAttribute(root, ARIA_LABEL) || "",
            labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
          }, DEFAULTS, _Splide.defaults, options || {});
    
          try {
            merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
          } catch (e) {
            assert(false, "Invalid JSON");
          }
    
          this._o = Object.create(merge({}, options));
        }
    
        var _proto = _Splide.prototype;
    
        _proto.mount = function mount(Extensions, Transition) {
          var _this = this;
    
          var state = this.state,
              Components2 = this.Components;
          assert(state.is([CREATED, DESTROYED]), "Already mounted!");
          state.set(CREATED);
          this._C = Components2;
          this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
          this._E = Extensions || this._E;
          var Constructors = assign({}, ComponentConstructors, this._E, {
            Transition: this._T
          });
          forOwn(Constructors, function (Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
          });
          forOwn(Components2, function (component) {
            component.mount && component.mount();
          });
          this.emit(EVENT_MOUNTED);
          addClass(this.root, CLASS_INITIALIZED);
          state.set(IDLE);
          this.emit(EVENT_READY);
          return this;
        };
    
        _proto.sync = function sync(splide) {
          this.splides.push({
            splide: splide
          });
          splide.splides.push({
            splide: this,
            isParent: true
          });
    
          if (this.state.is(IDLE)) {
            this._C.Sync.remount();
    
            splide.Components.Sync.remount();
          }
    
          return this;
        };
    
        _proto.go = function go(control) {
          this._C.Controller.go(control);
    
          return this;
        };
    
        _proto.on = function on(events, callback) {
          this.event.on(events, callback);
          return this;
        };
    
        _proto.off = function off(events) {
          this.event.off(events);
          return this;
        };
    
        _proto.emit = function emit(event) {
          var _this$event;
    
          (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
    
          return this;
        };
    
        _proto.add = function add(slides, index) {
          this._C.Slides.add(slides, index);
    
          return this;
        };
    
        _proto.remove = function remove(matcher) {
          this._C.Slides.remove(matcher);
    
          return this;
        };
    
        _proto.is = function is(type) {
          return this._o.type === type;
        };
    
        _proto.refresh = function refresh() {
          this.emit(EVENT_REFRESH);
          return this;
        };
    
        _proto.destroy = function destroy(completely) {
          if (completely === void 0) {
            completely = true;
          }
    
          var event = this.event,
              state = this.state;
    
          if (state.is(CREATED)) {
            EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
          } else {
            forOwn(this._C, function (component) {
              component.destroy && component.destroy(completely);
            }, true);
            event.emit(EVENT_DESTROY);
            event.destroy();
            completely && empty(this.splides);
            state.set(DESTROYED);
          }
    
          return this;
        };
    
        _createClass(_Splide, [{
          key: "options",
          get: function get() {
            return this._o;
          },
          set: function set(options) {
            this._C.Media.set(options, true, true);
          }
        }, {
          key: "length",
          get: function get() {
            return this._C.Slides.getLength(true);
          }
        }, {
          key: "index",
          get: function get() {
            return this._C.Controller.getIndex();
          }
        }]);
    
        return _Splide;
      }();
    
      var Splide = _Splide;
      Splide.defaults = {};
      Splide.STATES = STATES;
      return Splide;
    });
    
    /***/
  },
  /* 16 */
  /***/ function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */ (function (global) {
      /** Detect free variable `global` from Node.js. */
      var freeGlobal =
        typeof global == "object" &&
        global &&
        global.Object === Object &&
        global;

      module.exports = freeGlobal;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__(12));

    /***/
  },
  /* 17 */
  /***/ function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__(9);

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    module.exports = getRawTag;

    /***/
  },
  /* 18 */
  /***/ function (module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    module.exports = objectToString;

    /***/
  },
  /* 19 */
  /***/ function (module, exports, __webpack_require__) {
    var trimmedEndIndex = __webpack_require__(20);

    /** Used to match leading whitespace. */
    var reTrimStart = /^\s+/;

    /**
     * The base implementation of `_.trim`.
     *
     * @private
     * @param {string} string The string to trim.
     * @returns {string} Returns the trimmed string.
     */
    function baseTrim(string) {
      return string
        ? string
            .slice(0, trimmedEndIndex(string) + 1)
            .replace(reTrimStart, "")
        : string;
    }

    module.exports = baseTrim;

    /***/
  },
  /* 20 */
  /***/ function (module, exports) {
    /** Used to match a single whitespace character. */
    var reWhitespace = /\s/;

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
     * character of `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the index of the last non-whitespace character.
     */
    function trimmedEndIndex(string) {
      var index = string.length;

      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }

    module.exports = trimmedEndIndex;

    /***/
  },
  /* 21 */
  /***/ function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(13),
      isObjectLike = __webpack_require__(22);

    /** `Object#toString` result references. */
    var symbolTag = "[object Symbol]";

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return (
        typeof value == "symbol" ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag)
      );
    }

    module.exports = isSymbol;

    /***/
  },
  /* 22 */
  /***/ function (module, exports) {
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }

    module.exports = isObjectLike;

    /***/
  },
  /* 23 */
  /***/ function (module, exports, __webpack_require__) {
    var root = __webpack_require__(7);

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = function () {
      return root.Date.now();
    };

    module.exports = now;

    /***/
  },
  /* 24 */
  /***/ function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */ (function (global) {
      (function (global, factory) {
        true ? (module.exports = factory()) : undefined;
      })(this, function () {
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly)
              symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(
                  object,
                  sym
                ).enumerable;
              });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(
                target,
                Object.getOwnPropertyDescriptors(source)
              );
            } else {
              ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(
                  target,
                  key,
                  Object.getOwnPropertyDescriptor(source, key)
                );
              });
            }
          }

          return target;
        }

        var commonjsGlobal =
          typeof globalThis !== "undefined"
            ? globalThis
            : typeof window !== "undefined"
            ? window
            : typeof global !== "undefined"
            ? global
            : typeof self !== "undefined"
            ? self
            : {};

        function createCommonjsModule(fn) {
          var module = { exports: {} };
          return fn(module, module.exports), module.exports;
        }

        /* global define */
        var compareVersions = createCommonjsModule(function (
          module,
          exports
        ) {
          (function (root, factory) {
            /* istanbul ignore next */
            {
              module.exports = factory();
            }
          })(commonjsGlobal, function () {
            var semver =
              /^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z\-]+(?:\.[\da-z\-]+)*)?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;

            function indexOrEnd(str, q) {
              return str.indexOf(q) === -1 ? str.length : str.indexOf(q);
            }

            function split(v) {
              var c = v.replace(/^v/, "").replace(/\+.*$/, "");
              var patchIndex = indexOrEnd(c, "-");
              var arr = c.substring(0, patchIndex).split(".");
              arr.push(c.substring(patchIndex + 1));
              return arr;
            }

            function tryParse(v) {
              return isNaN(Number(v)) ? v : Number(v);
            }

            function validate(version) {
              if (typeof version !== "string") {
                throw new TypeError("Invalid argument expected string");
              }

              if (!semver.test(version)) {
                throw new Error(
                  "Invalid argument not valid semver ('" +
                    version +
                    "' received)"
                );
              }
            }

            function compareVersions(v1, v2) {
              [v1, v2].forEach(validate);
              var s1 = split(v1);
              var s2 = split(v2);

              for (
                var i = 0;
                i < Math.max(s1.length - 1, s2.length - 1);
                i++
              ) {
                var n1 = parseInt(s1[i] || 0, 10);
                var n2 = parseInt(s2[i] || 0, 10);
                if (n1 > n2) return 1;
                if (n2 > n1) return -1;
              }

              var sp1 = s1[s1.length - 1];
              var sp2 = s2[s2.length - 1];

              if (sp1 && sp2) {
                var p1 = sp1.split(".").map(tryParse);
                var p2 = sp2.split(".").map(tryParse);

                for (i = 0; i < Math.max(p1.length, p2.length); i++) {
                  if (
                    p1[i] === undefined ||
                    (typeof p2[i] === "string" && typeof p1[i] === "number")
                  )
                    return -1;
                  if (
                    p2[i] === undefined ||
                    (typeof p1[i] === "string" && typeof p2[i] === "number")
                  )
                    return 1;
                  if (p1[i] > p2[i]) return 1;
                  if (p2[i] > p1[i]) return -1;
                }
              } else if (sp1 || sp2) {
                return sp1 ? -1 : 1;
              }

              return 0;
            }
            var allowedOperators = [">", ">=", "=", "<", "<="];
            var operatorResMap = {
              ">": [1],
              ">=": [0, 1],
              "=": [0],
              "<=": [-1, 0],
              "<": [-1],
            };

            function validateOperator(op) {
              if (typeof op !== "string") {
                throw new TypeError(
                  "Invalid operator type, expected string but got " +
                    typeof op
                );
              }

              if (allowedOperators.indexOf(op) === -1) {
                throw new TypeError(
                  "Invalid operator, expected one of " +
                    allowedOperators.join("|")
                );
              }
            }

            compareVersions.validate = function (version) {
              return typeof version === "string" && semver.test(version);
            };

            compareVersions.compare = function (v1, v2, operator) {
              // Validate operator
              validateOperator(operator); // since result of compareVersions can only be -1 or 0 or 1
              // a simple map can be used to replace switch

              var res = compareVersions(v1, v2);
              return operatorResMap[operator].indexOf(res) > -1;
            };

            return compareVersions;
          });
        });

        const isNullOrUndefined = (value) => {
          return value === null || value === undefined;
        };
        const isObject = (_) => {
          return Object.getPrototypeOf(_) === Object.prototype;
        };
        const isArray = (_) => Array.isArray(_);
        const getMethods = (obj) => {
          let methods = {};
          Object.entries(obj)
            .filter(([_, value]) => typeof value === "function")
            .forEach(([key, value]) => (methods[key] = value));
          return methods;
        };
        const isTesting = () => {
          return (
            navigator.userAgent.includes("Node.js") ||
            navigator.userAgent.includes("jsdom")
          );
        };
        const checkForAlpine = () => {
          if (isTesting()) {
            return true;
          }

          if (!window.Alpine) {
            return false;
          }

          return compareVersions.compare(
            window.Alpine.version,
            "2.7.0",
            ">="
          );
        };

        const createObservable = (target, callbacks) => {
          Object.entries(target).forEach(([key, value]) => {
            if (
              !isNullOrUndefined(value) &&
              (isObject(value) || isArray(value))
            ) {
              target[key] = createObservable(value, callbacks);
            }
          });
          return new Proxy(target, {
            get(target, key, receiver) {
              return callbacks.get(target, key, receiver);
            },

            set(target, key, value, receiver) {
              if (
                !isNullOrUndefined(value) &&
                (isObject(value) || isArray(value))
              ) {
                value = createObservable(value, callbacks);
              }

              let originalValue = target[key];
              target[key] = value; // Copy watchers from the original value if they exist

              if (
                !isNullOrUndefined(originalValue) &&
                !isNullOrUndefined(originalValue.__watchers)
              ) {
                target[key].__watchers = originalValue.__watchers;
              }

              callbacks.set(target, key, target[key], receiver);
              return true;
            },
          });
        };

        const Spruce = {
          stores: {},
          persistenceDriver: window.localStorage,
          persisted: [],
          persistedDrivers: {},
          subscribers: [],
          pendingWatchers: {},
          disableReactivity: false,
          startingCallbacks: [],
          startedCallbacks: [],
          hasStarted: false,

          start() {
            this.startingCallbacks.forEach((fn) => fn());
            this.attach();
            this.stores = createObservable(this.stores, {
              get: (target, key, receiver) => {
                if (
                  Object.is(receiver, this.stores) &&
                  ["get", "set", "toggle", "call", "clear"].includes(key)
                ) {
                  return this[key].bind(this);
                }

                return Reflect.get(target, key, receiver);
              },
              set: (target, key, value, receiver) => {
                if (this.disableReactivity) {
                  return;
                }

                this.updateSubscribers();
                this.runWatchers(target, key, value, receiver);
                this.disableReactivity = true;

                try {
                  this.persisted.forEach(this.updateLocalStorage.bind(this));
                } catch (e) {
                  // Do nothing here (thanks Safari!)
                }

                this.disableReactivity = false;
              },
            });
            this.hasStarted = true;
            this.disableReactivity = true;
            Object.entries(this.pendingWatchers).forEach(
              ([name, callbacks]) => {
                callbacks.forEach((callback) => this.watch(name, callback));
              }
            );
            this.disableReactivity = false;
            this.startedCallbacks.forEach((fn) => fn());
          },

          starting(callback) {
            this.startingCallbacks.push(callback);
          },

          started(callback) {
            this.startedCallbacks.push(callback);
          },

          attach() {
            if (!checkForAlpine()) {
              throw new Error(
                "[Spruce] You must be using Alpine >= 2.5.0 to use Spruce."
              );
            }

            const self = this;
            window.Alpine.addMagicProperty("store", (el) => {
              self.subscribe(el);
              return self.stores;
            });
          },

          store(name, state, persist = false) {
            if (typeof state === "function") {
              state = state();
            }

            const isValidDriver = this.isValidDriver(persist);

            if (persist === true || isValidDriver) {
              try {
                this.stores[name] = this.retrieveFromLocalStorage(
                  name,
                  getMethods(state),
                  isValidDriver ? persist : undefined
                );

                if (isValidDriver) {
                  this.persistedDrivers[name] = persist;
                }

                if (!this.persisted.includes(name)) {
                  this.persisted.push(name);
                }
              } catch (e) {
                // Do nothing here (thanks Safari!)
              }
            }

            if (!this.stores[name]) {
              this.stores[name] = state;
            }

            return this.stores[name];
          },

          reset(name, state) {
            if (this.stores[name] === undefined) {
              return;
            }

            this.stores[name] = state;
          },

          delete(name, reload = true) {
            if (this.stores[name] === undefined) {
              return false;
            }

            delete this.stores[name];

            if (reload) {
              this.updateSubscribers();
            }

            return true;
          },

          deleteAll() {
            const results = Object.keys(this.stores).map((key) =>
              this.delete(key, false)
            );
            this.updateSubscribers();
            return !results.some((bool) => !bool);
          },

          subscribe(el) {
            if (!this.subscribers.includes(el)) {
              this.subscribers.push(el);
            }

            return this.stores;
          },

          updateSubscribers() {
            this.subscribers
              .filter((el) => !!el.__x)
              .forEach((el) => {
                el.__x.updateElements(el);
              });
          },

          retrieveFromLocalStorage(name, methods = {}, handler) {
            let driver = this.persistenceDriver;

            if (handler !== undefined) {
              this.guardAgainstInvalidDrivers(handler);
              driver = handler;
            }

            const value = driver.getItem(`__spruce:${name}`);

            if (!value) {
              return null;
            }

            let storage = JSON.parse(value);

            if (typeof storage === "object") {
              storage = Object.assign(methods, storage);
              delete storage.__watchers;
              delete storage.__key_name;
            }

            return storage;
          },

          updateLocalStorage(name) {
            const store = _objectSpread2({}, this.store(name));

            delete store.__watchers;
            delete store.__key_name;
            const driver =
              this.persistedDrivers[name] || this.persistenceDriver;
            driver.setItem(
              `__spruce:${name}`,
              JSON.stringify(this.store(name))
            );
          },

          get(name, target = this.stores) {
            return name
              .split(".")
              .reduce((target, part) => target[part], target);
          },

          set(name, value, target = this.stores) {
            if (!isArray(name)) {
              name = name.split(".");
            }

            if (name.length === 1) return (target[name[0]] = value);

            if (target[name[0]]) {
              return this.set(name.slice(1), value, target[name[0]]);
            } else {
              target[name[0]] = {};
              return this.set(name.slice(1), value, target[name[0]]);
            }
          },

          toggle(name) {
            return this.set(name, !this.get(name));
          },

          call(name, ...args) {
            return this.get(name)(...args);
          },

          clear(name) {
            return this.persistenceDriver.removeItem(`__spruce:${name}`);
          },

          watch(name, callback) {
            if (!this.hasStarted) {
              this.pendingWatchers[name] || (this.pendingWatchers[name] = []);
              this.pendingWatchers[name].push(callback);
              return [() => this.unwatch(name, callback)];
            }

            const nameParts = name.split(".");
            const target = nameParts.reduce((target, part) => {
              const sub = target[part];

              if (
                !isNullOrUndefined(sub) &&
                (isObject(sub) || isArray(sub))
              ) {
                return sub;
              }

              return target;
            }, this.stores);
            /**
             * If the target object / array is the property
             * that needs to be watched, a magic `__self` key is
             * used so that runner can pick up on it later.
             */

            const part = Object.is(target, this.get(name))
              ? "__self"
              : nameParts[nameParts.length - 1];

            if (!target.hasOwnProperty("__watchers")) {
              Object.defineProperty(target, "__watchers", {
                enumerable: false,
                value: new Map(),
                configurable: true,
              });
            }

            if (!target.__watchers.has(part)) {
              target.__watchers.set(part, new Set());
            }

            target.__watchers.get(part).add(callback);

            return [() => this.unwatch(name, callback)];
          },

          unwatch(name, callback) {
            const nameParts = name.split(".");
            const target = nameParts.reduce((target, part) => {
              const sub = target[part];

              if (
                !isNullOrUndefined(sub) &&
                (isObject(sub) || isArray(sub))
              ) {
                return sub;
              }

              return target;
            }, this.stores);
            const part = Object.is(target, this.get(name))
              ? "__self"
              : nameParts[nameParts.length - 1];
            const watchers = target.__watchers;

            if (!watchers.has(part)) {
              return;
            }

            watchers.get(part).delete(callback);
          },

          watchers(name) {
            const nameParts = name.split(".");
            const target = nameParts.reduce((target, part) => {
              const sub = target[part];

              if (
                !isNullOrUndefined(sub) &&
                (isObject(sub) || isArray(sub))
              ) {
                return sub;
              }

              return target;
            }, this.stores);
            const part = Object.is(target, this.get(name))
              ? "__self"
              : nameParts[nameParts.length - 1];

            if (!target.__watchers) {
              return {};
            }

            return target.__watchers.get(part);
          },

          runWatchers(target, key, value) {
            if (!target.__watchers) {
              return;
            }

            if (target.__watchers.has(key)) {
              target.__watchers.get(key).forEach((f) => f(value));
            }
            /**
             * The `__self` key is used for watchers that are registered
             * to the object or array being updated.
             */

            if (target.__watchers.has("__self")) {
              target.__watchers.get("__self").forEach((f) => f(value, key));
            }
          },

          persistUsing(driver) {
            if (this.persisted.length > 0) {
              console.warn(
                "[Spruce] You have already initialised a persisted store. Changing the driver may cause issues."
              );
            }

            this.guardAgainstInvalidDrivers(driver);
            this.persistenceDriver = driver;
          },

          guardAgainstInvalidDrivers(driver) {
            if (typeof driver.getItem !== "function") {
              throw new Error(
                "[Spruce] The persistence driver must have a `getItem(key)` method."
              );
            }

            if (typeof driver.setItem !== "function") {
              throw new Error(
                "[Spruce] The persistence driver must have a `setItem(key, value)` method."
              );
            }

            if (typeof driver.removeItem !== "function") {
              throw new Error(
                "[Spruce] The persistence driver must have a `removeItem(name)` method."
              );
            }
          },

          isValidDriver(driver) {
            try {
              this.guardAgainstInvalidDrivers(driver);
            } catch (e) {
              return false;
            }

            return true;
          },
        };
        // window.Alpine = Spruce;

        // const deferrer = window.deferLoadingAlpine || function (callback) {
        //   callback();
        // };

        // window.deferLoadingAlpine = function (callback) {
        //   window.Alpine.start();
        //   deferrer(callback);
        // };

        return Spruce;
      });
      //# sourceMappingURL=spruce.umd.js.map

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__(12));

    /***/
  },
  /* 25 */
  /***/ function (module, exports) {
    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    module.exports = identity;

    /***/
  },
  /* 26 */
  /***/ function (module, exports, __webpack_require__) {
    var baseDelay = __webpack_require__(40),
      baseRest = __webpack_require__(41),
      toNumber = __webpack_require__(14);

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function (func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    module.exports = delay;

    /***/
  },
  /* 27 */
  /***/ function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__,
      __WEBPACK_AMD_DEFINE_ARRAY__,
      __WEBPACK_AMD_DEFINE_RESULT__;
    (function (window, factory) {
      if (!window) {
        return;
      }
      var globalInstall = function (initialEvent) {
        factory(window.lazySizes, initialEvent);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (true && module.exports) {
        factory(__webpack_require__(2));
      } else if (true) {
        !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)]),
        (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
        (__WEBPACK_AMD_DEFINE_RESULT__ =
          typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
            ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                exports,
                __WEBPACK_AMD_DEFINE_ARRAY__
              )
            : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
          (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
      }
    })(
      typeof window != "undefined" ? window : 0,
      function (window, document, lazySizes, initialEvent) {
        "use strict";
        var cloneElementClass;
        var style = document.createElement("a").style;
        var fitSupport = "objectFit" in style;
        var positionSupport = fitSupport && "objectPosition" in style;
        var regCssFit = /object-fit["']*\s*:\s*["']*(contain|cover)/;
        var regCssPosition =
          /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/;
        var blankSrc =
          "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        var regBgUrlEscape = /\(|\)|'/;
        var positionDefaults = {
          center: "center",
          "50% 50%": "center",
        };

        function getObject(element) {
          var css = getComputedStyle(element, null) || {};
          var content = css.fontFamily || "";
          var objectFit = content.match(regCssFit) || "";
          var objectPosition =
            (objectFit && content.match(regCssPosition)) || "";

          if (objectPosition) {
            objectPosition = objectPosition[1];
          }

          return {
            fit: (objectFit && objectFit[1]) || "",
            position:
              positionDefaults[objectPosition] || objectPosition || "center",
          };
        }

        function generateStyleClass() {
          if (cloneElementClass) {
            return;
          }

          var styleElement = document.createElement("style");

          cloneElementClass =
            lazySizes.cfg.objectFitClass || "lazysizes-display-clone";

          document.querySelector("head").appendChild(styleElement);
        }

        function removePrevClone(element) {
          var prev = element.previousElementSibling;

          if (prev && lazySizes.hC(prev, cloneElementClass)) {
            prev.parentNode.removeChild(prev);
            element.style.position = prev.getAttribute("data-position") || "";
            element.style.visibility =
              prev.getAttribute("data-visibility") || "";
          }
        }

        function initFix(element, config) {
          var switchClassesAdded, addedSrc, styleElement, styleElementStyle;
          var lazysizesCfg = lazySizes.cfg;

          var onChange = function () {
            var src = element.currentSrc || element.src;

            if (src && addedSrc !== src) {
              addedSrc = src;
              styleElementStyle.backgroundImage =
                "url(" +
                (regBgUrlEscape.test(src) ? JSON.stringify(src) : src) +
                ")";

              if (!switchClassesAdded) {
                switchClassesAdded = true;
                lazySizes.rC(styleElement, lazysizesCfg.loadingClass);
                lazySizes.aC(styleElement, lazysizesCfg.loadedClass);
              }
            }
          };
          var rafedOnChange = function () {
            lazySizes.rAF(onChange);
          };

          element._lazysizesParentFit = config.fit;

          element.addEventListener("lazyloaded", rafedOnChange, true);
          element.addEventListener("load", rafedOnChange, true);

          lazySizes.rAF(function () {
            var hideElement = element;
            var container = element.parentNode;

            if (container.nodeName.toUpperCase() == "PICTURE") {
              hideElement = container;
              container = container.parentNode;
            }

            removePrevClone(hideElement);

            if (!cloneElementClass) {
              generateStyleClass();
            }

            styleElement = element.cloneNode(false);
            styleElementStyle = styleElement.style;

            styleElement.addEventListener("load", function () {
              var curSrc = styleElement.currentSrc || styleElement.src;

              if (curSrc && curSrc != blankSrc) {
                styleElement.src = blankSrc;
                styleElement.srcset = "";
              }
            });

            lazySizes.rC(styleElement, lazysizesCfg.loadedClass);
            lazySizes.rC(styleElement, lazysizesCfg.lazyClass);
            lazySizes.rC(styleElement, lazysizesCfg.autosizesClass);
            lazySizes.aC(styleElement, lazysizesCfg.loadingClass);
            lazySizes.aC(styleElement, cloneElementClass);

            [
              "data-parent-fit",
              "data-parent-container",
              "data-object-fit-polyfilled",
              lazysizesCfg.srcsetAttr,
              lazysizesCfg.srcAttr,
            ].forEach(function (attr) {
              styleElement.removeAttribute(attr);
            });

            styleElement.src = blankSrc;
            styleElement.srcset = "";

            styleElementStyle.backgroundRepeat = "no-repeat";
            styleElementStyle.backgroundPosition = config.position;
            styleElementStyle.backgroundSize = config.fit;

            styleElement.setAttribute(
              "data-position",
              hideElement.style.position
            );
            styleElement.setAttribute(
              "data-visibility",
              hideElement.style.visibility
            );

            hideElement.style.visibility = "hidden";
            hideElement.style.position = "absolute";

            element.setAttribute("data-parent-fit", config.fit);
            element.setAttribute("data-parent-container", "prev");
            element.setAttribute("data-object-fit-polyfilled", "");
            element._objectFitPolyfilledDisplay = styleElement;

            container.insertBefore(styleElement, hideElement);

            if (element._lazysizesParentFit) {
              delete element._lazysizesParentFit;
            }

            if (element.complete) {
              onChange();
            }
          });
        }

        if (!fitSupport || !positionSupport) {
          var onRead = function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }

            var element = e.target;
            var obj = getObject(element);

            if (obj.fit && (!fitSupport || obj.position != "center")) {
              initFix(element, obj);
              return true;
            }

            return false;
          };

          window.addEventListener("lazybeforesizes", function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }
            var element = e.target;

            if (
              element.getAttribute("data-object-fit-polyfilled") != null &&
              !element._objectFitPolyfilledDisplay
            ) {
              if (!onRead(e)) {
                lazySizes.rAF(function () {
                  element.removeAttribute("data-object-fit-polyfilled");
                });
              }
            }
          });
          window.addEventListener("lazyunveilread", onRead, true);

          if (initialEvent && initialEvent.detail) {
            onRead(initialEvent);
          }
        }
      }
    );

    /***/
  },
  /* 28 */
  /***/ function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__,
      __WEBPACK_AMD_DEFINE_ARRAY__,
      __WEBPACK_AMD_DEFINE_RESULT__;
    (function (window, factory) {
      if (!window) {
        return;
      }
      var globalInstall = function () {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (true && module.exports) {
        factory(__webpack_require__(2));
      } else if (true) {
        !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)]),
        (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
        (__WEBPACK_AMD_DEFINE_RESULT__ =
          typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
            ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                exports,
                __WEBPACK_AMD_DEFINE_ARRAY__
              )
            : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
          (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
      }
    })(
      typeof window != "undefined" ? window : 0,
      function (window, document, lazySizes) {
        "use strict";

        if (!window.addEventListener) {
          return;
        }

        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
        var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
        var regCssObject =
          /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
        var regPicture = /^picture$/i;
        var cfg = lazySizes.cfg;

        var getCSS = function (elem) {
          return getComputedStyle(elem, null) || {};
        };

        var parentFit = {
          getParent: function (element, parentSel) {
            var parent = element;
            var parentNode = element.parentNode;

            if (
              (!parentSel || parentSel == "prev") &&
              parentNode &&
              regPicture.test(parentNode.nodeName || "")
            ) {
              parentNode = parentNode.parentNode;
            }

            if (parentSel != "self") {
              if (parentSel == "prev") {
                parent = element.previousElementSibling;
              } else if (parentSel && (parentNode.closest || window.jQuery)) {
                parent =
                  (parentNode.closest
                    ? parentNode.closest(parentSel)
                    : jQuery(parentNode).closest(parentSel)[0]) || parentNode;
              } else {
                parent = parentNode;
              }
            }

            return parent;
          },

          getFit: function (element) {
            var tmpMatch, parentObj;
            var css = getCSS(element);
            var content = css.content || css.fontFamily;
            var obj = {
              fit:
                element._lazysizesParentFit ||
                element.getAttribute("data-parent-fit"),
            };

            if (
              !obj.fit &&
              content &&
              (tmpMatch = content.match(regCssFit))
            ) {
              obj.fit = tmpMatch[1];
            }

            if (obj.fit) {
              parentObj =
                element._lazysizesParentContainer ||
                element.getAttribute("data-parent-container");

              if (
                !parentObj &&
                content &&
                (tmpMatch = content.match(regCssObject))
              ) {
                parentObj = tmpMatch[1];
              }

              obj.parent = parentFit.getParent(element, parentObj);
            } else {
              obj.fit = css.objectFit;
            }

            return obj;
          },

          getImageRatio: function (element) {
            var i, srcset, media, ratio, match, width, height;
            var parent = element.parentNode;
            var elements =
              parent && regPicture.test(parent.nodeName || "")
                ? parent.querySelectorAll("source, img")
                : [element];
            for (i = 0; i < elements.length; i++) {
              element = elements[i];
              srcset =
                element.getAttribute(cfg.srcsetAttr) ||
                element.getAttribute("srcset") ||
                element.getAttribute("data-pfsrcset") ||
                element.getAttribute("data-risrcset") ||
                "";
              media = element._lsMedia || element.getAttribute("media");
              media =
                cfg.customMedia[
                  element.getAttribute("data-media") || media
                ] || media;

              if (
                srcset &&
                (!media ||
                  ((window.matchMedia && matchMedia(media)) || {}).matches)
              ) {
                ratio = parseFloat(element.getAttribute("data-aspectratio"));

                if (!ratio) {
                  match = srcset.match(regDescriptors);

                  if (match) {
                    if (match[2] == "w") {
                      width = match[1];
                      height = match[3];
                    } else {
                      width = match[3];
                      height = match[1];
                    }
                  } else {
                    width = element.getAttribute("width");
                    height = element.getAttribute("height");
                  }

                  ratio = width / height;
                }

                break;
              }
            }

            return ratio;
          },

          calculateSize: function (element, width) {
            var displayRatio, height, imageRatio, retWidth;
            var fitObj = this.getFit(element);
            var fit = fitObj.fit;
            var fitElem = fitObj.parent;

            if (
              fit != "width" &&
              ((fit != "contain" && fit != "cover") ||
                !(imageRatio = this.getImageRatio(element)))
            ) {
              return width;
            }

            if (fitElem) {
              width = fitElem.clientWidth;
            } else {
              fitElem = element;
            }

            retWidth = width;

            if (fit == "width") {
              retWidth = width;
            } else {
              height = fitElem.clientHeight;

              if (
                (displayRatio = width / height) &&
                ((fit == "cover" && displayRatio < imageRatio) ||
                  (fit == "contain" && displayRatio > imageRatio))
              ) {
                retWidth = width * (imageRatio / displayRatio);
              }
            }

            return retWidth;
          },
        };

        lazySizes.parentFit = parentFit;

        document.addEventListener("lazybeforesizes", function (e) {
          if (e.defaultPrevented || e.detail.instance != lazySizes) {
            return;
          }

          var element = e.target;
          e.detail.width = parentFit.calculateSize(element, e.detail.width);
        });
      }
    );

    /***/
  },
  /* 29 */
  /***/ function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__,
      __WEBPACK_AMD_DEFINE_ARRAY__,
      __WEBPACK_AMD_DEFINE_RESULT__;
    (function (window, factory) {
      var globalInstall = function () {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (true && module.exports) {
        factory(__webpack_require__(2));
      } else if (true) {
        !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)]),
        (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
        (__WEBPACK_AMD_DEFINE_RESULT__ =
          typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
            ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                exports,
                __WEBPACK_AMD_DEFINE_ARRAY__
              )
            : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
          (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
      }
    })(window, function (window, document, lazySizes) {
      /*jshint eqnull:true */
      "use strict";

      var config, riasCfg;
      var lazySizesCfg = lazySizes.cfg;
      var replaceTypes = { string: 1, number: 1 };
      var regNumber = /^\-*\+*\d+\.*\d*$/;
      var regPicture = /^picture$/i;
      var regWidth = /\s*\{\s*width\s*\}\s*/i;
      var regHeight = /\s*\{\s*height\s*\}\s*/i;
      var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi;
      var regObj = /^\[.*\]|\{.*\}$/;
      var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
      var anchor = document.createElement("a");
      var img = document.createElement("img");
      var buggySizes = "srcset" in img && !("sizes" in img);
      var supportPicture = !!window.HTMLPictureElement && !buggySizes;

      (function () {
        var prop;
        var noop = function () {};
        var riasDefaults = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: false,
          modifyOptions: noop,
          widthmap: {},
          ratio: false,
          traditionalRatio: false,
          aspectratio: false,
        };

        config = lazySizes && lazySizes.cfg;

        if (!config.supportsType) {
          config.supportsType = function (type /*, elem*/) {
            return !type;
          };
        }

        if (!config.rias) {
          config.rias = {};
        }
        riasCfg = config.rias;

        if (!("widths" in riasCfg)) {
          riasCfg.widths = [];
          (function (widths) {
            var width;
            var i = 0;
            while (!width || width < 3000) {
              i += 5;
              if (i > 30) {
                i += 1;
              }
              width = 36 * i;
              widths.push(width);
            }
          })(riasCfg.widths);
        }

        for (prop in riasDefaults) {
          if (!(prop in riasCfg)) {
            riasCfg[prop] = riasDefaults[prop];
          }
        }
      })();

      function getElementOptions(elem, src, options) {
        var attr, parent, setOption, prop, opts;
        var elemStyles = window.getComputedStyle(elem);

        if (!options) {
          parent = elem.parentNode;

          options = {
            isPicture: !!(parent && regPicture.test(parent.nodeName || "")),
          };
        } else {
          opts = {};

          for (prop in options) {
            opts[prop] = options[prop];
          }

          options = opts;
        }

        setOption = function (attr, run) {
          var attrVal = elem.getAttribute("data-" + attr);

          if (!attrVal) {
            // no data- attr, get value from the CSS
            var styles = elemStyles.getPropertyValue("--ls-" + attr);
            // at least Safari 9 returns null rather than
            // an empty string for getPropertyValue causing
            // .trim() to fail
            if (styles) {
              attrVal = styles.trim();
            }
          }

          if (attrVal) {
            if (attrVal == "true") {
              attrVal = true;
            } else if (attrVal == "false") {
              attrVal = false;
            } else if (regNumber.test(attrVal)) {
              attrVal = parseFloat(attrVal);
            } else if (typeof riasCfg[attr] == "function") {
              attrVal = riasCfg[attr](elem, attrVal);
            } else if (regObj.test(attrVal)) {
              try {
                attrVal = JSON.parse(attrVal);
              } catch (e) {}
            }
            options[attr] = attrVal;
          } else if (
            attr in riasCfg &&
            typeof riasCfg[attr] != "function" &&
            !options[attr]
          ) {
            options[attr] = riasCfg[attr];
          } else if (run && typeof riasCfg[attr] == "function") {
            options[attr] = riasCfg[attr](elem, attrVal);
          }
        };

        for (attr in riasCfg) {
          setOption(attr);
        }
        src.replace(regPlaceholder, function (full, match) {
          if (!(match in options)) {
            setOption(match, true);
          }
        });

        return options;
      }

      function replaceUrlProps(url, options) {
        var candidates = [];
        var replaceFn = function (full, match) {
          return replaceTypes[typeof options[match]] ? options[match] : full;
        };
        candidates.srcset = [];

        if (options.absUrl) {
          anchor.setAttribute("href", url);
          url = anchor.href;
        }

        url = (
          (options.prefix || "") +
          url +
          (options.postfix || "")
        ).replace(regPlaceholder, replaceFn);

        options.widths.forEach(function (width) {
          var widthAlias = options.widthmap[width] || width;
          var ratio = options.aspectratio || options.ratio;
          var traditionalRatio =
            !options.aspectratio && riasCfg.traditionalRatio;
          var candidate = {
            u: url
              .replace(regWidth, widthAlias)
              .replace(
                regHeight,
                ratio
                  ? traditionalRatio
                    ? Math.round(width * ratio)
                    : Math.round(width / ratio)
                  : ""
              ),
            w: width,
          };

          candidates.push(candidate);
          candidates.srcset.push(
            (candidate.c = candidate.u + " " + width + "w")
          );
        });
        return candidates;
      }

      function setSrc(src, opts, elem) {
        var elemW = 0;
        var elemH = 0;
        var sizeElement = elem;

        if (!src) {
          return;
        }

        if (opts.ratio === "container") {
          // calculate image or parent ratio
          elemW = sizeElement.scrollWidth;
          elemH = sizeElement.scrollHeight;

          while ((!elemW || !elemH) && sizeElement !== document) {
            sizeElement = sizeElement.parentNode;
            elemW = sizeElement.scrollWidth;
            elemH = sizeElement.scrollHeight;
          }
          if (elemW && elemH) {
            opts.ratio = opts.traditionalRatio
              ? elemH / elemW
              : elemW / elemH;
          }
        }

        src = replaceUrlProps(src, opts);

        src.isPicture = opts.isPicture;

        if (buggySizes && elem.nodeName.toUpperCase() == "IMG") {
          elem.removeAttribute(config.srcsetAttr);
        } else {
          elem.setAttribute(config.srcsetAttr, src.srcset.join(", "));
        }

        Object.defineProperty(elem, "_lazyrias", {
          value: src,
          writable: true,
        });
      }

      function createAttrObject(elem, src) {
        var opts = getElementOptions(elem, src);

        riasCfg.modifyOptions.call(elem, {
          target: elem,
          details: opts,
          detail: opts,
        });

        lazySizes.fire(elem, "lazyriasmodifyoptions", opts);
        return opts;
      }

      function getSrc(elem) {
        return (
          elem.getAttribute(
            elem.getAttribute("data-srcattr") || riasCfg.srcAttr
          ) ||
          elem.getAttribute(config.srcsetAttr) ||
          elem.getAttribute(config.srcAttr) ||
          elem.getAttribute("data-pfsrcset") ||
          ""
        );
      }

      addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance != lazySizes) {
            return;
          }

          var elem,
            src,
            elemOpts,
            sourceOpts,
            parent,
            sources,
            i,
            len,
            sourceSrc,
            sizes,
            detail,
            hasPlaceholder,
            modified,
            emptyList;
          elem = e.target;

          if (
            !e.detail.dataAttr ||
            e.defaultPrevented ||
            riasCfg.disabled ||
            !(
              (sizes =
                elem.getAttribute(config.sizesAttr) ||
                elem.getAttribute("sizes")) && regAllowedSizes.test(sizes)
            )
          ) {
            return;
          }

          src = getSrc(elem);

          elemOpts = createAttrObject(elem, src);

          hasPlaceholder =
            regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);

          if (elemOpts.isPicture && (parent = elem.parentNode)) {
            sources = parent.getElementsByTagName("source");
            for (i = 0, len = sources.length; i < len; i++) {
              if (
                hasPlaceholder ||
                regWidth.test((sourceSrc = getSrc(sources[i])))
              ) {
                sourceOpts = getElementOptions(
                  sources[i],
                  sourceSrc,
                  elemOpts
                );
                setSrc(sourceSrc, sourceOpts, sources[i]);
                modified = true;
              }
            }
          }

          if (hasPlaceholder || regWidth.test(src)) {
            setSrc(src, elemOpts, elem);
            modified = true;
          } else if (modified) {
            emptyList = [];
            emptyList.srcset = [];
            emptyList.isPicture = true;
            Object.defineProperty(elem, "_lazyrias", {
              value: emptyList,
              writable: true,
            });
          }

          if (modified) {
            if (supportPicture) {
              elem.removeAttribute(config.srcAttr);
            } else if (sizes != "auto") {
              detail = {
                width: parseInt(sizes, 10),
              };
              polyfill({
                target: elem,
                detail: detail,
              });
            }
          }
        },
        true
      );
      // partial polyfill
      var polyfill = (function () {
        var ascendingSort = function (a, b) {
          return a.w - b.w;
        };

        var reduceCandidate = function (srces) {
          var lowerCandidate, bonusFactor;
          var len = srces.length;
          var candidate = srces[len - 1];
          var i = 0;

          for (i; i < len; i++) {
            candidate = srces[i];
            candidate.d = candidate.w / srces.w;
            if (candidate.d >= srces.d) {
              if (
                !candidate.cached &&
                (lowerCandidate = srces[i - 1]) &&
                lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)
              ) {
                bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                if (lowerCandidate.cached) {
                  lowerCandidate.d += 0.15 * bonusFactor;
                }

                if (
                  lowerCandidate.d + (candidate.d - srces.d) * bonusFactor >
                  srces.d
                ) {
                  candidate = lowerCandidate;
                }
              }
              break;
            }
          }
          return candidate;
        };

        var getWSet = function (elem, testPicture) {
          var src;
          if (
            !elem._lazyrias &&
            lazySizes.pWS &&
            (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || "")))
              .length
          ) {
            Object.defineProperty(elem, "_lazyrias", {
              value: src,
              writable: true,
            });
            if (testPicture && elem.parentNode) {
              src.isPicture =
                elem.parentNode.nodeName.toUpperCase() == "PICTURE";
            }
          }
          return elem._lazyrias;
        };

        var getX = function (elem) {
          var dpr = window.devicePixelRatio || 1;
          var optimum = lazySizes.getX && lazySizes.getX(elem);
          return Math.min(optimum || dpr, 2.4, dpr);
        };

        var getCandidate = function (elem, width) {
          var sources, i, len, media, srces, src;

          srces = elem._lazyrias;

          if (srces.isPicture && window.matchMedia) {
            for (
              i = 0,
                sources = elem.parentNode.getElementsByTagName("source"),
                len = sources.length;
              i < len;
              i++
            ) {
              if (
                getWSet(sources[i]) &&
                !sources[i].getAttribute("type") &&
                (!(media = sources[i].getAttribute("media")) ||
                  (matchMedia(media) || {}).matches)
              ) {
                srces = sources[i]._lazyrias;
                break;
              }
            }
          }

          if (!srces.w || srces.w < width) {
            srces.w = width;
            srces.d = getX(elem);
            src = reduceCandidate(srces.sort(ascendingSort));
          }

          return src;
        };

        var polyfill = function (e) {
          if (e.detail.instance != lazySizes) {
            return;
          }

          var candidate;
          var elem = e.target;

          if (
            !buggySizes &&
            (window.respimage || window.picturefill || lazySizesCfg.pf)
          ) {
            document.removeEventListener("lazybeforesizes", polyfill);
            return;
          }

          if (
            !("_lazyrias" in elem) &&
            (!e.detail.dataAttr || !getWSet(elem, true))
          ) {
            return;
          }

          candidate = getCandidate(elem, e.detail.width);

          if (candidate && candidate.u && elem._lazyrias.cur != candidate.u) {
            elem._lazyrias.cur = candidate.u;
            candidate.cached = true;
            lazySizes.rAF(function () {
              elem.setAttribute(config.srcAttr, candidate.u);
              elem.setAttribute("src", candidate.u);
            });
          }
        };

        if (!supportPicture) {
          addEventListener("lazybeforesizes", polyfill);
        } else {
          polyfill = function () {};
        }

        return polyfill;
      })();
    });

    /***/
  },
  /* 30 */
  /***/ function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__,
      __WEBPACK_AMD_DEFINE_ARRAY__,
      __WEBPACK_AMD_DEFINE_RESULT__;
    (function (window, factory) {
      var globalInstall = function () {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (true && module.exports) {
        factory(__webpack_require__(2));
      } else if (true) {
        !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)]),
        (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
        (__WEBPACK_AMD_DEFINE_RESULT__ =
          typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
            ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                exports,
                __WEBPACK_AMD_DEFINE_ARRAY__
              )
            : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
          (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
      }
    })(window, function (window, document, lazySizes) {
      "use strict";
      if (!window.addEventListener) {
        return;
      }

      var lazySizesCfg = lazySizes.cfg;
      var regWhite = /\s+/g;
      var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
      var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
      var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
      var regBgUrlEscape = /\(|\)|'/;
      var allowedBackgroundSize = { contain: 1, cover: 1 };
      var proxyWidth = function (elem) {
        var width = lazySizes.gW(elem, elem.parentNode);

        if (!elem._lazysizesWidth || width > elem._lazysizesWidth) {
          elem._lazysizesWidth = width;
        }
        return elem._lazysizesWidth;
      };
      var getBgSize = function (elem) {
        var bgSize;

        bgSize = (
          getComputedStyle(elem) || { getPropertyValue: function () {} }
        ).getPropertyValue("background-size");

        if (
          !allowedBackgroundSize[bgSize] &&
          allowedBackgroundSize[elem.style.backgroundSize]
        ) {
          bgSize = elem.style.backgroundSize;
        }

        return bgSize;
      };
      var setTypeOrMedia = function (source, match) {
        if (match) {
          var typeMatch = match.match(regType);
          if (typeMatch && typeMatch[1]) {
            source.setAttribute("type", typeMatch[1]);
          } else {
            source.setAttribute(
              "media",
              lazySizesCfg.customMedia[match] || match
            );
          }
        }
      };
      var createPicture = function (sets, elem, img) {
        var picture = document.createElement("picture");
        var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
        var ratio = elem.getAttribute("data-ratio");
        var optimumx = elem.getAttribute("data-optimumx");

        if (elem._lazybgset && elem._lazybgset.parentNode == elem) {
          elem.removeChild(elem._lazybgset);
        }

        Object.defineProperty(img, "_lazybgset", {
          value: elem,
          writable: true,
        });
        Object.defineProperty(elem, "_lazybgset", {
          value: picture,
          writable: true,
        });

        sets = sets.replace(regWhite, " ").split(regSplitSet);

        picture.style.display = "none";
        img.className = lazySizesCfg.lazyClass;

        if (sets.length == 1 && !sizes) {
          sizes = "auto";
        }

        sets.forEach(function (set) {
          var match;
          var source = document.createElement("source");

          if (sizes && sizes != "auto") {
            source.setAttribute("sizes", sizes);
          }

          if ((match = set.match(regSource))) {
            source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);

            setTypeOrMedia(source, match[2]);
            setTypeOrMedia(source, match[3]);
          } else {
            source.setAttribute(lazySizesCfg.srcsetAttr, set);
          }

          picture.appendChild(source);
        });

        if (sizes) {
          img.setAttribute(lazySizesCfg.sizesAttr, sizes);
          elem.removeAttribute(lazySizesCfg.sizesAttr);
          elem.removeAttribute("sizes");
        }
        if (optimumx) {
          img.setAttribute("data-optimumx", optimumx);
        }
        if (ratio) {
          img.setAttribute("data-ratio", ratio);
        }

        picture.appendChild(img);

        elem.appendChild(picture);
      };

      var proxyLoad = function (e) {
        if (!e.target._lazybgset) {
          return;
        }

        var image = e.target;
        var elem = image._lazybgset;
        var bg = image.currentSrc || image.src;

        if (bg) {
          var useSrc = regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg;
          var event = lazySizes.fire(elem, "bgsetproxy", {
            src: bg,
            useSrc: useSrc,
            fullSrc: null,
          });

          if (!event.defaultPrevented) {
            elem.style.backgroundImage =
              event.detail.fullSrc || "url(" + event.detail.useSrc + ")";
          }
        }

        if (image._lazybgsetLoading) {
          lazySizes.fire(elem, "_lazyloaded", {}, false, true);
          delete image._lazybgsetLoading;
        }
      };

      addEventListener("lazybeforeunveil", function (e) {
        var set, image, elem;

        if (
          e.defaultPrevented ||
          !(set = e.target.getAttribute("data-bgset"))
        ) {
          return;
        }

        elem = e.target;
        image = document.createElement("img");

        image.alt = "";

        image._lazybgsetLoading = true;
        e.detail.firesLoad = true;

        createPicture(set, elem, image);

        setTimeout(function () {
          lazySizes.loader.unveil(image);

          lazySizes.rAF(function () {
            lazySizes.fire(image, "_lazyloaded", {}, true, true);
            if (image.complete) {
              proxyLoad({ target: image });
            }
          });
        });
      });

      document.addEventListener("load", proxyLoad, true);

      window.addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance != lazySizes) {
            return;
          }
          if (e.target._lazybgset && e.detail.dataAttr) {
            var elem = e.target._lazybgset;
            var bgSize = getBgSize(elem);

            if (allowedBackgroundSize[bgSize]) {
              e.target._lazysizesParentFit = bgSize;

              lazySizes.rAF(function () {
                e.target.setAttribute("data-parent-fit", bgSize);
                if (e.target._lazysizesParentFit) {
                  delete e.target._lazysizesParentFit;
                }
              });
            }
          }
        },
        true
      );

      document.documentElement.addEventListener(
        "lazybeforesizes",
        function (e) {
          if (
            e.defaultPrevented ||
            !e.target._lazybgset ||
            e.detail.instance != lazySizes
          ) {
            return;
          }
          e.detail.width = proxyWidth(e.target._lazybgset);
        }
      );
    });

    /***/
  },
  /* 31 */
  /***/ function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_FACTORY__,
      __WEBPACK_AMD_DEFINE_ARRAY__,
      __WEBPACK_AMD_DEFINE_RESULT__;
    (function (window, factory) {
      if (!window) {
        return;
      }
      var globalInstall = function () {
        factory(window.lazySizes);
        window.removeEventListener("lazyunveilread", globalInstall, true);
      };

      factory = factory.bind(null, window, window.document);

      if (true && module.exports) {
        factory(__webpack_require__(2));
      } else if (true) {
        !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)]),
        (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
        (__WEBPACK_AMD_DEFINE_RESULT__ =
          typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
            ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                exports,
                __WEBPACK_AMD_DEFINE_ARRAY__
              )
            : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
          (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {
      }
    })(
      typeof window != "undefined" ? window : 0,
      function (window, document, lazySizes) {
        /*jshint eqnull:true */
        "use strict";
        var polyfill;
        var lazySizesCfg = lazySizes.cfg;
        var img = document.createElement("img");
        var supportSrcset = "sizes" in img && "srcset" in img;
        var regHDesc = /\s+\d+h/g;
        var fixEdgeHDescriptor = (function () {
          var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
          var forEach = Array.prototype.forEach;

          return function () {
            var img = document.createElement("img");
            var removeHDescriptors = function (source) {
              var ratio, match;
              var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
              if (srcset) {
                if ((match = srcset.match(regDescriptors))) {
                  if (match[2] == "w") {
                    ratio = match[1] / match[3];
                  } else {
                    ratio = match[3] / match[1];
                  }

                  if (ratio) {
                    source.setAttribute("data-aspectratio", ratio);
                  }
                  source.setAttribute(
                    lazySizesCfg.srcsetAttr,
                    srcset.replace(regHDesc, "")
                  );
                }
              }
            };
            var handler = function (e) {
              if (e.detail.instance != lazySizes) {
                return;
              }
              var picture = e.target.parentNode;

              if (picture && picture.nodeName == "PICTURE") {
                forEach.call(
                  picture.getElementsByTagName("source"),
                  removeHDescriptors
                );
              }
              removeHDescriptors(e.target);
            };

            var test = function () {
              if (!!img.currentSrc) {
                document.removeEventListener("lazybeforeunveil", handler);
              }
            };

            document.addEventListener("lazybeforeunveil", handler);

            img.onload = test;
            img.onerror = test;

            img.srcset = "data:,a 1w 1h";

            if (img.complete) {
              test();
            }
          };
        })();

        if (!lazySizesCfg.supportsType) {
          lazySizesCfg.supportsType = function (type /*, elem*/) {
            return !type;
          };
        }

        if (window.HTMLPictureElement && supportSrcset) {
          if (!lazySizes.hasHDescriptorFix && document.msElementsFromPoint) {
            lazySizes.hasHDescriptorFix = true;
            fixEdgeHDescriptor();
          }
          return;
        }

        if (window.picturefill || lazySizesCfg.pf) {
          return;
        }

        lazySizesCfg.pf = function (options) {
          var i, len;
          if (window.picturefill) {
            return;
          }
          for (i = 0, len = options.elements.length; i < len; i++) {
            polyfill(options.elements[i]);
          }
        };

        // partial polyfill
        polyfill = (function () {
          var ascendingSort = function (a, b) {
            return a.w - b.w;
          };
          var regPxLength = /^\s*\d+\.*\d*px\s*$/;
          var reduceCandidate = function (srces) {
            var lowerCandidate, bonusFactor;
            var len = srces.length;
            var candidate = srces[len - 1];
            var i = 0;

            for (i; i < len; i++) {
              candidate = srces[i];
              candidate.d = candidate.w / srces.w;

              if (candidate.d >= srces.d) {
                if (
                  !candidate.cached &&
                  (lowerCandidate = srces[i - 1]) &&
                  lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)
                ) {
                  bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                  if (lowerCandidate.cached) {
                    lowerCandidate.d += 0.15 * bonusFactor;
                  }

                  if (
                    lowerCandidate.d + (candidate.d - srces.d) * bonusFactor >
                    srces.d
                  ) {
                    candidate = lowerCandidate;
                  }
                }
                break;
              }
            }
            return candidate;
          };

          var parseWsrcset = (function () {
            var candidates;
            var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
            var regMultiple = /\s/;
            var addCandidate = function (match, candidate, url, wDescriptor) {
              candidates.push({
                c: candidate,
                u: url,
                w: wDescriptor * 1,
              });
            };

            return function (input) {
              candidates = [];
              input = input.trim();
              input
                .replace(regHDesc, "")
                .replace(regWCandidates, addCandidate);

              if (!candidates.length && input && !regMultiple.test(input)) {
                candidates.push({
                  c: input,
                  u: input,
                  w: 99,
                });
              }

              return candidates;
            };
          })();

          var runMatchMedia = function () {
            if (runMatchMedia.init) {
              return;
            }

            runMatchMedia.init = true;
            addEventListener(
              "resize",
              (function () {
                var timer;
                var matchMediaElems =
                  document.getElementsByClassName("lazymatchmedia");
                var run = function () {
                  var i, len;
                  for (i = 0, len = matchMediaElems.length; i < len; i++) {
                    polyfill(matchMediaElems[i]);
                  }
                };

                return function () {
                  clearTimeout(timer);
                  timer = setTimeout(run, 66);
                };
              })()
            );
          };

          var createSrcset = function (elem, isImage) {
            var parsedSet;
            var srcSet =
              elem.getAttribute("srcset") ||
              elem.getAttribute(lazySizesCfg.srcsetAttr);

            if (!srcSet && isImage) {
              srcSet = !elem._lazypolyfill
                ? elem.getAttribute(lazySizesCfg.srcAttr) ||
                  elem.getAttribute("src")
                : elem._lazypolyfill._set;
            }

            if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
              parsedSet = parseWsrcset(srcSet || "");
              if (isImage && elem.parentNode) {
                parsedSet.isPicture =
                  elem.parentNode.nodeName.toUpperCase() == "PICTURE";

                if (parsedSet.isPicture) {
                  if (window.matchMedia) {
                    lazySizes.aC(elem, "lazymatchmedia");
                    runMatchMedia();
                  }
                }
              }

              parsedSet._set = srcSet;
              Object.defineProperty(elem, "_lazypolyfill", {
                value: parsedSet,
                writable: true,
              });
            }
          };

          var getX = function (elem) {
            var dpr = window.devicePixelRatio || 1;
            var optimum = lazySizes.getX && lazySizes.getX(elem);
            return Math.min(optimum || dpr, 2.5, dpr);
          };

          var matchesMedia = function (media) {
            if (window.matchMedia) {
              matchesMedia = function (media) {
                return !media || (matchMedia(media) || {}).matches;
              };
            } else {
              return !media;
            }

            return matchesMedia(media);
          };

          var getCandidate = function (elem) {
            var sources, i, len, media, source, srces, src, width;

            source = elem;
            createSrcset(source, true);
            srces = source._lazypolyfill;

            if (srces.isPicture) {
              for (
                i = 0,
                  sources = elem.parentNode.getElementsByTagName("source"),
                  len = sources.length;
                i < len;
                i++
              ) {
                if (
                  lazySizesCfg.supportsType(
                    sources[i].getAttribute("type"),
                    elem
                  ) &&
                  matchesMedia(sources[i].getAttribute("media"))
                ) {
                  source = sources[i];
                  createSrcset(source);
                  srces = source._lazypolyfill;
                  break;
                }
              }
            }

            if (srces.length > 1) {
              width = source.getAttribute("sizes") || "";
              width =
                (regPxLength.test(width) && parseInt(width, 10)) ||
                lazySizes.gW(elem, elem.parentNode);
              srces.d = getX(elem);
              if (!srces.src || !srces.w || srces.w < width) {
                srces.w = width;
                src = reduceCandidate(srces.sort(ascendingSort));
                srces.src = src;
              } else {
                src = srces.src;
              }
            } else {
              src = srces[0];
            }

            return src;
          };

          var p = function (elem) {
            if (
              supportSrcset &&
              elem.parentNode &&
              elem.parentNode.nodeName.toUpperCase() != "PICTURE"
            ) {
              return;
            }
            var candidate = getCandidate(elem);

            if (
              candidate &&
              candidate.u &&
              elem._lazypolyfill.cur != candidate.u
            ) {
              elem._lazypolyfill.cur = candidate.u;
              candidate.cached = true;
              elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
              elem.setAttribute("src", candidate.u);
            }
          };

          p.parse = parseWsrcset;

          return p;
        })();

        if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) {
          (function () {
            var sels = [];
            [
              'img[sizes$="px"][srcset].',
              "picture > img:not([srcset]).",
            ].forEach(function (sel) {
              sels.push(sel + lazySizesCfg.loadedClass);
              sels.push(sel + lazySizesCfg.loadingClass);
            });
            lazySizesCfg.pf({
              elements: document.querySelectorAll(sels.join(", ")),
            });
          })();
        }
      }
    );

    /***/
  },
  /* 32 */
  /***/ function (module, exports) {
    window.document.addEventListener("alpine:init", () => {
      window.Alpine.store("cartCount", {
        count: (window.theme && window.theme.cartItemCount) || 0,
        countWithText: function countWithText() {
          var string = theme.strings.itemCountOther;

          if (this.count === 1) {
            string = theme.strings.itemCountOne;
          }

          return string.replace("{{ count }}", this.count);
        },
      });
      document.body.addEventListener(
        "label:modalcart:itemcountupdate",
        function (e) {
          window.Alpine.store("cartCount").count = e.detail.count || 0;
        }
      );
    });

    /***/
  },
  /* 33 */
  /***/ function (module, exports, __webpack_require__) {
    (function (global, factory) {
      true ? (module.exports = factory()) : undefined;
    })(this, function () {
      "use strict";
      // packages/alpinejs/src/scheduler.js
      var flushPending = false;
      var flushing = false;
      var queue = [];
      var lastFlushedIndex = -1;
      function scheduler(callback) {
        queueJob(callback);
      }
      function queueJob(job) {
        if (!queue.includes(job)) queue.push(job);
        queueFlush();
      }
      function dequeueJob(job) {
        let index = queue.indexOf(job);
        if (index !== -1 && index > lastFlushedIndex) queue.splice(index, 1);
      }
      function queueFlush() {
        if (!flushing && !flushPending) {
          flushPending = true;
          queueMicrotask(flushJobs);
        }
      }
      function flushJobs() {
        flushPending = false;
        flushing = true;
        for (let i = 0; i < queue.length; i++) {
          queue[i]();
          lastFlushedIndex = i;
        }
        queue.length = 0;
        lastFlushedIndex = -1;
        flushing = false;
      }

      // packages/alpinejs/src/reactivity.js
      var reactive;
      var effect;
      var release;
      var raw;
      var shouldSchedule = true;
      function disableEffectScheduling(callback) {
        shouldSchedule = false;
        callback();
        shouldSchedule = true;
      }
      function setReactivityEngine(engine) {
        reactive = engine.reactive;
        release = engine.release;
        effect = (callback) =>
          engine.effect(callback, {
            scheduler: (task) => {
              if (shouldSchedule) {
                scheduler(task);
              } else {
                task();
              }
            },
          });
        raw = engine.raw;
      }
      function overrideEffect(override) {
        effect = override;
      }
      function elementBoundEffect(el) {
        let cleanup2 = () => {};
        let wrappedEffect = (callback) => {
          let effectReference = effect(callback);
          if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = () => {
              el._x_effects.forEach((i) => i());
            };
          }
          el._x_effects.add(effectReference);
          cleanup2 = () => {
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            release(effectReference);
          };
          return effectReference;
        };
        return [
          wrappedEffect,
          () => {
            cleanup2();
          },
        ];
      }
      function watch(getter, callback) {
        let firstTime = true;
        let oldValue;
        let effectReference = effect(() => {
          let value = getter();
          JSON.stringify(value);
          if (!firstTime) {
            queueMicrotask(() => {
              callback(value, oldValue);
              oldValue = value;
            });
          } else {
            oldValue = value;
          }
          firstTime = false;
        });
        return () => release(effectReference);
      }

      // packages/alpinejs/src/mutation.js
      var onAttributeAddeds = [];
      var onElRemoveds = [];
      var onElAddeds = [];
      function onElAdded(callback) {
        onElAddeds.push(callback);
      }
      function onElRemoved(el, callback) {
        if (typeof callback === "function") {
          if (!el._x_cleanups) el._x_cleanups = [];
          el._x_cleanups.push(callback);
        } else {
          callback = el;
          onElRemoveds.push(callback);
        }
      }
      function onAttributesAdded(callback) {
        onAttributeAddeds.push(callback);
      }
      function onAttributeRemoved(el, name, callback) {
        if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
        if (!el._x_attributeCleanups[name])
          el._x_attributeCleanups[name] = [];
        el._x_attributeCleanups[name].push(callback);
      }
      function cleanupAttributes(el, names) {
        if (!el._x_attributeCleanups) return;
        Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
          if (names === void 0 || names.includes(name)) {
            value.forEach((i) => i());
            delete el._x_attributeCleanups[name];
          }
        });
      }
      function cleanupElement(el) {
        if (el._x_cleanups) {
          while (el._x_cleanups.length) el._x_cleanups.pop()();
        }
      }
      var observer = new MutationObserver(onMutate);
      var currentlyObserving = false;
      function startObservingMutations() {
        observer.observe(document, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeOldValue: true,
        });
        currentlyObserving = true;
      }
      function stopObservingMutations() {
        flushObserver();
        observer.disconnect();
        currentlyObserving = false;
      }
      var queuedMutations = [];
      function flushObserver() {
        let records = observer.takeRecords();
        queuedMutations.push(() => records.length > 0 && onMutate(records));
        let queueLengthWhenTriggered = queuedMutations.length;
        queueMicrotask(() => {
          if (queuedMutations.length === queueLengthWhenTriggered) {
            while (queuedMutations.length > 0) queuedMutations.shift()();
          }
        });
      }
      function mutateDom(callback) {
        if (!currentlyObserving) return callback();
        stopObservingMutations();
        let result = callback();
        startObservingMutations();
        return result;
      }
      var isCollecting = false;
      var deferredMutations = [];
      function deferMutations() {
        isCollecting = true;
      }
      function flushAndStopDeferringMutations() {
        isCollecting = false;
        onMutate(deferredMutations);
        deferredMutations = [];
      }
      function onMutate(mutations) {
        if (isCollecting) {
          deferredMutations = deferredMutations.concat(mutations);
          return;
        }
        let addedNodes = /* @__PURE__ */ new Set();
        let removedNodes = /* @__PURE__ */ new Set();
        let addedAttributes = /* @__PURE__ */ new Map();
        let removedAttributes = /* @__PURE__ */ new Map();
        for (let i = 0; i < mutations.length; i++) {
          if (mutations[i].target._x_ignoreMutationObserver) continue;
          if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach(
              (node) => node.nodeType === 1 && addedNodes.add(node)
            );
            mutations[i].removedNodes.forEach(
              (node) => node.nodeType === 1 && removedNodes.add(node)
            );
          }
          if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = () => {
              if (!addedAttributes.has(el)) addedAttributes.set(el, []);
              addedAttributes
                .get(el)
                .push({ name, value: el.getAttribute(name) });
            };
            let remove = () => {
              if (!removedAttributes.has(el)) removedAttributes.set(el, []);
              removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) {
              add2();
            } else if (el.hasAttribute(name)) {
              remove();
              add2();
            } else {
              remove();
            }
          }
        }
        removedAttributes.forEach((attrs, el) => {
          cleanupAttributes(el, attrs);
        });
        addedAttributes.forEach((attrs, el) => {
          onAttributeAddeds.forEach((i) => i(el, attrs));
        });
        for (let node of removedNodes) {
          if (addedNodes.has(node)) continue;
          onElRemoveds.forEach((i) => i(node));
        }
        addedNodes.forEach((node) => {
          node._x_ignoreSelf = true;
          node._x_ignore = true;
        });
        for (let node of addedNodes) {
          if (removedNodes.has(node)) continue;
          if (!node.isConnected) continue;
          delete node._x_ignoreSelf;
          delete node._x_ignore;
          onElAddeds.forEach((i) => i(node));
          node._x_ignore = true;
          node._x_ignoreSelf = true;
        }
        addedNodes.forEach((node) => {
          delete node._x_ignoreSelf;
          delete node._x_ignore;
        });
        addedNodes = null;
        removedNodes = null;
        addedAttributes = null;
        removedAttributes = null;
      }

      // packages/alpinejs/src/scope.js
      function scope(node) {
        return mergeProxies(closestDataStack(node));
      }
      function addScopeToNode(node, data2, referenceNode) {
        node._x_dataStack = [
          data2,
          ...closestDataStack(referenceNode || node),
        ];
        return () => {
          node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
        };
      }
      function closestDataStack(node) {
        if (node._x_dataStack) return node._x_dataStack;
        if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
          return closestDataStack(node.host);
        }
        if (!node.parentNode) {
          return [];
        }
        return closestDataStack(node.parentNode);
      }
      function mergeProxies(objects) {
        return new Proxy({ objects }, mergeProxyTrap);
      }
      var mergeProxyTrap = {
        ownKeys({ objects }) {
          return Array.from(new Set(objects.flatMap((i) => Object.keys(i))));
        },
        has({ objects }, name) {
          if (name == Symbol.unscopables) return false;
          return objects.some(
            (obj) =>
              Object.prototype.hasOwnProperty.call(obj, name) ||
              Reflect.has(obj, name)
          );
        },
        get({ objects }, name, thisProxy) {
          if (name == "toJSON") return collapseProxies;
          return Reflect.get(
            objects.find((obj) => Reflect.has(obj, name)) || {},
            name,
            thisProxy
          );
        },
        set({ objects }, name, value, thisProxy) {
          const target =
            objects.find((obj) =>
              Object.prototype.hasOwnProperty.call(obj, name)
            ) || objects[objects.length - 1];
          const descriptor = Object.getOwnPropertyDescriptor(target, name);
          if (descriptor?.set && descriptor?.get)
            return descriptor.set.call(thisProxy, value) || true;
          return Reflect.set(target, name, value);
        },
      };
      function collapseProxies() {
        let keys = Reflect.ownKeys(this);
        return keys.reduce((acc, key) => {
          acc[key] = Reflect.get(this, key);
          return acc;
        }, {});
      }

      // packages/alpinejs/src/interceptor.js
      function initInterceptors(data2) {
        let isObject2 = (val) =>
          typeof val === "object" && !Array.isArray(val) && val !== null;
        let recurse = (obj, basePath = "") => {
          Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(
            ([key, { value, enumerable }]) => {
              if (enumerable === false || value === void 0) return;
              if (
                typeof value === "object" &&
                value !== null &&
                value.__v_skip
              )
                return;
              let path = basePath === "" ? key : `${basePath}.${key}`;
              if (
                typeof value === "object" &&
                value !== null &&
                value._x_interceptor
              ) {
                obj[key] = value.initialize(data2, path, key);
              } else {
                if (
                  isObject2(value) &&
                  value !== obj &&
                  !(value instanceof Element)
                ) {
                  recurse(value, path);
                }
              }
            }
          );
        };
        return recurse(data2);
      }
      function interceptor(callback, mutateObj = () => {}) {
        let obj = {
          initialValue: void 0,
          _x_interceptor: true,
          initialize(data2, path, key) {
            return callback(
              this.initialValue,
              () => get(data2, path),
              (value) => set(data2, path, value),
              path,
              key
            );
          },
        };
        mutateObj(obj);
        return (initialValue) => {
          if (
            typeof initialValue === "object" &&
            initialValue !== null &&
            initialValue._x_interceptor
          ) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key) => {
              let innerValue = initialValue.initialize(data2, path, key);
              obj.initialValue = innerValue;
              return initialize(data2, path, key);
            };
          } else {
            obj.initialValue = initialValue;
          }
          return obj;
        };
      }
      function get(obj, path) {
        return path
          .split(".")
          .reduce((carry, segment) => carry[segment], obj);
      }
      function set(obj, path, value) {
        if (typeof path === "string") path = path.split(".");
        if (path.length === 1) obj[path[0]] = value;
        else if (path.length === 0) throw error;
        else {
          if (obj[path[0]]) return set(obj[path[0]], path.slice(1), value);
          else {
            obj[path[0]] = {};
            return set(obj[path[0]], path.slice(1), value);
          }
        }
      }

      // packages/alpinejs/src/magics.js
      var magics = {};
      function magic(name, callback) {
        magics[name] = callback;
      }
      function injectMagics(obj, el) {
        Object.entries(magics).forEach(([name, callback]) => {
          let memoizedUtilities = null;
          function getUtilities() {
            if (memoizedUtilities) {
              return memoizedUtilities;
            } else {
              let [utilities, cleanup2] = getElementBoundUtilities(el);
              memoizedUtilities = { interceptor, ...utilities };
              onElRemoved(el, cleanup2);
              return memoizedUtilities;
            }
          }
          Object.defineProperty(obj, `$${name}`, {
            get() {
              return callback(el, getUtilities());
            },
            enumerable: false,
          });
        });
        return obj;
      }

      // packages/alpinejs/src/utils/error.js
      function tryCatch(el, expression, callback, ...args) {
        try {
          return callback(...args);
        } catch (e) {
          handleError(e, el, expression);
        }
      }
      function handleError(error2, el, expression = void 0) {
        error2 = Object.assign(
          error2 ?? { message: "No error message given." },
          { el, expression }
        );
        console.warn(
          `Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`,
          el
        );
        setTimeout(() => {
          throw error2;
        }, 0);
      }

      // packages/alpinejs/src/evaluator.js
      var shouldAutoEvaluateFunctions = true;
      function dontAutoEvaluateFunctions(callback) {
        let cache = shouldAutoEvaluateFunctions;
        shouldAutoEvaluateFunctions = false;
        let result = callback();
        shouldAutoEvaluateFunctions = cache;
        return result;
      }
      function evaluate(el, expression, extras = {}) {
        let result;
        evaluateLater(el, expression)((value) => (result = value), extras);
        return result;
      }
      function evaluateLater(...args) {
        return theEvaluatorFunction(...args);
      }
      var theEvaluatorFunction = normalEvaluator;
      function setEvaluator(newEvaluator) {
        theEvaluatorFunction = newEvaluator;
      }
      function normalEvaluator(el, expression) {
        let overriddenMagics = {};
        injectMagics(overriddenMagics, el);
        let dataStack = [overriddenMagics, ...closestDataStack(el)];
        let evaluator =
          typeof expression === "function"
            ? generateEvaluatorFromFunction(dataStack, expression)
            : generateEvaluatorFromString(dataStack, expression, el);
        return tryCatch.bind(null, el, expression, evaluator);
      }
      function generateEvaluatorFromFunction(dataStack, func) {
        return (
          receiver = () => {},
          { scope: scope2 = {}, params = [] } = {}
        ) => {
          let result = func.apply(
            mergeProxies([scope2, ...dataStack]),
            params
          );
          runIfTypeOfFunction(receiver, result);
        };
      }
      var evaluatorMemo = {};
      function generateFunctionFromString(expression, el) {
        if (evaluatorMemo[expression]) {
          return evaluatorMemo[expression];
        }
        let AsyncFunction = Object.getPrototypeOf(
          async function () {}
        ).constructor;
        let rightSideSafeExpression =
          /^[\n\s]*if.*\(.*\)/.test(expression.trim()) ||
          /^(let|const)\s/.test(expression.trim())
            ? `(async()=>{ ${expression} })()`
            : expression;
        const safeAsyncFunction = () => {
          try {
            let func2 = new AsyncFunction(
              ["__self", "scope"],
              `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
            );
            Object.defineProperty(func2, "name", {
              value: `[Alpine] ${expression}`,
            });
            return func2;
          } catch (error2) {
            handleError(error2, el, expression);
            return Promise.resolve();
          }
        };
        let func = safeAsyncFunction();
        evaluatorMemo[expression] = func;
        return func;
      }
      function generateEvaluatorFromString(dataStack, expression, el) {
        let func = generateFunctionFromString(expression, el);
        return (
          receiver = () => {},
          { scope: scope2 = {}, params = [] } = {}
        ) => {
          func.result = void 0;
          func.finished = false;
          let completeScope = mergeProxies([scope2, ...dataStack]);
          if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2) =>
              handleError(error2, el, expression)
            );
            if (func.finished) {
              runIfTypeOfFunction(
                receiver,
                func.result,
                completeScope,
                params,
                el
              );
              func.result = void 0;
            } else {
              promise
                .then((result) => {
                  runIfTypeOfFunction(
                    receiver,
                    result,
                    completeScope,
                    params,
                    el
                  );
                })
                .catch((error2) => handleError(error2, el, expression))
                .finally(() => (func.result = void 0));
            }
          }
        };
      }
      function runIfTypeOfFunction(receiver, value, scope2, params, el) {
        if (shouldAutoEvaluateFunctions && typeof value === "function") {
          let result = value.apply(scope2, params);
          if (result instanceof Promise) {
            result
              .then((i) => runIfTypeOfFunction(receiver, i, scope2, params))
              .catch((error2) => handleError(error2, el, value));
          } else {
            receiver(result);
          }
        } else if (typeof value === "object" && value instanceof Promise) {
          value.then((i) => receiver(i));
        } else {
          receiver(value);
        }
      }

      // packages/alpinejs/src/directives.js
      var prefixAsString = "x-";
      function prefix(subject = "") {
        return prefixAsString + subject;
      }
      function setPrefix(newPrefix) {
        prefixAsString = newPrefix;
      }
      var directiveHandlers = {};
      function directive(name, callback) {
        directiveHandlers[name] = callback;
        return {
          before(directive2) {
            if (!directiveHandlers[directive2]) {
              console.warn(
                String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`
              );
              return;
            }
            const pos = directiveOrder.indexOf(directive2);
            directiveOrder.splice(
              pos >= 0 ? pos : directiveOrder.indexOf("DEFAULT"),
              0,
              name
            );
          },
        };
      }
      function directiveExists(name) {
        return Object.keys(directiveHandlers).includes(name);
      }
      function directives(el, attributes, originalAttributeOverride) {
        attributes = Array.from(attributes);
        if (el._x_virtualDirectives) {
          let vAttributes = Object.entries(el._x_virtualDirectives).map(
            ([name, value]) => ({ name, value })
          );
          let staticAttributes = attributesOnly(vAttributes);
          vAttributes = vAttributes.map((attribute) => {
            if (
              staticAttributes.find((attr) => attr.name === attribute.name)
            ) {
              return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`,
              };
            }
            return attribute;
          });
          attributes = attributes.concat(vAttributes);
        }
        let transformedAttributeMap = {};
        let directives2 = attributes
          .map(
            toTransformedAttributes(
              (newName, oldName) =>
                (transformedAttributeMap[newName] = oldName)
            )
          )
          .filter(outNonAlpineAttributes)
          .map(
            toParsedDirectives(
              transformedAttributeMap,
              originalAttributeOverride
            )
          )
          .sort(byPriority);
        return directives2.map((directive2) => {
          return getDirectiveHandler(el, directive2);
        });
      }
      function attributesOnly(attributes) {
        return Array.from(attributes)
          .map(toTransformedAttributes())
          .filter((attr) => !outNonAlpineAttributes(attr));
      }
      var isDeferringHandlers = false;
      var directiveHandlerStacks = /* @__PURE__ */ new Map();
      var currentHandlerStackKey = Symbol();
      function deferHandlingDirectives(callback) {
        isDeferringHandlers = true;
        let key = Symbol();
        currentHandlerStackKey = key;
        directiveHandlerStacks.set(key, []);
        let flushHandlers = () => {
          while (directiveHandlerStacks.get(key).length)
            directiveHandlerStacks.get(key).shift()();
          directiveHandlerStacks.delete(key);
        };
        let stopDeferring = () => {
          isDeferringHandlers = false;
          flushHandlers();
        };
        callback(flushHandlers);
        stopDeferring();
      }
      function getElementBoundUtilities(el) {
        let cleanups = [];
        let cleanup2 = (callback) => cleanups.push(callback);
        let [effect3, cleanupEffect] = elementBoundEffect(el);
        cleanups.push(cleanupEffect);
        let utilities = {
          Alpine: alpine_default,
          effect: effect3,
          cleanup: cleanup2,
          evaluateLater: evaluateLater.bind(evaluateLater, el),
          evaluate: evaluate.bind(evaluate, el),
        };
        let doCleanup = () => cleanups.forEach((i) => i());
        return [utilities, doCleanup];
      }
      function getDirectiveHandler(el, directive2) {
        let noop = () => {};
        let handler4 = directiveHandlers[directive2.type] || noop;
        let [utilities, cleanup2] = getElementBoundUtilities(el);
        onAttributeRemoved(el, directive2.original, cleanup2);
        let fullHandler = () => {
          if (el._x_ignore || el._x_ignoreSelf) return;
          handler4.inline && handler4.inline(el, directive2, utilities);
          handler4 = handler4.bind(handler4, el, directive2, utilities);
          isDeferringHandlers
            ? directiveHandlerStacks
                .get(currentHandlerStackKey)
                .push(handler4)
            : handler4();
        };
        fullHandler.runCleanups = cleanup2;
        return fullHandler;
      }
      var startingWith =
        (subject, replacement) =>
        ({ name, value }) => {
          if (name.startsWith(subject))
            name = name.replace(subject, replacement);
          return { name, value };
        };
      var into = (i) => i;
      function toTransformedAttributes(callback = () => {}) {
        return ({ name, value }) => {
          let { name: newName, value: newValue } =
            attributeTransformers.reduce(
              (carry, transform) => {
                return transform(carry);
              },
              { name, value }
            );
          if (newName !== name) callback(newName, name);
          return { name: newName, value: newValue };
        };
      }
      var attributeTransformers = [];
      function mapAttributes(callback) {
        attributeTransformers.push(callback);
      }
      function outNonAlpineAttributes({ name }) {
        return alpineAttributeRegex().test(name);
      }
      var alpineAttributeRegex = () =>
        new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
      function toParsedDirectives(
        transformedAttributeMap,
        originalAttributeOverride
      ) {
        return ({ name, value }) => {
          let typeMatch = name.match(alpineAttributeRegex());
          let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
          let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
          let original =
            originalAttributeOverride ||
            transformedAttributeMap[name] ||
            name;
          return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i) => i.replace(".", "")),
            expression: value,
            original,
          };
        };
      }
      var DEFAULT = "DEFAULT";
      var directiveOrder = [
        "ignore",
        "ref",
        "data",
        "id",
        "anchor",
        "bind",
        "init",
        "for",
        "model",
        "modelable",
        "transition",
        "show",
        "if",
        DEFAULT,
        "teleport",
      ];
      function byPriority(a, b) {
        let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
        let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
        return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
      }

      // packages/alpinejs/src/utils/dispatch.js
      function dispatch(el, name, detail = {}) {
        el.dispatchEvent(
          new CustomEvent(name, {
            detail,
            bubbles: true,
            // Allows events to pass the shadow DOM barrier.
            composed: true,
            cancelable: true,
          })
        );
      }

      // packages/alpinejs/src/utils/walk.js
      function walk(el, callback) {
        if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
          Array.from(el.children).forEach((el2) => walk(el2, callback));
          return;
        }
        let skip = false;
        callback(el, () => (skip = true));
        if (skip) return;
        let node = el.firstElementChild;
        while (node) {
          walk(node, callback, false);
          node = node.nextElementSibling;
        }
      }

      // packages/alpinejs/src/utils/warn.js
      function warn(message, ...args) {
        console.warn(`Alpine Warning: ${message}`, ...args);
      }

      // packages/alpinejs/src/lifecycle.js
      var started = false;
      function start() {
        if (started)
          warn(
            "Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."
          );
        started = true;
        if (!document.body)
          warn(
            "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
          );
        dispatch(document, "alpine:init");
        dispatch(document, "alpine:initializing");
        startObservingMutations();
        onElAdded((el) => initTree(el, walk));
        onElRemoved((el) => destroyTree(el));
        onAttributesAdded((el, attrs) => {
          directives(el, attrs).forEach((handle) => handle());
        });
        let outNestedComponents = (el) =>
          !closestRoot(el.parentElement, true);
        Array.from(document.querySelectorAll(allSelectors().join(",")))
          .filter(outNestedComponents)
          .forEach((el) => {
            initTree(el);
          });
        dispatch(document, "alpine:initialized");
        setTimeout(() => {
          warnAboutMissingPlugins();
        });
      }
      var rootSelectorCallbacks = [];
      var initSelectorCallbacks = [];
      function rootSelectors() {
        return rootSelectorCallbacks.map((fn) => fn());
      }
      function allSelectors() {
        return rootSelectorCallbacks
          .concat(initSelectorCallbacks)
          .map((fn) => fn());
      }
      function addRootSelector(selectorCallback) {
        rootSelectorCallbacks.push(selectorCallback);
      }
      function addInitSelector(selectorCallback) {
        initSelectorCallbacks.push(selectorCallback);
      }
      function closestRoot(el, includeInitSelectors = false) {
        return findClosest(el, (element) => {
          const selectors = includeInitSelectors
            ? allSelectors()
            : rootSelectors();
          if (selectors.some((selector) => element.matches(selector)))
            return true;
        });
      }
      function findClosest(el, callback) {
        if (!el) return;
        if (callback(el)) return el;
        if (el._x_teleportBack) el = el._x_teleportBack;
        if (!el.parentElement) return;
        return findClosest(el.parentElement, callback);
      }
      function isRoot(el) {
        return rootSelectors().some((selector) => el.matches(selector));
      }
      var initInterceptors2 = [];
      function interceptInit(callback) {
        initInterceptors2.push(callback);
      }
      function initTree(el, walker = walk, intercept = () => {}) {
        deferHandlingDirectives(() => {
          walker(el, (el2, skip) => {
            intercept(el2, skip);
            initInterceptors2.forEach((i) => i(el2, skip));
            directives(el2, el2.attributes).forEach((handle) => handle());
            el2._x_ignore && skip();
          });
        });
      }
      function destroyTree(root, walker = walk) {
        walker(root, (el) => {
          cleanupAttributes(el);
          cleanupElement(el);
        });
      }
      function warnAboutMissingPlugins() {
        let pluginDirectives = [
          ["ui", "dialog", ["[x-dialog], [x-popover]"]],
          ["anchor", "anchor", ["[x-anchor]"]],
          ["sort", "sort", ["[x-sort]"]],
        ];
        pluginDirectives.forEach(([plugin2, directive2, selectors]) => {
          if (directiveExists(directive2)) return;
          selectors.some((selector) => {
            if (document.querySelector(selector)) {
              warn(`found "${selector}", but missing ${plugin2} plugin`);
              return true;
            }
          });
        });
      }

      // packages/alpinejs/src/nextTick.js
      var tickStack = [];
      var isHolding = false;
      function nextTick(callback = () => {}) {
        queueMicrotask(() => {
          isHolding ||
            setTimeout(() => {
              releaseNextTicks();
            });
        });
        return new Promise((res) => {
          tickStack.push(() => {
            callback();
            res();
          });
        });
      }
      function releaseNextTicks() {
        isHolding = false;
        while (tickStack.length) tickStack.shift()();
      }
      function holdNextTicks() {
        isHolding = true;
      }

      // packages/alpinejs/src/utils/classes.js
      function setClasses(el, value) {
        if (Array.isArray(value)) {
          return setClassesFromString(el, value.join(" "));
        } else if (typeof value === "object" && value !== null) {
          return setClassesFromObject(el, value);
        } else if (typeof value === "function") {
          return setClasses(el, value());
        }
        return setClassesFromString(el, value);
      }
      function setClassesFromString(el, classString) {
        let split = (classString2) => classString2.split(" ").filter(Boolean);
        let missingClasses = (classString2) =>
          classString2
            .split(" ")
            .filter((i) => !el.classList.contains(i))
            .filter(Boolean);
        let addClassesAndReturnUndo = (classes) => {
          el.classList.add(...classes);
          return () => {
            el.classList.remove(...classes);
          };
        };
        classString =
          classString === true ? (classString = "") : classString || "";
        return addClassesAndReturnUndo(missingClasses(classString));
      }
      function setClassesFromObject(el, classObject) {
        let split = (classString) => classString.split(" ").filter(Boolean);
        let forAdd = Object.entries(classObject)
          .flatMap(([classString, bool]) =>
            bool ? split(classString) : false
          )
          .filter(Boolean);
        let forRemove = Object.entries(classObject)
          .flatMap(([classString, bool]) =>
            !bool ? split(classString) : false
          )
          .filter(Boolean);
        let added = [];
        let removed = [];
        forRemove.forEach((i) => {
          if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
          }
        });
        forAdd.forEach((i) => {
          if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
          }
        });
        return () => {
          removed.forEach((i) => el.classList.add(i));
          added.forEach((i) => el.classList.remove(i));
        };
      }

      // packages/alpinejs/src/utils/styles.js
      function setStyles(el, value) {
        if (typeof value === "object" && value !== null) {
          return setStylesFromObject(el, value);
        }
        return setStylesFromString(el, value);
      }
      function setStylesFromObject(el, value) {
        let previousStyles = {};
        Object.entries(value).forEach(([key, value2]) => {
          previousStyles[key] = el.style[key];
          if (!key.startsWith("--")) {
            key = kebabCase(key);
          }
          el.style.setProperty(key, value2);
        });
        setTimeout(() => {
          if (el.style.length === 0) {
            el.removeAttribute("style");
          }
        });
        return () => {
          setStyles(el, previousStyles);
        };
      }
      function setStylesFromString(el, value) {
        let cache = el.getAttribute("style", value);
        el.setAttribute("style", value);
        return () => {
          el.setAttribute("style", cache || "");
        };
      }
      function kebabCase(subject) {
        return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
      }

      // packages/alpinejs/src/utils/once.js
      function once(callback, fallback = () => {}) {
        let called = false;
        return function () {
          if (!called) {
            called = true;
            callback.apply(this, arguments);
          } else {
            fallback.apply(this, arguments);
          }
        };
      }

      // packages/alpinejs/src/directives/x-transition.js
      directive(
        "transition",
        (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
          if (typeof expression === "function")
            expression = evaluate2(expression);
          if (expression === false) return;
          if (!expression || typeof expression === "boolean") {
            registerTransitionsFromHelper(el, modifiers, value);
          } else {
            registerTransitionsFromClassString(el, expression, value);
          }
        }
      );
      function registerTransitionsFromClassString(el, classString, stage) {
        registerTransitionObject(el, setClasses, "");
        let directiveStorageMap = {
          enter: (classes) => {
            el._x_transition.enter.during = classes;
          },
          "enter-start": (classes) => {
            el._x_transition.enter.start = classes;
          },
          "enter-end": (classes) => {
            el._x_transition.enter.end = classes;
          },
          leave: (classes) => {
            el._x_transition.leave.during = classes;
          },
          "leave-start": (classes) => {
            el._x_transition.leave.start = classes;
          },
          "leave-end": (classes) => {
            el._x_transition.leave.end = classes;
          },
        };
        directiveStorageMap[stage](classString);
      }
      function registerTransitionsFromHelper(el, modifiers, stage) {
        registerTransitionObject(el, setStyles);
        let doesntSpecify =
          !modifiers.includes("in") && !modifiers.includes("out") && !stage;
        let transitioningIn =
          doesntSpecify ||
          modifiers.includes("in") ||
          ["enter"].includes(stage);
        let transitioningOut =
          doesntSpecify ||
          modifiers.includes("out") ||
          ["leave"].includes(stage);
        if (modifiers.includes("in") && !doesntSpecify) {
          modifiers = modifiers.filter(
            (i, index) => index < modifiers.indexOf("out")
          );
        }
        if (modifiers.includes("out") && !doesntSpecify) {
          modifiers = modifiers.filter(
            (i, index) => index > modifiers.indexOf("out")
          );
        }
        let wantsAll =
          !modifiers.includes("opacity") && !modifiers.includes("scale");
        let wantsOpacity = wantsAll || modifiers.includes("opacity");
        let wantsScale = wantsAll || modifiers.includes("scale");
        let opacityValue = wantsOpacity ? 0 : 1;
        let scaleValue = wantsScale
          ? modifierValue(modifiers, "scale", 95) / 100
          : 1;
        let delay = modifierValue(modifiers, "delay", 0) / 1e3;
        let origin = modifierValue(modifiers, "origin", "center");
        let property = "opacity, transform";
        let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
        let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
        let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
        if (transitioningIn) {
          el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing,
          };
          el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`,
          };
          el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`,
          };
        }
        if (transitioningOut) {
          el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing,
          };
          el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`,
          };
          el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`,
          };
        }
      }
      function registerTransitionObject(el, setFunction, defaultValue = {}) {
        if (!el._x_transition)
          el._x_transition = {
            enter: {
              during: defaultValue,
              start: defaultValue,
              end: defaultValue,
            },
            leave: {
              during: defaultValue,
              start: defaultValue,
              end: defaultValue,
            },
            in(before = () => {}, after = () => {}) {
              transition(
                el,
                setFunction,
                {
                  during: this.enter.during,
                  start: this.enter.start,
                  end: this.enter.end,
                },
                before,
                after
              );
            },
            out(before = () => {}, after = () => {}) {
              transition(
                el,
                setFunction,
                {
                  during: this.leave.during,
                  start: this.leave.start,
                  end: this.leave.end,
                },
                before,
                after
              );
            },
          };
      }
      window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
        el,
        value,
        show,
        hide
      ) {
        const nextTick2 =
          document.visibilityState === "visible"
            ? requestAnimationFrame
            : setTimeout;
        let clickAwayCompatibleShow = () => nextTick2(show);
        if (value) {
          if (
            el._x_transition &&
            (el._x_transition.enter || el._x_transition.leave)
          ) {
            el._x_transition.enter &&
            (Object.entries(el._x_transition.enter.during).length ||
              Object.entries(el._x_transition.enter.start).length ||
              Object.entries(el._x_transition.enter.end).length)
              ? el._x_transition.in(show)
              : clickAwayCompatibleShow();
          } else {
            el._x_transition
              ? el._x_transition.in(show)
              : clickAwayCompatibleShow();
          }
          return;
        }
        el._x_hidePromise = el._x_transition
          ? new Promise((resolve, reject) => {
              el._x_transition.out(
                () => {},
                () => resolve(hide)
              );
              el._x_transitioning &&
                el._x_transitioning.beforeCancel(() =>
                  reject({ isFromCancelledTransition: true })
                );
            })
          : Promise.resolve(hide);
        queueMicrotask(() => {
          let closest = closestHide(el);
          if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
          } else {
            nextTick2(() => {
              let hideAfterChildren = (el2) => {
                let carry = Promise.all([
                  el2._x_hidePromise,
                  ...(el2._x_hideChildren || []).map(hideAfterChildren),
                ]).then(([i]) => i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
              };
              hideAfterChildren(el).catch((e) => {
                if (!e.isFromCancelledTransition) throw e;
              });
            });
          }
        });
      };
      function closestHide(el) {
        let parent = el.parentNode;
        if (!parent) return;
        return parent._x_hidePromise ? parent : closestHide(parent);
      }
      function transition(
        el,
        setFunction,
        { during, start: start2, end } = {},
        before = () => {},
        after = () => {}
      ) {
        if (el._x_transitioning) el._x_transitioning.cancel();
        if (
          Object.keys(during).length === 0 &&
          Object.keys(start2).length === 0 &&
          Object.keys(end).length === 0
        ) {
          before();
          after();
          return;
        }
        let undoStart, undoDuring, undoEnd;
        performTransition(el, {
          start() {
            undoStart = setFunction(el, start2);
          },
          during() {
            undoDuring = setFunction(el, during);
          },
          before,
          end() {
            undoStart();
            undoEnd = setFunction(el, end);
          },
          after,
          cleanup() {
            undoDuring();
            undoEnd();
          },
        });
      }
      function performTransition(el, stages) {
        let interrupted, reachedBefore, reachedEnd;
        let finish = once(() => {
          mutateDom(() => {
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
              stages.end();
              releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
          });
        });
        el._x_transitioning = {
          beforeCancels: [],
          beforeCancel(callback) {
            this.beforeCancels.push(callback);
          },
          cancel: once(function () {
            while (this.beforeCancels.length) {
              this.beforeCancels.shift()();
            }
            finish();
          }),
          finish,
        };
        mutateDom(() => {
          stages.start();
          stages.during();
        });
        holdNextTicks();
        requestAnimationFrame(() => {
          if (interrupted) return;
          let duration =
            Number(
              getComputedStyle(el)
                .transitionDuration.replace(/,.*/, "")
                .replace("s", "")
            ) * 1e3;
          let delay =
            Number(
              getComputedStyle(el)
                .transitionDelay.replace(/,.*/, "")
                .replace("s", "")
            ) * 1e3;
          if (duration === 0)
            duration =
              Number(
                getComputedStyle(el).animationDuration.replace("s", "")
              ) * 1e3;
          mutateDom(() => {
            stages.before();
          });
          reachedBefore = true;
          requestAnimationFrame(() => {
            if (interrupted) return;
            mutateDom(() => {
              stages.end();
            });
            releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
          });
        });
      }
      function modifierValue(modifiers, key, fallback) {
        if (modifiers.indexOf(key) === -1) return fallback;
        const rawValue = modifiers[modifiers.indexOf(key) + 1];
        if (!rawValue) return fallback;
        if (key === "scale") {
          if (isNaN(rawValue)) return fallback;
        }
        if (key === "duration" || key === "delay") {
          let match = rawValue.match(/([0-9]+)ms/);
          if (match) return match[1];
        }
        if (key === "origin") {
          if (
            ["top", "right", "left", "center", "bottom"].includes(
              modifiers[modifiers.indexOf(key) + 2]
            )
          ) {
            return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(
              " "
            );
          }
        }
        return rawValue;
      }

      // packages/alpinejs/src/clone.js
      var isCloning = false;
      function skipDuringClone(callback, fallback = () => {}) {
        return (...args) =>
          isCloning ? fallback(...args) : callback(...args);
      }
      function onlyDuringClone(callback) {
        return (...args) => isCloning && callback(...args);
      }
      var interceptors = [];
      function interceptClone(callback) {
        interceptors.push(callback);
      }
      function cloneNode(from, to) {
        interceptors.forEach((i) => i(from, to));
        isCloning = true;
        dontRegisterReactiveSideEffects(() => {
          initTree(to, (el, callback) => {
            callback(el, () => {});
          });
        });
        isCloning = false;
      }
      var isCloningLegacy = false;
      function clone(oldEl, newEl) {
        if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
        isCloning = true;
        isCloningLegacy = true;
        dontRegisterReactiveSideEffects(() => {
          cloneTree(newEl);
        });
        isCloning = false;
        isCloningLegacy = false;
      }
      function cloneTree(el) {
        let hasRunThroughFirstEl = false;
        let shallowWalker = (el2, callback) => {
          walk(el2, (el3, skip) => {
            if (hasRunThroughFirstEl && isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
          });
        };
        initTree(el, shallowWalker);
      }
      function dontRegisterReactiveSideEffects(callback) {
        let cache = effect;
        overrideEffect((callback2, el) => {
          let storedEffect = cache(callback2);
          release(storedEffect);
          return () => {};
        });
        callback();
        overrideEffect(cache);
      }

      // packages/alpinejs/src/utils/bind.js
      function bind(el, name, value, modifiers = []) {
        if (!el._x_bindings) el._x_bindings = reactive({});
        el._x_bindings[name] = value;
        name = modifiers.includes("camel") ? camelCase(name) : name;
        switch (name) {
          case "value":
            bindInputValue(el, value);
            break;
          case "style":
            bindStyles(el, value);
            break;
          case "class":
            bindClasses(el, value);
            break;
          case "selected":
          case "checked":
            bindAttributeAndProperty(el, name, value);
            break;
          default:
            bindAttribute(el, name, value);
            break;
        }
      }
      function bindInputValue(el, value) {
        if (el.type === "radio") {
          if (el.attributes.value === void 0) {
            el.value = value;
          }
          if (window.fromModel) {
            if (typeof value === "boolean") {
              el.checked = safeParseBoolean(el.value) === value;
            } else {
              el.checked = checkedAttrLooseCompare(el.value, value);
            }
          }
        } else if (el.type === "checkbox") {
          if (Number.isInteger(value)) {
            el.value = value;
          } else if (
            !Array.isArray(value) &&
            typeof value !== "boolean" &&
            ![null, void 0].includes(value)
          ) {
            el.value = String(value);
          } else {
            if (Array.isArray(value)) {
              el.checked = value.some((val) =>
                checkedAttrLooseCompare(val, el.value)
              );
            } else {
              el.checked = !!value;
            }
          }
        } else if (el.tagName === "SELECT") {
          updateSelect(el, value);
        } else {
          if (el.value === value) return;
          el.value = value === void 0 ? "" : value;
        }
      }
      function bindClasses(el, value) {
        if (el._x_undoAddedClasses) el._x_undoAddedClasses();
        el._x_undoAddedClasses = setClasses(el, value);
      }
      function bindStyles(el, value) {
        if (el._x_undoAddedStyles) el._x_undoAddedStyles();
        el._x_undoAddedStyles = setStyles(el, value);
      }
      function bindAttributeAndProperty(el, name, value) {
        bindAttribute(el, name, value);
        setPropertyIfChanged(el, name, value);
      }
      function bindAttribute(el, name, value) {
        if (
          [null, void 0, false].includes(value) &&
          attributeShouldntBePreservedIfFalsy(name)
        ) {
          el.removeAttribute(name);
        } else {
          if (isBooleanAttr(name)) value = name;
          setIfChanged(el, name, value);
        }
      }
      function setIfChanged(el, attrName, value) {
        if (el.getAttribute(attrName) != value) {
          el.setAttribute(attrName, value);
        }
      }
      function setPropertyIfChanged(el, propName, value) {
        if (el[propName] !== value) {
          el[propName] = value;
        }
      }
      function updateSelect(el, value) {
        const arrayWrappedValue = [].concat(value).map((value2) => {
          return value2 + "";
        });
        Array.from(el.options).forEach((option) => {
          option.selected = arrayWrappedValue.includes(option.value);
        });
      }
      function camelCase(subject) {
        return subject
          .toLowerCase()
          .replace(/-(\w)/g, (match, char) => char.toUpperCase());
      }
      function checkedAttrLooseCompare(valueA, valueB) {
        return valueA == valueB;
      }
      function safeParseBoolean(rawValue) {
        if ([1, "1", "true", "on", "yes", true].includes(rawValue)) {
          return true;
        }
        if ([0, "0", "false", "off", "no", false].includes(rawValue)) {
          return false;
        }
        return rawValue ? Boolean(rawValue) : null;
      }
      function isBooleanAttr(attrName) {
        const booleanAttributes = [
          "disabled",
          "checked",
          "required",
          "readonly",
          "open",
          "selected",
          "autofocus",
          "itemscope",
          "multiple",
          "novalidate",
          "allowfullscreen",
          "allowpaymentrequest",
          "formnovalidate",
          "autoplay",
          "controls",
          "loop",
          "muted",
          "playsinline",
          "default",
          "ismap",
          "reversed",
          "async",
          "defer",
          "nomodule",
        ];
        return booleanAttributes.includes(attrName);
      }
      function attributeShouldntBePreservedIfFalsy(name) {
        return ![
          "aria-pressed",
          "aria-checked",
          "aria-expanded",
          "aria-selected",
        ].includes(name);
      }
      function getBinding(el, name, fallback) {
        if (el._x_bindings && el._x_bindings[name] !== void 0)
          return el._x_bindings[name];
        return getAttributeBinding(el, name, fallback);
      }
      function extractProp(el, name, fallback, extract = true) {
        if (el._x_bindings && el._x_bindings[name] !== void 0)
          return el._x_bindings[name];
        if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
          let binding = el._x_inlineBindings[name];
          binding.extract = extract;
          return dontAutoEvaluateFunctions(() => {
            return evaluate(el, binding.expression);
          });
        }
        return getAttributeBinding(el, name, fallback);
      }
      function getAttributeBinding(el, name, fallback) {
        let attr = el.getAttribute(name);
        if (attr === null)
          return typeof fallback === "function" ? fallback() : fallback;
        if (attr === "") return true;
        if (isBooleanAttr(name)) {
          return !![name, "true"].includes(attr);
        }
        return attr;
      }

      // packages/alpinejs/src/utils/debounce.js
      function debounce(func, wait) {
        var timeout;
        return function () {
          var context = this,
            args = arguments;
          var later = function () {
            timeout = null;
            func.apply(context, args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      }

      // packages/alpinejs/src/utils/throttle.js
      function throttle(func, limit) {
        let inThrottle;
        return function () {
          let context = this,
            args = arguments;
          if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
          }
        };
      }

      // packages/alpinejs/src/entangle.js
      function entangle(
        { get: outerGet, set: outerSet },
        { get: innerGet, set: innerSet }
      ) {
        let firstRun = true;
        let outerHash;
        let innerHash;
        let reference = effect(() => {
          let outer = outerGet();
          let inner = innerGet();
          if (firstRun) {
            innerSet(cloneIfObject(outer));
            firstRun = false;
          } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) {
              innerSet(cloneIfObject(outer));
            } else if (outerHashLatest !== innerHashLatest) {
              outerSet(cloneIfObject(inner));
            } else {
            }
          }
          outerHash = JSON.stringify(outerGet());
          innerHash = JSON.stringify(innerGet());
        });
        return () => {
          release(reference);
        };
      }
      function cloneIfObject(value) {
        return typeof value === "object"
          ? JSON.parse(JSON.stringify(value))
          : value;
      }

      // packages/alpinejs/src/plugin.js
      function plugin(callback) {
        let callbacks = Array.isArray(callback) ? callback : [callback];
        callbacks.forEach((i) => i(alpine_default));
      }

      // packages/alpinejs/src/store.js
      var stores = {};
      var isReactive = false;
      function store(name, value) {
        if (!isReactive) {
          stores = reactive(stores);
          isReactive = true;
        }
        if (value === void 0) {
          return stores[name];
        }
        stores[name] = value;
        if (
          typeof value === "object" &&
          value !== null &&
          value.hasOwnProperty("init") &&
          typeof value.init === "function"
        ) {
          stores[name].init();
        }
        initInterceptors(stores[name]);
      }
      function getStores() {
        return stores;
      }

      // packages/alpinejs/src/binds.js
      var binds = {};
      function bind2(name, bindings) {
        let getBindings =
          typeof bindings !== "function" ? () => bindings : bindings;
        if (name instanceof Element) {
          return applyBindingsObject(name, getBindings());
        } else {
          binds[name] = getBindings;
        }
        return () => {};
      }
      function injectBindingProviders(obj) {
        Object.entries(binds).forEach(([name, callback]) => {
          Object.defineProperty(obj, name, {
            get() {
              return (...args) => {
                return callback(...args);
              };
            },
          });
        });
        return obj;
      }
      function applyBindingsObject(el, obj, original) {
        let cleanupRunners = [];
        while (cleanupRunners.length) cleanupRunners.pop()();
        let attributes = Object.entries(obj).map(([name, value]) => ({
          name,
          value,
        }));
        let staticAttributes = attributesOnly(attributes);
        attributes = attributes.map((attribute) => {
          if (staticAttributes.find((attr) => attr.name === attribute.name)) {
            return {
              name: `x-bind:${attribute.name}`,
              value: `"${attribute.value}"`,
            };
          }
          return attribute;
        });
        directives(el, attributes, original).map((handle) => {
          cleanupRunners.push(handle.runCleanups);
          handle();
        });
        return () => {
          while (cleanupRunners.length) cleanupRunners.pop()();
        };
      }

      // packages/alpinejs/src/datas.js
      var datas = {};
      function data(name, callback) {
        datas[name] = callback;
      }
      function injectDataProviders(obj, context) {
        Object.entries(datas).forEach(([name, callback]) => {
          Object.defineProperty(obj, name, {
            get() {
              return (...args) => {
                return callback.bind(context)(...args);
              };
            },
            enumerable: false,
          });
        });
        return obj;
      }

      // packages/alpinejs/src/alpine.js
      var Alpine = {
        get reactive() {
          return reactive;
        },
        get release() {
          return release;
        },
        get effect() {
          return effect;
        },
        get raw() {
          return raw;
        },
        version: "3.14.1",
        flushAndStopDeferringMutations,
        dontAutoEvaluateFunctions,
        disableEffectScheduling,
        startObservingMutations,
        stopObservingMutations,
        setReactivityEngine,
        onAttributeRemoved,
        onAttributesAdded,
        closestDataStack,
        skipDuringClone,
        onlyDuringClone,
        addRootSelector,
        addInitSelector,
        interceptClone,
        addScopeToNode,
        deferMutations,
        mapAttributes,
        evaluateLater,
        interceptInit,
        setEvaluator,
        mergeProxies,
        extractProp,
        findClosest,
        onElRemoved,
        closestRoot,
        destroyTree,
        interceptor,
        // INTERNAL: not public API and is subject to change without major release.
        transition,
        // INTERNAL
        setStyles,
        // INTERNAL
        mutateDom,
        directive,
        entangle,
        throttle,
        debounce,
        evaluate,
        initTree,
        nextTick,
        prefixed: prefix,
        prefix: setPrefix,
        plugin,
        magic,
        store,
        start,
        clone,
        // INTERNAL
        cloneNode,
        // INTERNAL
        bound: getBinding,
        $data: scope,
        watch,
        walk,
        data,
        bind: bind2,
      };
      var alpine_default = Alpine;

      // node_modules/@vue/shared/dist/shared.esm-bundler.js
      function makeMap(str, expectsLowerCase) {
        const map = /* @__PURE__ */ Object.create(null);
        const list = str.split(",");
        for (let i = 0; i < list.length; i++) {
          map[list[i]] = true;
        }
        return expectsLowerCase
          ? (val) => !!map[val.toLowerCase()]
          : (val) => !!map[val];
      }
      var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
      var isBooleanAttr2 = /* @__PURE__ */ makeMap(
        specialBooleanAttrs +
          `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`
      );
      var EMPTY_OBJ = true ? Object.freeze({}) : {};
      var EMPTY_ARR = true ? Object.freeze([]) : [];
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var hasOwn = (val, key) => hasOwnProperty.call(val, key);
      var isArray = Array.isArray;
      var isMap = (val) => toTypeString(val) === "[object Map]";
      var isString = (val) => typeof val === "string";
      var isSymbol = (val) => typeof val === "symbol";
      var isObject = (val) => val !== null && typeof val === "object";
      var objectToString = Object.prototype.toString;
      var toTypeString = (value) => objectToString.call(value);
      var toRawType = (value) => {
        return toTypeString(value).slice(8, -1);
      };
      var isIntegerKey = (key) =>
        isString(key) &&
        key !== "NaN" &&
        key[0] !== "-" &&
        "" + parseInt(key, 10) === key;
      var cacheStringFunction = (fn) => {
        const cache = /* @__PURE__ */ Object.create(null);
        return (str) => {
          const hit = cache[str];
          return hit || (cache[str] = fn(str));
        };
      };
      var camelizeRE = /-(\w)/g;
      var camelize = cacheStringFunction((str) => {
        return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ""));
      });
      var hyphenateRE = /\B([A-Z])/g;
      var hyphenate = cacheStringFunction((str) =>
        str.replace(hyphenateRE, "-$1").toLowerCase()
      );
      var capitalize = cacheStringFunction(
        (str) => str.charAt(0).toUpperCase() + str.slice(1)
      );
      var toHandlerKey = cacheStringFunction((str) =>
        str ? `on${capitalize(str)}` : ``
      );
      var hasChanged = (value, oldValue) =>
        value !== oldValue && (value === value || oldValue === oldValue);

      // node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
      var targetMap = /* @__PURE__ */ new WeakMap();
      var effectStack = [];
      var activeEffect;
      var ITERATE_KEY = Symbol(true ? "iterate" : "");
      var MAP_KEY_ITERATE_KEY = Symbol(true ? "Map key iterate" : "");
      function isEffect(fn) {
        return fn && fn._isEffect === true;
      }
      function effect2(fn, options = EMPTY_OBJ) {
        if (isEffect(fn)) {
          fn = fn.raw;
        }
        const effect3 = createReactiveEffect(fn, options);
        if (!options.lazy) {
          effect3();
        }
        return effect3;
      }
      function stop(effect3) {
        if (effect3.active) {
          cleanup(effect3);
          if (effect3.options.onStop) {
            effect3.options.onStop();
          }
          effect3.active = false;
        }
      }
      var uid = 0;
      function createReactiveEffect(fn, options) {
        const effect3 = function reactiveEffect() {
          if (!effect3.active) {
            return fn();
          }
          if (!effectStack.includes(effect3)) {
            cleanup(effect3);
            try {
              enableTracking();
              effectStack.push(effect3);
              activeEffect = effect3;
              return fn();
            } finally {
              effectStack.pop();
              resetTracking();
              activeEffect = effectStack[effectStack.length - 1];
            }
          }
        };
        effect3.id = uid++;
        effect3.allowRecurse = !!options.allowRecurse;
        effect3._isEffect = true;
        effect3.active = true;
        effect3.raw = fn;
        effect3.deps = [];
        effect3.options = options;
        return effect3;
      }
      function cleanup(effect3) {
        const { deps } = effect3;
        if (deps.length) {
          for (let i = 0; i < deps.length; i++) {
            deps[i].delete(effect3);
          }
          deps.length = 0;
        }
      }
      var shouldTrack = true;
      var trackStack = [];
      function pauseTracking() {
        trackStack.push(shouldTrack);
        shouldTrack = false;
      }
      function enableTracking() {
        trackStack.push(shouldTrack);
        shouldTrack = true;
      }
      function resetTracking() {
        const last = trackStack.pop();
        shouldTrack = last === void 0 ? true : last;
      }
      function track(target, type, key) {
        if (!shouldTrack || activeEffect === void 0) {
          return;
        }
        let depsMap = targetMap.get(target);
        if (!depsMap) {
          targetMap.set(target, (depsMap = /* @__PURE__ */ new Map()));
        }
        let dep = depsMap.get(key);
        if (!dep) {
          depsMap.set(key, (dep = /* @__PURE__ */ new Set()));
        }
        if (!dep.has(activeEffect)) {
          dep.add(activeEffect);
          activeEffect.deps.push(dep);
          if (activeEffect.options.onTrack) {
            activeEffect.options.onTrack({
              effect: activeEffect,
              target,
              type,
              key,
            });
          }
        }
      }
      function trigger(target, type, key, newValue, oldValue, oldTarget) {
        const depsMap = targetMap.get(target);
        if (!depsMap) {
          return;
        }
        const effects = /* @__PURE__ */ new Set();
        const add2 = (effectsToAdd) => {
          if (effectsToAdd) {
            effectsToAdd.forEach((effect3) => {
              if (effect3 !== activeEffect || effect3.allowRecurse) {
                effects.add(effect3);
              }
            });
          }
        };
        if (type === "clear") {
          depsMap.forEach(add2);
        } else if (key === "length" && isArray(target)) {
          depsMap.forEach((dep, key2) => {
            if (key2 === "length" || key2 >= newValue) {
              add2(dep);
            }
          });
        } else {
          if (key !== void 0) {
            add2(depsMap.get(key));
          }
          switch (type) {
            case "add":
              if (!isArray(target)) {
                add2(depsMap.get(ITERATE_KEY));
                if (isMap(target)) {
                  add2(depsMap.get(MAP_KEY_ITERATE_KEY));
                }
              } else if (isIntegerKey(key)) {
                add2(depsMap.get("length"));
              }
              break;
            case "delete":
              if (!isArray(target)) {
                add2(depsMap.get(ITERATE_KEY));
                if (isMap(target)) {
                  add2(depsMap.get(MAP_KEY_ITERATE_KEY));
                }
              }
              break;
            case "set":
              if (isMap(target)) {
                add2(depsMap.get(ITERATE_KEY));
              }
              break;
          }
        }
        const run = (effect3) => {
          if (effect3.options.onTrigger) {
            effect3.options.onTrigger({
              effect: effect3,
              target,
              key,
              type,
              newValue,
              oldValue,
              oldTarget,
            });
          }
          if (effect3.options.scheduler) {
            effect3.options.scheduler(effect3);
          } else {
            effect3();
          }
        };
        effects.forEach(run);
      }
      var isNonTrackableKeys = /* @__PURE__ */ makeMap(
        `__proto__,__v_isRef,__isVue`
      );
      var builtInSymbols = new Set(
        Object.getOwnPropertyNames(Symbol)
          .map((key) => Symbol[key])
          .filter(isSymbol)
      );
      var get2 = /* @__PURE__ */ createGetter();
      var readonlyGet = /* @__PURE__ */ createGetter(true);
      var arrayInstrumentations =
        /* @__PURE__ */ createArrayInstrumentations();
      function createArrayInstrumentations() {
        const instrumentations = {};
        ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
          instrumentations[key] = function (...args) {
            const arr = toRaw(this);
            for (let i = 0, l = this.length; i < l; i++) {
              track(arr, "get", i + "");
            }
            const res = arr[key](...args);
            if (res === -1 || res === false) {
              return arr[key](...args.map(toRaw));
            } else {
              return res;
            }
          };
        });
        ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
          instrumentations[key] = function (...args) {
            pauseTracking();
            const res = toRaw(this)[key].apply(this, args);
            resetTracking();
            return res;
          };
        });
        return instrumentations;
      }
      function createGetter(isReadonly = false, shallow = false) {
        return function get3(target, key, receiver) {
          if (key === "__v_isReactive") {
            return !isReadonly;
          } else if (key === "__v_isReadonly") {
            return isReadonly;
          } else if (
            key === "__v_raw" &&
            receiver ===
              (isReadonly
                ? shallow
                  ? shallowReadonlyMap
                  : readonlyMap
                : shallow
                ? shallowReactiveMap
                : reactiveMap
              ).get(target)
          ) {
            return target;
          }
          const targetIsArray = isArray(target);
          if (
            !isReadonly &&
            targetIsArray &&
            hasOwn(arrayInstrumentations, key)
          ) {
            return Reflect.get(arrayInstrumentations, key, receiver);
          }
          const res = Reflect.get(target, key, receiver);
          if (
            isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)
          ) {
            return res;
          }
          if (!isReadonly) {
            track(target, "get", key);
          }
          if (shallow) {
            return res;
          }
          if (isRef(res)) {
            const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
          }
          if (isObject(res)) {
            return isReadonly ? readonly(res) : reactive2(res);
          }
          return res;
        };
      }
      var set2 = /* @__PURE__ */ createSetter();
      function createSetter(shallow = false) {
        return function set3(target, key, value, receiver) {
          let oldValue = target[key];
          if (!shallow) {
            value = toRaw(value);
            oldValue = toRaw(oldValue);
            if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
              oldValue.value = value;
              return true;
            }
          }
          const hadKey =
            isArray(target) && isIntegerKey(key)
              ? Number(key) < target.length
              : hasOwn(target, key);
          const result = Reflect.set(target, key, value, receiver);
          if (target === toRaw(receiver)) {
            if (!hadKey) {
              trigger(target, "add", key, value);
            } else if (hasChanged(value, oldValue)) {
              trigger(target, "set", key, value, oldValue);
            }
          }
          return result;
        };
      }
      function deleteProperty(target, key) {
        const hadKey = hasOwn(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) {
          trigger(target, "delete", key, void 0, oldValue);
        }
        return result;
      }
      function has(target, key) {
        const result = Reflect.has(target, key);
        if (!isSymbol(key) || !builtInSymbols.has(key)) {
          track(target, "has", key);
        }
        return result;
      }
      function ownKeys(target) {
        track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
        return Reflect.ownKeys(target);
      }
      var mutableHandlers = {
        get: get2,
        set: set2,
        deleteProperty,
        has,
        ownKeys,
      };
      var readonlyHandlers = {
        get: readonlyGet,
        set(target, key) {
          if (true) {
            console.warn(
              `Set operation on key "${String(
                key
              )}" failed: target is readonly.`,
              target
            );
          }
          return true;
        },
        deleteProperty(target, key) {
          if (true) {
            console.warn(
              `Delete operation on key "${String(
                key
              )}" failed: target is readonly.`,
              target
            );
          }
          return true;
        },
      };
      var toReactive = (value) =>
        isObject(value) ? reactive2(value) : value;
      var toReadonly = (value) => (isObject(value) ? readonly(value) : value);
      var toShallow = (value) => value;
      var getProto = (v) => Reflect.getPrototypeOf(v);
      function get$1(target, key, isReadonly = false, isShallow = false) {
        target =
          target[
            "__v_raw"
            /* RAW */
          ];
        const rawTarget = toRaw(target);
        const rawKey = toRaw(key);
        if (key !== rawKey) {
          !isReadonly && track(rawTarget, "get", key);
        }
        !isReadonly && track(rawTarget, "get", rawKey);
        const { has: has2 } = getProto(rawTarget);
        const wrap = isShallow
          ? toShallow
          : isReadonly
          ? toReadonly
          : toReactive;
        if (has2.call(rawTarget, key)) {
          return wrap(target.get(key));
        } else if (has2.call(rawTarget, rawKey)) {
          return wrap(target.get(rawKey));
        } else if (target !== rawTarget) {
          target.get(key);
        }
      }
      function has$1(key, isReadonly = false) {
        const target =
          this[
            "__v_raw"
            /* RAW */
          ];
        const rawTarget = toRaw(target);
        const rawKey = toRaw(key);
        if (key !== rawKey) {
          !isReadonly && track(rawTarget, "has", key);
        }
        !isReadonly && track(rawTarget, "has", rawKey);
        return key === rawKey
          ? target.has(key)
          : target.has(key) || target.has(rawKey);
      }
      function size(target, isReadonly = false) {
        target =
          target[
            "__v_raw"
            /* RAW */
          ];
        !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
        return Reflect.get(target, "size", target);
      }
      function add(value) {
        value = toRaw(value);
        const target = toRaw(this);
        const proto = getProto(target);
        const hadKey = proto.has.call(target, value);
        if (!hadKey) {
          target.add(value);
          trigger(target, "add", value, value);
        }
        return this;
      }
      function set$1(key, value) {
        value = toRaw(value);
        const target = toRaw(this);
        const { has: has2, get: get3 } = getProto(target);
        let hadKey = has2.call(target, key);
        if (!hadKey) {
          key = toRaw(key);
          hadKey = has2.call(target, key);
        } else if (true) {
          checkIdentityKeys(target, has2, key);
        }
        const oldValue = get3.call(target, key);
        target.set(key, value);
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value, oldValue);
        }
        return this;
      }
      function deleteEntry(key) {
        const target = toRaw(this);
        const { has: has2, get: get3 } = getProto(target);
        let hadKey = has2.call(target, key);
        if (!hadKey) {
          key = toRaw(key);
          hadKey = has2.call(target, key);
        } else if (true) {
          checkIdentityKeys(target, has2, key);
        }
        const oldValue = get3 ? get3.call(target, key) : void 0;
        const result = target.delete(key);
        if (hadKey) {
          trigger(target, "delete", key, void 0, oldValue);
        }
        return result;
      }
      function clear() {
        const target = toRaw(this);
        const hadItems = target.size !== 0;
        const oldTarget = true
          ? isMap(target)
            ? new Map(target)
            : new Set(target)
          : void 0;
        const result = target.clear();
        if (hadItems) {
          trigger(target, "clear", void 0, void 0, oldTarget);
        }
        return result;
      }
      function createForEach(isReadonly, isShallow) {
        return function forEach(callback, thisArg) {
          const observed = this;
          const target =
            observed[
              "__v_raw"
              /* RAW */
            ];
          const rawTarget = toRaw(target);
          const wrap = isShallow
            ? toShallow
            : isReadonly
            ? toReadonly
            : toReactive;
          !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
          return target.forEach((value, key) => {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
          });
        };
      }
      function createIterableMethod(method, isReadonly, isShallow) {
        return function (...args) {
          const target =
            this[
              "__v_raw"
              /* RAW */
            ];
          const rawTarget = toRaw(target);
          const targetIsMap = isMap(rawTarget);
          const isPair =
            method === "entries" ||
            (method === Symbol.iterator && targetIsMap);
          const isKeyOnly = method === "keys" && targetIsMap;
          const innerIterator = target[method](...args);
          const wrap = isShallow
            ? toShallow
            : isReadonly
            ? toReadonly
            : toReactive;
          !isReadonly &&
            track(
              rawTarget,
              "iterate",
              isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
            );
          return {
            // iterator protocol
            next() {
              const { value, done } = innerIterator.next();
              return done
                ? { value, done }
                : {
                    value: isPair
                      ? [wrap(value[0]), wrap(value[1])]
                      : wrap(value),
                    done,
                  };
            },
            // iterable protocol
            [Symbol.iterator]() {
              return this;
            },
          };
        };
      }
      function createReadonlyMethod(type) {
        return function (...args) {
          if (true) {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(
              `${capitalize(
                type
              )} operation ${key}failed: target is readonly.`,
              toRaw(this)
            );
          }
          return type === "delete" ? false : this;
        };
      }
      function createInstrumentations() {
        const mutableInstrumentations2 = {
          get(key) {
            return get$1(this, key);
          },
          get size() {
            return size(this);
          },
          has: has$1,
          add,
          set: set$1,
          delete: deleteEntry,
          clear,
          forEach: createForEach(false, false),
        };
        const shallowInstrumentations2 = {
          get(key) {
            return get$1(this, key, false, true);
          },
          get size() {
            return size(this);
          },
          has: has$1,
          add,
          set: set$1,
          delete: deleteEntry,
          clear,
          forEach: createForEach(false, true),
        };
        const readonlyInstrumentations2 = {
          get(key) {
            return get$1(this, key, true);
          },
          get size() {
            return size(this, true);
          },
          has(key) {
            return has$1.call(this, key, true);
          },
          add: createReadonlyMethod(
            "add"
            /* ADD */
          ),
          set: createReadonlyMethod(
            "set"
            /* SET */
          ),
          delete: createReadonlyMethod(
            "delete"
            /* DELETE */
          ),
          clear: createReadonlyMethod(
            "clear"
            /* CLEAR */
          ),
          forEach: createForEach(true, false),
        };
        const shallowReadonlyInstrumentations2 = {
          get(key) {
            return get$1(this, key, true, true);
          },
          get size() {
            return size(this, true);
          },
          has(key) {
            return has$1.call(this, key, true);
          },
          add: createReadonlyMethod(
            "add"
            /* ADD */
          ),
          set: createReadonlyMethod(
            "set"
            /* SET */
          ),
          delete: createReadonlyMethod(
            "delete"
            /* DELETE */
          ),
          clear: createReadonlyMethod(
            "clear"
            /* CLEAR */
          ),
          forEach: createForEach(true, true),
        };
        const iteratorMethods = [
          "keys",
          "values",
          "entries",
          Symbol.iterator,
        ];
        iteratorMethods.forEach((method) => {
          mutableInstrumentations2[method] = createIterableMethod(
            method,
            false,
            false
          );
          readonlyInstrumentations2[method] = createIterableMethod(
            method,
            true,
            false
          );
          shallowInstrumentations2[method] = createIterableMethod(
            method,
            false,
            true
          );
          shallowReadonlyInstrumentations2[method] = createIterableMethod(
            method,
            true,
            true
          );
        });
        return [
          mutableInstrumentations2,
          readonlyInstrumentations2,
          shallowInstrumentations2,
          shallowReadonlyInstrumentations2,
        ];
      }
      var [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations,
      ] = /* @__PURE__ */ createInstrumentations();
      function createInstrumentationGetter(isReadonly, shallow) {
        const instrumentations = shallow
          ? isReadonly
            ? shallowReadonlyInstrumentations
            : shallowInstrumentations
          : isReadonly
          ? readonlyInstrumentations
          : mutableInstrumentations;
        return (target, key, receiver) => {
          if (key === "__v_isReactive") {
            return !isReadonly;
          } else if (key === "__v_isReadonly") {
            return isReadonly;
          } else if (key === "__v_raw") {
            return target;
          }
          return Reflect.get(
            hasOwn(instrumentations, key) && key in target
              ? instrumentations
              : target,
            key,
            receiver
          );
        };
      }
      var mutableCollectionHandlers = {
        get: /* @__PURE__ */ createInstrumentationGetter(false, false),
      };
      var readonlyCollectionHandlers = {
        get: /* @__PURE__ */ createInstrumentationGetter(true, false),
      };
      function checkIdentityKeys(target, has2, key) {
        const rawKey = toRaw(key);
        if (rawKey !== key && has2.call(target, rawKey)) {
          const type = toRawType(target);
          console.warn(
            `Reactive ${type} contains both the raw and reactive versions of the same object${
              type === `Map` ? ` as keys` : ``
            }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
          );
        }
      }
      var reactiveMap = /* @__PURE__ */ new WeakMap();
      var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
      var readonlyMap = /* @__PURE__ */ new WeakMap();
      var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
      function targetTypeMap(rawType) {
        switch (rawType) {
          case "Object":
          case "Array":
            return 1;
          case "Map":
          case "Set":
          case "WeakMap":
          case "WeakSet":
            return 2;
          default:
            return 0;
        }
      }
      function getTargetType(value) {
        return value[
          "__v_skip"
          /* SKIP */
        ] || !Object.isExtensible(value)
          ? 0
          : targetTypeMap(toRawType(value));
      }
      function reactive2(target) {
        if (
          target &&
          target[
            "__v_isReadonly"
            /* IS_READONLY */
          ]
        ) {
          return target;
        }
        return createReactiveObject(
          target,
          false,
          mutableHandlers,
          mutableCollectionHandlers,
          reactiveMap
        );
      }
      function readonly(target) {
        return createReactiveObject(
          target,
          true,
          readonlyHandlers,
          readonlyCollectionHandlers,
          readonlyMap
        );
      }
      function createReactiveObject(
        target,
        isReadonly,
        baseHandlers,
        collectionHandlers,
        proxyMap
      ) {
        if (!isObject(target)) {
          if (true) {
            console.warn(`value cannot be made reactive: ${String(target)}`);
          }
          return target;
        }
        if (
          target[
            "__v_raw"
            /* RAW */
          ] &&
          !(
            isReadonly &&
            target[
              "__v_isReactive"
              /* IS_REACTIVE */
            ]
          )
        ) {
          return target;
        }
        const existingProxy = proxyMap.get(target);
        if (existingProxy) {
          return existingProxy;
        }
        const targetType = getTargetType(target);
        if (targetType === 0) {
          return target;
        }
        const proxy = new Proxy(
          target,
          targetType === 2 ? collectionHandlers : baseHandlers
        );
        proxyMap.set(target, proxy);
        return proxy;
      }
      function toRaw(observed) {
        return (
          (observed &&
            toRaw(
              observed[
                "__v_raw"
                /* RAW */
              ]
            )) ||
          observed
        );
      }
      function isRef(r) {
        return Boolean(r && r.__v_isRef === true);
      }

      // packages/alpinejs/src/magics/$nextTick.js
      magic("nextTick", () => nextTick);

      // packages/alpinejs/src/magics/$dispatch.js
      magic("dispatch", (el) => dispatch.bind(dispatch, el));

      // packages/alpinejs/src/magics/$watch.js
      magic(
        "watch",
        (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) =>
          (key, callback) => {
            let evaluate2 = evaluateLater2(key);
            let getter = () => {
              let value;
              evaluate2((i) => (value = i));
              return value;
            };
            let unwatch = watch(getter, callback);
            cleanup2(unwatch);
          }
      );

      // packages/alpinejs/src/magics/$store.js
      magic("store", getStores);

      // packages/alpinejs/src/magics/$data.js
      magic("data", (el) => scope(el));

      // packages/alpinejs/src/magics/$root.js
      magic("root", (el) => closestRoot(el));

      // packages/alpinejs/src/magics/$refs.js
      magic("refs", (el) => {
        if (el._x_refs_proxy) return el._x_refs_proxy;
        el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
        return el._x_refs_proxy;
      });
      function getArrayOfRefObject(el) {
        let refObjects = [];
        findClosest(el, (i) => {
          if (i._x_refs) refObjects.push(i._x_refs);
        });
        return refObjects;
      }

      // packages/alpinejs/src/ids.js
      var globalIdMemo = {};
      function findAndIncrementId(name) {
        if (!globalIdMemo[name]) globalIdMemo[name] = 0;
        return ++globalIdMemo[name];
      }
      function closestIdRoot(el, name) {
        return findClosest(el, (element) => {
          if (element._x_ids && element._x_ids[name]) return true;
        });
      }
      function setIdRoot(el, name) {
        if (!el._x_ids) el._x_ids = {};
        if (!el._x_ids[name]) el._x_ids[name] = findAndIncrementId(name);
      }

      // packages/alpinejs/src/magics/$id.js
      magic("id", (el, { cleanup: cleanup2 }) => (name, key = null) => {
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return cacheIdByNameOnElement(el, cacheKey, cleanup2, () => {
          let root = closestIdRoot(el, name);
          let id = root ? root._x_ids[name] : findAndIncrementId(name);
          return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
      });
      interceptClone((from, to) => {
        if (from._x_id) {
          to._x_id = from._x_id;
        }
      });
      function cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
        if (!el._x_id) el._x_id = {};
        if (el._x_id[cacheKey]) return el._x_id[cacheKey];
        let output = callback();
        el._x_id[cacheKey] = output;
        cleanup2(() => {
          delete el._x_id[cacheKey];
        });
        return output;
      }

      // packages/alpinejs/src/magics/$el.js
      magic("el", (el) => el);

      // packages/alpinejs/src/magics/index.js
      warnMissingPluginMagic("Focus", "focus", "focus");
      warnMissingPluginMagic("Persist", "persist", "persist");
      function warnMissingPluginMagic(name, magicName, slug) {
        magic(magicName, (el) =>
          warn(
            `You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`,
            el
          )
        );
      }

      // packages/alpinejs/src/directives/x-modelable.js
      directive(
        "modelable",
        (
          el,
          { expression },
          {
            effect: effect3,
            evaluateLater: evaluateLater2,
            cleanup: cleanup2,
          }
        ) => {
          let func = evaluateLater2(expression);
          let innerGet = () => {
            let result;
            func((i) => (result = i));
            return result;
          };
          let evaluateInnerSet = evaluateLater2(
            `${expression} = __placeholder`
          );
          let innerSet = (val) =>
            evaluateInnerSet(() => {}, { scope: { __placeholder: val } });
          let initialValue = innerGet();
          innerSet(initialValue);
          queueMicrotask(() => {
            if (!el._x_model) return;
            el._x_removeModelListeners["default"]();
            let outerGet = el._x_model.get;
            let outerSet = el._x_model.set;
            let releaseEntanglement = entangle(
              {
                get() {
                  return outerGet();
                },
                set(value) {
                  outerSet(value);
                },
              },
              {
                get() {
                  return innerGet();
                },
                set(value) {
                  innerSet(value);
                },
              }
            );
            cleanup2(releaseEntanglement);
          });
        }
      );

      // packages/alpinejs/src/directives/x-teleport.js
      directive(
        "teleport",
        (el, { modifiers, expression }, { cleanup: cleanup2 }) => {
          if (el.tagName.toLowerCase() !== "template")
            warn("x-teleport can only be used on a <template> tag", el);
          let target = getTarget(expression);
          let clone2 = el.content.cloneNode(true).firstElementChild;
          el._x_teleport = clone2;
          clone2._x_teleportBack = el;
          el.setAttribute("data-teleport-template", true);
          clone2.setAttribute("data-teleport-target", true);
          if (el._x_forwardEvents) {
            el._x_forwardEvents.forEach((eventName) => {
              clone2.addEventListener(eventName, (e) => {
                e.stopPropagation();
                el.dispatchEvent(new e.constructor(e.type, e));
              });
            });
          }
          addScopeToNode(clone2, {}, el);
          let placeInDom = (clone3, target2, modifiers2) => {
            if (modifiers2.includes("prepend")) {
              target2.parentNode.insertBefore(clone3, target2);
            } else if (modifiers2.includes("append")) {
              target2.parentNode.insertBefore(clone3, target2.nextSibling);
            } else {
              target2.appendChild(clone3);
            }
          };
          mutateDom(() => {
            placeInDom(clone2, target, modifiers);
            skipDuringClone(() => {
              initTree(clone2);
              clone2._x_ignore = true;
            })();
          });
          el._x_teleportPutBack = () => {
            let target2 = getTarget(expression);
            mutateDom(() => {
              placeInDom(el._x_teleport, target2, modifiers);
            });
          };
          cleanup2(() => clone2.remove());
        }
      );
      var teleportContainerDuringClone = document.createElement("div");
      function getTarget(expression) {
        let target = skipDuringClone(
          () => {
            return document.querySelector(expression);
          },
          () => {
            return teleportContainerDuringClone;
          }
        )();
        if (!target)
          warn(
            `Cannot find x-teleport element for selector: "${expression}"`
          );
        return target;
      }

      // packages/alpinejs/src/directives/x-ignore.js
      var handler = () => {};
      handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
        modifiers.includes("self")
          ? (el._x_ignoreSelf = true)
          : (el._x_ignore = true);
        cleanup2(() => {
          modifiers.includes("self")
            ? delete el._x_ignoreSelf
            : delete el._x_ignore;
        });
      };
      directive("ignore", handler);

      // packages/alpinejs/src/directives/x-effect.js
      directive(
        "effect",
        skipDuringClone((el, { expression }, { effect: effect3 }) => {
          effect3(evaluateLater(el, expression));
        })
      );

      // packages/alpinejs/src/utils/on.js
      function on(el, event, modifiers, callback) {
        let listenerTarget = el;
        let handler4 = (e) => callback(e);
        let options = {};
        let wrapHandler = (callback2, wrapper) => (e) =>
          wrapper(callback2, e);
        if (modifiers.includes("dot")) event = dotSyntax(event);
        if (modifiers.includes("camel")) event = camelCase2(event);
        if (modifiers.includes("passive")) options.passive = true;
        if (modifiers.includes("capture")) options.capture = true;
        if (modifiers.includes("window")) listenerTarget = window;
        if (modifiers.includes("document")) listenerTarget = document;
        if (modifiers.includes("debounce")) {
          let nextModifier =
            modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
          let wait = isNumeric(nextModifier.split("ms")[0])
            ? Number(nextModifier.split("ms")[0])
            : 250;
          handler4 = debounce(handler4, wait);
        }
        if (modifiers.includes("throttle")) {
          let nextModifier =
            modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
          let wait = isNumeric(nextModifier.split("ms")[0])
            ? Number(nextModifier.split("ms")[0])
            : 250;
          handler4 = throttle(handler4, wait);
        }
        if (modifiers.includes("prevent"))
          handler4 = wrapHandler(handler4, (next, e) => {
            e.preventDefault();
            next(e);
          });
        if (modifiers.includes("stop"))
          handler4 = wrapHandler(handler4, (next, e) => {
            e.stopPropagation();
            next(e);
          });
        if (modifiers.includes("once")) {
          handler4 = wrapHandler(handler4, (next, e) => {
            next(e);
            listenerTarget.removeEventListener(event, handler4, options);
          });
        }
        if (modifiers.includes("away") || modifiers.includes("outside")) {
          listenerTarget = document;
          handler4 = wrapHandler(handler4, (next, e) => {
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
          });
        }
        if (modifiers.includes("self"))
          handler4 = wrapHandler(handler4, (next, e) => {
            e.target === el && next(e);
          });
        if (isKeyEvent(event) || isClickEvent(event)) {
          handler4 = wrapHandler(handler4, (next, e) => {
            if (
              isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)
            ) {
              return;
            }
            next(e);
          });
        }
        listenerTarget.addEventListener(event, handler4, options);
        return () => {
          listenerTarget.removeEventListener(event, handler4, options);
        };
      }
      function dotSyntax(subject) {
        return subject.replace(/-/g, ".");
      }
      function camelCase2(subject) {
        return subject
          .toLowerCase()
          .replace(/-(\w)/g, (match, char) => char.toUpperCase());
      }
      function isNumeric(subject) {
        return !Array.isArray(subject) && !isNaN(subject);
      }
      function kebabCase2(subject) {
        if ([" ", "_"].includes(subject)) return subject;
        return subject
          .replace(/([a-z])([A-Z])/g, "$1-$2")
          .replace(/[_\s]/, "-")
          .toLowerCase();
      }
      function isKeyEvent(event) {
        return ["keydown", "keyup"].includes(event);
      }
      function isClickEvent(event) {
        return ["contextmenu", "click", "mouse"].some((i) =>
          event.includes(i)
        );
      }
      function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
        let keyModifiers = modifiers.filter((i) => {
          return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
          ].includes(i);
        });
        if (keyModifiers.includes("debounce")) {
          let debounceIndex = keyModifiers.indexOf("debounce");
          keyModifiers.splice(
            debounceIndex,
            isNumeric(
              (keyModifiers[debounceIndex + 1] || "invalid-wait").split(
                "ms"
              )[0]
            )
              ? 2
              : 1
          );
        }
        if (keyModifiers.includes("throttle")) {
          let debounceIndex = keyModifiers.indexOf("throttle");
          keyModifiers.splice(
            debounceIndex,
            isNumeric(
              (keyModifiers[debounceIndex + 1] || "invalid-wait").split(
                "ms"
              )[0]
            )
              ? 2
              : 1
          );
        }
        if (keyModifiers.length === 0) return false;
        if (
          keyModifiers.length === 1 &&
          keyToModifiers(e.key).includes(keyModifiers[0])
        )
          return false;
        const systemKeyModifiers = [
          "ctrl",
          "shift",
          "alt",
          "meta",
          "cmd",
          "super",
        ];
        const selectedSystemKeyModifiers = systemKeyModifiers.filter(
          (modifier) => keyModifiers.includes(modifier)
        );
        keyModifiers = keyModifiers.filter(
          (i) => !selectedSystemKeyModifiers.includes(i)
        );
        if (selectedSystemKeyModifiers.length > 0) {
          const activelyPressedKeyModifiers =
            selectedSystemKeyModifiers.filter((modifier) => {
              if (modifier === "cmd" || modifier === "super")
                modifier = "meta";
              return e[`${modifier}Key`];
            });
          if (
            activelyPressedKeyModifiers.length ===
            selectedSystemKeyModifiers.length
          ) {
            if (isClickEvent(e.type)) return false;
            if (keyToModifiers(e.key).includes(keyModifiers[0])) return false;
          }
        }
        return true;
      }
      function keyToModifiers(key) {
        if (!key) return [];
        key = kebabCase2(key);
        let modifierToKeyMap = {
          ctrl: "control",
          slash: "/",
          space: " ",
          spacebar: " ",
          cmd: "meta",
          esc: "escape",
          up: "arrow-up",
          down: "arrow-down",
          left: "arrow-left",
          right: "arrow-right",
          period: ".",
          comma: ",",
          equal: "=",
          minus: "-",
          underscore: "_",
        };
        modifierToKeyMap[key] = key;
        return Object.keys(modifierToKeyMap)
          .map((modifier) => {
            if (modifierToKeyMap[modifier] === key) return modifier;
          })
          .filter((modifier) => modifier);
      }

      // packages/alpinejs/src/directives/x-model.js
      directive(
        "model",
        (
          el,
          { modifiers, expression },
          { effect: effect3, cleanup: cleanup2 }
        ) => {
          let scopeTarget = el;
          if (modifiers.includes("parent")) {
            scopeTarget = el.parentNode;
          }
          let evaluateGet = evaluateLater(scopeTarget, expression);
          let evaluateSet;
          if (typeof expression === "string") {
            evaluateSet = evaluateLater(
              scopeTarget,
              `${expression} = __placeholder`
            );
          } else if (
            typeof expression === "function" &&
            typeof expression() === "string"
          ) {
            evaluateSet = evaluateLater(
              scopeTarget,
              `${expression()} = __placeholder`
            );
          } else {
            evaluateSet = () => {};
          }
          let getValue = () => {
            let result;
            evaluateGet((value) => (result = value));
            return isGetterSetter(result) ? result.get() : result;
          };
          let setValue = (value) => {
            let result;
            evaluateGet((value2) => (result = value2));
            if (isGetterSetter(result)) {
              result.set(value);
            } else {
              evaluateSet(() => {}, {
                scope: { __placeholder: value },
              });
            }
          };
          if (typeof expression === "string" && el.type === "radio") {
            mutateDom(() => {
              if (!el.hasAttribute("name"))
                el.setAttribute("name", expression);
            });
          }
          var event =
            el.tagName.toLowerCase() === "select" ||
            ["checkbox", "radio"].includes(el.type) ||
            modifiers.includes("lazy")
              ? "change"
              : "input";
          let removeListener = isCloning
            ? () => {}
            : on(el, event, modifiers, (e) => {
                setValue(getInputValue(el, modifiers, e, getValue()));
              });
          if (modifiers.includes("fill")) {
            if (
              [void 0, null, ""].includes(getValue()) ||
              (el.type === "checkbox" && Array.isArray(getValue())) ||
              (el.tagName.toLowerCase() === "select" && el.multiple)
            ) {
              setValue(
                getInputValue(el, modifiers, { target: el }, getValue())
              );
            }
          }
          if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
          el._x_removeModelListeners["default"] = removeListener;
          cleanup2(() => el._x_removeModelListeners["default"]());
          if (el.form) {
            let removeResetListener = on(el.form, "reset", [], (e) => {
              nextTick(
                () =>
                  el._x_model &&
                  el._x_model.set(
                    getInputValue(el, modifiers, { target: el }, getValue())
                  )
              );
            });
            cleanup2(() => removeResetListener());
          }
          el._x_model = {
            get() {
              return getValue();
            },
            set(value) {
              setValue(value);
            },
          };
          el._x_forceModelUpdate = (value) => {
            if (
              value === void 0 &&
              typeof expression === "string" &&
              expression.match(/\./)
            )
              value = "";
            window.fromModel = true;
            mutateDom(() => bind(el, "value", value));
            delete window.fromModel;
          };
          effect3(() => {
            let value = getValue();
            if (
              modifiers.includes("unintrusive") &&
              document.activeElement.isSameNode(el)
            )
              return;
            el._x_forceModelUpdate(value);
          });
        }
      );
      function getInputValue(el, modifiers, event, currentValue) {
        return mutateDom(() => {
          if (event instanceof CustomEvent && event.detail !== void 0)
            return event.detail !== null && event.detail !== void 0
              ? event.detail
              : event.target.value;
          else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
              let newValue = null;
              if (modifiers.includes("number")) {
                newValue = safeParseNumber(event.target.value);
              } else if (modifiers.includes("boolean")) {
                newValue = safeParseBoolean(event.target.value);
              } else {
                newValue = event.target.value;
              }
              return event.target.checked
                ? currentValue.includes(newValue)
                  ? currentValue
                  : currentValue.concat([newValue])
                : currentValue.filter(
                    (el2) => !checkedAttrLooseCompare2(el2, newValue)
                  );
            } else {
              return event.target.checked;
            }
          } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) {
              return Array.from(event.target.selectedOptions).map(
                (option) => {
                  let rawValue = option.value || option.text;
                  return safeParseNumber(rawValue);
                }
              );
            } else if (modifiers.includes("boolean")) {
              return Array.from(event.target.selectedOptions).map(
                (option) => {
                  let rawValue = option.value || option.text;
                  return safeParseBoolean(rawValue);
                }
              );
            }
            return Array.from(event.target.selectedOptions).map((option) => {
              return option.value || option.text;
            });
          } else {
            let newValue;
            if (el.type === "radio") {
              if (event.target.checked) {
                newValue = event.target.value;
              } else {
                newValue = currentValue;
              }
            } else {
              newValue = event.target.value;
            }
            if (modifiers.includes("number")) {
              return safeParseNumber(newValue);
            } else if (modifiers.includes("boolean")) {
              return safeParseBoolean(newValue);
            } else if (modifiers.includes("trim")) {
              return newValue.trim();
            } else {
              return newValue;
            }
          }
        });
      }
      function safeParseNumber(rawValue) {
        let number = rawValue ? parseFloat(rawValue) : null;
        return isNumeric2(number) ? number : rawValue;
      }
      function checkedAttrLooseCompare2(valueA, valueB) {
        return valueA == valueB;
      }
      function isNumeric2(subject) {
        return !Array.isArray(subject) && !isNaN(subject);
      }
      function isGetterSetter(value) {
        return (
          value !== null &&
          typeof value === "object" &&
          typeof value.get === "function" &&
          typeof value.set === "function"
        );
      }

      // packages/alpinejs/src/directives/x-cloak.js
      directive("cloak", (el) =>
        queueMicrotask(() =>
          mutateDom(() => el.removeAttribute(prefix("cloak")))
        )
      );

      // packages/alpinejs/src/directives/x-init.js
      addInitSelector(() => `[${prefix("init")}]`);
      directive(
        "init",
        skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
          if (typeof expression === "string") {
            return !!expression.trim() && evaluate2(expression, {}, false);
          }
          return evaluate2(expression, {}, false);
        })
      );

      // packages/alpinejs/src/directives/x-text.js
      directive(
        "text",
        (
          el,
          { expression },
          { effect: effect3, evaluateLater: evaluateLater2 }
        ) => {
          let evaluate2 = evaluateLater2(expression);
          effect3(() => {
            evaluate2((value) => {
              mutateDom(() => {
                el.textContent = value;
              });
            });
          });
        }
      );

      // packages/alpinejs/src/directives/x-html.js
      directive(
        "html",
        (
          el,
          { expression },
          { effect: effect3, evaluateLater: evaluateLater2 }
        ) => {
          let evaluate2 = evaluateLater2(expression);
          effect3(() => {
            evaluate2((value) => {
              mutateDom(() => {
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                initTree(el);
                delete el._x_ignoreSelf;
              });
            });
          });
        }
      );

      // packages/alpinejs/src/directives/x-bind.js
      mapAttributes(startingWith(":", into(prefix("bind:"))));
      var handler2 = (
        el,
        { value, modifiers, expression, original },
        { effect: effect3, cleanup: cleanup2 }
      ) => {
        if (!value) {
          let bindingProviders = {};
          injectBindingProviders(bindingProviders);
          let getBindings = evaluateLater(el, expression);
          getBindings(
            (bindings) => {
              applyBindingsObject(el, bindings, original);
            },
            { scope: bindingProviders }
          );
          return;
        }
        if (value === "key") return storeKeyForXFor(el, expression);
        if (
          el._x_inlineBindings &&
          el._x_inlineBindings[value] &&
          el._x_inlineBindings[value].extract
        ) {
          return;
        }
        let evaluate2 = evaluateLater(el, expression);
        effect3(() =>
          evaluate2((result) => {
            if (
              result === void 0 &&
              typeof expression === "string" &&
              expression.match(/\./)
            ) {
              result = "";
            }
            mutateDom(() => bind(el, value, result, modifiers));
          })
        );
        cleanup2(() => {
          el._x_undoAddedClasses && el._x_undoAddedClasses();
          el._x_undoAddedStyles && el._x_undoAddedStyles();
        });
      };
      handler2.inline = (el, { value, modifiers, expression }) => {
        if (!value) return;
        if (!el._x_inlineBindings) el._x_inlineBindings = {};
        el._x_inlineBindings[value] = { expression, extract: false };
      };
      directive("bind", handler2);
      function storeKeyForXFor(el, expression) {
        el._x_keyExpression = expression;
      }

      // packages/alpinejs/src/directives/x-data.js
      addRootSelector(() => `[${prefix("data")}]`);
      directive("data", (el, { expression }, { cleanup: cleanup2 }) => {
        if (shouldSkipRegisteringDataDuringClone(el)) return;
        expression = expression === "" ? "{}" : expression;
        let magicContext = {};
        injectMagics(magicContext, el);
        let dataProviderContext = {};
        injectDataProviders(dataProviderContext, magicContext);
        let data2 = evaluate(el, expression, { scope: dataProviderContext });
        if (data2 === void 0 || data2 === true) data2 = {};
        injectMagics(data2, el);
        let reactiveData = reactive(data2);
        initInterceptors(reactiveData);
        let undo = addScopeToNode(el, reactiveData);
        reactiveData["init"] && evaluate(el, reactiveData["init"]);
        cleanup2(() => {
          reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
          undo();
        });
      });
      interceptClone((from, to) => {
        if (from._x_dataStack) {
          to._x_dataStack = from._x_dataStack;
          to.setAttribute("data-has-alpine-state", true);
        }
      });
      function shouldSkipRegisteringDataDuringClone(el) {
        if (!isCloning) return false;
        if (isCloningLegacy) return true;
        return el.hasAttribute("data-has-alpine-state");
      }

      // packages/alpinejs/src/directives/x-show.js
      directive(
        "show",
        (el, { modifiers, expression }, { effect: effect3 }) => {
          let evaluate2 = evaluateLater(el, expression);
          if (!el._x_doHide)
            el._x_doHide = () => {
              mutateDom(() => {
                el.style.setProperty(
                  "display",
                  "none",
                  modifiers.includes("important") ? "important" : void 0
                );
              });
            };
          if (!el._x_doShow)
            el._x_doShow = () => {
              mutateDom(() => {
                if (el.style.length === 1 && el.style.display === "none") {
                  el.removeAttribute("style");
                } else {
                  el.style.removeProperty("display");
                }
              });
            };
          let hide = () => {
            el._x_doHide();
            el._x_isShown = false;
          };
          let show = () => {
            el._x_doShow();
            el._x_isShown = true;
          };
          let clickAwayCompatibleShow = () => setTimeout(show);
          let toggle = once(
            (value) => (value ? show() : hide()),
            (value) => {
              if (
                typeof el._x_toggleAndCascadeWithTransitions === "function"
              ) {
                el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
              } else {
                value ? clickAwayCompatibleShow() : hide();
              }
            }
          );
          let oldValue;
          let firstTime = true;
          effect3(() =>
            evaluate2((value) => {
              if (!firstTime && value === oldValue) return;
              if (modifiers.includes("immediate"))
                value ? clickAwayCompatibleShow() : hide();
              toggle(value);
              oldValue = value;
              firstTime = false;
            })
          );
        }
      );

      // packages/alpinejs/src/directives/x-for.js
      directive(
        "for",
        (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
          let iteratorNames = parseForExpression(expression);
          let evaluateItems = evaluateLater(el, iteratorNames.items);
          let evaluateKey = evaluateLater(
            el,
            // the x-bind:key expression is stored for our use instead of evaluated.
            el._x_keyExpression || "index"
          );
          el._x_prevKeys = [];
          el._x_lookup = {};
          effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
          cleanup2(() => {
            Object.values(el._x_lookup).forEach((el2) => el2.remove());
            delete el._x_prevKeys;
            delete el._x_lookup;
          });
        }
      );
      function loop(el, iteratorNames, evaluateItems, evaluateKey) {
        let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
        let templateEl = el;
        evaluateItems((items) => {
          if (isNumeric3(items) && items >= 0) {
            items = Array.from(Array(items).keys(), (i) => i + 1);
          }
          if (items === void 0) items = [];
          let lookup = el._x_lookup;
          let prevKeys = el._x_prevKeys;
          let scopes = [];
          let keys = [];
          if (isObject2(items)) {
            items = Object.entries(items).map(([key, value]) => {
              let scope2 = getIterationScopeVariables(
                iteratorNames,
                value,
                key,
                items
              );
              evaluateKey(
                (value2) => {
                  if (keys.includes(value2))
                    warn("Duplicate key on x-for", el);
                  keys.push(value2);
                },
                { scope: { index: key, ...scope2 } }
              );
              scopes.push(scope2);
            });
          } else {
            for (let i = 0; i < items.length; i++) {
              let scope2 = getIterationScopeVariables(
                iteratorNames,
                items[i],
                i,
                items
              );
              evaluateKey(
                (value) => {
                  if (keys.includes(value))
                    warn("Duplicate key on x-for", el);
                  keys.push(value);
                },
                { scope: { index: i, ...scope2 } }
              );
              scopes.push(scope2);
            }
          }
          let adds = [];
          let moves = [];
          let removes = [];
          let sames = [];
          for (let i = 0; i < prevKeys.length; i++) {
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
          }
          prevKeys = prevKeys.filter((key) => !removes.includes(key));
          let lastKey = "template";
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
              prevKeys.splice(i, 0, key);
              adds.push([lastKey, i]);
            } else if (prevIndex !== i) {
              let keyInSpot = prevKeys.splice(i, 1)[0];
              let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
              prevKeys.splice(i, 0, keyForSpot);
              prevKeys.splice(prevIndex, 0, keyInSpot);
              moves.push([keyInSpot, keyForSpot]);
            } else {
              sames.push(key);
            }
            lastKey = key;
          }
          for (let i = 0; i < removes.length; i++) {
            let key = removes[i];
            if (!!lookup[key]._x_effects) {
              lookup[key]._x_effects.forEach(dequeueJob);
            }
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
          }
          for (let i = 0; i < moves.length; i++) {
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            mutateDom(() => {
              if (!elForSpot)
                warn(
                  `x-for ":key" is undefined or invalid`,
                  templateEl,
                  keyForSpot,
                  lookup
                );
              elForSpot.after(marker);
              elInSpot.after(elForSpot);
              elForSpot._x_currentIfEl &&
                elForSpot.after(elForSpot._x_currentIfEl);
              marker.before(elInSpot);
              elInSpot._x_currentIfEl &&
                elInSpot.after(elInSpot._x_currentIfEl);
              marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
          }
          for (let i = 0; i < adds.length; i++) {
            let [lastKey2, index] = adds[i];
            let lastEl =
              lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(
              templateEl.content,
              true
            ).firstElementChild;
            let reactiveScope = reactive(scope2);
            addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope) => {
              Object.entries(newScope).forEach(([key2, value]) => {
                reactiveScope[key2] = value;
              });
            };
            mutateDom(() => {
              lastEl.after(clone2);
              skipDuringClone(() => initTree(clone2))();
            });
            if (typeof key === "object") {
              warn(
                "x-for key cannot be an object, it must be a string or an integer",
                templateEl
              );
            }
            lookup[key] = clone2;
          }
          for (let i = 0; i < sames.length; i++) {
            lookup[sames[i]]._x_refreshXForScope(
              scopes[keys.indexOf(sames[i])]
            );
          }
          templateEl._x_prevKeys = keys;
        });
      }
      function parseForExpression(expression) {
        let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
        let stripParensRE = /^\s*\(|\)\s*$/g;
        let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
        let inMatch = expression.match(forAliasRE);
        if (!inMatch) return;
        let res = {};
        res.items = inMatch[2].trim();
        let item = inMatch[1].replace(stripParensRE, "").trim();
        let iteratorMatch = item.match(forIteratorRE);
        if (iteratorMatch) {
          res.item = item.replace(forIteratorRE, "").trim();
          res.index = iteratorMatch[1].trim();
          if (iteratorMatch[2]) {
            res.collection = iteratorMatch[2].trim();
          }
        } else {
          res.item = item;
        }
        return res;
      }
      function getIterationScopeVariables(iteratorNames, item, index, items) {
        let scopeVariables = {};
        if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
          let names = iteratorNames.item
            .replace("[", "")
            .replace("]", "")
            .split(",")
            .map((i) => i.trim());
          names.forEach((name, i) => {
            scopeVariables[name] = item[i];
          });
        } else if (
          /^\{.*\}$/.test(iteratorNames.item) &&
          !Array.isArray(item) &&
          typeof item === "object"
        ) {
          let names = iteratorNames.item
            .replace("{", "")
            .replace("}", "")
            .split(",")
            .map((i) => i.trim());
          names.forEach((name) => {
            scopeVariables[name] = item[name];
          });
        } else {
          scopeVariables[iteratorNames.item] = item;
        }
        if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
        if (iteratorNames.collection)
          scopeVariables[iteratorNames.collection] = items;
        return scopeVariables;
      }
      function isNumeric3(subject) {
        return !Array.isArray(subject) && !isNaN(subject);
      }

      // packages/alpinejs/src/directives/x-ref.js
      function handler3() {}
      handler3.inline = (el, { expression }, { cleanup: cleanup2 }) => {
        let root = closestRoot(el);
        if (!root._x_refs) root._x_refs = {};
        root._x_refs[expression] = el;
        cleanup2(() => delete root._x_refs[expression]);
      };
      directive("ref", handler3);

      // packages/alpinejs/src/directives/x-if.js
      directive(
        "if",
        (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
          if (el.tagName.toLowerCase() !== "template")
            warn("x-if can only be used on a <template> tag", el);
          let evaluate2 = evaluateLater(el, expression);
          let show = () => {
            if (el._x_currentIfEl) return el._x_currentIfEl;
            let clone2 = el.content.cloneNode(true).firstElementChild;
            addScopeToNode(clone2, {}, el);
            mutateDom(() => {
              el.after(clone2);
              skipDuringClone(() => initTree(clone2))();
            });
            el._x_currentIfEl = clone2;
            el._x_undoIf = () => {
              walk(clone2, (node) => {
                if (!!node._x_effects) {
                  node._x_effects.forEach(dequeueJob);
                }
              });
              clone2.remove();
              delete el._x_currentIfEl;
            };
            return clone2;
          };
          let hide = () => {
            if (!el._x_undoIf) return;
            el._x_undoIf();
            delete el._x_undoIf;
          };
          effect3(() =>
            evaluate2((value) => {
              value ? show() : hide();
            })
          );
          cleanup2(() => el._x_undoIf && el._x_undoIf());
        }
      );

      // packages/alpinejs/src/directives/x-id.js
      directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
        let names = evaluate2(expression);
        names.forEach((name) => setIdRoot(el, name));
      });
      interceptClone((from, to) => {
        if (from._x_ids) {
          to._x_ids = from._x_ids;
        }
      });

      // packages/alpinejs/src/directives/x-on.js
      mapAttributes(startingWith("@", into(prefix("on:"))));
      directive(
        "on",
        skipDuringClone(
          (el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
            let evaluate2 = expression
              ? evaluateLater(el, expression)
              : () => {};
            if (el.tagName.toLowerCase() === "template") {
              if (!el._x_forwardEvents) el._x_forwardEvents = [];
              if (!el._x_forwardEvents.includes(value))
                el._x_forwardEvents.push(value);
            }
            let removeListener = on(el, value, modifiers, (e) => {
              evaluate2(() => {}, { scope: { $event: e }, params: [e] });
            });
            cleanup2(() => removeListener());
          }
        )
      );

      // packages/alpinejs/src/directives/index.js
      warnMissingPluginDirective("Collapse", "collapse", "collapse");
      warnMissingPluginDirective("Intersect", "intersect", "intersect");
      warnMissingPluginDirective("Focus", "trap", "focus");
      warnMissingPluginDirective("Mask", "mask", "mask");
      function warnMissingPluginDirective(name, directiveName, slug) {
        directive(directiveName, (el) =>
          warn(
            `You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`,
            el
          )
        );
      }

      // packages/alpinejs/src/index.js
      alpine_default.setEvaluator(normalEvaluator);
      alpine_default.setReactivityEngine({
        reactive: reactive2,
        effect: effect2,
        release: stop,
        raw: toRaw,
      });
      var src_default = alpine_default;

      // packages/alpinejs/builds/cdn.js
      window.Alpine = src_default;
      queueMicrotask(() => {
        src_default.start();
      });
      return src_default;
    });

    /***/
  },
  /* 34 */
  /***/ function (module, exports) {
    var _createClass = (function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    /**
     * This work is licensed under the W3C Software and Document License
     * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
     */

    (function () {
      // Return early if we're not running inside of the browser.
      if (typeof window === "undefined") {
        return;
      }

      // Convenience function for converting NodeLists.
      /** @type {typeof Array.prototype.slice} */
      var slice = Array.prototype.slice;

      /**
       * IE has a non-standard name for "matches".
       * @type {typeof Element.prototype.matches}
       */
      var matches =
        Element.prototype.matches || Element.prototype.msMatchesSelector;

      /** @type {string} */
      var _focusableElementsString = [
        "a[href]",
        "area[href]",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "button:not([disabled])",
        "details",
        "summary",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
      ].join(",");

      /**
       * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
       * attribute.
       *
       * Its main functions are:
       *
       * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
       *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
       *   each focusable node in the subtree with the singleton `InertManager` which manages all known
       *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
       *   instance exists for each focusable node which has at least one inert root as an ancestor.
       *
       * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
       *   attribute is removed from the root node). This is handled in the destructor, which calls the
       *   `deregister` method on `InertManager` for each managed inert node.
       */

      var InertRoot = (function () {
        /**
         * @param {!Element} rootElement The Element at the root of the inert subtree.
         * @param {!InertManager} inertManager The global singleton InertManager object.
         */
        function InertRoot(rootElement, inertManager) {
          _classCallCheck(this, InertRoot);

          /** @type {!InertManager} */
          this._inertManager = inertManager;

          /** @type {!Element} */
          this._rootElement = rootElement;

          /**
           * @type {!Set<!InertNode>}
           * All managed focusable nodes in this InertRoot's subtree.
           */
          this._managedNodes = new Set();

          // Make the subtree hidden from assistive technology
          if (this._rootElement.hasAttribute("aria-hidden")) {
            /** @type {?string} */
            this._savedAriaHidden =
              this._rootElement.getAttribute("aria-hidden");
          } else {
            this._savedAriaHidden = null;
          }
          this._rootElement.setAttribute("aria-hidden", "true");

          // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
          this._makeSubtreeUnfocusable(this._rootElement);

          // Watch for:
          // - any additions in the subtree: make them unfocusable too
          // - any removals from the subtree: remove them from this inert root's managed nodes
          // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
          //   element, make that node a managed node.
          this._observer = new MutationObserver(this._onMutation.bind(this));
          this._observer.observe(this._rootElement, {
            attributes: true,
            childList: true,
            subtree: true,
          });
        }

        /**
         * Call this whenever this object is about to become obsolete.  This unwinds all of the state
         * stored in this object and updates the state of all of the managed nodes.
         */

        _createClass(InertRoot, [
          {
            key: "destructor",
            value: function destructor() {
              this._observer.disconnect();

              if (this._rootElement) {
                if (this._savedAriaHidden !== null) {
                  this._rootElement.setAttribute(
                    "aria-hidden",
                    this._savedAriaHidden
                  );
                } else {
                  this._rootElement.removeAttribute("aria-hidden");
                }
              }

              this._managedNodes.forEach(function (inertNode) {
                this._unmanageNode(inertNode.node);
              }, this);

              // Note we cast the nulls to the ANY type here because:
              // 1) We want the class properties to be declared as non-null, or else we
              //    need even more casts throughout this code. All bets are off if an
              //    instance has been destroyed and a method is called.
              // 2) We don't want to cast "this", because we want type-aware optimizations
              //    to know which properties we're setting.
              this._observer = /** @type {?} */ null;
              this._rootElement = /** @type {?} */ null;
              this._managedNodes = /** @type {?} */ null;
              this._inertManager = /** @type {?} */ null;
            },

            /**
             * @return {!Set<!InertNode>} A copy of this InertRoot's managed nodes set.
             */
          },
          {
            key: "_makeSubtreeUnfocusable",

            /**
             * @param {!Node} startNode
             */
            value: function _makeSubtreeUnfocusable(startNode) {
              var _this2 = this;

              composedTreeWalk(startNode, function (node) {
                return _this2._visitNode(node);
              });

              var activeElement = document.activeElement;

              if (!document.body.contains(startNode)) {
                // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
                var node = startNode;
                /** @type {!ShadowRoot|undefined} */
                var root = undefined;
                while (node) {
                  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    root = /** @type {!ShadowRoot} */ node;
                    break;
                  }
                  node = node.parentNode;
                }
                if (root) {
                  activeElement = root.activeElement;
                }
              }
              if (startNode.contains(activeElement)) {
                activeElement.blur();
                // In IE11, if an element is already focused, and then set to tabindex=-1
                // calling blur() will not actually move the focus.
                // To work around this we call focus() on the body instead.
                if (activeElement === document.activeElement) {
                  document.body.focus();
                }
              }
            },

            /**
             * @param {!Node} node
             */
          },
          {
            key: "_visitNode",
            value: function _visitNode(node) {
              if (node.nodeType !== Node.ELEMENT_NODE) {
                return;
              }
              var element = /** @type {!Element} */ node;

              // If a descendant inert root becomes un-inert, its descendants will still be inert because of
              // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
              if (
                element !== this._rootElement &&
                element.hasAttribute("inert")
              ) {
                this._adoptInertRoot(element);
              }

              if (
                matches.call(element, _focusableElementsString) ||
                element.hasAttribute("tabindex")
              ) {
                this._manageNode(element);
              }
            },

            /**
             * Register the given node with this InertRoot and with InertManager.
             * @param {!Node} node
             */
          },
          {
            key: "_manageNode",
            value: function _manageNode(node) {
              var inertNode = this._inertManager.register(node, this);
              this._managedNodes.add(inertNode);
            },

            /**
             * Unregister the given node with this InertRoot and with InertManager.
             * @param {!Node} node
             */
          },
          {
            key: "_unmanageNode",
            value: function _unmanageNode(node) {
              var inertNode = this._inertManager.deregister(node, this);
              if (inertNode) {
                this._managedNodes["delete"](inertNode);
              }
            },

            /**
             * Unregister the entire subtree starting at `startNode`.
             * @param {!Node} startNode
             */
          },
          {
            key: "_unmanageSubtree",
            value: function _unmanageSubtree(startNode) {
              var _this3 = this;

              composedTreeWalk(startNode, function (node) {
                return _this3._unmanageNode(node);
              });
            },

            /**
             * If a descendant node is found with an `inert` attribute, adopt its managed nodes.
             * @param {!Element} node
             */
          },
          {
            key: "_adoptInertRoot",
            value: function _adoptInertRoot(node) {
              var inertSubroot = this._inertManager.getInertRoot(node);

              // During initialisation this inert root may not have been registered yet,
              // so register it now if need be.
              if (!inertSubroot) {
                this._inertManager.setInert(node, true);
                inertSubroot = this._inertManager.getInertRoot(node);
              }

              inertSubroot.managedNodes.forEach(function (savedInertNode) {
                this._manageNode(savedInertNode.node);
              }, this);
            },

            /**
             * Callback used when mutation observer detects subtree additions, removals, or attribute changes.
             * @param {!Array<!MutationRecord>} records
             * @param {!MutationObserver} self
             */
          },
          {
            key: "_onMutation",
            value: function _onMutation(records, self) {
              records.forEach(function (record) {
                var target = /** @type {!Element} */ record.target;
                if (record.type === "childList") {
                  // Manage added nodes
                  slice.call(record.addedNodes).forEach(function (node) {
                    this._makeSubtreeUnfocusable(node);
                  }, this);

                  // Un-manage removed nodes
                  slice.call(record.removedNodes).forEach(function (node) {
                    this._unmanageSubtree(node);
                  }, this);
                } else if (record.type === "attributes") {
                  if (record.attributeName === "tabindex") {
                    // Re-initialise inert node if tabindex changes
                    this._manageNode(target);
                  } else if (
                    target !== this._rootElement &&
                    record.attributeName === "inert" &&
                    target.hasAttribute("inert")
                  ) {
                    // If a new inert root is added, adopt its managed nodes and make sure it knows about the
                    // already managed nodes from this inert subroot.
                    this._adoptInertRoot(target);
                    var inertSubroot =
                      this._inertManager.getInertRoot(target);
                    this._managedNodes.forEach(function (managedNode) {
                      if (target.contains(managedNode.node)) {
                        inertSubroot._manageNode(managedNode.node);
                      }
                    });
                  }
                }
              }, this);
            },
          },
          {
            key: "managedNodes",
            get: function get() {
              return new Set(this._managedNodes);
            },

            /** @return {boolean} */
          },
          {
            key: "hasSavedAriaHidden",
            get: function get() {
              return this._savedAriaHidden !== null;
            },

            /** @param {?string} ariaHidden */
          },
          {
            key: "savedAriaHidden",
            set: function set(ariaHidden) {
              this._savedAriaHidden = ariaHidden;
            },

            /** @return {?string} */
            get: function get() {
              return this._savedAriaHidden;
            },
          },
        ]);

        return InertRoot;
      })();

      /**
       * `InertNode` initialises and manages a single inert node.
       * A node is inert if it is a descendant of one or more inert root elements.
       *
       * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
       * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
       * is intrinsically focusable or not.
       *
       * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
       * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
       * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
       * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
       * or removes the `tabindex` attribute if the element is intrinsically focusable.
       */

      var InertNode = (function () {
        /**
         * @param {!Node} node A focusable element to be made inert.
         * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
         */
        function InertNode(node, inertRoot) {
          _classCallCheck(this, InertNode);

          /** @type {!Node} */
          this._node = node;

          /** @type {boolean} */
          this._overrodeFocusMethod = false;

          /**
           * @type {!Set<!InertRoot>} The set of descendant inert roots.
           *    If and only if this set becomes empty, this node is no longer inert.
           */
          this._inertRoots = new Set([inertRoot]);

          /** @type {?number} */
          this._savedTabIndex = null;

          /** @type {boolean} */
          this._destroyed = false;

          // Save any prior tabindex info and make this node untabbable
          this.ensureUntabbable();
        }

        /**
         * Call this whenever this object is about to become obsolete.
         * This makes the managed node focusable again and deletes all of the previously stored state.
         */

        _createClass(InertNode, [
          {
            key: "destructor",
            value: function destructor() {
              this._throwIfDestroyed();

              if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                var element = /** @type {!Element} */ this._node;
                if (this._savedTabIndex !== null) {
                  element.setAttribute("tabindex", this._savedTabIndex);
                } else {
                  element.removeAttribute("tabindex");
                }

                // Use `delete` to restore native focus method.
                if (this._overrodeFocusMethod) {
                  delete element.focus;
                }
              }

              // See note in InertRoot.destructor for why we cast these nulls to ANY.
              this._node = /** @type {?} */ null;
              this._inertRoots = /** @type {?} */ null;
              this._destroyed = true;
            },

            /**
             * @type {boolean} Whether this object is obsolete because the managed node is no longer inert.
             * If the object has been destroyed, any attempt to access it will cause an exception.
             */
          },
          {
            key: "_throwIfDestroyed",

            /**
             * Throw if user tries to access destroyed InertNode.
             */
            value: function _throwIfDestroyed() {
              if (this.destroyed) {
                throw new Error("Trying to access destroyed InertNode");
              }
            },

            /** @return {boolean} */
          },
          {
            key: "ensureUntabbable",

            /** Save the existing tabindex value and make the node untabbable and unfocusable */
            value: function ensureUntabbable() {
              if (this.node.nodeType !== Node.ELEMENT_NODE) {
                return;
              }
              var element = /** @type {!Element} */ this.node;
              if (matches.call(element, _focusableElementsString)) {
                if (
                  /** @type {!HTMLElement} */ element.tabIndex === -1 &&
                  this.hasSavedTabIndex
                ) {
                  return;
                }

                if (element.hasAttribute("tabindex")) {
                  this._savedTabIndex =
                    /** @type {!HTMLElement} */ element.tabIndex;
                }
                element.setAttribute("tabindex", "-1");
                if (element.nodeType === Node.ELEMENT_NODE) {
                  element.focus = function () {};
                  this._overrodeFocusMethod = true;
                }
              } else if (element.hasAttribute("tabindex")) {
                this._savedTabIndex =
                  /** @type {!HTMLElement} */ element.tabIndex;
                element.removeAttribute("tabindex");
              }
            },

            /**
             * Add another inert root to this inert node's set of managing inert roots.
             * @param {!InertRoot} inertRoot
             */
          },
          {
            key: "addInertRoot",
            value: function addInertRoot(inertRoot) {
              this._throwIfDestroyed();
              this._inertRoots.add(inertRoot);
            },

            /**
             * Remove the given inert root from this inert node's set of managing inert roots.
             * If the set of managing inert roots becomes empty, this node is no longer inert,
             * so the object should be destroyed.
             * @param {!InertRoot} inertRoot
             */
          },
          {
            key: "removeInertRoot",
            value: function removeInertRoot(inertRoot) {
              this._throwIfDestroyed();
              this._inertRoots["delete"](inertRoot);
              if (this._inertRoots.size === 0) {
                this.destructor();
              }
            },
          },
          {
            key: "destroyed",
            get: function get() {
              return /** @type {!InertNode} */ this._destroyed;
            },
          },
          {
            key: "hasSavedTabIndex",
            get: function get() {
              return this._savedTabIndex !== null;
            },

            /** @return {!Node} */
          },
          {
            key: "node",
            get: function get() {
              this._throwIfDestroyed();
              return this._node;
            },

            /** @param {?number} tabIndex */
          },
          {
            key: "savedTabIndex",
            set: function set(tabIndex) {
              this._throwIfDestroyed();
              this._savedTabIndex = tabIndex;
            },

            /** @return {?number} */
            get: function get() {
              this._throwIfDestroyed();
              return this._savedTabIndex;
            },
          },
        ]);

        return InertNode;
      })();

      /**
       * InertManager is a per-document singleton object which manages all inert roots and nodes.
       *
       * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
       * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
       * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
       * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
       * is created for each such node, via the `_managedNodes` map.
       */

      var InertManager = (function () {
        /**
         * @param {!Document} document
         */
        function InertManager(document) {
          _classCallCheck(this, InertManager);

          if (!document) {
            throw new Error(
              "Missing required argument; InertManager needs to wrap a document."
            );
          }

          /** @type {!Document} */
          this._document = document;

          /**
           * All managed nodes known to this InertManager. In a map to allow looking up by Node.
           * @type {!Map<!Node, !InertNode>}
           */
          this._managedNodes = new Map();

          /**
           * All inert roots known to this InertManager. In a map to allow looking up by Node.
           * @type {!Map<!Node, !InertRoot>}
           */
          this._inertRoots = new Map();

          /**
           * Observer for mutations on `document.body`.
           * @type {!MutationObserver}
           */
          this._observer = new MutationObserver(
            this._watchForInert.bind(this)
          );

          // Add inert style.
          addInertStyle(
            document.head || document.body || document.documentElement
          );

          // Wait for document to be loaded.
          if (document.readyState === "loading") {
            document.addEventListener(
              "DOMContentLoaded",
              this._onDocumentLoaded.bind(this)
            );
          } else {
            this._onDocumentLoaded();
          }
        }

        /**
         * Set whether the given element should be an inert root or not.
         * @param {!Element} root
         * @param {boolean} inert
         */

        _createClass(InertManager, [
          {
            key: "setInert",
            value: function setInert(root, inert) {
              if (inert) {
                if (this._inertRoots.has(root)) {
                  // element is already inert
                  return;
                }

                var inertRoot = new InertRoot(root, this);
                root.setAttribute("inert", "");
                this._inertRoots.set(root, inertRoot);
                // If not contained in the document, it must be in a shadowRoot.
                // Ensure inert styles are added there.
                if (!this._document.body.contains(root)) {
                  var parent = root.parentNode;
                  while (parent) {
                    if (parent.nodeType === 11) {
                      addInertStyle(parent);
                    }
                    parent = parent.parentNode;
                  }
                }
              } else {
                if (!this._inertRoots.has(root)) {
                  // element is already non-inert
                  return;
                }

                var _inertRoot = this._inertRoots.get(root);
                _inertRoot.destructor();
                this._inertRoots["delete"](root);
                root.removeAttribute("inert");
              }
            },

            /**
             * Get the InertRoot object corresponding to the given inert root element, if any.
             * @param {!Node} element
             * @return {!InertRoot|undefined}
             */
          },
          {
            key: "getInertRoot",
            value: function getInertRoot(element) {
              return this._inertRoots.get(element);
            },

            /**
             * Register the given InertRoot as managing the given node.
             * In the case where the node has a previously existing inert root, this inert root will
             * be added to its set of inert roots.
             * @param {!Node} node
             * @param {!InertRoot} inertRoot
             * @return {!InertNode} inertNode
             */
          },
          {
            key: "register",
            value: function register(node, inertRoot) {
              var inertNode = this._managedNodes.get(node);
              if (inertNode !== undefined) {
                // node was already in an inert subtree
                inertNode.addInertRoot(inertRoot);
              } else {
                inertNode = new InertNode(node, inertRoot);
              }

              this._managedNodes.set(node, inertNode);

              return inertNode;
            },

            /**
             * De-register the given InertRoot as managing the given inert node.
             * Removes the inert root from the InertNode's set of managing inert roots, and remove the inert
             * node from the InertManager's set of managed nodes if it is destroyed.
             * If the node is not currently managed, this is essentially a no-op.
             * @param {!Node} node
             * @param {!InertRoot} inertRoot
             * @return {?InertNode} The potentially destroyed InertNode associated with this node, if any.
             */
          },
          {
            key: "deregister",
            value: function deregister(node, inertRoot) {
              var inertNode = this._managedNodes.get(node);
              if (!inertNode) {
                return null;
              }

              inertNode.removeInertRoot(inertRoot);
              if (inertNode.destroyed) {
                this._managedNodes["delete"](node);
              }

              return inertNode;
            },

            /**
             * Callback used when document has finished loading.
             */
          },
          {
            key: "_onDocumentLoaded",
            value: function _onDocumentLoaded() {
              // Find all inert roots in document and make them actually inert.
              var inertElements = slice.call(
                this._document.querySelectorAll("[inert]")
              );
              inertElements.forEach(function (inertElement) {
                this.setInert(inertElement, true);
              }, this);

              // Comment this out to use programmatic API only.
              this._observer.observe(
                this._document.body || this._document.documentElement,
                { attributes: true, subtree: true, childList: true }
              );
            },

            /**
             * Callback used when mutation observer detects attribute changes.
             * @param {!Array<!MutationRecord>} records
             * @param {!MutationObserver} self
             */
          },
          {
            key: "_watchForInert",
            value: function _watchForInert(records, self) {
              var _this = this;
              records.forEach(function (record) {
                switch (record.type) {
                  case "childList":
                    slice.call(record.addedNodes).forEach(function (node) {
                      if (node.nodeType !== Node.ELEMENT_NODE) {
                        return;
                      }
                      var inertElements = slice.call(
                        node.querySelectorAll("[inert]")
                      );
                      if (matches.call(node, "[inert]")) {
                        inertElements.unshift(node);
                      }
                      inertElements.forEach(function (inertElement) {
                        this.setInert(inertElement, true);
                      }, _this);
                    }, _this);
                    break;
                  case "attributes":
                    if (record.attributeName !== "inert") {
                      return;
                    }
                    var target = /** @type {!Element} */ record.target;
                    var inert = target.hasAttribute("inert");
                    _this.setInert(target, inert);
                    break;
                }
              }, this);
            },
          },
        ]);

        return InertManager;
      })();

      /**
       * Recursively walk the composed tree from |node|.
       * @param {!Node} node
       * @param {(function (!Element))=} callback Callback to be called for each element traversed,
       *     before descending into child nodes.
       * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
       */

      function composedTreeWalk(node, callback, shadowRootAncestor) {
        if (node.nodeType == Node.ELEMENT_NODE) {
          var element = /** @type {!Element} */ node;
          if (callback) {
            callback(element);
          }

          // Descend into node:
          // If it has a ShadowRoot, ignore all child elements - these will be picked
          // up by the <content> or <shadow> elements. Descend straight into the
          // ShadowRoot.
          var shadowRoot = /** @type {!HTMLElement} */ element.shadowRoot;
          if (shadowRoot) {
            composedTreeWalk(shadowRoot, callback, shadowRoot);
            return;
          }

          // If it is a <content> element, descend into distributed elements - these
          // are elements from outside the shadow root which are rendered inside the
          // shadow DOM.
          if (element.localName == "content") {
            var content = /** @type {!HTMLContentElement} */ element;
            // Verifies if ShadowDom v0 is supported.
            var distributedNodes = content.getDistributedNodes
              ? content.getDistributedNodes()
              : [];
            for (var i = 0; i < distributedNodes.length; i++) {
              composedTreeWalk(
                distributedNodes[i],
                callback,
                shadowRootAncestor
              );
            }
            return;
          }

          // If it is a <slot> element, descend into assigned nodes - these
          // are elements from outside the shadow root which are rendered inside the
          // shadow DOM.
          if (element.localName == "slot") {
            var slot = /** @type {!HTMLSlotElement} */ element;
            // Verify if ShadowDom v1 is supported.
            var _distributedNodes = slot.assignedNodes
              ? slot.assignedNodes({ flatten: true })
              : [];
            for (var _i = 0; _i < _distributedNodes.length; _i++) {
              composedTreeWalk(
                _distributedNodes[_i],
                callback,
                shadowRootAncestor
              );
            }
            return;
          }
        }

        // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
        // element, nor a <shadow> element recurse normally.
        var child = node.firstChild;
        while (child != null) {
          composedTreeWalk(child, callback, shadowRootAncestor);
          child = child.nextSibling;
        }
      }

      /**
       * Adds a style element to the node containing the inert specific styles
       * @param {!Node} node
       */
      function addInertStyle(node) {
        if (node.querySelector("style#inert-style, link#inert-style")) {
          return;
        }
        var style = document.createElement("style");
        style.setAttribute("id", "inert-style");
        style.textContent =
          "\n" +
          "[inert] {\n" +
          "  pointer-events: none;\n" +
          "  cursor: default;\n" +
          "}\n" +
          "\n" +
          "[inert], [inert] * {\n" +
          "  -webkit-user-select: none;\n" +
          "  -moz-user-select: none;\n" +
          "  -ms-user-select: none;\n" +
          "  user-select: none;\n" +
          "}\n";
        node.appendChild(style);
      }

      if (!Element.prototype.hasOwnProperty("inert")) {
        /** @type {!InertManager} */
        var inertManager = new InertManager(document);

        Object.defineProperty(Element.prototype, "inert", {
          enumerable: true,
          /** @this {!Element} */
          get: function get() {
            return this.hasAttribute("inert");
          },
          /** @this {!Element} */
          set: function set(inert) {
            inertManager.setInert(this, inert);
          },
        });
      }
    })();

    /***/
  },
  /* 35 */
  /***/ function (module, exports) {
    /*! outline.js v1.2.0 - https://github.com/lindsayevans/outline.js/ */
    // modified by Switch Themes to use body classname instead of adding a style tag
    (function (d) {
      const dom_events = "addEventListener" in d;
      const add_event_listener = function (type, callback) {
        // Basic cross-browser event handling
        if (dom_events) {
          d.addEventListener(type, callback);
        } else {
          d.attachEvent("on" + type, callback);
        }
      };
      // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
      add_event_listener("mousedown", function () {
        document.body.classList.add("user-using-mouse");
      });

      add_event_listener("keydown", function () {
        document.body.classList.remove("user-using-mouse");
      });
    })(document);

    /***/
  },
  /* 36 */
  /***/ function (module, exports, __webpack_require__) {
    // extracted by mini-css-extract-plugin
    /***/
  },
  /* 37 */
  /***/ function (module, exports) {
    /**
     * Insert your styles with Liquid below.
     *
     * Import additional stylesheets into this sheet using CSS imports:
     * @import url('./global/form.scss');
     */
    /***/
  },
  /* 38 */
  /***/ function (module, exports) {
    window.ThemeComponent_Login = function () {
      return {
        state: "login",
        mounted: function mounted() {
          var _this = this;

          this.$watch("state", function () {
            _this.$nextTick(function () {
              var toFocus = document.querySelector("[data-login-focus]");
              if (toFocus) toFocus.focus();
            });
          });
          this.$nextTick(function () {
            if (
              window.location.hash === "#recover" ||
              document.querySelector("[data-recover-success]")
            ) {
              _this.state = "recover";
            }

            var toFocus = document.querySelector("[data-login-error]");
            if (toFocus) toFocus.focus();
          });
        },
      };
    };

    /***/
  },
  /* 39 */
  /***/ function (module, exports) {
    window.Alpine.store("product-grid-audio-player", {
      audio: null,
      is_playing: false,
      playTrack: function playTrack(
        audio,
        product_title,
        featured_media_url
      ) {
        if (this.audio !== null) {
          this.audio.pause();
        }

        document.body.dispatchEvent(new CustomEvent("pauseAllMedia"));
        this.audio = audio;
        this.audio.currentTime = 0;
        this.audio.play();
        this.updateMediaSession(product_title, featured_media_url);
      },
      updatePlayStatus: function updatePlayStatus(status) {
        this.is_playing = status;
      },
      updateMediaSession: function updateMediaSession(
        product_title,
        featured_media_url
      ) {
        var artist = "";
        var album = "";

        if (product_title.indexOf(" - ") > -1) {
          var splitTitle = product_title.split(" - ");
          artist = splitTitle[0];
          album = splitTitle[1];
        } else {
          artist = product_title;
        }

        if ("mediaSession" in navigator) {
          navigator.mediaSession.metadata = new MediaMetadata({
            title: "",
            artist: artist,
            album: album,
            artwork: [
              {
                src: featured_media_url.replace("{width}", "96"),
                sizes: "96x96",
              },
              {
                src: featured_media_url.replace("{width}", "128"),
                sizes: "128x128",
              },
              {
                src: featured_media_url.replace("{width}", "192"),
                sizes: "192x192",
              },
              {
                src: featured_media_url.replace("{width}", "256"),
                sizes: "256x256",
              },
              {
                src: featured_media_url.replace("{width}", "384"),
                sizes: "384x384",
              },
              {
                src: featured_media_url.replace("{width}", "512"),
                sizes: "512x512",
              },
            ],
          });
        }
      },
    });

    window["ThemeComponent_ProductGrid"] = function (
      mode,
      product_title,
      featured_media_url,
      current_media= 1,
    ) {
      var audio_url =
        arguments.length > 3 && arguments[3] !== undefined
          ? arguments[3]
          : null;
      var audio = new Audio(audio_url);
      audio.preload = "none";
      return {
        mode: mode,
        audio: audio_url !== null ? audio : null,
        hover: false,
        product_title: product_title,
        featured_media_url: featured_media_url,
        current_media: 1,
        is_mobile: false,
        current_swatch_variant: "",

        get is_playing() {
          if (this.$store["product-grid-audio-player"].audio !== null) {
            return (
              this.$store["product-grid-audio-player"].audio.src.includes(
                audio_url
              ) && this.$store["product-grid-audio-player"].is_playing
            );
          } else {
            return false;
          }
        },

        mounted: function mounted() {
          if (this.audio !== null) {
            this.setUpAudio();
          }
        },
        resetHover: function resetHover() {
          this.hover = false;
          this.current_media = 1;
        },
        onFocusOut: function onFocusOut(event) {
          var productGridItem = event.target.closest(
            "[data-product-grid-item]"
          );

          if (
            productGridItem &&
            !productGridItem.contains(event.relatedTarget)
          ) {
            this.resetHover();
          }
        },
        setUpAudio: function setUpAudio() {
          var _this = this;

          this.audio.onplay = function () {
            _this.$store["product-grid-audio-player"].updatePlayStatus(true);
          };

          this.audio.onpause = function () {
            _this.$store["product-grid-audio-player"].updatePlayStatus(false);
          };

          document.body.addEventListener("pauseAllMedia", function () {
            _this.audio.pause();
          });
        },
        playButtonToggle: function playButtonToggle() {
          this.is_playing
            ? this.audio.pause()
            : this.$store["product-grid-audio-player"].playTrack(
                this.audio,
                this.product_title,
                this.featured_media_url
              );
        },
      };
    };

    /***/
  },
  /* 40 */
  /***/ function (module, exports) {
    /** Error message constants. */
    var FUNC_ERROR_TEXT = "Expected a function";

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function () {
        func.apply(undefined, args);
      }, wait);
    }

    module.exports = baseDelay;

    /***/
  },
  /* 41 */
  /***/ function (module, exports, __webpack_require__) {
    var identity = __webpack_require__(25),
      overRest = __webpack_require__(42),
      setToString = __webpack_require__(44);

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }

    module.exports = baseRest;

    /***/
  },
  /* 42 */
  /***/ function (module, exports, __webpack_require__) {
    var apply = __webpack_require__(43);

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max;

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    module.exports = overRest;

    /***/
  },
  /* 43 */
  /***/ function (module, exports) {
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }

    module.exports = apply;

    /***/
  },
  /* 44 */
  /***/ function (module, exports, __webpack_require__) {
    var baseSetToString = __webpack_require__(45),
      shortOut = __webpack_require__(55);

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    module.exports = setToString;

    /***/
  },
  /* 45 */
  /***/ function (module, exports, __webpack_require__) {
    var constant = __webpack_require__(46),
      defineProperty = __webpack_require__(47),
      identity = __webpack_require__(25);

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty
      ? identity
      : function (func, string) {
          return defineProperty(func, "toString", {
            configurable: true,
            enumerable: false,
            value: constant(string),
            writable: true,
          });
        };

    module.exports = baseSetToString;

    /***/
  },
  /* 46 */
  /***/ function (module, exports) {
    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function () {
        return value;
      };
    }

    module.exports = constant;

    /***/
  },
  /* 47 */
  /***/ function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__(48);

    var defineProperty = (function () {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {}
    })();

    module.exports = defineProperty;

    /***/
  },
  /* 48 */
  /***/ function (module, exports, __webpack_require__) {
    var baseIsNative = __webpack_require__(49),
      getValue = __webpack_require__(54);

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    module.exports = getNative;

    /***/
  },
  /* 49 */
  /***/ function (module, exports, __webpack_require__) {
    var isFunction = __webpack_require__(50),
      isMasked = __webpack_require__(51),
      isObject = __webpack_require__(6),
      toSource = __webpack_require__(53);

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used for built-in method references. */
    var funcProto = Function.prototype,
      objectProto = Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp(
      "^" +
        funcToString
          .call(hasOwnProperty)
          .replace(reRegExpChar, "\\$&")
          .replace(
            /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
            "$1.*?"
          ) +
        "$"
    );

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    module.exports = baseIsNative;

    /***/
  },
  /* 50 */
  /***/ function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__(13),
      isObject = __webpack_require__(6);

    /** `Object#toString` result references. */
    var asyncTag = "[object AsyncFunction]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      proxyTag = "[object Proxy]";

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return (
        tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag
      );
    }

    module.exports = isFunction;

    /***/
  },
  /* 51 */
  /***/ function (module, exports, __webpack_require__) {
    var coreJsData = __webpack_require__(52);

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function () {
      var uid = /[^.]+$/.exec(
        (coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || ""
      );
      return uid ? "Symbol(src)_1." + uid : "";
    })();

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }

    module.exports = isMasked;

    /***/
  },
  /* 52 */
  /***/ function (module, exports, __webpack_require__) {
    var root = __webpack_require__(7);

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root["__core-js_shared__"];

    module.exports = coreJsData;

    /***/
  },
  /* 53 */
  /***/ function (module, exports) {
    /** Used for built-in method references. */
    var funcProto = Function.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + "";
        } catch (e) {}
      }
      return "";
    }

    module.exports = toSource;

    /***/
  },
  /* 54 */
  /***/ function (module, exports) {
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }

    module.exports = getValue;

    /***/
  },
  /* 55 */
  /***/ function (module, exports) {
    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
      HOT_SPAN = 16;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeNow = Date.now;

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
        lastCalled = 0;

      return function () {
        var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    module.exports = shortOut;

    /***/
  },
  /* 56 */
  /***/ function (module, exports) {
    window["QuantityControls"] = function () {
      return {
        shouldSendEvent: true,
        mounted: function mounted(property) {
          var _this = this;

          this.$watch(property, function (value) {
            if (_this.shouldSendEvent) {
              _this.sendEvent(value);
            }
          });
        },
        qtyAdjust: function qtyAdjust($event, value, property) {
          this[property] += value;

          if (this[property] < 0) {
            this[property] = 0;
          }
        },
        resetQuantity: function resetQuantity($event, value, property) {
          var _this2 = this;

          this.shouldSendEvent = false;
          this[property] = value;
          this.$nextTick(function () {
            _this2.shouldSendEvent = true;
          });
        },
        sendEvent: function sendEvent(value) {
          var event = new CustomEvent("change", {
            detail: {
              line: this.$refs.quantity.dataset.index,
              value: value,
              name: document.activeElement.getAttribute("name"),
            },
            bubbles: true,
          });
          this.$root.dispatchEvent(event);
        },
        removeItem: function removeItem() {
          this.sendEvent(0);
        },
      };
    };

    /***/
  },
  /* 57 */
  /***/ function (module, exports) {
    window["ThemeComponent_GiftCardRecipient"] = function () {
      return {
        enabled: false,
        recipientMessage: "",

        get messageLength() {
          return this.recipientMessage.length;
        },

        errorMessage: null,
        errors: null,
        mounted: function mounted() {
          var _this = this;

          document.body.addEventListener("label:cart:adderror", function (e) {
            if (
              e.detail.source === "product-form" &&
              e.detail.sourceId ===
                _this.$root.closest("form").getAttribute("id")
            ) {
              _this.errorMessage = e.detail.message;
              _this.errors = e.detail.errors;
              _this.enabled = true;
            }
          });
        },
      };
    };

    /***/
  },
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  /* 58 */ /* 59 */ /* 60 */ /* 61 */ /* 62 */ /* 63 */ /* 64 */ /* 65 */ /* 66 */
  /***/ function (module, __webpack_exports__, __webpack_require__) {
    "use strict";
    // ESM COMPAT FLAG
    __webpack_require__.r(__webpack_exports__);

    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/object-fit/ls.object-fit.js
    var ls_object_fit = __webpack_require__(27);

    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js
    var ls_parent_fit = __webpack_require__(28);

    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/rias/ls.rias.js
    var ls_rias = __webpack_require__(29);

    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/bgset/ls.bgset.js
    var ls_bgset = __webpack_require__(30);

    // EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
    var lazysizes = __webpack_require__(2);

    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/respimg/ls.respimg.js
    var ls_respimg = __webpack_require__(31);

    // EXTERNAL MODULE: ./node_modules/@ryangjchandler/spruce/dist/spruce.umd.js
    var spruce_umd = __webpack_require__(24);

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
    /**
     * A11y Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help make your theme more accessible
     */

    /**
     * Moves focus to an HTML element
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects. Used in bindInPageLinks()
     * eg move focus to a modal that is opened. Used in trapFocus()
     *
     * @param {Element} container - Container DOM element to trap focus inside of
     * @param {Object} options - Settings unique to your theme
     * @param {string} options.className - Class name to apply to element on focus.
     */
    function forceFocus(element, options) {
      options = options || {};

      var savedTabIndex = element.tabIndex;

      element.tabIndex = -1;
      element.dataset.tabIndex = savedTabIndex;
      element.focus();
      if (typeof options.className !== "undefined") {
        element.classList.add(options.className);
      }
      element.addEventListener("blur", callback);

      function callback(event) {
        event.target.removeEventListener(event.type, callback);

        element.tabIndex = savedTabIndex;
        delete element.dataset.tabIndex;
        if (typeof options.className !== "undefined") {
          element.classList.remove(options.className);
        }
      }
    }

    /**
     * If there's a hash in the url, focus the appropriate element
     * This compensates for older browsers that do not move keyboard focus to anchor links.
     * Recommendation: To be called once the page in loaded.
     *
     * @param {Object} options - Settings unique to your theme
     * @param {string} options.className - Class name to apply to element on focus.
     * @param {string} options.ignore - Selector for elements to not include.
     */

    function focusHash(options) {
      options = options || {};
      var hash = window.location.hash;
      var element = document.getElementById(hash.slice(1));

      // if we are to ignore this element, early return
      if (element && options.ignore && element.matches(options.ignore)) {
        return false;
      }

      if (hash && element) {
        forceFocus(element, options);
      }
    }

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     * This compensates for older browsers that do not move keyboard focus to anchor links.
     * Recommendation: To be called once the page in loaded.
     *
     * @param {Object} options - Settings unique to your theme
     * @param {string} options.className - Class name to apply to element on focus.
     * @param {string} options.ignore - CSS selector for elements to not include.
     */

    function bindInPageLinks(options) {
      options = options || {};
      var links = Array.prototype.slice.call(
        document.querySelectorAll('a[href^="#"]')
      );

      return links.filter(function (link) {
        if (link.hash === "#" || link.hash === "") {
          return false;
        }

        if (options.ignore && link.matches(options.ignore)) {
          return false;
        }

        var element = document.querySelector(link.hash);

        if (!element) {
          return false;
        }

        link.addEventListener("click", function () {
          forceFocus(element, options);
        });

        return true;
      });
    }

    function focusable(container) {
      var elements = Array.prototype.slice.call(
        container.querySelectorAll(
          "[tabindex]," +
            "[draggable]," +
            "a[href]," +
            "area," +
            "button:enabled," +
            "input:not([type=hidden]):enabled," +
            "object," +
            "select:enabled," +
            "textarea:enabled"
        )
      );

      // Filter out elements that are not visible.
      // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
      return elements.filter(function (element) {
        return !!(
          element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length
        );
      });
    }

    /**
     * Traps the focus in a particular container
     *
     * @param {Element} container - Container DOM element to trap focus inside of
     * @param {Element} elementToFocus - Element to be focused on first
     * @param {Object} options - Settings unique to your theme
     * @param {string} options.className - Class name to apply to element on focus.
     */

    var trapFocusHandlers = {};

    function trapFocus(container, options) {
      options = options || {};
      var elements = focusable(container);
      var elementToFocus = options.elementToFocus || container;
      var first = elements[0];
      var last = elements[elements.length - 1];

      removeTrapFocus();

      trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          first.focus();
        }

        if (
          event.target !== container &&
          event.target !== last &&
          event.target !== first
        )
          return;
        document.addEventListener("keydown", trapFocusHandlers.keydown);
      };

      trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
      };

      trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return; // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
          (event.target === container || event.target === first) &&
          event.shiftKey
        ) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener("focusout", trapFocusHandlers.focusout);
      document.addEventListener("focusin", trapFocusHandlers.focusin);

      forceFocus(elementToFocus, options);
    }

    /**
     * Removes the trap of focus from the page
     */
    function removeTrapFocus() {
      document.removeEventListener("focusin", trapFocusHandlers.focusin);
      document.removeEventListener("focusout", trapFocusHandlers.focusout);
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }

    /**
     * Add a preventive message to external links and links that open to a new window.
     * @param {string} elements - Specific elements to be targeted
     * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
     * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
     * @param {string} options.messages.external - When the link is to a different host domain.
     * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
     * @param {object} options.prefix - Prefix to namespace "id" of the messages
     */
    function accessibleLinks(elements, options) {
      if (typeof elements !== "string") {
        throw new TypeError(elements + " is not a String.");
      }

      elements = document.querySelectorAll(elements);

      if (elements.length === 0) {
        return;
      }

      options = options || {};
      options.messages = options.messages || {};

      var messages = {
        newWindow: options.messages.newWindow || "Opens in a new window.",
        external: options.messages.external || "Opens external website.",
        newWindowExternal:
          options.messages.newWindowExternal ||
          "Opens external website in a new window.",
      };

      var prefix = options.prefix || "a11y";

      var messageSelectors = {
        newWindow: prefix + "-new-window-message",
        external: prefix + "-external-message",
        newWindowExternal: prefix + "-new-window-external-message",
      };

      function generateHTML(messages) {
        var container = document.createElement("ul");
        var htmlMessages = Object.keys(messages).reduce(function (html, key) {
          return (html +=
            "<li id=" +
            messageSelectors[key] +
            ">" +
            messages[key] +
            "</li>");
        }, "");

        container.setAttribute("hidden", true);
        container.innerHTML = htmlMessages;

        document.body.appendChild(container);
      }

      function externalSite(link) {
        return link.hostname !== window.location.hostname;
      }

      elements.forEach(function (link) {
        var target = link.getAttribute("target");
        var rel = link.getAttribute("rel");
        var isExternal = externalSite(link);
        var isTargetBlank = target === "_blank";
        var missingRelNoopener =
          rel === null || rel.indexOf("noopener") === -1;

        if (isTargetBlank && missingRelNoopener) {
          var relValue = rel === null ? "noopener" : rel + " noopener";
          link.setAttribute("rel", relValue);
        }

        if (isExternal && isTargetBlank) {
          link.setAttribute(
            "aria-describedby",
            messageSelectors.newWindowExternal
          );
        } else if (isExternal) {
          link.setAttribute("aria-describedby", messageSelectors.external);
        } else if (isTargetBlank) {
          link.setAttribute("aria-describedby", messageSelectors.newWindow);
        }
      });

      generateHTML(messages);
    }
    // EXTERNAL MODULE: ./node_modules/@switchthemes/utilities/index.js + 1 modules
    var utilities = __webpack_require__(0);

    // EXTERNAL MODULE: ./src/scripts/tools/cart-store.js
    var cart_store = __webpack_require__(32);

    // EXTERNAL MODULE: ./node_modules/alpinejs/dist/alpine.js
    var alpine = __webpack_require__(33);

    // EXTERNAL MODULE: ./node_modules/wicg-inert/dist/inert.esm.js
    var inert_esm = __webpack_require__(34);

    // EXTERNAL MODULE: ./node_modules/@switchthemes/outline/index.js
    var outline = __webpack_require__(35);

    // EXTERNAL MODULE: ./src/styles/theme.scss
    var styles_theme = __webpack_require__(36);

    // EXTERNAL MODULE: ./src/styles/theme.scss.liquid
    var theme_scss_liquid = __webpack_require__(37);

    // EXTERNAL MODULE: ./src/scripts/components/login.js
    var login = __webpack_require__(38);

    // CONCATENATED MODULE: ./src/scripts/components/popup.js

    // CONCATENATED MODULE: ./src/scripts/tools/drawer-store.js

    alpine.store("drawer", {
      persistCover: false,
      menuDrawerOpen: false,
      cartDrawerOpen: false,
      availabilityDrawerOpen: false,
      filterDrawerOpen: false,
      cartOpener: null,
      availabilityOpener: null,
      passwordOpen: false,
      productOpen: false,
      productOpener: null,

    });

    window.addEventListener("alpine:init", function () {
      alpine.watch(()=>{
        Alpine.store('drawer').availabilityDrawerOpen, function (value) {
        var drawer = document.querySelector("[data-availability-drawer]");
        var drawerToggle = store.availabilityOpener;
        toggleDrawer(drawer, drawerToggle, value);
      }});

      // alpine.watch(()=>{
      //   Alpine.store('drawer').productOpener, function (value) {
      //     var drawer = document.querySelector("[data-product-modal]");
      //     var drawerToggle = store.productOpener;
      //   toggleDrawer(drawer, drawerToggle, value);
      // }});

      // this.$watch("$store.drawer.productOpen", function (value) {
      //   var drawer = document.querySelector("[data-product-modal]");
      //   var drawerToggle = store.productOpener;
      //   toggleDrawer(drawer, drawerToggle, value);
      // });
      // this.$watch("$store.drawer.menuDrawerOpen", function (value) {
      //   var drawer = document.querySelector("[data-menu-drawer]");
      //   var drawerToggle = document.querySelector(
      //     "[data-menu-drawer-toggle]"
      //   );
      //   toggleDrawer(drawer, drawerToggle, value);
      // });
      // this.$watch("$store.drawer.cartDrawerOpen", function (value) {
      //   var drawer = document.querySelector("[data-cart-drawer]");
      //   var drawerToggle = store.cartOpener;
      //   toggleDrawer(drawer, drawerToggle, value);
      // });
      // this.$watch("$store.drawer.passwordOpen", function (value) {
      //   var drawer = document.querySelector("[data-password-login]");
      //   var drawerToggle = document.querySelector("[data-password-toggle]");
      //   toggleDrawer(drawer, drawerToggle, value);
      // });
      // this.$watch("$store.drawer.availabilityDrawerOpen", function (value) {
      //   var drawer = document.querySelector("[data-availability-drawer]");
      //   var drawerToggle = store.availabilityOpener;
      //   toggleDrawer(drawer, drawerToggle, value);
      // });
      // this.$watch("$store.drawer.filterDrawerOpen", function (value) {
      //   var parent = document.getElementById("MainContent");
      //   var drawer = document.querySelector("[data-filter-drawer]");
      //   var drawerToggle = document.querySelector("[data-filter-toggle]");
      //   toggleDrawer(drawer, drawerToggle, value, parent);
      // });
      

    });
    document.addEventListener("keyup", function (event) {
      if (event.key === "Escape") {
        if (store.menuDrawerOpen)
          alpine.store("drawer").menuDrawerOpen = false;
        if (store.availabilityDrawerOpen)
          alpine.store("drawer").availabilityDrawerOpen = false;
        if (store.passwordOpen) alpine.store("drawer").passwordOpen = false;
        if (store.filterDrawerOpen)
          alpine.store("drawer").filterDrawerOpen = false;
        if (store.cartDrawerOpen)
          alpine.store("drawer").cartDrawerOpen = false;
        if (store.productOpen) alpine.store("drawer").productOpen = false;
      }
    });
    /* Accepts
drawer: a element (which must be a direct child of the body element)
drawerToggle: element that triggered the drawer, focus will be returned to it when closed
isOpen: Boolean, whether or not the drawer is being opened or closed
*/

    function toggleDrawer(drawer, drawerToggle, isOpen, parent) {
      var parentSection =
        parent ||
        drawer.closest(".shopify-section") ||
        drawer.closest("[data-section-type]") ||
        drawer;
      var parentSiblings = Object(utilities["c" /* getSiblings */])(
        parentSection
      );
      var siblings = Object(utilities["c" /* getSiblings */])(drawer);

      if (isOpen === true) {
        document.documentElement.style.overflowY = "hidden";
        document.getElementById("drawerCover").style.display = "block";
        setTimeout(function () {
          document.getElementById("drawerCover").style.opacity = 0.9;
        });
        setTimeout(function () {
          trapFocus(drawer);
        }, 300); // Make everything else inert, this could be rewritten more elegantly/make less assumptions about the DOM but the alpine version has perf issues with the size of Shopify Themes

        parentSiblings.forEach(function (sibling) {
          if (!sibling.getAttribute("aria-live")) {
            sibling.setAttribute("inert", true);
          }
        });
        siblings.forEach(function (sibling) {
          if (!sibling.getAttribute("aria-live")) {
            sibling.setAttribute("inert", true);
          }
        }); //if product modal we need do dispatch event

        if (store.productOpen) {
          document.body.dispatchEvent(
            new CustomEvent("label:productmodal:open")
          );
        }
      } else {
        document.documentElement.style.overflowY = "auto";

        if (store.persistCover) {
          store.persistCover = false;
        } else {
          setTimeout(function () {
            document.getElementById("drawerCover").style.display = "none";

            if (
              Shopify.designMode &&
              drawer.hasAttribute("data-cart-drawer") &&
              document
                .getElementById("ProductModalDesignMode")
                .hasAttribute("data-design-mode-modal")
            ) {
              alpine.store("drawer").productOpen = true;
            }
          }, 150);
        }

        parentSiblings.forEach(function (sibling) {
          sibling.removeAttribute("inert");
        });
        siblings.forEach(function (sibling) {
          sibling.removeAttribute("inert");
        });
        removeTrapFocus(); // Focus on the toggle

        if (drawerToggle) {
          setTimeout(function () {
            drawerToggle.focus();
          }, 300);
        } //if product modal we need to close

        if (!store.productOpen) {
          document.body.dispatchEvent(
            new CustomEvent("label:productmodal:close")
          );
        }
      }
    }
    // CONCATENATED MODULE: ./src/scripts/tools/availability-store.js

    var availability_store_store = alpine.store("availability", {
      loading: false,
      product_title: null,
      current_variant: null,
      availability: {},
      getVariantTitle: function getVariantTitle() {
        if (this.current_variant && this.current_variant.title) {
          if (!this.current_variant.title.includes("Default")) {
            return this.current_variant.title;
          }
        }

        return "";
      },
    });

    window["ThemeComponent_PopUp"] = function (id) {
      var popUpId = "ThemePopUp_" + id;
      window.Alpine.store(popUpId, {
        open: false,
      });
      return {
        undoTrappings: [],
        modal: document.getElementById(popUpId),
        close: document.getElementById(popUpId + "_CloseBtn"),

        open() {
          return this.$store[popUpId].open;
        },

        mounted() {
          var _this = this;

          var watch = popUpId + ".open";
          this.$watch(watch, function (value) {
            value ? _this.openModal() : _this.closeModal();
          });
        },
        openModal: function openModal() {
          var _this2 = this;

          document.documentElement.style.overflowY = "hidden";
          setTimeout(function () {
            trapFocus(_this2.modal);

            _this2.close.focus();
          }, 300);
        },
        closeModal: function closeModal() {
          var _this3 = this;

          document.documentElement.style.overflowY = "auto";
          removeTrapFocus(); //focus back on the trigger

          setTimeout(function () {
            _this3.$refs.trigger.focus();
          }, 300);
        },
        openButton: function openButton() {
          this.$store[popUpId].open = true;
        },
      };
    };
    // EXTERNAL MODULE: ./node_modules/@switchthemes/live-region/index.js + 1 modules
    var live_region = __webpack_require__(1);

    // CONCATENATED MODULE: ./src/scripts/components/predictive-search.js

    window.ThemeComponent_PredictiveSearch = function (resources) {
      return {
        cachedResults: {},
        loading: false,
        isOpen: false,
        rawQuery: "",
        results: false,
        resultsMarkup: null,
        resources: resources,

        get trimmedQuery() {
          return this.rawQuery.trim();
        },

        mounted: function mounted() {
          var _this = this;

          var toggles = document.querySelectorAll("[data-open-search]");
          toggles.forEach(function (toggle) {
            toggle.setAttribute("role", "button");
          });
          document.addEventListener("keyup", function (event) {
            if (event.key === "Escape") {
              _this.close(false, true);

              setTimeout(function () {
                return _this.$refs.input.focus();
              }, 100);
            }
          });
        },
        close: function close() {
          var clearSearchTerm =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : false;
          var closeButton =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : false;
          this.isOpen = false;

          if (clearSearchTerm) {
            this.rawQuery = "";
          }

          var selected = this.$root.querySelector('[aria-selected="true"]');
          if (selected) selected.setAttribute("aria-selected", false);
          this.$refs.input.setAttribute("aria-activedescendant", "");
          this.$refs.input.setAttribute("aria-expanded", false);
          removeTrapFocus();
          document.documentElement.style.overflowY = "auto";

          if (closeButton) {
            document.body.dispatchEvent(
              new CustomEvent("label:search:closebutton")
            );
          }

          var toggleSearch = document.querySelector("[data-open-search]");

          if (toggleSearch) {
            setTimeout(function () {
              return toggleSearch.focus();
            }, 100);
          }
        },
        getSearchResults: function getSearchResults() {
          var _this2 = this;

          this.loading = true; //this.$store.predictiveSearch.loading = true;

          var queryKey = this.trimmedQuery.replace(" ", "-").toLowerCase();
          Object(live_region["b" /* liveRegion */])(
            window.theme.strings.loading
          ); // if (this.cachedResults[queryKey]) {
          //   this.renderSearchResults(this.cachedResults[queryKey]);
          //   return;
          // }

          fetch(
            ""
              .concat(window.theme.routes.predictive_search_url, "?q=")
              .concat(encodeURIComponent(this.trimmedQuery), "&")
              .concat(encodeURIComponent("resources[type]"), "=")
              .concat(this.resources, "&")
              .concat(
                encodeURIComponent("resources[limit]"),
                "=10&section_id=predictive-search"
              )
          )
            .then(function (response) {
              _this2.loading = false;

              if (!response.ok) {
                var error = new Error(response.status);

                _this2.close();

                throw error;
              }

              return response.text();
            })
            .then(function (text) {
              _this2.results = true;
              var resultsMarkup = new DOMParser()
                .parseFromString(text, "text/html")
                .querySelector(
                  "#shopify-section-predictive-search"
                ).innerHTML;
              var liveRegionText = new DOMParser()
                .parseFromString(text, "text/html")
                .querySelector("#predictive-search-count").textContent;
              _this2.cachedResults[queryKey] = resultsMarkup;

              _this2.renderSearchResults(resultsMarkup);

              Object(live_region["b" /* liveRegion */])(liveRegionText);
            })
            ["catch"](function (error) {
              _this2.close();

              throw error;
            });
        },
        onChange: function onChange() {
          if (!this.trimmedQuery.length) {
            this.close(true);
          } else {
            this.open();
            this.getSearchResults();
          }
        },
        onFocus: function onFocus() {
          if (!this.trimmedQuery.length) return;

          if (this.results === true) {
            this.open();
          } else {
            this.getSearchResults();
          }
        },
        onFocusOut: function onFocusOut() {
          var _this3 = this;

          setTimeout(function () {
            if (!_this3.$el.contains(document.activeElement)) _this3.close();
          });
        },
        onFormSubmit: function onFormSubmit(event) {
          if (
            !this.trimmedQuery.length ||
            this.$root.querySelector('[aria-selected="true"] a')
          )
            event.preventDefault();
        },
        onKeyup: function onKeyup(event) {
          event.preventDefault();

          switch (event.code) {
            case "ArrowUp":
              this.switchOption("up");
              break;

            case "ArrowDown":
              this.switchOption("down");
              break;

            case "Enter":
              this.selectOption();
              break;
          }
        },
        onKeydown: function onKeydown(event) {
          // Prevent the cursor from moving in the input when using the up and down arrow keys
          if (event.code === "ArrowUp" || event.code === "ArrowDown") {
            event.preventDefault();
          }
        },
        open: function open() {
          this.isOpen = true;
          this.$refs.input.setAttribute("aria-expanded", true);
          document.documentElement.style.overflowY = "hidden";
        },
        renderSearchResults: function renderSearchResults(resultsMarkup) {
          var _this4 = this;

          this.$refs.results.innerHTML = resultsMarkup;
          this.results = true;
          this.open();
          setTimeout(function () {
            trapFocus(_this4.$el);

            _this4.$refs.input.focus();
          }, 300);
        },
        selectOption: function selectOption() {
          var selectedProduct = this.$root.querySelector(
            '[aria-selected="true"] a, [aria-selected="true"] button'
          );
          if (selectedProduct) selectedProduct.click();
        },
        switchOption: function switchOption(direction) {
          if (!this.isOpen) return;
          var moveUp = direction === "up";
          var selectedElement = this.$root.querySelector(
            '[aria-selected="true"]'
          );
          var allElements = this.$root.querySelectorAll("li");
          var activeElement = this.$root.querySelector("li");
          if (moveUp && !selectedElement) return;

          if (!moveUp && selectedElement) {
            activeElement =
              selectedElement.nextElementSibling || allElements[0];
          } else if (moveUp) {
            activeElement =
              selectedElement.previousElementSibling ||
              allElements[allElements.length - 1];
          }

          if (activeElement === selectedElement) return;
          activeElement.setAttribute("aria-selected", true);
          if (selectedElement)
            selectedElement.setAttribute("aria-selected", false);
          this.$refs.input.setAttribute(
            "aria-activedescendant",
            activeElement.id
          );
        },
      };
    };
    // EXTERNAL MODULE: ./src/scripts/components/product-grid.js
    var product_grid = __webpack_require__(39);

    // EXTERNAL MODULE: ./node_modules/lodash/delay.js
    var delay = __webpack_require__(26);
    var delay_default = /*#__PURE__*/ __webpack_require__.n(delay);

    // EXTERNAL MODULE: ./node_modules/lodash/debounce.js
    var debounce = __webpack_require__(4);
    var debounce_default = /*#__PURE__*/ __webpack_require__.n(debounce);

    // CONCATENATED MODULE: ./src/scripts/tools/promise-stylesheet.js
    var PromiseStylesheet = (function () {
      function promiseStylesheet(stylesheet) {
        var stylesheetUrl = stylesheet || window.theme_stylesheet;

        if (typeof this.stylesheetPromise === "undefined") {
          this.stylesheetPromise = new Promise(function (resolve) {
            var link = document.querySelector(
              'link[href="' + stylesheetUrl + '"]'
            );

            if (link.loaded) {
              resolve();
            }

            link.addEventListener("stylesLoaded", function () {
              setTimeout(resolve, 0);
            });
          });
        }

        return this.stylesheetPromise;
      }

      return {
        promiseStylesheet: promiseStylesheet,
      };
    })();

    /* harmony default export */ var promise_stylesheet = PromiseStylesheet;
    // CONCATENATED MODULE: ./src/scripts/components/animations.js
    function _createForOfIteratorHelper(o, allowArrayLike) {
      var it =
        (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
        o["@@iterator"];
      if (!it) {
        if (
          Array.isArray(o) ||
          (it = _unsupportedIterableToArray(o)) ||
          (allowArrayLike && o && typeof o.length === "number")
        ) {
          if (it) o = it;
          var i = 0;
          var F = function F() {};
          return {
            s: F,
            n: function n() {
              if (i >= o.length) return { done: true };
              return { done: false, value: o[i++] };
            },
            e: function e(_e) {
              throw _e;
            },
            f: F,
          };
        }
        throw new TypeError(
          "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      }
      var normalCompletion = true,
        didErr = false,
        err;
      return {
        s: function s() {
          it = it.call(o);
        },
        n: function n() {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        },
        e: function e(_e2) {
          didErr = true;
          err = _e2;
        },
        f: function f() {
          try {
            if (!normalCompletion && it["return"] != null) it["return"]();
          } finally {
            if (didErr) throw err;
          }
        },
      };
    }

    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return _arrayLikeToArray(o, minLen);
    }

    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }

    var itemsNeedSetUp = true;

    var animations_setUpAnimations = function setUpAnimations(shopifyReload) {
      if (theme.animations.fade_in_sections) {
        var observerOptions = {
          root: null,
          threshold: 0,
          rootMargin: "0px 0px -100px 0px",
        };
        var timer = 1;
        var resetTimer = debounce_default()(function () {
          timer = 1;
        }, 500);
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (entry.target.hasAttribute("data-fade-in")) {
                delay_default()(
                  function (entry) {
                    entry.target.classList.add("in-view");
                  },
                  timer * 100,
                  entry
                );
                timer++;
                resetTimer();
              } else {
                entry.target.classList.add("in-view");
              }

              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        var setUpItems = function setUpItems() {
          if (itemsNeedSetUp === false) return;
          var mainContent = document.getElementById("MainContent");
          var sections = Array.from(
            mainContent.getElementsByClassName("shopify-section")
          );

          for (
            var _i = 0, _sections = sections;
            _i < _sections.length;
            _i++
          ) {
            var section = _sections[_i];
            observer.observe(section);
          }

          var fadeItems = document.querySelectorAll("[data-fade-in]");

          var _iterator = _createForOfIteratorHelper(fadeItems),
            _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done; ) {
              var item = _step.value;
              observer.observe(item);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          itemsNeedSetUp = false;
        };

        if (shopifyReload) {
          itemsNeedSetUp = true;
          setUpItems();
        }

        window.addEventListener("DOMContentLoaded", function () {
          setUpItems();
        });
        setUpItems();
      }
    };

    var removeInViewClasses = function removeInViewClasses(event) {
      if (!event.target.matches(".shopify-section.in-view")) return;
      var sectionEl = event.target;
      sectionEl.classList.add("will-mutate");
      sectionEl.querySelectorAll(".in-view").forEach(function (el) {
        el.style.opacity = 0;
      });
      sectionEl.classList.remove("will-mutate");
    };

    promise_stylesheet.promiseStylesheet().then(function () {
      animations_setUpAnimations();
      window.addEventListener("shopify:section:load", function (event) {
        animations_setUpAnimations(true);
      });
      window.addEventListener("label:section:hasmutated", function (event) {
        animations_setUpAnimations(true);
      });
      window.addEventListener("label:section:willmutate", function (event) {
        removeInViewClasses(event);
      });
    });
    // EXTERNAL MODULE: ./src/scripts/components/quantity.js
    var quantity = __webpack_require__(56);

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/section.js
    var SECTION_ID_ATTR = "data-section-id";

    function Section(container, properties) {
      this.container = validateContainerElement(container);
      this.id = container.getAttribute(SECTION_ID_ATTR);
      this.extensions = [];

      // eslint-disable-next-line es5/no-es6-static-methods
      Object.assign(this, validatePropertiesObject(properties));

      this.onLoad();
    }

    Section.prototype = {
      onLoad: Function.prototype,
      onUnload: Function.prototype,
      onSelect: Function.prototype,
      onDeselect: Function.prototype,
      onBlockSelect: Function.prototype,
      onBlockDeselect: Function.prototype,

      extend: function extend(extension) {
        this.extensions.push(extension); // Save original extension

        // eslint-disable-next-line es5/no-es6-static-methods
        var extensionClone = Object.assign({}, extension);
        delete extensionClone.init; // Remove init function before assigning extension properties

        // eslint-disable-next-line es5/no-es6-static-methods
        Object.assign(this, extensionClone);

        if (typeof extension.init === "function") {
          extension.init.apply(this);
        }
      },
    };

    function validateContainerElement(container) {
      if (!(container instanceof Element)) {
        throw new TypeError(
          "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
        );
      }
      if (container.getAttribute(SECTION_ID_ATTR) === null) {
        throw new Error(
          "Theme Sections: The section container provided does not have an id assigned to the " +
            SECTION_ID_ATTR +
            " attribute."
        );
      }

      return container;
    }

    function validatePropertiesObject(value) {
      if (
        (typeof value !== "undefined" && typeof value !== "object") ||
        value === null
      ) {
        throw new TypeError(
          "Theme Sections: The properties object provided is not a valid"
        );
      }

      return value;
    }

    // Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
    if (typeof Object.assign != "function") {
      // Must be writable: true, enumerable: false, configurable: true
      Object.defineProperty(Object, "assign", {
        value: function assign(target) {
          // .length of function is 2
          "use strict";
          if (target == null) {
            // TypeError if undefined or null
            throw new TypeError("Cannot convert undefined or null to object");
          }

          var to = Object(target);

          for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) {
              // Skip over if undefined or null
              for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (
                  Object.prototype.hasOwnProperty.call(nextSource, nextKey)
                ) {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
          return to;
        },
        writable: true,
        configurable: true,
      });
    }

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js
    /*
     * @shopify/theme-sections
     * -----------------------------------------------------------------------------
     *
     * A framework to provide structure to your Shopify sections and a load and unload
     * lifecycle. The lifecycle is automatically connected to theme editor events so
     * that your sections load and unload as the editor changes the content and
     * settings of your sections.
     */

    var SECTION_TYPE_ATTR = "data-section-type";
    var theme_sections_SECTION_ID_ATTR = "data-section-id";

    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};

    var registered = (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {});
    var instances = (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);

    function register(type, properties) {
      if (typeof type !== "string") {
        throw new TypeError(
          "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
        );
      }

      if (typeof registered[type] !== "undefined") {
        throw new Error(
          'Theme Sections: A section of type "' +
            type +
            '" has already been registered. You cannot register the same section type twice'
        );
      }

      function TypedSection(container) {
        Section.call(this, container, properties);
      }

      TypedSection.constructor = Section;
      TypedSection.prototype = Object.create(Section.prototype);
      TypedSection.prototype.type = type;

      return (registered[type] = TypedSection);
    }

    function unregister(types) {
      types = normalizeType(types);

      types.forEach(function (type) {
        delete registered[type];
      });
    }

    function load(types, containers) {
      types = normalizeType(types);

      if (typeof containers === "undefined") {
        containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
      }

      containers = normalizeContainers(containers);

      types.forEach(function (type) {
        var TypedSection = registered[type];

        if (typeof TypedSection === "undefined") {
          return;
        }

        containers = containers.filter(function (container) {
          // Filter from list of containers because container already has an instance loaded
          if (isInstance(container)) {
            return false;
          }

          // Filter from list of containers because container doesn't have data-section-type attribute
          if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
            return false;
          }

          // Keep in list of containers because current type doesn't match
          if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
            return true;
          }

          instances.push(new TypedSection(container));

          // Filter from list of containers because container now has an instance loaded
          return false;
        });
      });
    }

    function unload(selector) {
      var instancesToUnload = getInstances(selector);

      instancesToUnload.forEach(function (instance) {
        var index = instances
          .map(function (e) {
            return e.id;
          })
          .indexOf(instance.id);
        instances.splice(index, 1);
        instance.onUnload();
      });
    }

    function extend(selector, extension) {
      var instancesToExtend = getInstances(selector);

      instancesToExtend.forEach(function (instance) {
        instance.extend(extension);
      });
    }

    function getInstances(selector) {
      var filteredInstances = [];

      // Fetch first element if its an array
      if (
        NodeList.prototype.isPrototypeOf(selector) ||
        Array.isArray(selector)
      ) {
        var firstElement = selector[0];
      }

      // If selector element is DOM element
      if (selector instanceof Element || firstElement instanceof Element) {
        var containers = normalizeContainers(selector);

        containers.forEach(function (container) {
          filteredInstances = filteredInstances.concat(
            instances.filter(function (instance) {
              return instance.container === container;
            })
          );
        });

        // If select is type string
      } else if (
        typeof selector === "string" ||
        typeof firstElement === "string"
      ) {
        var types = normalizeType(selector);

        types.forEach(function (type) {
          filteredInstances = filteredInstances.concat(
            instances.filter(function (instance) {
              return instance.type === type;
            })
          );
        });
      }

      return filteredInstances;
    }

    function getInstanceById(id) {
      var instance;

      for (var i = 0; i < instances.length; i++) {
        if (instances[i].id === id) {
          instance = instances[i];
          break;
        }
      }
      return instance;
    }

    function isInstance(selector) {
      return getInstances(selector).length > 0;
    }

    function normalizeType(types) {
      // If '*' then fetch all registered section types
      if (types === "*") {
        types = Object.keys(registered);

        // If a single section type string is passed, put it in an array
      } else if (typeof types === "string") {
        types = [types];

        // If single section constructor is passed, transform to array with section
        // type string
      } else if (types.constructor === Section) {
        types = [types.prototype.type];

        // If array of typed section constructors is passed, transform the array to
        // type strings
      } else if (Array.isArray(types) && types[0].constructor === Section) {
        types = types.map(function (TypedSection) {
          return TypedSection.prototype.type;
        });
      }

      types = types.map(function (type) {
        return type.toLowerCase();
      });

      return types;
    }

    function normalizeContainers(containers) {
      // Nodelist with entries
      if (
        NodeList.prototype.isPrototypeOf(containers) &&
        containers.length > 0
      ) {
        containers = Array.prototype.slice.call(containers);

        // Empty Nodelist
      } else if (
        NodeList.prototype.isPrototypeOf(containers) &&
        containers.length === 0
      ) {
        containers = [];

        // Handle null (document.querySelector() returns null with no match)
      } else if (containers === null) {
        containers = [];

        // Single DOM element
      } else if (
        !Array.isArray(containers) &&
        containers instanceof Element
      ) {
        containers = [containers];
      }

      return containers;
    }

    if (window.Shopify.designMode) {
      document.addEventListener("shopify:section:load", function (event) {
        var id = event.detail.sectionId;
        var container = event.target.querySelector(
          "[" + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
        );

        if (container !== null) {
          load(container.getAttribute(SECTION_TYPE_ATTR), container);
        }
      });

      document.addEventListener("shopify:section:unload", function (event) {
        var id = event.detail.sectionId;
        var container = event.target.querySelector(
          "[" + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
        );
        var instance = getInstances(container)[0];

        if (typeof instance === "object") {
          unload(container);
        }
      });

      document.addEventListener("shopify:section:select", function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object") {
          instance.onSelect(event);
        }
      });

      document.addEventListener("shopify:section:deselect", function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object") {
          instance.onDeselect(event);
        }
      });

      document.addEventListener("shopify:block:select", function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object") {
          instance.onBlockSelect(event);
        }
      });

      document.addEventListener("shopify:block:deselect", function (event) {
        var instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object") {
          instance.onBlockDeselect(event);
        }
      });
    }

    // EXTERNAL MODULE: ./node_modules/@shopify/theme-cart/theme-cart.js + 2 modules
    var theme_cart = __webpack_require__(3);

    // CONCATENATED MODULE: ./src/scripts/components/quick-buy.js

    window["QuickBuyModal"] = function ({ baseUrl }) {
      return {
        open: false,
        baseUrl: baseUrl || '/',
        loading: false,
        design_mode: false,
        mounted: function mounted() {
          var _this = this;

          this.$watch('$store.drawer.productOpen', function (value) {
            _this.open = value;
          });
          document.body.addEventListener(
            "label:productmodal:loading",
            function (props) {
              _this.loading = props.detail?.loading || false;
            }
          );

          document.body.addEventListener(
            "label:productmodal:open",
            function () {
              _this.open = true;
            }
          );
          document.body.addEventListener(
            "label:productmodal:close",
            function () {
              _this.open = false;
            }
          );
          document.body.addEventListener(
            "label:modalcart:afteradditem",
            function () {
              alpine.store("drawer").persistCover = true;
              alpine.store("drawer").productOpen = false;
            }
          );

          if (this.$root.hasAttribute("data-design-mode-modal")) {
            alpine.store("drawer").productOpen = true;
            this.design_mode = true;
          }
        },
        close: function close() {
          alpine.store("drawer").productOpen = false;
        },
        switchProduct(handle) {
          /*
          For switching sibling products 
          */
          var self = this;
          self.loading = true;
          if(!this.baseUrl.endsWith('/')){
            this.baseUrl= this.baseUrl + '/'
          }
          var productUrl = this.baseUrl + "products/" + handle + "?view=quickbuy";
          return fetch(productUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (productHTML) {
              var parsed = new DOMParser().parseFromString(
                productHTML,
                "text/html"
              );
              var outerHTML = parsed.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              ).outerHTML;
              var containers = parsed.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              );
              load("product", containers);
              self.$refs.modalContent.innerHTML = outerHTML;
              self.loading = false;
              alpine.store("drawer").productOpen = true;
              setTimeout(function () {
                window.dispatchEvent(new Event("resize"));
              }, 50);
            });
        },
      };
    };

    window["QuickBuy"] = function () {
      return {
        state: "default",
        fetchContent: function fetchContent() {
          var self = this;
          var handle = this.handle;
          var baseUrl = this.baseUrl
          if (!baseUrl.endsWith("/")) {
                baseUrl = baseUrl + "/";
            }
          var productUrl =
            baseUrl + "products/" + handle + "?view=quickbuy";
          var modalContent = document.querySelector(
            "[data-product-modal-content]"
          );
          return fetch(productUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (productHTML) {
              var parsed = new DOMParser().parseFromString(
                productHTML,
                "text/html"
              );
              var outerHTML = parsed.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              ).outerHTML;
              var containers = parsed.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              );
              load("product", containers);
              modalContent.innerHTML = outerHTML;
              self.state = "default";
              self.$store.drawer.productOpen = true;
              document.body.dispatchEvent(
                new CustomEvent("label:productmodal:open")
              )
              document.body.dispatchEvent(
                new CustomEvent("label:productmodal:loading", { detail: {loading: false} })
              )
              setTimeout(function () {
                window.dispatchEvent(new Event("resize"));
              }, 50);
            });
        },
        onClick: function onClick(event) {
          alpine.store("drawer").productOpener = event.currentTarget;
          alpine.store("drawer").cartOpener = event.currentTarget;
          this.state = "loading";
          document.body.dispatchEvent(
            new CustomEvent("label:productmodal:loading", { detail: {loading: true} })
          )

          if (this.variant) {
            this.addToCart(this.variant);
          } else {
            this.fetchContent();
          }
        },
        addToCart: function addToCart(variant) {
          var _this2 = this;

          Object(theme_cart["a" /* addItem */])(variant)
            .then(function () {
              _this2.state = "success";
              document.body.dispatchEvent(
                new CustomEvent("label:modalcart:afteradditem")
              );
              Object(theme_cart["c" /* getState */])().then(function (state) {
                document.body.dispatchEvent(
                  new CustomEvent("label:modalcart:itemcountupdate", {
                    detail: {
                      count: state.item_count,
                    },
                  })
                );
              });
            })
            ["catch"](function (error) {
              error.json().then(function (a) {
                _this2.state = "default";
                alert(a.description);
              });
            });
        },
      };
    };
    // EXTERNAL MODULE: ./src/scripts/components/gift-card-recipient.js
    var gift_card_recipient = __webpack_require__(57);

    // CONCATENATED MODULE: ./src/scripts/sections/header.js
    function _slicedToArray(arr, i) {
      return (
        _arrayWithHoles(arr) ||
        _iterableToArrayLimit(arr, i) ||
        header_unsupportedIterableToArray(arr, i) ||
        _nonIterableRest()
      );
    }

    function _nonIterableRest() {
      throw new TypeError(
        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }

    function header_unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return header_arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return header_arrayLikeToArray(o, minLen);
    }

    function header_arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }

    function _iterableToArrayLimit(arr, i) {
      var _i =
        arr == null
          ? null
          : (typeof Symbol !== "undefined" && arr[Symbol.iterator]) ||
            arr["@@iterator"];
      if (_i == null) return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _s, _e;
      try {
        for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }

    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }

    /**
     * Header
     * ------------------------------------------------------------------------------
     *
     * @namespace header
     */

    register("header", {
      onLoad: function onLoad() {
        this.sectionId = this.id;
        var dropdownCount = parseInt(this.container.dataset.dropdownCount);
        var menuOpen = {};

        for (var i = 0; i < dropdownCount; i++) {
          menuOpen["menu" + i] = false;
        }

        var announcementBar = document.getElementById(
          "shopify-section-announcement-bar"
        );
        var headerOverlay = this.container.dataset.headerOverlay;

        if (announcementBar) {
          document.documentElement.style.setProperty(
            "--announcement-bar-height",
            "".concat(announcementBar.clientHeight, "px")
          );
        } //set header height variable

        document.documentElement.style.setProperty(
          "--header-height",
          "".concat(
            (headerOverlay
              ? 0
              : document.getElementById("headerBorderWrap").clientHeight) +
              (announcementBar ? announcementBar.clientHeight : 0),
            "px"
          )
        );
        document.documentElement.style.setProperty(
          "--header-height-no-search",
          "".concat(
            document.getElementById("headerContainer").clientHeight,
            "px"
          )
        );
        var showBorder = true;
        var hideBorderMobile = false;
        var firstSection = document
          .getElementById("MainContent")
          .querySelector(".shopify-section");

        if (firstSection !== null) {
          var firstSectionNoPadding = document
            .getElementById("MainContent")
            .querySelector(".shopify-section")
            .querySelector(".section-with-no-padding");

          if (firstSectionNoPadding !== null) {
            showBorder = false;
          }

          var firstSectionNoPaddingMobile = document
            .getElementById("MainContent")
            .querySelector(".shopify-section")
            .querySelector(".section-with-no-padding-mobile");

          if (firstSectionNoPaddingMobile !== null) {
            hideBorderMobile = true;
          }
        }

        window["ThemeSection_header"] = function () {
          return {
            menuOpen: menuOpen,
            prepareSticky: false,
            revealSticky: false,
            showBorder: showBorder,
            hideBorderMobile: hideBorderMobile,
            searchOpen: false,

            get menuIsActive() {
              return !Object.keys(menuOpen).every(function (k) {
                return !menuOpen[k];
              });
            },

            mounted: function mounted() {
              var _this = this;

              document.addEventListener("keyup", function (event) {
                if (event.key === "Escape") {
                  for (var _i = 0; _i < dropdownCount; _i++) {
                    if (_this.menuOpen["menu" + _i] === true) {
                      _this.menuOpen["menu" + _i] = false;
                      document
                        .querySelector(
                          '[aria-controls="menu'.concat(_i, '"]')
                        )
                        .focus();
                    }
                  }
                }
              });
              var el = document.getElementById("sticky-positioner");

              if (el) {
                var observer = new IntersectionObserver(
                  function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 1),
                      e = _ref2[0];

                    _this.toggleStickyHeader(e.isIntersecting);
                  },
                  {
                    rootMargin: "0px",
                    threshold: 1.0,
                  }
                );
                observer.observe(el);
              }

              document.body.addEventListener(
                "label:search:closebutton",
                function () {
                  _this.searchOpen = false;
                }
              );
            },
            toggleStickyHeader: function toggleStickyHeader(intersecting) {
              var _this2 = this;

              if (!intersecting) {
                this.prepareSticky = true;
                setTimeout(function () {
                  _this2.revealSticky = true;
                }, 300);
              } else {
                this.revealSticky = false;
                this.prepareSticky = false;
              }
            },
            openMenu: function openMenu(index) {
              this.menuOpen["menu" + index] = true;
            },
            focusOut: function focusOut(event, menu) {
              if (event.relatedTarget) {
                var dropdownParent = event.relatedTarget.closest(
                  "[data-header-dropdown]"
                );

                if (!dropdownParent) {
                  this.menuOpen[menu] = false;
                }
              }
            },
            openSearch: function openSearch() {
              this.searchOpen = true;
              var input = document.querySelector(".header-search-input");
              setTimeout(function () {
                input.focus();
              }, 100);
            },
          };
        };
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function onUnload() {},
    });
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-product/theme-product.js
    /**
     * Returns a product JSON object when passed a product URL
     * @param {*} url
     */
    function getProductJson(handle) {
      return fetch("/products/" + handle + ".js").then(function (response) {
        return response.json();
      });
    }

    /**
     * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
     * @param {Object} product Product JSON object
     * @param {Number} value Accepts Number (e.g. 6908023078973)
     * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
     */
    function getVariantFromId(product, value) {
      _validateProductStructure(product);

      if (typeof value !== "number") {
        throw new TypeError(value + " is not a Number.");
      }

      var result = product.variants.filter(function (variant) {
        return variant.id === value;
      });

      return result[0] || null;
    }

    /**
     * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
     * @param {Object} product Product JSON object
     * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
     * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
     */
    function getVariantFromSerializedArray(product, collection) {
      _validateProductStructure(product);

      // If value is an array of options
      var optionArray = _createOptionArrayFromOptionCollection(
        product,
        collection
      );
      return getVariantFromOptionArray(product, optionArray);
    }

    /**
     * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
     * @param {Object} product Product JSON object
     * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
     * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
     */
    function getVariantFromOptionArray(product, options) {
      _validateProductStructure(product);
      _validateOptionsArray(options);

      var result = product.variants.filter(function (variant) {
        return options.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      return result[0] || null;
    }

    /**
     * Creates an array of selected options from the object
     * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
     * @param {Object} product Product JSON object
     * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
     * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
     */
    function _createOptionArrayFromOptionCollection(product, collection) {
      _validateProductStructure(product);
      _validateSerializedArray(collection);

      var optionArray = [];

      collection.forEach(function (option) {
        for (var i = 0; i < product.options.length; i++) {
          if (
            product.options[i].name.toLowerCase() ===
            option.name.toLowerCase()
          ) {
            optionArray[i] = option.value;
            break;
          }
        }
      });

      return optionArray;
    }

    /**
     * Check if the product data is a valid JS object
     * Error will be thrown if type is invalid
     * @param {object} product Product JSON object
     */
    function _validateProductStructure(product) {
      if (typeof product !== "object") {
        throw new TypeError(product + " is not an object.");
      }

      if (
        Object.keys(product).length === 0 &&
        product.constructor === Object
      ) {
        throw new Error(product + " is empty.");
      }
    }

    /**
     * Validate the structure of the array
     * It must be formatted like jQuery's serializeArray()
     * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
     */
    function _validateSerializedArray(collection) {
      if (!Array.isArray(collection)) {
        throw new TypeError(collection + " is not an array.");
      }

      if (collection.length === 0) {
        return [];
      }

      if (collection[0].hasOwnProperty("name")) {
        if (typeof collection[0].name !== "string") {
          throw new TypeError(
            "Invalid value type passed for name of option " +
              collection[0].name +
              ". Value should be string."
          );
        }
      } else {
        throw new Error(collection[0] + "does not contain name key.");
      }
    }

    /**
     * Validate the structure of the array
     * It must be formatted as list of values
     * @param {Array} collection Array of object (e.g. ['36', 'Black'])
     */
    function _validateOptionsArray(options) {
      if (Array.isArray(options) && typeof options[0] === "object") {
        throw new Error(options + "is not a valid array of options.");
      }
    }

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/listeners.js
    function Listeners() {
      this.entries = [];
    }

    Listeners.prototype.add = function (element, event, fn) {
      this.entries.push({ element: element, event: event, fn: fn });
      element.addEventListener(event, fn);
    };

    Listeners.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (listener) {
        listener.element.removeEventListener(listener.event, listener.fn);
        return false;
      });
    };

    // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/theme-product-form.js

    var theme_product_form_selectors = {
      idInput: '[name="id"]',
      optionInput: '[name^="options"]',
      quantityInput: '[name="quantity"]',
      propertyInput: '[name^="properties"]',
    };

    // Public Methods
    // -----------------------------------------------------------------------------

    /**
     * Returns a URL with a variant ID query parameter. Useful for updating window.history
     * with a new URL based on the currently select product variant.
     * @param {string} url - The URL you wish to append the variant ID to
     * @param {number} id  - The variant ID you wish to append to the URL
     * @returns {string} - The new url which includes the variant ID query parameter
     */

    function getUrlWithVariant(url, id) {
      if (/variant=/.test(url)) {
        return url.replace(/(variant=)[^&]+/, "$1" + id);
      } else if (/\?/.test(url)) {
        return url.concat("&variant=").concat(id);
      }

      return url.concat("?variant=").concat(id);
    }

    /**
     * Constructor class that creates a new instance of a product form controller.
     *
     * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
     * @param {Object} product - A product object
     * @param {Object} options - Optional options object
     * @param {Function} options.onOptionChange - Callback for whenever an option input changes
     * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
     * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
     * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
     */
    function ProductForm(element, product, options) {
      this.element = element;
      this.product = _validateProductObject(product);

      options = options || {};

      this._listeners = new Listeners();
      this._listeners.add(
        this.element,
        "submit",
        this._onSubmit.bind(this, options)
      );

      this.optionInputs = this._initInputs(
        theme_product_form_selectors.optionInput,
        options.onOptionChange
      );

      this.quantityInputs = this._initInputs(
        theme_product_form_selectors.quantityInput,
        options.onQuantityChange
      );

      this.propertyInputs = this._initInputs(
        theme_product_form_selectors.propertyInput,
        options.onPropertyChange
      );
    }

    /**
     * Cleans up all event handlers that were assigned when the Product Form was constructed.
     * Useful for use when a section needs to be reloaded in the theme editor.
     */
    ProductForm.prototype.destroy = function () {
      this._listeners.removeAll();
    };

    /**
     * Getter method which returns the array of currently selected option values
     *
     * @returns {Array} An array of option values
     */
    ProductForm.prototype.options = function () {
      return _serializeOptionValues(this.optionInputs, function (item) {
        var regex = /(?:^(options\[))(.*?)(?:\])/;
        item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
        return item;
      });
    };

    /**
     * Getter method which returns the currently selected variant, or `null` if variant
     * doesn't exist.
     *
     * @returns {Object|null} Variant object
     */
    ProductForm.prototype.variant = function () {
      return getVariantFromSerializedArray(this.product, this.options());
    };

    /**
     * Getter method which returns a collection of objects containing name and values
     * of property inputs
     *
     * @returns {Array} Collection of objects with name and value keys
     */
    ProductForm.prototype.properties = function () {
      var properties = _serializePropertyValues(
        this.propertyInputs,
        function (propertyName) {
          var regex = /(?:^(properties\[))(.*?)(?:\])/;
          var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
          return name;
        }
      );

      return Object.entries(properties).length === 0 ? null : properties;
    };

    /**
     * Getter method which returns the current quantity or 1 if no quantity input is
     * included in the form
     *
     * @returns {Array} Collection of objects with name and value keys
     */
    ProductForm.prototype.quantity = function () {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    };

    // Private Methods
    // -----------------------------------------------------------------------------
    ProductForm.prototype._setIdInputValue = function (value) {
      var idInputElement = this.element.querySelector(
        theme_product_form_selectors.idInput
      );

      if (!idInputElement) {
        idInputElement = document.createElement("input");
        idInputElement.type = "hidden";
        idInputElement.name = "id";
        this.element.appendChild(idInputElement);
      }

      idInputElement.value = value.toString();
    };

    ProductForm.prototype._onSubmit = function (options, event) {
      event.dataset = this._getProductFormEventData();

      if (event.dataset.variant) {
        this._setIdInputValue(event.dataset.variant.id);
      }

      if (options.onFormSubmit) {
        options.onFormSubmit(event);
      }
    };

    ProductForm.prototype._onFormEvent = function (cb) {
      if (typeof cb === "undefined") {
        return Function.prototype;
      }

      return function (event) {
        event.dataset = this._getProductFormEventData();
        cb(event);
      }.bind(this);
    };

    ProductForm.prototype._initInputs = function (selector, cb) {
      var elements = Array.prototype.slice.call(
        this.element.querySelectorAll(selector)
      );

      return elements.map(
        function (element) {
          this._listeners.add(element, "change", this._onFormEvent(cb));
          return element;
        }.bind(this)
      );
    };

    ProductForm.prototype._getProductFormEventData = function () {
      return {
        options: this.options(),
        variant: this.variant(),
        properties: this.properties(),
        quantity: this.quantity(),
      };
    };

    function _serializeOptionValues(inputs, transform) {
      return inputs.reduce(function (options, input) {
        if (
          input.checked || // If input is a checked (means type radio or checkbox)
          (input.type !== "radio" && input.type !== "checkbox") // Or if its any other type of input
        ) {
          options.push(transform({ name: input.name, value: input.value }));
        }

        return options;
      }, []);
    }

    function _serializePropertyValues(inputs, transform) {
      return inputs.reduce(function (properties, input) {
        if (
          input.checked || // If input is a checked (means type radio or checkbox)
          (input.type !== "radio" && input.type !== "checkbox") // Or if its any other type of input
        ) {
          properties[transform(input.name)] = input.value;
        }

        return properties;
      }, {});
    }

    function _validateProductObject(product) {
      if (typeof product !== "object") {
        throw new TypeError(product + " is not an object.");
      }

      if (typeof product.variants[0].options === "undefined") {
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      }

      return product;
    }

    // EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/dist/currency.cjs.js
    var currency_cjs = __webpack_require__(10);

    // EXTERNAL MODULE: ./node_modules/@splidejs/splide/dist/js/splide.esm.js
    var splide_esm = __webpack_require__(15);
    var splide_esm_default = /*#__PURE__*/ __webpack_require__.n(splide_esm);
    // CONCATENATED MODULE: ./node_modules/@switchthemes/splide-a11y/index.js
    const applyInert = function (splide) {
      // Make sure that clickable children of inactive slides can't be focused to
      const elements = splide.Components.Slides;
      const slides = Array.from(elements.get(true));
      slides.forEach((slide) => {
        if (slide.slide.classList.contains('is-visible')) {
          slide.slide.removeAttribute("inert");
        } else {
          slide.slide.setAttribute("inert", "");
        }
      });
    };

    // EXTERNAL MODULE: ./node_modules/@switchthemes/library-loader/index.js
    var library_loader = __webpack_require__(5);

    // CONCATENATED MODULE: ./src/scripts/components/media.js

    document.addEventListener("touchstart", function () {
      utilities["a" /* Helpers */].setTouch();
    });
    var ProductModel = (function () {
      var modelJsonSections = {};
      var models = {};
      var xrButtons = {};
      var selectors = {
        mediaGroup: "[data-product-single-media-group]",
        xrButton: "[data-shopify-xr]",
        activateButton: "[data-model-toggle]",
      };

      function init(modelViewerContainers, sectionId) {
        // loadFeature will use mutation observer.
        // Final version of debut will not check this.

        /*
  if (Shopify.designMode) {
    window.Shopify.detectLoadJS();
  }
  */
        modelJsonSections[sectionId] = {
          loaded: false,
        };
        modelViewerContainers.forEach(function (container, index) {
          var mediaId = container.dataset.mediaId;
          var modelViewerElement = container.querySelector("model-viewer");
          var modelId = modelViewerElement.dataset.modelId;

          if (index === 0) {
            var xrButton = container
              .closest(selectors.mediaGroup)
              .querySelector(selectors.xrButton);
            xrButtons[sectionId] = {
              element: xrButton,
              defaultId: modelId,
            };
          }

          models[mediaId] = {
            modelId: modelId,
            sectionId: sectionId,
            container: container,
            element: modelViewerElement,
          };
        }); //LibraryLoader.load('shopifyXr', setupShopifyXr);

        window.Shopify.loadFeatures([
          {
            name: "shopify-xr",
            version: "1.0",
            onLoad: setupShopifyXr,
          },
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: setupModelViewerUi,
          },
        ]);
        library_loader["a" /* default */].load("modelViewerUiStyles");
      }

      function setupShopifyXr(errors) {
        if (errors) {
          errors.forEach(function (error) {
            console.warn(error.message);
          }); // When loadFeature is implemented, you can console or throw errors by doing something like this:

          return;
        }

        if (!window.ShopifyXR) {
          document.addEventListener("shopify_xr_initialized", function () {
            setupShopifyXr();
          });
          return;
        }

        for (var sectionId in modelJsonSections) {
          if (modelJsonSections.hasOwnProperty(sectionId)) {
            var modelSection = modelJsonSections[sectionId];
            if (modelSection.loaded) continue;
            var modelJson = JSON.parse(
              document.getElementById("ModelJson-" + sectionId).innerHTML
            );

            if (modelJson) {
              window.ShopifyXR.addModels(modelJson);
              modelSection.loaded = true;
            }
          }
        }

        window.ShopifyXR.setupXRElements();
      }

      function setupModelViewerUi(errors) {
        if (errors) {
          // When loadFeature is implemented, you can console or throw errors by doing something like this:
          // errors.forEach((error) => { console.warn(error.message); });
          return;
        }

        for (var key in models) {
          if (models.hasOwnProperty(key)) {
            var model = models[key];

            if (!model.modelViewerUi) {
              var element = '[data-model-id="' + model.modelId + '"]';
              model.modelViewerUi = new Shopify.ModelViewerUI(element);
            }

            setupModelViewerListeners(model);
          }
        }
      }

      function setupModelViewerListeners(model) {
        var xrButton = xrButtons[model.sectionId];
        model.container.addEventListener("mediaVisible", function () {
          xrButton.element.setAttribute(
            "data-shopify-model3d-id",
            model.modelId
          );
          if (utilities["a" /* Helpers */].isTouch()) return;
          model.modelViewerUi.play();
        });
        model.container.addEventListener("mediaHidden", function () {
          xrButton.element.setAttribute(
            "data-shopify-model3d-id",
            xrButton.defaultId
          );
          model.modelViewerUi.pause();
        });
        model.container.addEventListener("xrLaunch", function () {
          model.modelViewerUi.pause();
        });
      }

      function removeSectionModels(sectionId) {
        for (var key in models) {
          if (models.hasOwnProperty(key)) {
            var model = models[key];

            if (model.sectionId === sectionId) {
              delete models[key];
            }
          }
        }

        delete modelJsonSections[sectionId];
      }

      return {
        init: init,
        removeSectionModels: removeSectionModels,
      };
    })();
    // CONCATENATED MODULE: ./node_modules/@switchthemes/store-availability/index.js

    const store_availability_StoreAvailability = (function () {
      /**
       * @constructor
       * StoreAvailability constructor
       *
       * @param {HTMLElement} container An HTML container
       */
      function StoreAvailability(container) {
        this.container = container;
        this.fetchContent = debounce_default()(
          this.__fetchContent.bind(this),
          500,
          {
            leading: true,
            trailing: true,
          }
        );

        window.Alpine.store("availability").product_title =
          this.container.dataset.productTitle;
      }

      StoreAvailability.prototype = Object.assign(
        {},
        StoreAvailability.prototype,
        {
          /**
           * @description
           * Gets information about a variant’s store
           * pickup availability from its section response,
           * and replaces the inner HTML of the container element
           * with the one from the section response
           *
           * @param {Number} variantId The ID of the variant
           */
          __fetchContent: function (variant) {
            if (
              window.Alpine.store("availability").availability[variant.id]
            ) {
              window.Alpine.store("availability").current_variant = variant;
              window.Alpine.store("availability").loading = false;
              return;
            } else {
              let baseUrl = this.container.dataset.baseUrl;

              if (!baseUrl.endsWith("/")) {
                baseUrl = baseUrl + "/";
              }

              const variantSectionUrl =
                baseUrl +
                "variants/" +
                variant.id +
                "/?section_id=store-availability";
              window.Alpine.store("availability").loading = true;

              return fetch(variantSectionUrl)
                .then(function (response) {
                  return response.text();
                })
                .then(function (storeAvailabilityHTML) {
                  // todo: think we can refactor this to be a little cleaner but right now i want this to work with both json and non json content
                  window.Alpine.store("availability").loading = false;
                  window.Alpine.store("availability").current_variant =
                    variant;
                  let data = "";
                  const parser = new DOMParser();
                  const html = parser.parseFromString(
                    storeAvailabilityHTML,
                    "text/html"
                  );
                  const dataWrapper = html.querySelector(
                    "[data-availability-json]"
                  );
                  if (dataWrapper) {
                    data = JSON.parse(dataWrapper.innerHTML);
                  }
                  window.Alpine.store("availability").availability[
                    data.variant
                  ] = data.availability;
                });
            }
          },
        }
      );

      return StoreAvailability;
    })();

    /* harmony default export */ var store_availability =
      store_availability_StoreAvailability;

    // EXTERNAL MODULE: ./node_modules/@shopify/theme-images/dist/images.cjs.js
    var images_cjs = __webpack_require__(8);

    // CONCATENATED MODULE: ./src/scripts/sections/product.js
    function product_createForOfIteratorHelper(o, allowArrayLike) {
      var it =
        (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
        o["@@iterator"];
      if (!it) {
        if (
          Array.isArray(o) ||
          (it = product_unsupportedIterableToArray(o)) ||
          (allowArrayLike && o && typeof o.length === "number")
        ) {
          if (it) o = it;
          var i = 0;
          var F = function F() {};
          return {
            s: F,
            n: function n() {
              if (i >= o.length) return { done: true };
              return { done: false, value: o[i++] };
            },
            e: function e(_e) {
              throw _e;
            },
            f: F,
          };
        }
        throw new TypeError(
          "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      }
      var normalCompletion = true,
        didErr = false,
        err;
      return {
        s: function s() {
          it = it.call(o);
        },
        n: function n() {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        },
        e: function e(_e2) {
          didErr = true;
          err = _e2;
        },
        f: function f() {
          try {
            if (!normalCompletion && it["return"] != null) it["return"]();
          } finally {
            if (didErr) throw err;
          }
        },
      };
    }

    function product_unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return product_arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return product_arrayLikeToArray(o, minLen);
    }

    function product_arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }

    /**
     * Product Template Script
     * ------------------------------------------------------------------------------
     * A file that contains scripts highly couple code to the Product template.
     *
     * @namespace product
     */
    //import Variants from '@shopify/theme-variants';

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register("product", {
      onLoad: function onLoad() {
        var _this = this;

        var section = this;
        var alpineId = this.container.dataset.alpineId;
        var storeAvailabilityContainer = this.container.querySelector(
          "[data-store-availability]"
        );
        var hasGiftCardRecipientForm = Boolean(
          this.container.querySelector("[data-gift-card-recipient-form]")
        );

        if (!this.container.querySelector("[data-product-json]")) {
          return;
        }

        this.productSingleObject = JSON.parse(
          this.container.querySelector("[data-product-json]").innerHTML
        );
        this.selectedVariantObject = JSON.parse(
          this.container.querySelector("[data-selected-variant-json]")
            .innerHTML
        );
        this.featuredMediaID = JSON.parse(
          this.container.querySelector("[data-featured-media-id]").innerHTML
        );

        if (this.container.querySelector("[data-variant-inventory]")) {
          this.inventoryData = JSON.parse(
            this.container.querySelector("[data-variant-inventory]").innerHTML
          );
        } else {
          this.inventoryData = null;
        }

        if (storeAvailabilityContainer) {
          this.storeAvailability = new store_availability(
            storeAvailabilityContainer
          );
        }

        this.sectionId = this.id;
        this.enableImageZoom =
          this.container.dataset.enableImageZoom === "true" || false;

        if (this.enableImageZoom) {
          Promise.all(
            /* import() | product-image-zoom */ [
              __webpack_require__.e(8),
              __webpack_require__.e(4),
            ]
          )
            .then(__webpack_require__.bind(null, 70))
            .then(function (_ref) {
              var PhotoSwipeModule = _ref["default"];

              _this.setUpImageZoom(
                PhotoSwipeModule.PhotoSwipe,
                PhotoSwipeModule.PhotoSwipeUI_Default
              );
            })
            ["catch"](function (error) {
              return console.warn(error);
            });
        }

        var functionName = "ThemeSection_" + alpineId;

        window[functionName] = function () {
          return {
            current_media_id: _this.featuredMediaID,
            product: _this.productSingleObject,
            current_variant: _this.selectedVariantObject,
            quantity: "1",
            headerSection: null,
            enableQuantityInput: false,
            options: [],
            optionHandles: [],
            current_price: _this.selectedVariantObject.price,
            addedToCart: false,
            loading: false,
            locationsToShow: null,
            addErrorMessage: "",
            changeVariant: null,
            inventoryData: _this.inventoryData,
            splide: null,
            splideHover: false,
            productModal: false,
            formatMoney: function formatMoney(price) {
              return Object(currency_cjs["formatMoney"])(
                price,
                window.theme.moneyFormat
              );
            },

            get currentVariantAvailable() {
              if (this.current_variant) {
                return this.current_variant.available;
              } else {
                return null;
              }
            },

            get currentVariantId() {
              if (this.current_variant) {
                return this.current_variant.id;
              } else {
                return null;
              }
            },

            get currentVariantInventoryData() {
              if (this.inventoryData !== null) {
                if (
                  this.current_variant &&
                  this.inventoryData[this.current_variant.id]
                ) {
                  return this.inventoryData[this.current_variant.id];
                } else {
                  return null;
                }
              } else {
                return null;
              }
            },

            get currentVariantAvailability() {
              // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
              var id = window.Alpine.store("availability").current_variant.id;
              var storeData =
                window.Alpine.store("availability").availability[id];

              if (storeData) {
                return storeData.closest_location;
              } else {
                return null;
              }
            },

            get currentVariantLocations() {
              // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
              var id = window.Alpine.store("availability").current_variant.id;
              var storeData =
                window.Alpine.store("availability").availability[id];
              var locationStock = {};

              if (storeData && storeData.list) {
                // fallback scenario of grabbing data from the object
                for (var i = 0; i < storeData.list.length; i++) {
                  if (!locationStock[storeData.list[i].name]) {
                    if (
                      this.locationsToShow === "in_stock" &&
                      !storeData.list[i].available
                    ) {
                      continue;
                    }

                    locationStock[storeData.list[i].name] =
                      storeData.list[i].available;
                  }
                }

                return locationStock;
              }

              return null;
            },

            initProductModels: function initProductModels() {
              var models = section.container.querySelectorAll(
                "[data-product-media-type-model]"
              );

              if (models.length > 0) {
                ProductModel.init(models, section.sectionId);
              }
            },
            decodeHTML: function decodeHTML(html) {
              var txt = document.createElement("textarea");
              txt.innerHTML = html;
              return txt.value;
            },
            mounted: function mounted() {
              var _this2 = this;

              if (this.$refs.productForm) {
                this.$refs.productForm.addEventListener(
                  "submit",
                  this.submitForm.bind(this)
                );
              }

              promise_stylesheet.promiseStylesheet().then(function () {
                if (_this2.$refs.productPageSplide) {
                  _this2.setupSplide();
                }

                _this2.getAddToCartButtonHeight();
              });
              this._debouncedCalculateSlideshowHeight = debounce_default()(
                this.calculateSlideshowHeight.bind(this),
                200
              );
              window.addEventListener(
                "resize",
                this._debouncedCalculateSlideshowHeight
              );
              this.getOptions();
              this.changeVariant = debounce_default()(
                this.__changeVariant,
                500,
                {
                  leading: true,
                  trailing: true,
                }
              );
              this.initProductModels();

              if (
                this.$refs.locationInventoryData &&
                this.$refs.locationInventoryData.dataset.locationsToShow
              ) {
                this.locationsToShow =
                  this.$refs.locationInventoryData.dataset.locationsToShow;
              }

              window.Alpine.store("availability").current_variant =
                this.current_variant;
              this.updateStoreAvailability(this.current_variant);
              /*
        this.$nextTick(() => {
          if (section.container.dataset.productModal === 'true') {
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }
        });
        */

              var iframeSelectors =
                '.product-rte iframe[src*="youtube.com/embed"],' +
                '.product-rte iframe[src*="player.vimeo"]';
              Object(utilities["e" /* wrapIframe */])({
                iframes: document.querySelectorAll(iframeSelectors),
                iframeWrapperClass: "video-wrapper",
              });
            },
            getAddToCartButtonHeight: function getAddToCartButtonHeight() {
              var addToCartBtn = document.querySelector(".add-to-cart-btn");

              if (addToCartBtn) {
                var height = addToCartBtn.offsetHeight;
                document.documentElement.style.setProperty(
                  "--payment-button-height",
                  "".concat(height, "px")
                );
              }
            },
            getOptions: function getOptions() {
              var _this3 = this;

              this.options = [];
              this.optionHandles = [];
              var selectors = this.$root.querySelectorAll(
                "[data-single-option-selector]"
              );
              selectors.forEach(function (selector) {
                if (selector.nodeName === "SELECT") {
                  var value = selector.value;

                  _this3.options.push(value);

                  _this3.optionHandles.push(
                    selector.options[selector.selectedIndex].dataset.handle
                  );
                } else {
                  if (selector.checked) {
                    var _value = selector.value;

                    _this3.options.push(_value);

                    _this3.optionHandles.push(selector.dataset.handle);
                  }
                }
              });
            },
            setupSplide: function setupSplide() {
              var _this4 = this;
              var startIndex = this.$refs.featuredMedia.dataset.index;
              this.splide = new splide_esm_default.a(
                this.$refs.productPageSplide,
                {
                  perPage: this.$refs.productPageSplide.dataset.perPage || 1,
                  focus: parseInt(this.$refs.productPageSplide.dataset.perPage || "1") > 1 ? 1 : 0,
                  perMove: 1,
                  start: startIndex,
                  type:
                    this.$refs.productPageSplide.dataset.dragDisabled ==
                    "true"
                      ? "slide"
                      : "loop",
                  pagination: false,
                  arrows: true,
                  width: "100%",
                  breakpoints: {
                    768: {
                      focus: 'center',
                      perPage: 1,
                    }
                  },
                  drag:
                    this.$refs.productPageSplide.dataset.dragDisabled ===
                    "true"
                      ? false
                      : true,
                }
              );
              this.$refs.productPageSplide.addEventListener(
                "productSplideChange",
                function () {
                  console.log("splide change");
                  _this4.splideChange();
                }
              );
              this.splide.on("resize", function () {
                _this4.$refs.productSplideTrack.style.maxWidth = "none";
              });
              this.splide.on("resized", function () {
                console.log();
                // var currentSlide = document.querySelector(
                //   ".splide__slide.is-active.is-visible"
                // );
                // if (currentSlide) {
                //   var maxWidth = currentSlide.clientWidth;
                //   _this4.$refs.productSplideTrack.style.maxWidth = maxWidth + 'px';
                // }
              });
              this.splide.mount({
                SplideProduct: product_SplideProduct,
              });
              this.calculateSlideshowHeight();
            },
            calculateSlideshowHeight: function calculateSlideshowHeight() {
              var splideTrack = this.$refs.productSplideTrack;

              if (splideTrack == null) {
                return;
              }

              if (
                this.$refs.productPageSplide &&
                this.$refs.productPageSplide.classList.contains("is-active")
              ) {
                var elements = this.splide.Components.Slides;
                var slide = elements.getAt(this.splide.index).slide;
                var slideMedia = slide.querySelector(".product-media-height");
                splideTrack.style.maxHeight = slideMedia.offsetHeight + "px";
              } else {
                splideTrack.style.removeProperty("max-height");
              }
            },
            optionChange: function optionChange() {
              this.getOptions();
              this.changeVariant();
            },
            __changeVariant: function __changeVariant() {
              var matchedVariant = getVariantFromOptionArray(
                this.product,
                this.options
              );
              this.current_variant = matchedVariant;

              if (this.current_variant) {
                Object(live_region["c" /* variantLiveRegion */])(
                  this.current_variant
                );
                this.current_price = this.current_variant.price;
                this.updateStoreAvailability(this.current_variant);

                // if (this.current_variant.featured_media) {
                //   this.current_media_id =
                //     this.current_variant.featured_media.id;
                //   // this.setSplideToCurrentMedia();
                // }

                var url = getUrlWithVariant(
                  window.location.href,
                  this.current_variant.id
                );
                window.history.replaceState(
                  {
                    path: url,
                  },
                  "",
                  url
                );
                this.$refs.singleVariantSelector.dispatchEvent(
                  new Event("change", {
                    bubbles: true,
                  })
                );
              }
            },
            setSplideToCurrentMedia: function setSplideToCurrentMedia() {
              var featuredMedia = document.querySelector(
                '[data-media-id="' + this.current_media_id + '"]'
              );

              if (
                this.$refs.productPageSplide &&
                this.$refs.productPageSplide.classList.contains("is-active")
              ) {
                var parentSlide = featuredMedia.closest("[data-index]");
                var index = parseInt(parentSlide.dataset.index);
                this.splide.go(index);
              }
            },
            splideChange: function splideChange() {
              var currentSlideMediaId = parseInt(
                this.splide.Components.Slides.getAt(
                  this.splide.index
                ).slide.querySelector(".product-media-object").dataset.mediaId
              );

              if (currentSlideMediaId !== this.current_media_id) {
                this.current_media_id = currentSlideMediaId;
              }

              if (this.$refs.productLeftThumbnails) {
                var thumbnail = this.$refs.productLeftThumbnails
                  .querySelector(
                    '[data-thumbnail-id="'.concat(currentSlideMediaId, '"]')
                  )
                  .closest(".product-single__thumbnail-item");

                if (
                  thumbnail.offsetTop >
                  this.$refs.productLeftThumbnailsScrollContainer
                    .offsetHeight +
                    this.$refs.productLeftThumbnailsScrollContainer
                      .scrollTop -
                    thumbnail.offsetHeight
                ) {
                  this.$refs.productLeftThumbnailsScrollContainer.scrollTo({
                    top: thumbnail.offsetTop,
                    behavior: "smooth",
                  });
                }

                if (
                  thumbnail.offsetTop <
                  this.$refs.productLeftThumbnailsScrollContainer.scrollTop
                ) {
                  this.$refs.productLeftThumbnailsScrollContainer.scrollTo({
                    top: thumbnail.offsetTop,
                    behavior: "smooth",
                  });
                }
              }
            },
            quantityChange: function quantityChange() {
              var _this5 = this;

              if (this.quantity === "10+") {
                this.quantity = "10";
                this.enableQuantityInput = true;
                this.$nextTick(function () {
                  _this5.$refs.quantityInput.focus();

                  _this5.$refs.quantityInput.select(); //this.$refs.quantityInput.focus().select());
                });
              }
            },
            submitForm: function submitForm(evt) {
              var _this6 = this;

              evt.preventDefault();
              this.loading = true;
              Object(live_region["b" /* liveRegion */])(
                window.theme.strings.loading
              );
              Object(theme_cart["b" /* addItemFromForm */])(
                this.$refs.productForm
              )
                .then(function () {
                  _this6.loading = false;
                  _this6.addedToCart = true;
                  document.body.dispatchEvent(
                    new CustomEvent("label:modalcart:afteradditem")
                  );

                  if (!document.querySelector('[data-show-on-add="true"]')) {
                    _this6.$nextTick(function () {
                      return _this6.$refs.added.focus();
                    });

                    Object(theme_cart["c" /* getState */])().then(function (
                      state
                    ) {
                      document.body.dispatchEvent(
                        new CustomEvent("label:modalcart:itemcountupdate", {
                          detail: {
                            count: state.item_count,
                          },
                        })
                      );
                    });
                  }
                })
                ["catch"](function (error) {
                  error.json().then(function (errorData) {
                    _this6.loading = false;
                    var errors = errorData.errors || errorData.description;
                    var message = errorData.description || errorData.message; // Gift card recipient form errors are handled in gift-card-recipient.js

                    if (!hasGiftCardRecipientForm) {
                      _this6.addErrorMessage =
                        message || window.theme.strings.cartError;
                    }

                    if (errorData.status) {
                      document.body.dispatchEvent(
                        new CustomEvent("label:cart:adderror", {
                          detail: {
                            source: "product-form",
                            sourceId:
                              _this6.$refs.productForm.getAttribute("id"),
                            errors: errors,
                            message: message,
                          },
                        })
                      );
                    } else {
                      alert(errorData.description);
                    }
                  });
                });
            },
            updateMedia: function updateMedia(
              mediaId
              /*,  mediaType */
            ) {
              this.current_media_id = mediaId;
              this.setSplideToCurrentMedia();
            },
            updateStoreAvailability: function updateStoreAvailability(
              variant
            ) {
              if (section.storeAvailability && variant) {
                section.storeAvailability.fetchContent(variant);
              }
            },
            openZoom: function openZoom(index) {
              var items = window.matchMedia("(max-width: 767px)").matches
                ? section.mobilePswpItems
                : section.desktopPswpItems;
              section.pswpOptions.index = index;
              var gallery = new section.PhotoSwipe(
                section.pswpElement,
                section.PhotoSwipeUI_Default,
                items,
                section.pswpOptions
              );
              gallery.init();
              trapFocus(section.pswpElement);
              document.documentElement.style.overflowY = "hidden";
              gallery.listen("close", function () {
                document.documentElement.style.overflowY = "";
                removeTrapFocus();
                var indexToRefocus = gallery.options.index;
                var elToRefocus = section.container.querySelector(
                  '[data-product-image-index="'.concat(indexToRefocus, '"]')
                );

                if (elToRefocus) {
                  // wait for the transition to occur so as to not open and close the popup again
                  setTimeout(function () {
                    return elToRefocus.focus();
                  }, 350);
                }
              });
            },
          };
        };
      },
      setUpImageZoom: function setUpImageZoom(
        PhotoSwipe,
        PhotoSwipeUI_Default
      ) {
        var imageDataEl = this.container.querySelector(
          "[data-product-images]"
        );
        if (!imageDataEl) return;
        var imageData = JSON.parse(imageDataEl.innerHTML);
        this.pswpElement = document.querySelector(".pswp");
        this.PhotoSwipe = PhotoSwipe;
        this.PhotoSwipeUI_Default = PhotoSwipeUI_Default;
        var mobileWidth = 1400;
        var desktopMaxWidth = 3000;
        this.mobilePswpItems = [];
        this.desktopPswpItems = [];

        var _iterator = product_createForOfIteratorHelper(imageData),
          _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var productImage = _step.value;
            var imageFullSizeUrl = productImage.fullSizeUrl,
              imageFullSizeWidth = productImage.width,
              imageFullSizeHeight = productImage.height,
              imageAspectRatio = productImage.aspectRatio;
            var mobileItem = {
              src: Object(images_cjs["getSizedImageUrl"])(
                imageFullSizeUrl,
                "".concat(mobileWidth, "x")
              ),
              w: mobileWidth,
              h: mobileWidth / imageAspectRatio,
            };
            this.mobilePswpItems.push(mobileItem);
            var desktopImageFinalUrl = "",
              desktopImageFinalWidth = 0,
              desktopImageFinalHeight = 0;

            if (imageFullSizeWidth <= desktopMaxWidth) {
              desktopImageFinalUrl = imageFullSizeUrl;
              desktopImageFinalWidth = imageFullSizeWidth;
              desktopImageFinalHeight = imageFullSizeHeight;
            } else {
              var desktopSizedImgUrl = Object(images_cjs["getSizedImageUrl"])(
                imageFullSizeUrl,
                "".concat(desktopMaxWidth, "x")
              );
              desktopImageFinalUrl = desktopSizedImgUrl;
              desktopImageFinalWidth = desktopMaxWidth;
              desktopImageFinalHeight = desktopMaxWidth / imageAspectRatio;
            }

            var desktopItem = {
              src: desktopImageFinalUrl,
              w: desktopImageFinalWidth,
              h: desktopImageFinalHeight,
            };
            this.desktopPswpItems.push(desktopItem);
            this.pswpOptions = {
              history: false,
              captionEl: false,
              fullscreenEl: false,
              zoomEl: false,
              shareEl: false,
              counterEl: false,
              arrowEl: true,
              preloaderEl: false,
              closeEl: true,
              barsSize: {
                top: 0,
                bottom: "auto",
              },
            };
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function onUnload() {
        if (this.splide) {
          this.splide.destroy();
        }
      },
    }); // Pull this out to a seperate component so that events are reinitialized on destroy.

    var product_SplideProduct = function SplideProduct(Splide) {
      Splide.root.addEventListener("click", function (event) {
        if (event.target.classList.contains("splide__pagination__page")) {
          Splide.paginationClicked = true;
        }
      });

      function handleDestroy() {
        var elements = Splide.Components.Elements.slides;
        elements.forEach(function (element) {
          element.removeAttribute("inert");
        });
      }

      function handleMountedMoved() {
        applyInert(Splide);

        if (Splide.paginationClicked) {
          Splide.paginationClicked = false;
          var elements = Splide.Components.Slides;
          var newSlide = elements.getAt(Splide.index).slide;
          setTimeout(function () {
            return newSlide.focus({
              preventScroll: true,
            });
          }, 0);
        }
      }

      function handleMoved(newIndex, oldIndex) {
        var elements = Splide.Components.Slides;
        var oldSlide = elements
          .getAt(oldIndex)
          .slide.querySelector("[data-product-single-media-wrapper]");
        var newSlide = elements
          .getAt(newIndex)
          .slide.querySelector("[data-product-single-media-wrapper]");
        if (oldSlide) oldSlide.dispatchEvent(new CustomEvent("mediaHidden"));
        if (newSlide) newSlide.dispatchEvent(new CustomEvent("mediaVisible"));
      }

      function handleMove(
        newIndex,
         oldIndex
      ) {
        var elements = Splide.Components.Slides;
        var newSlide = elements.getAt(newIndex).slide;
        var newSlideMedia = newSlide.querySelector(".product-media-height");
        newSlide.classList.add("is-active");
        var oldSlide = elements.getAt(oldIndex).slide;
        oldSlide.classList.remove("is-active");
        document
          .getElementById("productSplide")
          .dispatchEvent(new CustomEvent("productSplideChange"));
        newSlide.closest(".splide__track").style.maxHeight =
          newSlideMedia.offsetHeight + "px";
      }

      return {
        mount: function mount() {
          Splide.on("mounted moved", handleMountedMoved);
          Splide.on("moved", handleMoved);
          Splide.on("move", handleMove);
          Splide.on("destroy", handleDestroy);
        },
      };
    };
    // CONCATENATED MODULE: ./src/scripts/sections/product-recommendations.js
    /**
     * Product recommendations section script
     * ------------------------------------------------------------------------------
     * A file that contains scripts for the Product recommendations section
     *
     * @namespace product-recommendations
     */

    /* harmony default export */ var product_recommendations = register(
      "product-recommendations",
      {
        onLoad: function onLoad() {
          var productRecommendationsSection = this.container;
          var requestUrl = productRecommendationsSection.dataset.requestUrl;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);

          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;

              if (container.querySelector(".product-recommendations")) {
                productRecommendationsSection.innerHTML =
                  container.querySelector(
                    ".product-recommendations"
                  ).innerHTML;
                document.dispatchEvent(
                  new CustomEvent("label:section:hasmutated", {
                    bubbles: true,
                  })
                );
              }
            }
          };

          request.send();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function onUnload() {},
      }
    );
    // CONCATENATED MODULE: ./src/scripts/sections/slideshow.js
    /**
     * Slideshow
     * ------------------------------------------------------------------------------
     * Scripts for the Slideshow section
     *
     * @namespace slideshow
     */

    /**
     * Slideshow section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register("slideshow", {
      onLoad: function onLoad() {
        // Arbitrary constant found here https://github.com/Splidejs/splide/issues/58
        this.flag = 99;
        this.slides = this.container.querySelector(".splide");
        this.slideList = this.container.querySelector(".splide__list");
        this.autoplayControl = this.container.querySelector(
          ".splide__autoplay-control"
        );
        this.timer = null;
        this.paginationClicked = false;
        this.splideContainer = new splide_esm_default.a(this.slides, {
          perPage: 1,
          pagination: true,
          arrows: true,
          drag: this.container.dataset.autoRotate === "true" ? false : true,
          pauseOnHover: false,
          // We replicate this later in a way that does not conflict with our play and pause button.
          pauseOnFocus: false,
          classes: {
            // Add classes for pagination.
            pagination:
              "splide__pagination absolute left-1/2 transform -translate-x-1/2 bottom-3 w-auto text-white", // container
          },
        });
        this.bindEvents();
        this.setUpPlayButton();
        this.splideContainer.mount();
        this.autoplay = this.splideContainer.Components.Autoplay;
      },
      bindEvents: function bindEvents() {
        var _this = this;

        this.container.addEventListener("click", function (event) {
          if (event.target.classList.contains("splide__pagination__page")) {
            _this.paginationClicked = true;
          }
        }); // 2 is the internal library flag for focus.
        // We want to be able to pause if the user is interacting with the slide via focus,
        // but resume the autoplay once focus leaves, provided that the pause button has not manually been pressed

        this.container.addEventListener("focusin", function (event) {
          if (
            !event.target.classList.contains("splide__autoplay-control") &&
            _this.autoplay
          ) {
            _this.autoplay.pause(2);
          }
        });
        this.container.addEventListener("focusout", function (event) {
          _this.autoplay && _this.autoplay.play(2);
        });
        this.splideContainer.on("mounted updated", function () {
          if (_this.splideContainer.options.autoplay === true) {
            _this.autoplayControl.classList.remove("opacity-0", "invisible");
          } else {
            _this.autoplayControl.classList.add("opacity-0", "invisible");
          }
        });
        this.splideContainer.on("mounted moved", function () {
          // applyInert(_this.splideContainer);

          if (_this.paginationClicked) {
            // If pagination is clicked, move focus to that slide.
            _this.paginationClicked = false;
            var elements = _this.splideContainer.Components.Elements;
            var newSlide = elements.getSlide(
              _this.splideContainer.index
            ).slide;
            setTimeout(function () {
              return newSlide.focus({
                preventScroll: true,
              });
            }, 0);
          }
        });
      },
      setUpPlayButton: function setUpPlayButton() {
        var _this2 = this;

        if (this.autoplayControl) {
          var pausedClass = "splide__autoplay-control--paused";
          this.splideContainer.on("autoplay:play", function () {
            _this2.autoplayControl.classList.remove(pausedClass);

            _this2.autoplayControl.setAttribute(
              "aria-label",
              "Pause Autoplay"
            );
          });
          this.splideContainer.on("autoplay:pause", function () {
            _this2.autoplayControl.classList.add(pausedClass);

            _this2.autoplayControl.setAttribute(
              "aria-label",
              "Start Autoplay"
            );
          });
          this.splideContainer.on(
            "click",
            function () {
              if (_this2.autoplayControl.classList.contains(pausedClass)) {
                _this2.autoplay.play(_this2.flag);
              } else {
                _this2.autoplay.pause(_this2.flag);
              }
            },
            this.autoplayControl
          );
        }
      },
      onBlockSelect: function onBlockSelect(event) {
        var block = event.target;
        var index = parseInt(block.dataset.index);
        this.splideContainer.go(index);
        this.autoplay.pause(this.flag);
      },
      onBlockDeselect: function onBlockDeselect() {
        if (this.splideContainer.options.autoplay) {
          this.autoplay.play(this.flag);
        }
      },
      onUnload: function onUnload() {
        if (this.splideContainer) {
          this.splideContainer.destroy(true);
        }
      },
    });
    // CONCATENATED MODULE: ./src/scripts/sections/sidebar.js

    register("sidebar", {
      onLoad: function onLoad() {
        this.sectionId = this.id;
        var accordions = this.container.querySelectorAll("[data-accordion]");
        var accordionOpen = {};

        for (var i = 0; i < accordions.length; i++) {
          accordionOpen["accordion" + i] = false;
        }

        var functionName = "ThemeSection_" + this.sectionId;

        window[functionName] = function () {
          return {
            accordionOpen: accordionOpen,
            mounted: function mounted() {},
          };
        };
      },
      onSelect: function onSelect() {
        alpine.store("drawer").menuDrawerOpen = true;
      },
      onDeselect: function onDeselect() {
        alpine.store("drawer").menuDrawerOpen = false;
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function onUnload() {},
    });
    // CONCATENATED MODULE: ./src/scripts/sections/availability-drawer.js
    /**
     * Header
     * ------------------------------------------------------------------------------
     *
     * @namespace header
     */

    register("availability-drawer", {
      onLoad: function onLoad() {
        window["ThemeSection_availabilityDrawer"] = function () {
          return {
            get currentVariantAvailability() {
              // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
              if (window.Alpine.store("availability").current_variant) {
                var id =
                  window.Alpine.store("availability").current_variant.id;
                var storeData =
                  window.Alpine.store("availability").availability[id];

                if (storeData) {
                  return storeData.list;
                }
              }

              return [];
            },
          };
        };
      },
      onSelect: function onSelect() {
        alpine.store("drawer").availabilityDrawerOpen = true;
      },
      onDeselect: function onDeselect() {
        alpine.store("drawer").availabilityDrawerOpen = false;
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function onUnload() {},
    });
    // CONCATENATED MODULE: ./node_modules/@switchthemes/disclosure/index.js
    const Disclosure = (function () {
      var selectors = {
        disclosureForm: "[data-disclosure-form]",
        disclosureList: "[data-disclosure-list]",
        disclosureToggle: "[data-disclosure-toggle]",
        disclosureInput: "[data-disclosure-input]",
        disclosureOptions: "[data-disclosure-option]",
      };

      var classes = {
        listVisible: "opacity-100",
        listZIndex: "z-10",
      };

      function Disclosure(disclosure) {
        this.container = disclosure;
        this._cacheSelectors();
        this._setupListeners();
      }

      Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
        _cacheSelectors: function () {
          this.cache = {
            disclosureForm: this.container.closest(selectors.disclosureForm),
            disclosureList: this.container.querySelector(
              selectors.disclosureList
            ),
            disclosureToggle: this.container.querySelector(
              selectors.disclosureToggle
            ),
            disclosureInput: this.container.querySelector(
              selectors.disclosureInput
            ),
            disclosureOptions: this.container.querySelectorAll(
              selectors.disclosureOptions
            ),
          };
        },

        _setupListeners: function () {
          this.eventHandlers = this._setupEventHandlers();

          this.cache.disclosureToggle.addEventListener(
            "click",
            this.eventHandlers.toggleList
          );

          this.cache.disclosureOptions.forEach(function (disclosureOption) {
            disclosureOption.addEventListener(
              "click",
              this.eventHandlers.connectOptions
            );
          }, this);

          this.container.addEventListener(
            "keyup",
            this.eventHandlers.onDisclosureKeyUp
          );

          this.cache.disclosureList.addEventListener(
            "focusout",
            this.eventHandlers.onDisclosureListFocusOut
          );

          this.cache.disclosureToggle.addEventListener(
            "focusout",
            this.eventHandlers.onDisclosureToggleFocusOut
          );

          document.body.addEventListener(
            "click",
            this.eventHandlers.onBodyClick
          );
        },

        _setupEventHandlers: function () {
          return {
            connectOptions: this._connectOptions.bind(this),
            toggleList: this._toggleList.bind(this),
            onBodyClick: this._onBodyClick.bind(this),
            onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
            onDisclosureListFocusOut:
              this._onDisclosureListFocusOut.bind(this),
            onDisclosureToggleFocusOut:
              this._onDisclosureToggleFocusOut.bind(this),
          };
        },

        _connectOptions: function (event) {
          event.preventDefault();
          this._submitForm(event.currentTarget.dataset.value);
        },

        _onDisclosureToggleFocusOut: function (event) {
          var disclosureLostFocus =
            this.container.contains(event.relatedTarget) === false;

          if (disclosureLostFocus) {
            this._hideList();
          }
        },

        _onDisclosureListFocusOut: function (event) {
          var childInFocus = event.currentTarget.contains(
            event.relatedTarget
          );

          var isVisible = this.cache.disclosureList.classList.contains(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        },

        _onDisclosureKeyUp: function (event) {
          if (event.key !== "Escape") return;
          this._hideList();
          this.cache.disclosureToggle.focus();
        },

        _onBodyClick: function (event) {
          var isOption = this.container.contains(event.target);
          var isVisible = this.cache.disclosureList.classList.contains(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        },

        _submitForm: function (value) {
          this.cache.disclosureInput.value = value;
          this.cache.disclosureForm.submit();
        },

        _hideList: function () {
          this.cache.disclosureList.setAttribute("inert", true);
          this.cache.disclosureList.classList.remove(classes.listVisible);
          this.cache.disclosureToggle.setAttribute("aria-expanded", false);
        },

        _toggleList: function () {
          var ariaExpanded =
            this.cache.disclosureToggle.getAttribute("aria-expanded") ===
            "true";
          if (ariaExpanded) {
            this.cache.disclosureList.setAttribute("inert", true);
          } else {
            this.cache.disclosureList.removeAttribute("inert");
          }
          this.cache.disclosureList.classList.toggle(classes.listVisible);
          this.cache.disclosureList.classList.toggle(classes.listZIndex);
          this.cache.disclosureToggle.setAttribute(
            "aria-expanded",
            !ariaExpanded
          );
        },

        destroy: function () {
          this.cache.disclosureToggle.removeEventListener(
            "click",
            this.eventHandlers.toggleList
          );

          this.cache.disclosureOptions.forEach(function (disclosureOption) {
            disclosureOption.removeEventListener(
              "click",
              this.eventHandlers.connectOptions
            );
          }, this);

          this.container.removeEventListener(
            "keyup",
            this.eventHandlers.onDisclosureKeyUp
          );

          this.cache.disclosureList.removeEventListener(
            "focusout",
            this.eventHandlers.onDisclosureListFocusOut
          );

          this.cache.disclosureToggle.removeEventListener(
            "focusout",
            this.eventHandlers.onDisclosureToggleFocusOut
          );

          document.body.removeEventListener(
            "click",
            this.eventHandlers.onBodyClick
          );
        },
      });

      return Disclosure;
    })();

    /* harmony default export */ var disclosure = Disclosure;

    // CONCATENATED MODULE: ./src/scripts/sections/footer.js
    /**
     * Footer section script
     * ------------------------------------------------------------------------------
     * A file that contains scripts for the Footer section
     *
     * @namespace footer
     */

    /* harmony default export */ var footer = register("footer", {
      onLoad: function onLoad() {
        this.selectors = {
          disclosureLocale: "[data-disclosure-locale]",
          disclosureCountry: "[data-disclosure-country]",
        };
        this.cache = {};
        this.cacheSelectors();

        if (this.cache.localeDisclosure) {
          this.localeDisclosure = new disclosure(this.cache.localeDisclosure);
        }

        if (this.cache.countryDisclosure) {
          this.countryDisclosure = new disclosure(
            this.cache.countryDisclosure
          );
        }
      },
      cacheSelectors: function cacheSelectors() {
        this.cache = {
          localeDisclosure: this.container.querySelector(
            this.selectors.disclosureLocale
          ),
          countryDisclosure: this.container.querySelector(
            this.selectors.disclosureCountry
          ),
        };
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function onUnload() {
        if (this.cache.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.cache.countryDisclosure) {
          this.countryDisclosure.destroy();
        }
      },
    });
    // CONCATENATED MODULE: ./src/scripts/sections/filterable.js
    function _toConsumableArray(arr) {
      return (
        _arrayWithoutHoles(arr) ||
        _iterableToArray(arr) ||
        filterable_unsupportedIterableToArray(arr) ||
        _nonIterableSpread()
      );
    }

    function _nonIterableSpread() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }

    function filterable_unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string")
        return filterable_arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return filterable_arrayLikeToArray(o, minLen);
    }

    function _iterableToArray(iter) {
      if (
        (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
        iter["@@iterator"] != null
      )
        return Array.from(iter);
    }

    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return filterable_arrayLikeToArray(arr);
    }

    function filterable_arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }

    register("filterable", {
      onLoad: function onLoad() {
        var accordions = this.container.querySelectorAll("[data-accordion]");
        var accordionOpen = {};

        for (var i = 0; i < accordions.length; i++) {
          var initialState =
            accordions[i].dataset.initialState === "true" ? true : false;
          accordionOpen["accordion" + i] = initialState;
        }

        var section = this;

        window["ThemeSection_filterable"] = function () {
          return {
            accordionOpen: accordionOpen,
            focusId: "",
            filterData: [],
            price_range: null,
            mounted: function mounted() {
              var _this = this;

              document.addEventListener("keyup", function (event) {
                if (event.key === "Escape") {
                  if (_this.filtersOpen) {
                    _this.filtersOpen = false;

                    _this.$refs.filter.focus();
                  }

                  if (_this.sortOpen) {
                    _this.sortOpen = false;

                    _this.$refs.sort.focus();
                  }
                }
              });
              section.container.addEventListener(
                "baseline:collection:open-filters",
                function () {
                  _this.filtersOpen = true;
                }
              );
              window.addEventListener(
                "popstate",
                this.onHistoryChange.bind(this)
              );
              this.$watch("price_range", function (value) {
                var params = new URLSearchParams(value);
                _this.price_min = params.get("min");
                _this.price_max = params.get("max");
              });

              this._observeResultsMutations();
            },
            filterFormSubmit: function filterFormSubmit(e) {
              this.focusId = e.target.id;
              alpine.store("drawer").filterDrawerOpen = false;
              var form = e.target.form;

              if (e.target.tagName.toLowerCase() === "form") {
                form = e.target;
              }

              var formData = new FormData(form);
              var searchParams = new URLSearchParams(formData);
              searchParams["delete"]("price_range");
              this.renderPage(searchParams.toString(), e);
            },
            clearAllFilters: function clearAllFilters(e) {
              alpine.store("drawer").filterDrawerOpen = false;
              this.renderPage(
                new URL(e.currentTarget.href).searchParams.toString()
              );
            },
            renderPage: function renderPage(searchParams, event) {
              var updateURLHash =
                arguments.length > 2 && arguments[2] !== undefined
                  ? arguments[2]
                  : true;
              document
                .getElementById("facets-results")
                .classList.add("opacity-50");
              var url = ""
                .concat(window.location.pathname, "?section_id=")
                .concat(section.id, "&")
                .concat(searchParams);

              var filterDataUrl = function filterDataUrl(element) {
                return element.url === url;
              };

              this.filterData.some(filterDataUrl)
                ? this.renderFromCache(filterDataUrl, event)
                : this.renderFromFetch(url, event);
              if (updateURLHash) this.updateURLHash(searchParams);
            },
            renderFromFetch: function renderFromFetch(url, event) {
              var _this2 = this;

              fetch(url)
                .then(function (response) {
                  return response.text();
                })
                .then(function (responseText) {
                  var html = responseText;
                  _this2.filterData = [].concat(
                    _toConsumableArray(_this2.filterData),
                    [
                      {
                        html: html,
                        url: url,
                      },
                    ]
                  );

                  _this2.renderMarkup(html);
                });
            },
            renderFromCache: function renderFromCache(filterDataUrl, event) {
              var html = this.filterData.find(filterDataUrl).html;
              this.renderMarkup(html);
            },
            renderMarkup: function renderMarkup(html) {
              var _this3 = this;

              var parsed = new DOMParser().parseFromString(html, "text/html");
              var innerHTML =
                parsed.getElementById("facets-filterable").innerHTML;

              if (
                innerHTML !==
                document.getElementById("facets-filterable").innerHTML
              ) {
                document
                  .getElementById("facets-filterable")
                  .closest(".shopify-section")
                  .dispatchEvent(
                    new CustomEvent("label:section:willmutate", {
                      bubbles: true,
                    })
                  );
                setTimeout(function () {
                  document.getElementById("facets-filterable").innerHTML =
                    innerHTML;
                }, 300);
              } else {
                document
                  .getElementById("facets-results")
                  .classList.remove("opacity-50");
              }

              var count = parsed.getElementById(
                "facets-results-count"
              ).innerHTML;
              Object(live_region["b" /* liveRegion */])(count);
              var element = document.getElementById(this.focusId);

              if (element) {
                setTimeout(function () {
                  document.getElementById(_this3.focusId).focus();
                }, 50);
              }
            },
            updateURLHash: function updateURLHash(searchParams) {
              history.pushState(
                {
                  searchParams: searchParams,
                },
                "",
                ""
                  .concat(window.location.pathname)
                  .concat(searchParams && "?".concat(searchParams))
              );
            },
            onHistoryChange: function onHistoryChange(event) {
              var searchParams = event.state.searchParams || "";
              this.renderPage(searchParams, null, false);
            },
            _observeResultsMutations: function _observeResultsMutations() {
              var containerEl = document.getElementById("facets-filterable");
              var mutationObserverOptions = {
                childList: true,
                attributes: false,
                // Omit (or set to false) to observe only changes to the parent node
                subtree: false,
              };

              var callback = function callback(mutationList, observer) {
                mutationList.forEach(function (mutation) {
                  if (mutation.type === "childList") {
                    mutation.target.closest(".shopify-section").dispatchEvent(
                      new CustomEvent("label:section:hasmutated", {
                        bubbles: true,
                      })
                    );
                  }
                });
              };

              var mutationObserver = new MutationObserver(callback);
              mutationObserver.observe(containerEl, mutationObserverOptions);
            },
          };
        };
      },
      onBlockSelect: function onBlockSelect(event) {
        this.container.dispatchEvent(
          new CustomEvent("baseline:collection:open-filters")
        );
      },
      onUnload: function onUnload() {},
    });
    // EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
    var js_cookie = __webpack_require__(11);
    var js_cookie_default = /*#__PURE__*/ __webpack_require__.n(js_cookie);

    // CONCATENATED MODULE: ./src/scripts/sections/popup.js
    /**
     * Popup
     * ------------------------------------------------------------------------------
     * Scripts for the Popup section
     *
     * @namespace popup
     */

    /**
     * Popup section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register("popup", {
      onLoad: function onLoad() {
        var _this = this;

        this.sectionId = this.id;
        this.initSelected = false;
        var cookieName = "popup-" + this.sectionId;

        window["ThemeSection_popup"] = function () {
          return {
            show: false,
            delay: null,
            frequency: null,
            selected: _this.initSelected,
            cookie: js_cookie_default.a.get(cookieName),
            section_id: _this.sectionId,
            mounted: function mounted() {
              var _this2 = this;

              document.addEventListener("keyup", function (event) {
                if (event.key === "Escape") {
                  _this2.closePopUp();
                }
              });

              if (window.location.pathname === "/challenge") {
                return;
              }

              if (!this.cookie && !window.Shopify.designMode) {
                this.openPopUp(this.delay);
              } // Open modal if errors or success message exist or if selected

              if (
                this.$refs["form-success"] ||
                this.$refs["form-errors"] ||
                this.selected
              ) {
                this.openPopUp(0);
              } // Set cookie as opened if success message

              if (this.$refs["form-success"]) {
                js_cookie_default.a.set(this.cookieName, "opened", {
                  path: "/",
                  expires: 200,
                });
                return;
              } //check if form is a success

              window.addEventListener(
                "shopify:section:select",
                function (event) {
                  if (event.detail.sectionId === _this2.section_id) {
                    _this2.selected = true;

                    _this2.openPopUp(0);
                  }
                }
              );
              window.addEventListener(
                "shopify:section:deselect",
                function (event) {
                  if (event.detail.sectionId === _this2.section_id) {
                    _this2.closePopUp();

                    _this2.selected = false;
                  }
                }
              );
            },
            openPopUp: function openPopUp(delay) {
              var _this3 = this;

              setTimeout(function () {
                _this3.show = true;
              }, delay * 1000);
            },
            closePopUp: function closePopUp(event) {
              if (event) {
                event.stopPropagation();
              }

              this.show = false;

              if (this.selected) {
                js_cookie_default.a.remove(this.cookieName, {
                  path: "/",
                });
                return;
              }

              var expiry = this.frequency;
              js_cookie_default.a.set(cookieName, "opened", {
                path: "/",
                expires: expiry,
              });
            },
          };
        };
      },
      onSelect: function onSelect(event) {
        this.initSelected = true;
      },
    });
    // CONCATENATED MODULE: ./src/scripts/theme.js
    window.Label = window.Label || {};
    window.Splide = splide_esm_default.a;
    window.splideIsDestroyed = function splideIsDestroyed(splideInstance) {
      if (!splideInstance) return;
    
      if (window.Splide && splideInstance) {
        if (splideInstance.state.is(window.Splide.STATES.DESTROYED)) {
          return true;
        }
      }
    
      return false;
    }
    
    window.splideIsNotDestroyed = function splideIsNotDestroyed(splideInstance) {
      if (!splideInstance) return;
    
      if (window.Splide && splideInstance) {
        if (!splideInstance.state.is(window.Splide.STATES.DESTROYED)) {
          return true;
        }
      }
    
      return false;
    }
    

    __webpack_require__.p = window.baseAssetsUrl || "/"; // YouTube API callback
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars

    window.onYouTubeIframeAPIReady = function () {
      document.body.dispatchEvent(new CustomEvent("youtubeiframeapiready"));
    }; // Common a11y fixes

    focusHash();
    bindInPageLinks();
    var tableSelectors = ".rte table";
    Object(utilities["f" /* wrapTable */])({
      tables: document.querySelectorAll(tableSelectors),
      tableWrapperClass: "table-wrapper",
    });
    var theme_iframeSelectors =
      '.rte:not(.product-rte) iframe[src*="youtube.com/embed"],' +
      '.rte:not(.product-rte) iframe[src*="player.vimeo"]';
    Object(utilities["e" /* wrapIframe */])({
      iframes: document.querySelectorAll(theme_iframeSelectors),
      iframeWrapperClass: "video-wrapper",
    }); // Apply a specific class to the html element for browser support of cookies.

    if (window.navigator.cookieEnabled) {
      document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        );
    }

    load("*");

    /***/
  },
  /******/
]
);
